webpackJsonp([30],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(469)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(587),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(477)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(595),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(465)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(582),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(606),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(620),
  /* scopeId */
  "data-v-526eb96f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(666),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(498)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(618),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(581),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


if (true) module.exports = simpleheat;

function simpleheat(canvas) {
    if (!(this instanceof simpleheat)) return new simpleheat(canvas);

    this._canvas = canvas = typeof canvas === 'string' ? document.getElementById(canvas) : canvas;
    // console.log(this._canvas)
    this._ctx = canvas.getContext('2d');
    this._width = canvas.width;
    this._height = canvas.height;

    this._max = 1;
    this._data = [];
}

simpleheat.prototype = {

    defaultRadius: 25,

    defaultGradient: {
        0.4: 'blue',
        0.6: 'cyan',
        0.7: 'lime',
        0.8: 'yellow',
        1.0: 'red'
    },

    data: function data(_data) {
        this._data = _data;
        return this;
    },

    max: function max(_max) {
        this._max = _max;
        return this;
    },

    add: function add(point) {
        this._data.push(point);
        return this;
    },

    clear: function clear() {
        this._data = [];
        return this;
    },

    radius: function radius(r, blur) {
        blur = blur === undefined ? 15 : blur;

        // create a grayscale blurred circle image that we'll use for drawing points
        var circle = this._circle = this._createCanvas(),
            ctx = circle.getContext('2d'),
            r2 = this._r = r + blur;

        circle.width = circle.height = r2 * 2;

        ctx.shadowOffsetX = ctx.shadowOffsetY = r2 * 2;
        ctx.shadowBlur = blur;
        ctx.shadowColor = 'black';

        ctx.beginPath();
        ctx.arc(-r2, -r2, r, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();

        return this;
    },

    resize: function resize() {
        this._width = this._canvas.width;
        this._height = this._canvas.height;
    },

    gradient: function gradient(grad) {
        // create a 256x1 gradient that we'll use to turn a grayscale heatmap into a colored one
        var canvas = this._createCanvas(),
            ctx = canvas.getContext('2d'),
            gradient = ctx.createLinearGradient(0, 0, 0, 256);

        canvas.width = 1;
        canvas.height = 256;

        for (var i in grad) {
            gradient.addColorStop(+i, grad[i]);
        }

        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 1, 256);

        this._grad = ctx.getImageData(0, 0, 1, 256).data;

        return this;
    },

    draw: function draw(minOpacity) {
        if (!this._circle) this.radius(this.defaultRadius);
        if (!this._grad) this.gradient(this.defaultGradient);

        var ctx = this._ctx;

        ctx.clearRect(0, 0, this._width, this._height);
        // console.log('Drawing with data: ' + this._data.length)
        // draw a grayscale heatmap by putting a blurred circle at each data point
        for (var i = 0, len = this._data.length, p; i < len; i++) {
            p = this._data[i];
            // console.log('Drawing with data: ' + p[0] + p[1])

            ctx.globalAlpha = Math.min(Math.max(p[2] / this._max, minOpacity === undefined ? 0.05 : minOpacity), 1);
            ctx.drawImage(this._circle, p[0] - this._r, p[1] - this._r);
        }

        // colorize the heatmap, using opacity value of each pixel to get the right color from our gradient
        var colored = ctx.getImageData(0, 0, this._width, this._height);
        this._colorize(colored.data, this._grad);
        ctx.putImageData(colored, 0, 0);

        return this;
    },

    _colorize: function _colorize(pixels, gradient) {
        for (var i = 0, len = pixels.length, j; i < len; i += 4) {
            j = pixels[i + 3] * 4; // get gradient color from opacity value

            if (j) {
                pixels[i] = gradient[j];
                pixels[i + 1] = gradient[j + 1];
                pixels[i + 2] = gradient[j + 2];
            }
        }
    },

    _createCanvas: function _createCanvas() {
        if (typeof document !== 'undefined') {
            return document.createElement('canvas');
        } else {
            // create a new canvas instance in node.js
            // the canvas class needs to have a default constructor without any parameter
            return new this._canvas.constructor();
        }
    }
};

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(536)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(659),
  /* scopeId */
  "data-v-b9b17a50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(482)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(600),
  /* scopeId */
  "data-v-26efec78",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(478)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(596),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(525)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  "data-v-944c4aea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXPAND_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SWITCH_EFFECT; });
var TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = 'SWITCH_EFFECT';

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(462)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(578),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(495)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(614),
  /* scopeId */
  "data-v-47a2aaac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


if (true) module.exports = simpleshot;

function simpleshot(canvas) {
    if (!(this instanceof simpleshot)) return new simpleshot(canvas);
    this._canvas = canvas = typeof canvas === 'string' ? document.getElementById(canvas) : canvas;
    // console.log(this._canvas)
    this._ctx = canvas.getContext('2d');
    this._width = canvas.width;
    this._height = canvas.height;

    this._max = 1;
    this._data = [];
}

simpleshot.prototype = {

    defaultRadius: 5,

    data: function data(_data) {
        this._data = _data;
        return this;
    },

    max: function max(_max) {
        this._max = _max;
        return this;
    },

    resize: function resize() {
        this._width = this._canvas.width;
        this._height = this._canvas.height;
    },
    drawCircle: function drawCircle(ctx, posX, posY) {
        var radius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var color = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'black';

        ctx.shadowOffsetX = ctx.shadowOffsetY = .8;
        ctx.shadowBlur = 4;
        ctx.shadowColor = 'rgb(0, 0, 0)';
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.arc(posX, posY, radius, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return this;
    },

    render: function render() {

        var ctx = this._ctx;

        ctx.clearRect(0, 0, this._width, this._height);
        // Draw background
        ctx.beginPath();
        ctx.rect(0, 0, this._width, this._height);
        ctx.fillStyle = 'rgba(254, 254, 254, 0.02)';
        ctx.fill();
        for (var i = 0, len = this._data.length, p; i < len; i++) {
            p = this._data[i];

            this.drawCircle(ctx, p[0], p[1], p[3], p[4]);
        }
        var map = ctx.getImageData(0, 0, this._width, this._height);
        ctx.putImageData(map, 0, 0);

        return this;
    },

    _createCanvas: function _createCanvas() {
        if (typeof document !== 'undefined') {
            return document.createElement('canvas');
        } else {
            // create a new canvas instance in node.js
            // the canvas class needs to have a default constructor without any parameter
            return new this._canvas.constructor();
        }
    }
};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(481)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(599),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(665),
  /* scopeId */
  "data-v-e841d6c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(474)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(592),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(501)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(621),
  /* scopeId */
  "data-v-536df366",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(494)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(613),
  /* scopeId */
  "data-v-4333d959",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(457)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(573),
  /* scopeId */
  "data-v-031338be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(497)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(616),
  /* scopeId */
  "data-v-4ff5010d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(532)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  "data-v-b07c187c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fixtures__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lazyLoading__ = __webpack_require__(47);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/*
import charts from './charts'
import uifeatures from './uifeatures'
import components from './components'
import tables from './tables'
*/

// import season from './season'

// show: meta.label -> name
// name: component name
// meta.label: display label

var state = {
  items: [
  // {
  //   name: 'League Player Stats',
  //   path: '/stats/player-equiv',
  //   meta: {
  //     auth: true,
  //     icon: 'fa-line-chart',
  //     link: 'stats/player-equivalency.vue'
  //   },
  //   component: lazyLoading('stats/player-equivalency')
  // },
  {
    name: 'Season Stats',
    path: '/season-stats/season-stats-22',
    meta: {
      auth: true,
      icon: 'fa-line-chart',
      link: 'stats/season-stats/season-stats-22.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lazyLoading__["a" /* default */])('stats/season-stats/season-stats-22')
  }, {
    name: 'OLD Season Stats',
    path: '/season-stats/overview',
    meta: {
      auth: true,
      icon: 'fa-line-chart',
      link: 'stats/season-stats/overview.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lazyLoading__["a" /* default */])('stats/season-stats/overview')
  }, __WEBPACK_IMPORTED_MODULE_1__fixtures__["a" /* default */], {
    name: 'Teams',
    path: '/teams/',
    meta: {
      auth: true,
      icon: 'fa-users',
      link: 'teams/teams.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lazyLoading__["a" /* default */])('teams/teams')
  }, {
    name: 'Player Manager',
    path: '/editors/team-editor',
    meta: {
      auth: true,
      icon: 'fa-users',
      link: 'editors/team-editor.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lazyLoading__["a" /* default */])('editors/team-editor')
  }]
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* EXPAND_MENU */], function (state, menuItem) {
  if (menuItem.index > -1) {
    if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
      state.items[menuItem.index].meta.expanded = menuItem.expanded;
    }
  } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
    menuItem.item.meta.expanded = menuItem.expanded;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(255)("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/logo.52252a5.svg";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(531)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  "data-v-aeead01a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(535)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(658),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(530)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(627),
  /* scopeId */
  "data-v-68d1053e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(479)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(597),
  /* scopeId */
  "data-v-1ef30e12",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(545)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(669),
  /* scopeId */
  "data-v-f07887c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(622),
  /* scopeId */
  "data-v-57dab07c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(534)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(657),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(459)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(575),
  /* scopeId */
  "data-v-055a8124",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(476)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(594),
  /* scopeId */
  "data-v-1bdf5dcf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(490)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(609),
  /* scopeId */
  "data-v-407b606b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(491)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(610),
  /* scopeId */
  "data-v-42871f6d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(496)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(615),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(631),
  /* scopeId */
  "data-v-6d9220f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(628),
  /* scopeId */
  "data-v-6a535e5e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  "data-v-7eff0bc0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(546)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(671),
  /* scopeId */
  "data-v-f996f6ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(544)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(668),
  /* scopeId */
  "data-v-ec898226",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(458)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(574),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(471)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(589),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  "data-v-76e32ad6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(623),
  /* scopeId */
  "data-v-59608882",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  "data-v-a3d17f50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(461)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(577),
  /* scopeId */
  "data-v-08c1b451",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(467)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(585),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(528)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  "data-v-acfacde0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  "data-v-7f8eb234",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(484)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(602),
  /* scopeId */
  "data-v-28c74e18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(456)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(572),
  /* scopeId */
  "data-v-02b89137",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(626),
  /* scopeId */
  "data-v-637166da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(529)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  "data-v-ad74f624",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(473)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(591),
  /* scopeId */
  "data-v-19fe5107",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(460)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(576),
  /* scopeId */
  "data-v-08210798",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(485)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(604),
  /* scopeId */
  "data-v-37652b21",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  "data-v-6e02b1c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  "data-v-7f27656c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(486)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(605),
  /* scopeId */
  "data-v-3849b3c5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(480)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(598),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(538)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(661),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(619),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(539)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(662),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(475)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(593),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  "data-v-7f158d56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(504)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(624),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(489)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(608),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(483)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(601),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(543)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(667),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(470)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(588),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(472)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(590),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(625),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  "data-v-aa1a2d56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(468)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(586),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(533)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(656),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(540)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(663),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(466)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(584),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(630),
  /* scopeId */
  "data-v-6d15bd2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  "data-v-7367fd77",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(583),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */,
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(283);


__WEBPACK_IMPORTED_MODULE_0__app__["a" /* app */].$mount('#app');

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


if (true) module.exports = simpleshot;

function simpleshot(canvas, w, h) {
    if (!(this instanceof simpleshot)) return new simpleshot(canvas, w, h);
    this._canvas = canvas = typeof canvas === 'string' ? document.getElementById(canvas) : canvas;
    this._ctx = this._canvas.getContext('2d');

    this._canvas.style.width = w + "px";
    this._canvas.style.height = h + "px";
    var scale = window.devicePixelRatio; // <--- Change to 1 on retina screens to see blurry canvas.
    this._canvas.width = w * scale;
    this._canvas.height = h * scale;
    this._width = this._canvas.width;
    this._height = this._canvas.height;
    this._ctx.clearRect(0, 0, this.width, this.height);
    // Normalize coordinate system to use css pixels.
    this._ctx.scale(scale, scale);

    this._max = 1;
    this._data = [];
}

simpleshot.prototype = {

    defaultRadius: 1,

    data: function data(_data) {
        this._data = _data;
        return this;
    },

    max: function max(_max) {
        this._max = _max;
        return this;
    },

    resize: function resize() {
        this._width = this._canvas.width;
        this._height = this._canvas.height;
    },
    drawCircle: function drawCircle(ctx, posX, posY) {
        var radius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var color = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'black';

        ctx.shadowOffsetX = ctx.shadowOffsetY = 0.8;
        ctx.shadowBlur = 4;
        ctx.shadowColor = 'rgb(0, 0, 0)';
        ctx.fillStyle = color;
        ctx.beginPath();
        // console.log(posY, posX)
        ctx.arc(posY, posX, radius, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return this;
    },

    render: function render() {

        var ctx = this._ctx;

        ctx.clearRect(0, 0, this._width, this._height);
        // Draw background
        ctx.beginPath();
        ctx.rect(0, 0, this._width, this._height);
        ctx.fillStyle = 'rgba(254, 254, 254, 0.02)';
        ctx.fill();
        for (var i = 0, len = this._data.length, p; i < len; i++) {
            p = this._data[i];
            // console.log('Draw Cicle: ' + p[0] + ' ' + p[1])
            this.drawCircle(ctx, p[0], p[1], p[3], p[4]);
        }
        // console.log('Render w' + this._width)
        var map = ctx.getImageData(0, 0, this._width, this._height);
        ctx.putImageData(map, 0, 0);

        return this;
    },

    _createCanvas: function _createCanvas() {
        if (typeof document !== 'undefined') {
            return document.createElement('canvas');
        } else {
            // create a new canvas instance in node.js
            // the canvas class needs to have a default constructor without any parameter
            return new this._canvas.constructor();
        }
    }
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Apps/app-builds.vue": [
		188
	],
	"./EditTable/box-score.vue": [
		31
	],
	"./EditTable/edit-item.vue": [
		189
	],
	"./EditTable/edit-roster.vue": [
		190
	],
	"./EditTable/edit-table.vue": [
		191
	],
	"./EditTable/new-item.vue": [
		192
	],
	"./Fixtures/2018_2019_editor.vue": [
		193
	],
	"./Fixtures/game-night-live.vue": [
		194
	],
	"./Fixtures/season-fixtures.vue": [
		684,
		24
	],
	"./Fixtures/tbl.vue": [
		685,
		23
	],
	"./Home.vue": [
		195
	],
	"./auth/Login.vue": [
		196
	],
	"./axios/index.vue": [
		686,
		22
	],
	"./dashboard/index.vue": [
		687,
		21
	],
	"./editors/edit-goal-dialog.vue": [
		197
	],
	"./editors/edit-player-dialog.vue": [
		198
	],
	"./editors/faceoff-edit.vue": [
		199
	],
	"./editors/faceoff-editor.vue": [
		688,
		20
	],
	"./editors/fixture-editor.vue": [
		689,
		29
	],
	"./editors/game-editor.vue": [
		200
	],
	"./editors/goal-edit.vue": [
		201
	],
	"./editors/goal-editor.vue": [
		690,
		19
	],
	"./editors/hit-edit.vue": [
		202
	],
	"./editors/hit-editor.vue": [
		691,
		18
	],
	"./editors/new-player-dialog.vue": [
		203
	],
	"./editors/oddman-edit.vue": [
		204
	],
	"./editors/oddman-editor.vue": [
		692,
		17
	],
	"./editors/player-add.vue": [
		205
	],
	"./editors/player-edit.vue": [
		32
	],
	"./editors/player-editor.vue": [
		206
	],
	"./editors/team-editor.vue": [
		693,
		16
	],
	"./editors/time-on-ice-edit.vue": [
		207
	],
	"./editors/time-on-ice-editor.vue": [
		694,
		15
	],
	"./editors/turnover-edit.vue": [
		208
	],
	"./editors/turnover-editor.vue": [
		695,
		14
	],
	"./season-totals/game-checklist-19.vue": [
		696,
		13
	],
	"./season-totals/game-checklist.vue": [
		697,
		12
	],
	"./season-totals/team-select.vue": [
		698,
		11
	],
	"./season-totals/team-stats.vue": [
		209
	],
	"./season-totals/team-totals.vue": [
		699,
		10
	],
	"./stats/GB-TOI.vue": [
		210
	],
	"./stats/apex-realtime.vue": [
		211
	],
	"./stats/data-table.vue": [
		6
	],
	"./stats/embedded-data-graph.vue": [
		33
	],
	"./stats/faceoff-team-vs.vue": [
		25
	],
	"./stats/gamesheet-dynamic.vue": [
		212
	],
	"./stats/gamesheet.vue": [
		34
	],
	"./stats/match-faceoffs.vue": [
		35
	],
	"./stats/match-hits.vue": [
		213
	],
	"./stats/match-shots.vue": [
		214
	],
	"./stats/match-stats-22.vue": [
		215
	],
	"./stats/match-stats-opposition.vue": [
		216
	],
	"./stats/match-stats-short.vue": [
		217
	],
	"./stats/match-stats-test.vue": [
		218
	],
	"./stats/match-stats.vue": [
		219
	],
	"./stats/match-summary.vue": [
		36
	],
	"./stats/match-turnovers.vue": [
		220
	],
	"./stats/match-verifier.vue": [
		221
	],
	"./stats/match-zone-entries.vue": [
		222
	],
	"./stats/official-verifier.vue": [
		223
	],
	"./stats/player-equivalency.vue": [
		224
	],
	"./stats/playerCard.vue": [
		225
	],
	"./stats/playerTable.vue": [
		37
	],
	"./stats/rtable.vue": [
		26
	],
	"./stats/sandbox.vue": [
		226
	],
	"./stats/season-stats.vue": [
		700,
		28
	],
	"./stats/season-stats/Gamesheet2021.vue": [
		227
	],
	"./stats/season-stats/eihl_penalties.vue": [
		228
	],
	"./stats/season-stats/eihl_player_shotmap.vue": [
		681,
		9
	],
	"./stats/season-stats/eihl_player_shotmaps.vue": [
		701,
		3
	],
	"./stats/season-stats/eihl_shotmap.vue": [
		229
	],
	"./stats/season-stats/eihl_team_shotmap.vue": [
		682,
		8
	],
	"./stats/season-stats/eihl_team_shotmaps.vue": [
		702,
		2
	],
	"./stats/season-stats/faceoffs-pvp.vue": [
		19
	],
	"./stats/season-stats/faceoffs.vue": [
		230
	],
	"./stats/season-stats/hits.vue": [
		231
	],
	"./stats/season-stats/overview.vue": [
		232
	],
	"./stats/season-stats/penalty-minutes.vue": [
		233
	],
	"./stats/season-stats/per-sixty.vue": [
		234
	],
	"./stats/season-stats/player-report.vue": [
		235
	],
	"./stats/season-stats/player-season-stats.vue": [
		236
	],
	"./stats/season-stats/plus-minus.vue": [
		237
	],
	"./stats/season-stats/points.vue": [
		238
	],
	"./stats/season-stats/raw-data.vue": [
		239
	],
	"./stats/season-stats/season-stats-22.vue": [
		703,
		1
	],
	"./stats/season-stats/shot-differentials.vue": [
		240
	],
	"./stats/season-stats/shots.vue": [
		241
	],
	"./stats/season-stats/team-season-summary.vue": [
		683,
		7
	],
	"./stats/season-stats/time-on-ice.vue": [
		242
	],
	"./stats/season-stats/turnovers.vue": [
		243
	],
	"./stats/season-stats/vs_team.vue": [
		244
	],
	"./stats/season-stats/vs_team_summary.vue": [
		704,
		27
	],
	"./stats/season-stats/zone-entries.vue": [
		245
	],
	"./stats/season-stats/zone-starts.vue": [
		246
	],
	"./stats/season-totals-menu.vue": [
		7
	],
	"./stats/shot-diff-time.vue": [
		21
	],
	"./stats/shots-heatmap-single.vue": [
		247
	],
	"./stats/shots-heatmap-team.vue": [
		38
	],
	"./stats/shots-heatmap.vue": [
		20
	],
	"./stats/shots-quality.vue": [
		22
	],
	"./stats/sort-table.vue": [
		8
	],
	"./stats/sub-table.vue": [
		4
	],
	"./stats/zone-entries-game.vue": [
		248
	],
	"./tables/Basic.vue": [
		705,
		25
	],
	"./teams/players.vue": [
		249
	],
	"./teams/teams.vue": [
		706,
		6
	],
	"./ui/Buttons.vue": [
		707,
		5
	],
	"./ui/Form.vue": [
		708,
		4
	],
	"./ui/Icons.vue": [
		709,
		0
	],
	"./ui/Typography.vue": [
		710,
		26
	],
	"./ui/background_slider.vue": [
		250
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 255;

/***/ }),
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_nprogress__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_vue__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_store_mutation_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_scrollto__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_apexcharts__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_apexcharts__);
/* unused harmony reexport router */
/* unused harmony reexport store */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// import VueAuth from '@websanova/vue-auth'










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = 'https://devilsauth.roblutken.com/api/';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('apexchart', __WEBPACK_IMPORTED_MODULE_11_vue_apexcharts___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(260), {
  auth: __webpack_require__(256),
  http: __webpack_require__(257),
  router: __webpack_require__(258),
  rolesVar: 'type'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_scrollto___default.a);

// Enable devtools
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */]);

var nprogress = new __WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default.a({ parent: '.nprogress-container' });

var state = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state;


__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].beforeEach(function (route, redirect, next) {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_9_vuex_store_mutation_types__["a" /* TOGGLE_SIDEBAR */], false);
  }
  next();
});

Object.keys(__WEBPACK_IMPORTED_MODULE_8__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_8__filters__[key]);
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](_extends({
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  nprogress: nprogress
}, __WEBPACK_IMPORTED_MODULE_5__App_vue___default.a));



/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__AppMain___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FooterBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__FooterBar___default.a; });









/***/ }),
/* 285 */
/***/ (function(module, exports) {



/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__ = __webpack_require__(46);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    name: 'Home',
    path: '/',
    component: __webpack_require__(195),
    meta: { auth: true }
  }, {
    name: 'Login',
    path: '/login',
    component: __webpack_require__(196)
  }].concat(_toConsumableArray(generateRoutesFromMenu(__WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__["a" /* default */].state.items)), [{
    path: '*',
    redirect: '/'
  }, {
    path: '/goal-edit/:id',
    component: __webpack_require__(201)
  }, {
    path: '/faceoff-edit/:id',
    component: __webpack_require__(199)
  }, {
    path: '/player-edit/:id',
    component: __webpack_require__(32)
  }, {
    path: '/oddman-edit/:id',
    component: __webpack_require__(204)
  }, {
    path: '/hit-edit/:id',
    component: __webpack_require__(202)
  }, {
    path: '/turnover-edit/:id',
    component: __webpack_require__(208)
  }, {
    path: '/time-on-ice-edit/:id',
    component: __webpack_require__(207)
  }, {
    path: '/editors/season-totals/team-stats/:teamId',
    component: __webpack_require__(209)
  }, {
    path: '/game-editor/:gameId/:view',
    component: __webpack_require__(200)
  }, {
    path: '/teams/players/:teamId',
    component: __webpack_require__(249)
  }, {
    path: '/editors/player-editor/:teamId',
    component: __webpack_require__(206)
  }, {
    path: '/editors/player-edit/:teamId/:playerId',
    component: __webpack_require__(32)
  }, {
    path: '/editors/player-add/:teamId/',
    component: __webpack_require__(205)
  }, {
    path: '/Fixtures/game-night-live',
    component: __webpack_require__(194)
  }, {
    path: '/stats/match-stats/:gameId/:period',
    component: __webpack_require__(219),
    meta: { auth: true }
  }, {
    path: '/stats/match-stats-short/:gameId/:period',
    component: __webpack_require__(217),
    meta: { auth: true }
  }, {
    path: '/stats/match-stats-opposition/:gameId/:period',
    component: __webpack_require__(216),
    meta: { auth: true }
  }, {
    path: '/stats/match-stats-test/:gameId/:period',
    component: __webpack_require__(218),
    meta: { auth: true }
  }, {
    path: '/Fixtures/Season/18_19',
    component: __webpack_require__(193),
    meta: { auth: true }
  }, {
    path: '/stats/match-verifier/:gameId/',
    component: __webpack_require__(221),
    meta: { auth: true }
  }, {
    path: '/stats/player-equiv',
    component: __webpack_require__(224),
    meta: { auth: true }
  }, {
    path: '/sandbox',
    component: __webpack_require__(226)
  }, {
    path: '/apps',
    component: __webpack_require__(188)
  }, {
    path: '/season-stats/hits',
    component: __webpack_require__(231),
    meta: { auth: true }
  }, {
    path: '/season-stats/turnovers',
    component: __webpack_require__(243),
    meta: { auth: true }
  }, {
    path: '/season-stats/shots',
    component: __webpack_require__(241),
    meta: { auth: true }
  }, {
    path: '/season-stats/faceoffs',
    component: __webpack_require__(230),
    meta: { auth: true }
  }, {
    path: '/season-stats/points',
    component: __webpack_require__(238),
    meta: { auth: true }
  }, {
    path: '/season-stats/overview',
    component: __webpack_require__(232),
    meta: { auth: true }
  }, {
    path: '/season-stats/time-on-ice',
    component: __webpack_require__(242),
    meta: { auth: true }
  }, {
    path: '/season-stats/shot-differentials',
    component: __webpack_require__(240),
    meta: { auth: true }
  }, {
    path: '/season-stats/zone-entries',
    component: __webpack_require__(245),
    meta: { auth: true }
  }, {
    path: '/season-stats/zone-starts',
    component: __webpack_require__(246),
    meta: { auth: true }
  }, {
    path: '/season-stats/plus-minus',
    component: __webpack_require__(237),
    meta: { auth: true }
  }, {
    path: '/season-stats/penalty-minutes',
    component: __webpack_require__(233),
    meta: { auth: true }
  }, {
    path: '/season-stats/raw-data',
    component: __webpack_require__(239),
    meta: { auth: true }
  }, {
    path: '/stats/match-verifier-official/:gameId',
    component: __webpack_require__(223),
    meta: { auth: true }
  }, {
    path: '/season-stats/per-sixty',
    component: __webpack_require__(234),
    meta: { auth: true }
  }, {
    path: '/season-stats/player-stats/:player_id',
    component: __webpack_require__(236),
    meta: { auth: true }
  }, {
    path: '/season-stats/vs-team',
    component: __webpack_require__(244),
    meta: { auth: true }
  }, {
    path: '/stats/match-stats-22/:gameId/:period',
    component: __webpack_require__(215),
    meta: { auth: true }
  }, {
    path: '/stats/gb-toi/:gameId/:period',
    component: __webpack_require__(210),
    meta: { auth: true }
  }])
}));

// Menu should have 2 levels.
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebar", function() { return toggleSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleDevice", function() { return toggleDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandMenu", function() { return expandMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchEffect", function() { return switchEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(24);


var toggleSidebar = function toggleSidebar(_ref, config) {
  var commit = _ref.commit;

  if (config instanceof Object) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], config);
  }
};

var toggleDevice = function toggleDevice(_ref2, device) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], device);
};

var expandMenu = function expandMenu(_ref3, menuItem) {
  var commit = _ref3.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* EXPAND_MENU */], menuItem);
  }
};

var switchEffect = function switchEffect(_ref4, effectItem) {
  var commit = _ref4.commit;

  if (effectItem) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], effectItem);
  }
};

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pkg", function() { return pkg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "device", function() { return device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebar", function() { return sidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effect", function() { return effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuitems", function() { return menuitems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componententry", function() { return componententry; });
var pkg = function pkg(state) {
  return state.pkg;
};
var app = function app(state) {
  return state.app;
};
var device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var effect = function effect(state) {
  return state.app.effect;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};
var componententry = function componententry(state) {
  return state.menu.items.filter(function (c) {
    return c.meta && c.meta.label === 'Components';
  })[0];
};



/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_app__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_menu__ = __webpack_require__(46);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_5__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_6__modules_menu__["a" /* default */]
  },
  state: {
    pkg: __WEBPACK_IMPORTED_MODULE_2_package___default.a
  },
  mutations: {}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(24);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], function (state, device) {
  state.device.isMobile = device === 'mobile';
  state.device.isTablet = device === 'tablet';
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], function (state, config) {
  if (state.device.isMobile && config.hasOwnProperty('opened')) {
    state.sidebar.opened = config.opened;
  } else {
    state.sidebar.opened = true;
  }

  if (config.hasOwnProperty('hidden')) {
    state.sidebar.hidden = config.hidden;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], function (state, effectItem) {
  for (var name in effectItem) {
    state.effect[name] = effectItem[name];
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(47);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Fixtures',
  role: 'user',
  meta: {
    icon: 'fa-calendar',
    expanded: false,
    auth: { roles: 'user' }
  },

  children: [{
    name: 'Games',
    path: '/Fixtures/season-fixtures',
    role: 'user',
    meta: {
      label: 'Games',
      link: 'Fixtures/season-fixtures.vue',
      auth: true
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('Fixtures/season-fixtures')
  }, {
    name: 'Season Editor',
    path: '/Fixtures/2018_2019_editor',
    role: 'user',
    meta: {
      auth: { roles: ['user', 'admin'], redirect: '/Fixtures/Season/18_19' },
      label: 'Fixture Editor',
      link: 'Fixtures/2018_2019_editor.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('Fixtures/2018_2019_editor')
  }, {
    name: 'Season',
    path: '/Fixtures/tbl',
    role: 'admin',
    meta: {
      label: 'Season Stats',
      link: 'Fixtures/tbl.vue',
      auth: { roles: 'admin' }
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('Fixtures/tbl')
  }, {
    name: 'Game Data Checklist',
    path: '/season-totals/game-checklist',
    role: 'admin',
    meta: {
      label: 'Game Data Checklist',
      link: 'season-totals/game-checklist.vue',
      auth: { roles: 'admin' }
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('season-totals/game-checklist')
  }, {
    name: 'Game Data Checklist',
    path: '/season-totals/game-checklist-19',
    role: 'user',
    meta: {
      label: 'Game Data Checklist',
      link: 'season-totals/game-checklist-19.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('season-totals/game-checklist-19')
  }]
});

/***/ }),
/* 292 */,
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layout___ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["a" /* Navbar */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["b" /* Sidebar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_1_components_layout___["c" /* AppMain */],
    FooterBar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["d" /* FooterBar */],
    NprogressContainer: __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default.a
  },

  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 3;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar({
          opened: !isMobile
        });
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    sidebar: 'sidebar'
  }),

  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['toggleDevice', 'toggleSidebar'])
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Levelbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    sidebar: 'sidebar'
  }), {
    hiddenSidebarStyle: function hiddenSidebarStyle() {
      return this.sidebar.hidden ? { 'margin-left': 0 } : null;
    }
  }),

  components: {
    Levelbar: __WEBPACK_IMPORTED_MODULE_0__Levelbar___default.a
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return this.$store.state.pkg;
  },

  methods: {
    reload: function reload() {
      this.$router.go(this.$router.currentRoute);
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default.a,
    Tooltip: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__["a" /* default */]
  },

  data: function data() {
    return {
      list: null
    };
  },
  created: function created() {
    this.getList();
  },


  computed: {
    codelink: function codelink() {
      if (this.$route.meta && this.$route.meta.link) {
        return 'https://github.com/vue-bulma/vue-admin/blob/master/client/views/' + this.$route.meta.link;
      } else {
        return null;
      }
    },
    name: function name() {
      return this.$route.name;
    }
  },

  methods: {
    getList: function getList() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched);
      }
      this.list = matched;
    }
  },

  watch: {
    $route: function $route() {
      this.getList();
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  components: {
    Tooltip: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__["a" /* default */]
  },

  props: {
    show: Boolean
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    pkginfo: 'pkg',
    sidebar: 'sidebar'
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['toggleSidebar']), {
    logout: function logout() {
      this.$auth.logout({
        redirect: 'login',
        makeRequest: false
        // params: {},
        // success: function () {},
        // error: function () {},
        // etc...
      });
    }
  })
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default.a
  },

  props: {
    show: Boolean
  },

  data: function data() {
    return {
      isReady: false
    };
  },
  mounted: function mounted() {
    var route = this.$route;
    if (route.name) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    menu: 'menuitems'
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['expandMenu']), {
    isExpanded: function isExpanded(item) {
      return item.meta.expanded;
    },
    toggle: function toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      });
    },
    shouldExpandMatchItem: function shouldExpandMatchItem(route) {
      var matched = route.matched;
      var lastMatched = matched[matched.length - 1];
      var parent = lastMatched.parent || lastMatched;
      var isParent = parent === lastMatched;

      if (isParent) {
        var p = this.findParentFromMenu(route);
        if (p) {
          parent = p;
        }
      }

      if ('expanded' in parent.meta && !isParent) {
        this.expandMenu({
          item: parent,
          expanded: true
        });
      }
    },
    generatePath: function generatePath(item, subItem) {
      return '' + (item.component ? item.path + '/' : '') + subItem.path;
    },
    findParentFromMenu: function findParentFromMenu(route) {
      var menu = this.menu;
      for (var i = 0, l = menu.length; i < l; i++) {
        var item = menu[i];
        var k = item.children && item.children.length;
        if (k) {
          for (var j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item;
            }
          }
        }
      }
    }
  }),

  watch: {
    $route: function $route(route) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  }

});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppBuilds',
  data: function data() {
    return {
      urls: []
    };
  },

  methods: {
    fetchGamesheet: function fetchGamesheet() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/apps', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this.urls = response.data;
      }, function (response) {});
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['gameId'],
  data: function data() {
    return {
      Fixture: []
    };
  },

  methods: {
    fetchFixtures: function fetchFixtures() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games/get/single/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log('Data is ' + response.data);
        _this.Fixture = response.data[0];
        console.log(JSON.stringify(_this.Fixture));
      }, function (response) {});
    }
  },
  mounted: function mounted() {
    this.fetchFixtures();
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['type', 'open'],
  data: function data() {
    return {};
  },

  methods: {
    submit: function submit() {
      this.$emit('submit');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  },
  created: function created() {}
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a
  },
  props: ['game_id', 'team_id', 'team_name', 'team_logo'],
  data: function data() {
    return {
      Players: [],
      Team: [],
      cardModal: null,
      newModal: null,
      playerOptions: [],
      Roster: []
    };
  },

  computed: {
    sortByNumber: function sortByNumber() {
      return this.Players.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    }
  },
  methods: {
    fetchRoster: function fetchRoster() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games-played/get/' + this.game_id + '/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Roster = response.data;
        // console.log('Roster is: ' + JSON.stringify(this.Roster))
      }, function (response) {});
    },
    fetchPlayers: function fetchPlayers() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/players/get/teams/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this2.Players = response.data;
        // console.log(this.Players)
        // this.playerOptions.push({text: '-', value: -1})
        _this2.playerOptions.push({ text: 'Forwards', value: -2 });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this2.sortByNumber[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var i = _step.value;

            if (i.position === 'LW' || i.position === 'C' || i.position === 'RW') {
              _this2.playerOptions.push({ text: '#' + i.number + ' ' + i.surname, value: i.id });
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this2.playerOptions.push({ text: 'Defense', value: -2 });
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _this2.sortByNumber[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var d = _step2.value;

            if (d.position === 'LD' || d.position === 'RD') {
              _this2.playerOptions.push({ text: '#' + d.number + ' ' + d.surname, value: d.id });
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this2.playerOptions.push({ text: 'Goaltender', value: -2 });
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = _this2.sortByNumber[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var g = _step3.value;

            if (g.position === 'GT' || g.position === 'BKGT') {
              _this2.playerOptions.push({ text: '#' + g.number + ' ' + g.surname, value: g.id });
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }, function (response) {});
    },
    updateRoster: function updateRoster(_item, _newPlayer) {
      if (_item.player_id[0].id !== _newPlayer) {
        // console.log('Updated: ' + _item.player_id[0].id + ' TO player: ' + JSON.stringify(_newPlayer))
        /*eslint-disable */
        // eslint-disable-line no-use-before-define
        var formData = new FormData(); // eslint-disable-line no-use-before-define
        formData.append('game_id', this.game_id);
        formData.append('team_id', this.team_id);
        formData.append('id', _item.id);
        formData.append('line_number', _item.line_number);
        formData.append('position', _item.position);
        formData.append('player_id', _newPlayer);

        this.$http.post('https://devilsapi.roblutken.com/api/games-played/update/', formData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'multipart/form-data' } }).then(function (response) {
          console.log(response.data);
          if (response.data.status === '202') {
            // openNotification({
            //   title: 'Update Success',
            //   message: response.data.message,
            //   type: 'success',
            //   duration: 400
            // })
            // this.$router.push('/editors/player-editor/' + this.$route.params.teamId)
          } else {
            openNotification({
              title: 'Failed to update',
              message: response.data.message,
              type: 'danger',
              duration: 400
            });
            _newPlayer = '';
            // _item = ''
          }
        }, function (response) {});
        this.fetchRoster();
        /*eslint-enable*/
      }
    },
    clearRoster: function clearRoster() {
      var _this3 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games-played/clear/' + this.game_id + '/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Roster is: ' + JSON.stringify(this.Roster))
      }, function (response) {
        openNotification({
          title: 'Update Success',
          message: response.data.message,
          type: 'success',
          duration: 400
        });
        _this3.fetchPlayers();
        _this3.fetchRoster();
      });
    },
    validateRoster: function validateRoster() {
      var _this4 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games-played/validate/' + this.game_id + '/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Roster is: ' + JSON.stringify(this.Roster))
      }, function (response) {
        openNotification({
          title: 'Update Success',
          message: response.data.message,
          type: 'success',
          duration: 400
        });
        _this4.fetchPlayers();
        _this4.fetchRoster();
      });
    },
    invalidateRoster: function invalidateRoster() {
      var _this5 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games-played/invalidate/' + this.game_id + '/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Roster is: ' + JSON.stringify(this.Roster))
      }, function (response) {
        openNotification({
          title: 'Update Success',
          message: response.data.message,
          type: 'success',
          duration: 400
        });
        _this5.fetchPlayers();
        _this5.fetchRoster();
      });
    },
    generateRoster: function generateRoster() {
      var _this6 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games-played/clone/' + this.game_id + '/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Roster is: ' + JSON.stringify(this.Roster))
      }, function (response) {
        openNotification({
          title: 'Update Success',
          message: response.data.message,
          type: 'success',
          duration: 400
        });
        _this6.fetchPlayers();
        _this6.fetchRoster();
      });
    },
    openNotificationWithType: function openNotificationWithType(type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      });
    }
  },
  created: function created() {
    // console.log('Edit roster Loaded with game id: ' + this.game_id)
    this.fetchPlayers();
    this.fetchRoster();
  },
  update: function update() {
    this.fetchPlayers();
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['heading', 'headers', 'tableData', 'total', 'openNew'],
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification___default.a
  },
  data: function data() {
    return {};
  },

  methods: {
    edit: function edit(data) {
      // console.log('EDIT: ' + JSON.stringify(data))
      this.$emit('edit', data);
    },
    validate: function validate(data) {
      console.log('Validate: ' + JSON.stringify(data));
      this.verifyRecord(data.id, data.is_verified);
    },
    del: function del(data) {
      console.log('Delete: ' + JSON.stringify(data));
      this.deleteRecord(data.id);
    },
    deleteRecord: function deleteRecord(recordId) {
      var _this = this;

      var url = 'https://devilsapi.roblutken.com/api/delete-record/' + recordId;
      this.$http.get(url, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        if (response.data.status === 202) {
          openNotification({
            title: 'Deleted Item',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
          _this.$emit('reload');
        } else {
          openNotification({
            title: 'Error Validating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
    },
    verifyRecord: function verifyRecord(recordId, isVerified) {
      var _this2 = this;

      console.log('Validate record: ' + recordId);
      var url = '';
      if (isVerified === 0) {
        url = 'https://devilsapi.roblutken.com/api/verify-record/' + recordId;
      } else {
        url = 'https://devilsapi.roblutken.com/api/invalidate-record/' + recordId;
      }
      this.$http.get(url, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        if (response.data.status === 202) {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
          _this2.$emit('reload');
        } else {
          openNotification({
            title: 'Error Validating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
    },
    emitNew: function emitNew() {
      this.$emit('new');
    },
    openNotificationWithType: function openNotificationWithType(type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      });
    }
  },
  mounted: function mounted() {
    // console.log('Edit Table Data is: ' + this.total)
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['type', 'open'],
  data: function data() {
    return {};
  },

  methods: {
    submit: function submit() {
      this.$emit('submit');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  },
  created: function created() {}
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_datepicker__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'f',
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_datepicker___default.a
  },
  data: function data() {
    return {
      Fixtures: [],
      Teams: [],
      teamOptions: [],
      competitionOptions: [{ text: 'EIHL', value: 'EIHL' }, { text: 'Challenge-Cup', value: 'Challenge-Cup' }, { text: 'EIHL Conference', value: 'EIHL Conference' }, { text: 'Playoffs', value: 'Playoffs' }, { text: 'Pre-season', value: 'Pre-Season' }],
      newFixture: {
        location: '',
        match_date: '',
        home_team: '',
        away_team: '',
        competition: '',
        eihl_id: '',
        is_stream: false
      }
    };
  },

  methods: {
    fetchTeams: function fetchTeams() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/teams/get', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this.Teams = response.data;
        console.log(JSON.stringify(_this.Teams));
        for (var i = 0; i < _this.Teams.length; i++) {
          console.log(_this.Teams[i].name + _this.Teams[i].id);
          _this.teamOptions.push({ text: _this.Teams[i].name, value: _this.Teams[i].id });
        }
      }, function (response) {});
    },
    fetchFixtures: function fetchFixtures() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games/get', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this2.Fixtures = response.data;
        _this2.selectedData = response.data;
        console.log(JSON.stringify(_this2.Fixtures));
      }, function (response) {});
    },
    createFixture: function createFixture() {
      var _this3 = this;

      console.log('New fixture is: ' + JSON.stringify(this.newFixture));
      /*eslint-disable */
      var stream = this.newFixture.is_stream;
      if (stream) stream = 1;else stream = 0;
      var formData = new FormData();
      formData.append('home_team', this.newFixture.home_team);
      formData.append('away_team', this.newFixture.away_team);
      formData.append('match_date', this.newFixture.match_date);
      formData.append('competition', this.newFixture.competition);
      formData.append('location', this.newFixture.location);
      formData.append('is_stream', stream);
      formData.append('eihl_id', this.newFixture.eihl_id);
      console.log('Form data is: ' + formData);
      this.$http.post('https://devilsapi.roblutken.com/api/games/add', formData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        if (response.data.status === '202') {
          openNotification({
            title: 'Game Created Ok',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
          _this3.$router.go('Fixtures/Season/2019_2020');
          // this.$router.push('/editors/player-editor/' + this.$route.params.teamId)
        } else {
          openNotification({
            title: 'Failed to create game',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      }, function (response) {});
    },
    editFixture: function editFixture(item) {
      this.newFixture.competition = item.competition;
      this.newFixture.match_date = item.match_date;
      this.newFixture.home_team = item.home_team;
      this.newFixture.away_team = item.away_team;
      this.newFixture.location = item.location;
      this.newFixture.eihl_id = item.eihl_id;
      console.log(JSON.stringify(item));
      window.scrollTo(0, 0);
    },
    deleteFixture: function deleteFixture(id) {
      var _this4 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games/delete/' + id, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
          _this4.$router.go('Fixtures/Season/2019_2020');
          // this.$router.push('/editors/player-editor/' + this.$route.params.teamId)
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      }, function (response) {});
    },
    openNotificationWithType: function openNotificationWithType(type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      });
    }
  },
  created: function created() {
    this.fetchFixtures();
    this.fetchTeams();
  },
  update: function update() {}
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      GameState: [],
      time: 0
    };
  },

  methods: {
    startGame: function startGame() {
      this.updateTime();
    },
    endGame: function endGame() {},

    updateTime: function updateTime() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/live/time', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.time = response.data;
        console.log(_this.time);
      }, function (response) {});
    }
  },
  created: function created() {
    this.$http.get('https://devilsapi.roblutken.com/api/live/start', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
      // this.time = response.data
      console.log('Start session');
    }, function (response) {});
  },
  update: function update() {},
  mounted: function mounted() {
    console.log('Mounted');
    // Run every 30 seconds
    setInterval(function () {
      console.log('Poll Update');
      this.updateTime();
    }.bind(this), 1200);
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_background_slider_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_background_slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_background_slider_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BackgroundSlider: __WEBPACK_IMPORTED_MODULE_0__ui_background_slider_vue___default.a
  },
  data: function data() {
    return this.$store.state.pkg;
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      data: {
        body: {
          email: null,
          password: null
        },
        rememberMe: false
      },
      error: null
    };
  },
  mounted: function mounted() {
    if (this.$auth.check()) {
      console.log('is loggedin');
      this.$router.push('dashboard');
    }
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
  },

  methods: {
    login: function login() {
      // var redirect = this.$auth.redirect()
      this.$auth.login({
        headers: {
          'Content-Type': 'application/json'
        },
        params: {
          email: this.data.body.email,
          password: this.data.body.password
        },
        rememberMe: true,
        redirect: '/',
        fetchUser: true,
        success: function success(res) {
          console.log('Auth Success');
          console.log('USR ARR: ' + JSON.stringify(this.$auth.user()));
          console.log('ROLE: ' + this.$auth.user().role);
          // console.log('Token: ' + this.$auth.token())
          // console.log(res)
        },
        error: function error(err) {
          if (err.response) {
            // The request was made, but the server responded with a status code
            // that falls out of the range of 2xx
            console.log(err.response.status);
            console.log(err.response.data);
            console.log(err.response.headers);
            this.error = err.response.data;
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', err.message);
          }
          console.log(err.config);
        }
      });
    }
  }
  // filters: {
  //   json: function (value) {
  //     console.log(value)
  //     return value
  //   }
  // }

});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      goalData: {
        'team_id': 0,
        'goal_scorer': 0,
        'first_assist': 0,
        'second_assist': 0,
        'game_id': 1,
        'period': 0,
        'situation': 0,
        'on_ice_1': 0,
        'on_ice_2': 0,
        'on_ice_3': 0,
        'on_ice_4': 0,
        'on_ice_5': 0,
        'on_ice_6': 0
      }
    };
  },

  methods: {
    launch: function launch() {
      this.isActive = true;
    },
    close: function close() {
      this.isActive = false;
    },
    save: function save() {
      var _this = this;

      console.log(this.formData);
      var post = new FormData(); // eslint-disable-line no-undef
      this.formData.team_id = this.$route.params.teamId;
      post.append('player', JSON.stringify(this.formData));
      this.$http.post('https://devilsapi.roblutken.com/api/players/update/' + this.$route.params.teamId + '/' + this.formData.id, post, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response);
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
          _this.$router.push('/editors/player-editor/' + _this.$route.params.teamId);
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message + response.data.status,
            type: 'danger',
            duration: 3400
          });
        }
        _this.close();
        console.log('dataUpdate');
        _this.$emit('dataUpdate', 'test');
      });
    },
    openNotificationWithType: function openNotificationWithType(type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      });
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      formData: {
        'team_id': 0,
        'forename': '',
        'surname': '',
        'number': 0,
        'position': '',
        'age': 0,
        'dob': 0,
        'height': 0,
        'weight': 0,
        'handedness': '',
        'birth_place': '',
        'nationality': '',
        'status': 'Active',
        'external_url': 'none'
      },
      nameMax: 28,
      descriptionMax: 500,
      currentName: 0,
      isActive: false,
      image_path: ''
    };
  },

  methods: {
    launch: function launch() {
      this.isActive = true;
    },
    close: function close() {
      this.isActive = false;
    },
    onImageChange: function onImageChange(_fileInput) {
      this.image_path = _fileInput.target.files[0];
    },

    save: function save() {
      var _this = this;

      console.log(this.formData);
      var post = new FormData(); // eslint-disable-line no-undef
      this.formData.team_id = this.$route.params.teamId;
      post.append('player', JSON.stringify(this.formData));
      this.$http.post('https://devilsapi.roblutken.com/api/players/update/' + this.$route.params.teamId + '/' + this.formData.id, post, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response);
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
          _this.$router.push('/editors/player-editor/' + _this.$route.params.teamId);
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message + response.data.status,
            type: 'danger',
            duration: 3400
          });
        }
        _this.close();
        console.log('dataUpdate');
        _this.$emit('dataUpdate', 'test');
      });
    },
    openNotificationWithType: function openNotificationWithType(type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      });
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default.a
  },

  data: function data() {
    return {
      resultSelect: 'WinWin',
      resultOption: [{ text: 'Win Win', value: 'WinWin' }, { text: 'Win Loss', value: 'WinLoss' }, { text: 'Loss Win', value: 'LossWin' }, { text: 'Loss Loss', value: 'LossLoss' }],
      zoneSelect: 'Offensive',
      zoneOption: [{ text: 'Offensive', value: 'Offensive' }, { text: 'Neutral', value: 'Neutral' }, { text: 'Neutral Offensive', value: 'Neutral Offensive' }, { text: 'Neutral Defensive', value: 'Neutral Defensive' }, { text: 'Defensive', value: 'Defensive' }],
      laneSelect: 'Left',
      laneOption: [{ text: 'Left', value: 'Left' }, { text: 'Center', value: 'Center' }, { text: 'Right', value: 'Right' }],
      periodSelect: 1,
      periodOption: [{ text: 1, value: 1 }, { text: 2, value: 2 }, { text: 3, value: 3 }, { text: '4 - Overtime', value: 4 }],
      Faceoff: []
    };
  },


  methods: {
    fetchFaceoff: function fetchFaceoff(id) {
      var _this = this;

      console.log('Get query');
      this.$http.get('https://devilsapi.roblutken.com/api/faceoffs/get/single/' + id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Faceoff = response.data;
        _this.resultSelect = _this.Faceoff.result;
        _this.zoneSelect = _this.Faceoff.zone;
        _this.laneSelect = _this.Faceoff.lane;
        _this.periodSelect = _this.Faceoff.period;
        console.log(response.data);
      }, function (response) {});
    },
    updateFaceoff: function updateFaceoff(e) {
      var _this2 = this;

      e.preventDefault();
      var updateFaceoff = {
        player_id: this.Faceoff.home_player.player_number,
        offensive_player_id: this.Faceoff.away_player.player_number,
        lane: this.Faceoff.lane,
        zone: this.Faceoff.zone,
        result: this.Faceoff.result,
        period: this.Faceoff.period,
        situation: this.Faceoff.situation.secondary_situation
      };

      console.log(updateFaceoff);
      console.log(this.$route.params.id);
      this.$http.put('https://devilsapi.roblutken.com/api/faceoffs/update/' + this.$route.params.id, updateFaceoff, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        _this2.$router.push('/editors/faceoffs/');
      }, function (response) {});
    },
    onRawValueChanged: function onRawValueChanged(newVal) {
      this.demo.rawValue = newVal;
    }
  },
  watch: {
    'demo.value': function demoValue(newVal, oldVal) {
      console.log('value: new ->', newVal, 'old ->', oldVal);
    },
    'demo.rawValue': function demoRawValue(newVal, oldVal) {
      console.log('rawValue: new ->', newVal, 'old ->', oldVal);
    }
  },
  created: function created() {
    this.fetchFaceoff(this.$route.params.id);
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tabs__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cleave_js_dist_addons_cleave_phone_cn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cleave_js_dist_addons_cleave_phone_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_cleave_js_dist_addons_cleave_phone_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var NotificationComponent = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification___default.a);

var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'f',
  components: {
    Tabs: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tabs__["a" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tabs__["b" /* TabPane */],
    Cleave: __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      Fixture: [],
      Goals: [],
      Shots: [],
      Faceoffs: [],
      Turnovers: [],
      Hits: [],
      Pims: [],
      NewPim: [{
        id: 0,
        taker: 0,
        drawer: 0,
        type: '',
        for: '',
        time: '',
        period: '',
        game_time: ''
      }],
      PlusMinus: [],
      TOI: [],
      gameId: 0,
      tabSelected: 'FixtureInfo',
      teamSelect: [],
      teamOptions: [],
      periodOptions: [{ text: 1, value: 1 }, { text: 2, value: 2 }, { text: 3, value: 3 }, { text: 'OT', value: 4 }, { text: 'PSO', value: 5 }],
      situationOptions: [],
      shotResultOptions: [{ text: 'On Net', value: 'on_net' }, { text: 'Missed Net', value: 'missed_net' }, { text: 'Blocked', value: 'blocked' }, { text: 'Goal', value: 'goal' }],
      faceoffResultOptions: [{ text: 'Win Win', value: 'WinWin' }, { text: 'Win Loss', value: 'WinLoss' }, { text: 'Loss Loss', value: 'LossLoss' }, { text: 'Loss Win', value: 'Loss Win' }],
      turnoverResultOptions: [{ text: 'Offensive', value: 'Offensive' }, { text: 'Neutral', value: 'Neutral' }, { text: 'Defensive', value: 'Defensive' }, { text: 'NaN', value: '' }],
      pimTypeOptions: [{ text: 'Minor', value: 'minor' }, { text: 'Major', value: 'major' }, { text: 'Misconduct', value: 'misconduct' }, { text: 'Match', value: 'match' }, { text: 'Game', value: 'Game' }, { text: 'NaN', value: '' }],
      pimForOptions: [{ text: 'Slashing', value: 'slashing' }, { text: 'Cross Checking', value: 'cross_checking' }, { text: 'Hit from Behind', value: 'hit_from_behind' }, { text: 'Check To the Head', value: 'check_to_the_head' }, { text: 'Hooking', value: 'hooking' }, { text: 'Fighting', value: 'fighting' }, { text: 'Roughing', value: 'roughing' }, { text: 'Tripping', value: 'tripping' }, { text: 'Boarding', value: 'boarding' }, { text: 'Interference', value: 'interference' }, { text: 'Abuse of Official', value: 'abuse_of_official' }, { text: 'Too Many Men', value: 'too_many_men' }, { text: 'Illegal Equipment', value: 'illegal_equipment' }, { text: 'Unsportsmanlike Conduct', value: 'unsportsmanlike' }, { text: 'High Stick', value: 'high_stick' }, { text: 'Holding Stick', value: 'holding_stick' }, { text: 'Third Man', value: 'third_man' }, { text: 'Elbowing', value: 'elbowing' }, { text: 'Kneeing', value: 'kneeing' }, { text: 'Spearing', value: 'spearing' }, { text: 'Hand Pass', value: 'hand_pass' }, { text: 'Butt Ending', value: 'butt_ending' }, { text: 'Charging', value: 'charging' }, { text: 'NaN', value: '' }]
    };
  },

  methods: {
    fetchFixtures: function fetchFixtures() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/game/get/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Fixture = response.data;
        _this.teamOptions.push({ text: _this.Fixture.home_team, value: _this.Fixture.home_team });
        _this.teamOptions.push({ text: _this.Fixture.away_team, value: _this.Fixture.away_team });
      }, function (response) {});
    },
    fetchSituations: function fetchSituations() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/get/situations', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this2.Situations = response.data;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this2.Situations.situations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var i = _step.value;

            _this2.situationOptions.push({ text: i.secondary_situation, value: i.secondary_situation });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }, function (response) {});
    },
    fetchGoals: function fetchGoals() {
      var _this3 = this;

      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId;
        this.$http.get('https://devilsapi.roblutken.com/api/goals/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          _this3.Goals = response.data;
        }, function (response) {});
      } else {
        this.$http.get('https://devilsapi.roblutken.com/api/goals/get', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          _this3.Goals = response.data;
        }, function (response) {});
      }
    },
    fetchShots: function fetchShots() {
      var _this4 = this;

      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId;
        this.$http.get('https://devilsapi.roblutken.com/api/shots/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          _this4.Shots = response.data;
        }, function (response) {});
      }
    },
    fetchFaceoffs: function fetchFaceoffs() {
      var _this5 = this;

      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId;
        this.$http.get('https://devilsapi.roblutken.com/api/faceoffs/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          _this5.Faceoffs = response.data;
        }, function (response) {});
      }
    },
    fetchTurnovers: function fetchTurnovers() {
      var _this6 = this;

      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId;
        this.$http.get('https://devilsapi.roblutken.com/api/turnovers/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          _this6.Turnovers = response.data;
        }, function (response) {});
      }
    },
    fetchHits: function fetchHits() {
      var _this7 = this;

      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId;
        this.$http.get('https://devilsapi.roblutken.com/api/hits/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          _this7.Hits = response.data;
        }, function (response) {});
      }
    },
    fetchPims: function fetchPims() {
      var _this8 = this;

      console.log('Get query pims' + this.$route.params.gameId);
      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId;
        this.$http.get('https://devilsapi.roblutken.com/api/pims/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          _this8.Pims = response.data;
          console.log(response.data);
        }, function (response) {});
      }
    },
    fetchPlusMinus: function fetchPlusMinus() {
      var _this9 = this;

      console.log('Get query plus minus' + this.$route.params.gameId);
      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId;
        this.$http.get('https://devilsapi.roblutken.com/api/plus-minus/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          _this9.PlusMinus = response.data;
          console.log(response.data);
        }, function (response) {});
      }
    },
    fetchTimeOnIce: function fetchTimeOnIce(id) {
      var _this10 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/players/home/get', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this10.Player = response.data;
        for (var i = 0; i < _this10.Player.length; i++) {
          _this10.TOI.push({
            player_id: _this10.Player[i].id,
            player_forename: _this10.Player[i].forename,
            player_surname: _this10.Player[i].surname,
            player_number: _this10.Player[i].player_number,
            played_in_game: 0,
            shots_for: 0,
            shots_against: 0,
            shifts: 0,
            avg_shift: '',
            total_time: '',
            time_5v5: '',
            time_4v4: '',
            time_PP: '',
            time_SH: ''
          });
        }
      }, function (response) {});
    },
    updateShotRow: function updateShotRow(shot) {
      // console.log('Shot Update + ' + JSON.stringify(shot))
      var updateShot = {
        team: shot.for_team.name,
        player_id: shot.home_player,
        game_time: shot.game_time,
        situation: shot.situation.secondary_situation,
        shot_type: shot.result,
        period: shot.period,
        shot_location: shot.location
      };
      console.log('Shot Update data: ' + JSON.stringify(updateShot));
      this.$http.put('https://devilsapi.roblutken.com/api/shots/update/' + shot.id, updateShot, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        // this.$router.push('/editors/goal/')
      }, function (response) {});
    },
    updateGoalRow: function updateGoalRow(goal) {
      console.log('Goal: ' + goal);
      var updateGoal = {
        player_id: goal.scorer.player_number,
        first_assist: goal.first_assist.player_number,
        second_assist: goal.second_assist.player_number,
        period: goal.period,
        situation: goal.situation.secondary_situation
      };

      console.log(updateGoal);
      console.log(goal.id);
      this.$http.put('https://devilsapi.roblutken.com/api/goals/update/' + goal.id, updateGoal, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        // this.$router.push('/editors/goal/')
      }, function (response) {});
    },
    updateFaceoff: function updateFaceoff(faceoff) {
      var updateFaceoff = {
        home_player: faceoff.home_player,
        away_player: faceoff.away_player,
        result: faceoff.result,
        lane: faceoff.lane,
        zone: faceoff.zone,
        period: faceoff.period,
        situation: faceoff.situation.secondary_situation,
        game_time: faceoff.game_time
      };
      console.log(JSON.stringify(updateFaceoff));
      this.$http.put('https://devilsapi.roblutken.com/api/faceoffs/update/' + faceoff.id, updateFaceoff, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      }, function (response) {});
    },
    updateTurnover: function updateTurnover(turnover) {
      var updateTurnover = {
        home_player: turnover.home_player,
        result: turnover.type,
        period: turnover.period,
        situation: turnover.situation.secondary_situation,
        game_time: turnover.game_time
      };
      console.log(JSON.stringify(updateTurnover));
      this.$http.put('https://devilsapi.roblutken.com/api/turnovers/update/' + turnover.id, updateTurnover, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      }, function (response) {});
    },
    updateHit: function updateHit(hit) {
      var updateHit = {
        home_player: hit.home_player,
        away_player: hit.away_player,
        period: hit.period,
        situation: hit.situation.secondary_situation,
        game_time: hit.game_time
      };
      console.log(JSON.stringify(updateHit));
      this.$http.put('https://devilsapi.roblutken.com/api/hits/update/' + hit.id, updateHit, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      }, function (response) {});
    },
    updatePIM: function updatePIM(pim) {
      var updatePim = {
        taker: pim.taker,
        drawer: pim.drawer,
        type: pim.type,
        for: pim.for,
        time: pim.time,
        period: pim.period,
        game_time: pim.game_time
      };
      console.log(JSON.stringify(updatePim));
      this.$http.put('https://devilsapi.roblutken.com/api/pims/update/' + pim.id, updatePim, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      }, function (response) {});
    },
    deleteGoal: function deleteGoal(goal) {
      this.$http.get('https://devilsapi.roblutken.com/api/goals/delete/' + goal.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
    },
    deleteShot: function deleteShot(shot) {
      this.$http.get('https://devilsapi.roblutken.com/api/shots/delete/' + shot.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
    },
    deleteFacoff: function deleteFacoff(faceoff) {
      this.$http.get('https://devilsapi.roblutken.com/api/faceoffs/delete/' + faceoff.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
    },
    deleteHit: function deleteHit(hit) {
      this.$http.get('https://devilsapi.roblutken.com/api/hits/delete/' + hit.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
    },
    deleteTurnover: function deleteTurnover(turnover) {
      this.$http.get('https://devilsapi.roblutken.com/api/turnover/delete/' + turnover.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
    },
    deletePIM: function deletePIM(PIM) {
      this.$http.get('https://devilsapi.roblutken.com/api/pims/delete/' + PIM.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
    },
    addPIM: function addPIM(PIM) {
      console.log('New pim' + JSON.stringify(PIM));
    },
    openNotificationWithType: function openNotificationWithType(type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      });
    }
  },
  created: function created() {
    this.fetchGoals();
    this.fetchFixtures();
    this.fetchShots();
    this.fetchSituations();
    this.fetchFaceoffs();
    this.fetchTurnovers();
    this.fetchHits();
    this.fetchPims();
    this.fetchTimeOnIce();
  },
  update: function update() {
    this.fetchGoals();
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default.a
  },

  data: function data() {
    return {

      Goal: []
    };
  },


  methods: {
    fetchGoal: function fetchGoal(id) {
      var _this = this;

      console.log('Get query');
      this.$http.get('https://devilsapi.roblutken.com/api/goals/get/single/' + id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Goal = response.data;
        console.log(response.data);
      }, function (response) {});
    },
    updateGoal: function updateGoal(e) {
      var _this2 = this;

      e.preventDefault();
      var updateGoal = {
        player_id: this.Goal[0].scorer.player_number,
        first_assist: this.Goal[0].first_assist.player_number,
        second_assist: this.Goal[0].second_assist.player_number,
        period: this.Goal[0].period,
        situation: this.Goal[0].situation.secondary_situation
      };

      console.log(updateGoal);
      console.log(this.$route.params.id);
      this.$http.put('https://devilsapi.roblutken.com/api/goals/update/' + this.$route.params.id, updateGoal, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        _this2.$router.push('/editors/goal/');
      }, function (response) {});
    },
    onRawValueChanged: function onRawValueChanged(newVal) {
      this.demo.rawValue = newVal;
    }
  },
  watch: {
    'demo.value': function demoValue(newVal, oldVal) {
      console.log('value: new ->', newVal, 'old ->', oldVal);
    },
    'demo.rawValue': function demoRawValue(newVal, oldVal) {
      console.log('rawValue: new ->', newVal, 'old ->', oldVal);
    }
  },
  created: function created() {
    this.fetchGoal(this.$route.params.id);
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default.a
  },

  data: function data() {
    return {

      Hit: []
    };
  },


  methods: {
    fetchHit: function fetchHit(id) {
      var _this = this;

      console.log('Get query');
      this.$http.get('https://devilsapi.roblutken.com/api/hits/get/single/' + id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Hit = response.data;
        console.log(response.data);
      }, function (response) {});
    },
    updateHit: function updateHit(e) {
      var _this2 = this;

      e.preventDefault();
      var updateHit = {
        player_id: this.Hit.by,
        offensive_player_id: this.Hit.on,
        period: this.Hit.period,
        situation: this.Hit.situation.secondary_situation
      };

      console.log(updateHit);
      console.log(this.$route.params.id);
      this.$http.put('https://devilsapi.roblutken.com/api/hits/update/' + this.$route.params.id, updateHit, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        _this2.$router.push('/editors/hits/');
      }, function (response) {});
    },
    onRawValueChanged: function onRawValueChanged(newVal) {
      this.demo.rawValue = newVal;
    }
  },
  watch: {
    'demo.value': function demoValue(newVal, oldVal) {
      console.log('value: new ->', newVal, 'old ->', oldVal);
    },
    'demo.rawValue': function demoRawValue(newVal, oldVal) {
      console.log('rawValue: new ->', newVal, 'old ->', oldVal);
    }
  },
  created: function created() {
    this.fetchHit(this.$route.params.id);
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      formData: {
        'team_id': 0,
        'forename': '',
        'surname': '',
        'number': 0,
        'position': '',
        'age': 0,
        'dob': 0,
        'height': 0,
        'weight': 0,
        'handedness': '',
        'birth_place': '',
        'nationality': '',
        'status': 'Active',
        'external_url': 'none'
      },
      nameMax: 28,
      descriptionMax: 500,
      currentName: 0,
      isActive: false,
      image_path: ''
    };
  },

  methods: {
    launch: function launch() {
      this.isActive = true;
    },
    close: function close() {
      this.isActive = false;
    },
    onImageChange: function onImageChange(_fileInput) {
      this.image_path = _fileInput.target.files[0];
    },

    save: function save() {
      var _this = this;

      console.log('Formdata is: ' + this.formData);
      var post = new FormData(); // eslint-disable-line no-undef
      this.formData.team_id = this.$route.params.teamId;
      post.append('player', JSON.stringify(this.formData));
      console.log('post is: ' + post);
      this.$http.post('https://devilsapi.roblutken.com/api/players/add/', post, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response);
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        _this.close();
        console.log('dataUpdate');
        _this.$emit('dataUpdate', 'test');
        _this.$router.push('/editors/player-editor/' + _this.$route.params.teamId);
      });
    },
    openNotificationWithType: function openNotificationWithType(type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      });
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default.a
  },

  data: function data() {
    return {
      teamSelect: 'Cardiff Devils',
      teamOption: [{ text: 'Cardiff Devils', value: 'id' }, { text: 'away team', value: 'id' }],
      periodSelect: 1,
      periodOption: [{ text: 1, value: 1 }, { text: 2, value: 2 }, { text: 3, value: 3 }, { text: '4 - Overtime', value: 4 }],
      Oddman: []
    };
  },


  methods: {
    fetchOddman: function fetchOddman(id) {
      var _this = this;

      console.log('Get query');
      this.$http.get('https://devilsapi.roblutken.com/api/oddmans/get/single/' + id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Oddman = response.data;
        _this.periodSelect = _this.Oddman.period;
        var teams = [{ text: _this.Oddman.teams_info.home_name, value: _this.Oddman.teams_info.home_id }, { text: _this.Oddman.teams_info.away_name, value: _this.Oddman.teams_info.away_id }];
        _this.teamOption = teams;
        _this.teamSelect = _this.teamOption[0];
        // this.teamSelect = this.Oddman.te
        console.log(_this.teamSelect);
        console.log(response.data);
      }, function (response) {});
    },
    updateOddman: function updateOddman(e) {
      var _this2 = this;

      e.preventDefault();
      var updateOddman = {
        team: this.Oddman.team.id,
        period: this.Oddman.period,
        situation: this.Oddman.situation.secondary_situation
      };

      console.log(updateOddman);
      console.log(this.$route.params.id);
      this.$http.put('https://devilsapi.roblutken.com/api/oddmans/update/' + this.$route.params.id, updateOddman, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        _this2.$router.push('/editors/oddmans/');
      }, function (response) {});
    },
    onRawValueChanged: function onRawValueChanged(newVal) {
      this.demo.rawValue = newVal;
    }
  },
  watch: {
    'demo.value': function demoValue(newVal, oldVal) {
      console.log('value: new ->', newVal, 'old ->', oldVal);
    },
    'demo.rawValue': function demoRawValue(newVal, oldVal) {
      console.log('rawValue: new ->', newVal, 'old ->', oldVal);
    }
  },
  created: function created() {
    this.fetchOddman(this.$route.params.id);
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cleave_js_dist_addons_cleave_phone_cn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cleave_js_dist_addons_cleave_phone_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_cleave_js_dist_addons_cleave_phone_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a
  },
  props: {
    player: Object
  },
  data: function data() {
    return {
      file: '',
      isActive: false,
      positionOptions: [{ text: 'Left Wing - LW', value: 'LW' }, { text: 'Center - C', value: 'C' }, { text: 'Right Wing - RW', value: 'RW' }, { text: 'Left Defense - LD', value: 'LD' }, { text: 'Right Defense - RD', value: 'RD' }, { text: 'Goaltender - GT', value: 'GT' }],
      statusOptions: [{ text: 'Active', value: 'Active' }, { text: 'Inactive', value: 'Inactive' }, { text: 'Retired', value: 'Retired' }],
      handednessOptions: [{ text: 'Left', value: 'L' }, { text: 'Right', value: 'R' }],
      nationalityOptions: [],
      birthPlaceOptions: [],
      Player: {
        forename: '',
        surname: '',
        teamId: '',
        number: 0,
        dob: '',
        handedness: '',
        birth_place: '',
        nationaltiy: '',
        position: '',
        weight: 0,
        height: 0,
        external_url: '',
        status: '',
        team_id: this.$route.params.teamId
      }
    };
  },


  methods: {
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    launch: function launch() {
      this.isActive = true;
      console.log('launch');
    },
    close: function close() {
      this.isActive = false;
      this.data = [];
      console.log('close');
    },
    addPlayer: function addPlayer() {
      var _this = this;

      console.log(JSON.stringify(this.Player));
      /*eslint-disable */
      // eslint-disable-line no-use-before-define
      var formData = new FormData(); // eslint-disable-line no-use-before-define
      formData.append('player_picture', this.file);
      formData.append('player', JSON.stringify(this.Player));
      console.log(JSON.stringify(this.Player));
      /*eslint-enable */
      this.$http.post('https://devilsapi.roblutken.com/api/players/upload-picture/', formData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'multipart/form-data' } }).then(function (response) {
        console.log(response.data.status);
        console.log(response.data);
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        _this.close();
        console.log('dataUpdate');
        _this.$emit('dataUpdate', 'test');
      }, function (response) {});
    },
    openNotificationWithType: function openNotificationWithType(type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      });
    },

    created: function created() {}

  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cleave_js_dist_addons_cleave_phone_cn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cleave_js_dist_addons_cleave_phone_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_cleave_js_dist_addons_cleave_phone_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_datepicker___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a
  },
  props: {
    player: Object
  },
  data: function data() {
    return {
      file: '',
      positionOptions: [{ text: 'Left Wing - LW', value: 'LW' }, { text: 'Center - C', value: 'C' }, { text: 'Right Wing - RW', value: 'RW' }, { text: 'Left Defense - LD', value: 'LD' }, { text: 'Right Defense - RD', value: 'RD' }, { text: 'Goaltender - GT', value: 'GT' }],
      statusOptions: [{ text: 'Active', value: 'Active' }, { text: 'Inactive', value: 'Inactive' }, { text: 'Retired', value: 'Retired' }],
      Player: []
    };
  },


  methods: {
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    fetchPlayer: function fetchPlayer() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/players/get/' + this.$route.params.playerId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        _this.Player = response.data;
        console.log(JSON.stringify(_this.Player));
      }, function (response) {});
    },
    updatePlayer: function updatePlayer() {
      var _this2 = this;

      console.log(JSON.stringify(this.Player));
      /*eslint-disable */
      // eslint-disable-line no-use-before-define
      var formData = new FormData(); // eslint-disable-line no-use-before-define
      formData.append('player_picture', this.file);
      formData.append('player', JSON.stringify(this.Player));
      /*eslint-enable */
      this.$http.post('https://devilsapi.roblutken.com/api/players/update/' + this.$route.params.teamId + '/' + this.Player.id, formData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'multipart/form-data' } }).then(function (response) {
        console.log(response.data);
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
          _this2.$router.push('/editors/player-editor/' + _this2.$route.params.teamId);
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      }, function (response) {});
    }
  },
  openNotificationWithType: function openNotificationWithType(type) {
    openNotification({
      title: 'This is a title',
      message: 'This is the message.',
      type: type
    });
  },

  watch: {
    'demo.value': function demoValue(newVal, oldVal) {
      console.log('value: new ->', newVal, 'old ->', oldVal);
    },
    'demo.rawValue': function demoRawValue(newVal, oldVal) {
      console.log('rawValue: new ->', newVal, 'old ->', oldVal);
    }
  },
  created: function created() {
    this.fetchPlayer();
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__new_player_dialog__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__new_player_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__new_player_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__edit_player_dialog__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__edit_player_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__edit_player_dialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a,
    NewPlayer: __WEBPACK_IMPORTED_MODULE_2__new_player_dialog___default.a,
    EditPlayerDialog: __WEBPACK_IMPORTED_MODULE_3__edit_player_dialog___default.a
  },
  name: 'players',
  data: function data() {
    return {
      Players: [],
      Team: [],
      cardModal: null,
      newModal: null,
      playerOptions: [],
      activePlayers: [],
      activeOptions: [],
      Roster: []
    };
  },

  computed: {
    sortByNumber: function sortByNumber() {
      return this.Players.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    },
    sortByActiveNumber: function sortByActiveNumber() {
      return this.activePlayers.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    }
  },
  methods: {
    fetchRoster: function fetchRoster() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/rosters/get/' + this.$route.params.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Roster = response.data;
        console.log('Roster is: ' + JSON.stringify(_this.Roster));
      }, function (response) {});
    },
    fetchActivePlayers: function fetchActivePlayers() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/players/get/teams/active/' + this.$route.params.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this2.activePlayers = response.data;
        _this2.activeOptions.push({ text: 'Forwards', value: -2 });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this2.sortByActiveNumber[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var i = _step.value;

            if (i.position === 'LW' || i.position === 'C' || i.position === 'RW') {
              _this2.activeOptions.push({ text: '#' + i.number + ' ' + i.surname, value: i.id });
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this2.activeOptions.push({ text: 'Defense', value: -2 });
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _this2.sortByActiveNumber[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var d = _step2.value;

            if (d.position === 'LD' || d.position === 'RD') {
              _this2.activeOptions.push({ text: '#' + d.number + ' ' + d.surname, value: d.id });
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this2.activeOptions.push({ text: 'Goaltender', value: -2 });
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = _this2.sortByActiveNumber[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var g = _step3.value;

            if (g.position === 'GT' || g.position === 'BKGT' || g.position === 'EMRGGT') {
              _this2.activeOptions.push({ text: '#' + g.number + ' ' + g.surname, value: g.id });
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      });
    },
    fetchPlayers: function fetchPlayers() {
      var _this3 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/players/get/teams/' + this.$route.params.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this3.Players = response.data;
        // console.log(this.Players)
        // this.playerOptions.push({text: '-', value: -1})
        _this3.playerOptions.push({ text: 'Forwards', value: -2 });
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = _this3.sortByNumber[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var i = _step4.value;

            if (i.position === 'LW' || i.position === 'C' || i.position === 'RW') {
              _this3.playerOptions.push({ text: '#' + i.number + ' ' + i.surname, value: i.id });
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        _this3.playerOptions.push({ text: 'Defense', value: -2 });
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = _this3.sortByNumber[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var d = _step5.value;

            if (d.position === 'LD' || d.position === 'RD') {
              _this3.playerOptions.push({ text: '#' + d.number + ' ' + d.surname, value: d.id });
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        _this3.playerOptions.push({ text: 'Goaltender', value: -2 });
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = _this3.sortByNumber[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var g = _step6.value;

            if (g.position === 'GT' || g.position === 'BKGT' || g.position === 'EMRGGT') {
              _this3.playerOptions.push({ text: '#' + g.number + ' ' + g.surname, value: g.id });
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }, function (response) {});
    },
    fetchTeam: function fetchTeam() {
      var _this4 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/teams/get/' + this.$route.params.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this4.Team = response.data;
        // console.log(JSON.stringify(this.Team))
      }, function (response) {});
    },
    openEditModal: function openEditModal(player) {},
    loadEdit: function loadEdit(player) {
      console.log('Edit Player' + JSON.stringify(player));
      this.$refs.EditPlayerDialog.formData = player;
      this.$refs.EditPlayerDialog.launch();
      // this.$router.push('/editors/player-edit/' + this.$route.params.teamId + '/' + player.id)
    },
    openNew: function openNew() {
      this.$router.push('/editors/player-add/' + this.$route.params.teamId);
    },

    cancel: function cancel() {
      console.log('ok clicked');
    },
    updateRoster: function updateRoster(_item, _newPlayer) {
      if (_item.player_id[0].id !== _newPlayer) {
        console.log('Updated: ' + _item.player_id[0].id + ' TO player: ' + JSON.stringify(_newPlayer));
        /*eslint-disable */
        // eslint-disable-line no-use-before-define
        var formData = new FormData(); // eslint-disable-line no-use-before-define
        formData.append('team_id', _item.team_id);
        formData.append('line_number', _item.line_number);
        formData.append('position', _item.position);
        formData.append('player_id', _newPlayer);
        //
        this.$http.post('https://devilsapi.roblutken.com/api/rosters/update/', formData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'multipart/form-data' } }).then(function (response) {
          console.log(response.data);
          if (response.data.status === '202') {
            openNotification({
              title: 'Update Success',
              message: response.data.message,
              type: 'success',
              duration: 3400
            });
            // this.$router.push('/editors/player-editor/' + this.$route.params.teamId)
          } else {
            openNotification({
              title: 'Failed to update',
              message: response.data.message,
              type: 'danger',
              duration: 3400
            });
            _newPlayer = '';
            // _item = ''
          }
        }, function (response) {});
        /*eslint-enable*/
      }
    },
    clearRoster: function clearRoster() {}
  },
  openNotificationWithType: function openNotificationWithType(type) {
    openNotification({
      title: 'This is a title',
      message: 'This is the message.',
      type: type
    });
  },

  created: function created() {
    this.fetchPlayers();
    this.fetchTeam();
    this.fetchRoster();
    this.fetchActivePlayers();
  },
  update: function update() {
    this.fetchPlayers();
    this.fetchTeam();
    this.fetchActivePlayers();
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default.a
  },

  data: function data() {
    return {
      Player: [],
      TOI: []
    };
  },


  methods: {
    fetchGoal: function fetchGoal(id) {
      var _this = this;

      console.log('Get query');
      this.$http.get('https://devilsapi.roblutken.com/api/players/home/get', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Player = response.data;
        console.log(response.data);
        console.log('In Created: ' + _this.Player[0] + ' ' + _this.Player.length);
        for (var i = 0; i < _this.Player.length; i++) {
          console.log(_this.Player[i].forename);
          _this.TOI.push({
            player_id: _this.Player[i].id,
            player_forename: _this.Player[i].forename,
            player_surname: _this.Player[i].surname,
            player_number: _this.Player[i].player_number,
            played_in_game: 0,
            shots_for: 0,
            shots_against: 0,
            shifts: 0,
            avg_shift: '',
            total_time: '',
            time_5v5: '',
            time_4v4: '',
            time_PP: '',
            time_SH: ''
          });
        }
      }, function (response) {});
    },
    updateTimeOnice: function updateTimeOnice(e) {
      e.preventDefault();
      console.log(this.TOI);
      /* let updateGoal = {
        player_id: this.Player[0].scorer.player_number,
        first_assist: this.Player[0].first_assist.player_number,
        second_assist: this.Player[0].second_assist.player_number,
        period: this.Player[0].period,
        situation: this.Player[0].situation.secondary_situation
      } */

      console.log(this.$route.params.id);
      for (var i = 0; i < this.Player.length; i++) {
        this.$http.put('https://devilsapi.roblutken.com/api/timeonice/update/' + this.$route.params.id, this.TOI[i], { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          console.log(response.data);
        }, function (response) {});
      }
    },
    onRawValueChanged: function onRawValueChanged(newVal) {
      this.demo.rawValue = newVal;
    }
  },
  watch: {
    'demo.value': function demoValue(newVal, oldVal) {
      console.log('value: new ->', newVal, 'old ->', oldVal);
    },
    'demo.rawValue': function demoRawValue(newVal, oldVal) {
      console.log('rawValue: new ->', newVal, 'old ->', oldVal);
    }
  },
  created: function created() {
    this.fetchGoal(this.$route.params.id);
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cleave_js_dist_addons_cleave_phone_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_datepicker___default.a
  },

  data: function data() {
    return {

      Turnover: []
    };
  },


  methods: {
    fetchTurnover: function fetchTurnover(id) {
      var _this = this;

      console.log('Get query');
      this.$http.get('https://devilsapi.roblutken.com/api/turnovers/get/single/' + id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Turnover = response.data;
        console.log(response.data);
      }, function (response) {});
    },
    updateTurnover: function updateTurnover(e) {
      var _this2 = this;

      e.preventDefault();
      var updateTurnover = {
        player_id: this.Turnover.player.player_number,
        type: this.Turnover.type,
        period: this.Turnover.period,
        situation: this.Turnover.situation.secondary_situation
      };

      console.log(updateTurnover);
      console.log(this.$route.params.id);
      this.$http.put('https://devilsapi.roblutken.com/api/turnovers/update/' + this.$route.params.id, updateTurnover, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response.data);
        _this2.$router.push('/editors/turnovers/');
      }, function (response) {});
    },
    onRawValueChanged: function onRawValueChanged(newVal) {
      this.demo.rawValue = newVal;
    }
  },
  watch: {
    'demo.value': function demoValue(newVal, oldVal) {
      console.log('value: new ->', newVal, 'old ->', oldVal);
    },
    'demo.rawValue': function demoRawValue(newVal, oldVal) {
      console.log('rawValue: new ->', newVal, 'old ->', oldVal);
    }
  },
  created: function created() {
    this.fetchTurnover(this.$route.params.id);
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_slider__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_chartjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import randomColor from '../../store/modules/utils/randomColor'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'player',
  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_slider___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      Faceoffs: [],
      Shots: [],
      Turnovers: [],
      Hits: [],
      Totals: [],
      showAll: true,
      Teams: [],
      teamId: 0,
      heatData: [0, 0, 0],
      gameView: true,
      selected: '0',
      options: [{ text: 'All Shots', value: '0' }, { text: 'On Net', value: '1' }, { text: 'Blocked', value: '2' }, { text: 'Missed Net', value: '3' }],
      heatSize: 10,
      periodSelect: '0',
      periodOptions: [{ text: 'All Periods', value: '0' }, { text: 'Period 1', value: '1' }, { text: 'Period 2', value: '2' }, { text: 'Period 3', value: '3' }, { text: 'Overtime', value: '4' }],
      fo_total_labels: ['Won', 'Lossed'],
      so_total_labels: ['Home On Target', 'Away On Target'],
      fo_total_lane_labels: ['Left Wins', 'Center Wins', 'Right Wins'],
      fo_total_data: ['110', '120'],
      fo_total_options: {
        segmentShowStroke: false
      },
      bar_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'index',
          intersect: true,
          autoSkip: false
        },
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 30.21,
            ticks: {
              autoSkip: false
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 30.21,
            ticks: {
              autoSkip: false
            }
          }]
        }
      },
      backgroundColor: ['#1fc8db', '#fce473', '#42afe3', '#ed6c63', '#97cd76'],
      isFaceoffsPvp: false,
      isFaceoffOpen: true
    };
  },

  computed: {
    fo_total_chart: function fo_total_chart() {
      return {
        labels: this.fo_total_labels,
        datasets: [{
          data: this.getFoChartTotals(),
          backgroundColor: this.backgroundColor
        }]
      };
    },
    fo_total_lane_chart: function fo_total_lane_chart() {
      return {
        labels: this.fo_total_lane_labels,
        datasets: [{
          data: this.getFoLaneChartTotals(),
          backgroundColor: this.backgroundColor
        }]
      };
    },
    fo_player_series: function fo_player_series() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.Faceoffs.players[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerWins = [];
      var playerLosses = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.Faceoffs.players[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var wins = _step2.value;

          playerWins.push(wins.player_fow);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.Faceoffs.players[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var losses = _step3.value;

          playerLosses.push(losses.player_fol);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      data.datasets = [{
        data: playerWins,
        label: 'Wins',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: playerLosses,
        label: 'Losses',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_lane: function fo_player_lane() {
      var playerLabels = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.Faceoffs.players[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var label = _step4.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWins = [];
      var playerCenterWins = [];
      var playerRightWins = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.Faceoffs.players[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var leftWins = _step5.value;

          playerLeftWins.push(leftWins.player_lane_left_wins);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.Faceoffs.players[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var centerWins = _step6.value;

          playerCenterWins.push(centerWins.player_lane_center_wins);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.Faceoffs.players[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var rightWins = _step7.value;

          playerRightWins.push(rightWins.player_lane_right_wins);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWins,
        label: 'Left Wins',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: playerCenterWins,
        label: 'Center Wins',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerRightWins,
        label: 'Right Wins',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    fo_player_zone: function fo_player_zone() {
      var playerLabels = [];
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.Faceoffs.players[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var label = _step8.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerOffensiveWins = [];
      var playerNeutralWins = [];
      var playerDefensiveWins = [];
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.Faceoffs.players[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var offensiveWins = _step9.value;

          playerOffensiveWins.push(offensiveWins.player_zone_offensive_wins);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = this.Faceoffs.players[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var neutralWins = _step10.value;

          playerNeutralWins.push(neutralWins.player_zone_neutral_wins);
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = this.Faceoffs.players[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var defensiveWins = _step11.value;

          playerDefensiveWins.push(defensiveWins.player_zone_defensive_wins);
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      data.datasets = [{
        data: playerOffensiveWins,
        label: 'Offensive Wins',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: playerNeutralWins,
        label: 'Neutral Wins',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerDefensiveWins,
        label: 'Defensive Wins',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    fo_player_situation: function fo_player_situation() {
      var playerLabels = [];
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = this.Faceoffs.players[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var label = _step12.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerWinsEH = [];
      var playWinsPP = [];
      var playerWinsSH = [];
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = this.Faceoffs.players[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var eh = _step13.value;

          playerWinsEH.push(eh.player_situation_eh_wins);
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = this.Faceoffs.players[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var pp = _step14.value;

          playWinsPP.push(pp.player_situation_pp_wins);
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }

      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = this.Faceoffs.players[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var sh = _step15.value;

          playerWinsSH.push(sh.player_situation_sh_wins);
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }

      data.datasets = [{
        data: playerWinsEH,
        label: 'Even Handed Wins',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: playWinsPP,
        label: 'Power Play Wins',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerWinsSH,
        label: 'Short Handed Wins',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    so_total_chart: function so_total_chart() {
      return {
        labels: this.so_total_labels,
        datasets: [{
          data: this.getSoTotals(),
          backgroundColor: this.backgroundColor
        }]
      };
    },
    shot_player_totals: function shot_player_totals() {
      var playerLabels2 = [];
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = this.Shots.home_players[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var label = _step16.value;

          playerLabels2.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      var data = {
        labels: playerLabels2
      };
      data.datsets = [];
      var playerOnNet = [];
      var playerMissedNet = [];
      var playerBlocked = [];
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = this.Shots.home_players[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var onNet = _step17.value;

          playerOnNet.push(onNet.player_on_net);
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }

      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = this.Shots.home_players[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var missedNet = _step18.value;

          playerMissedNet.push(missedNet.player_missed_net);
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }

      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = this.Shots.home_players[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var blocked = _step19.value;

          playerBlocked.push(blocked.player_blocked);
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }

      data.datasets = [{
        data: playerOnNet,
        label: 'On Net',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: playerOnNet,
        label: 'Missed Net',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerBlocked,
        label: 'Blocked',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      console.log('DATA is: ' + data.datasets);
      return data;
    },
    shot_away_player_totals: function shot_away_player_totals() {
      var playerLabels = [];
      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;

      try {
        for (var _iterator20 = this.Shots.away_players[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var label = _step20.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerOnNet = [];
      var playerMissedNet = [];
      var playerBlocked = [];
      var _iteratorNormalCompletion21 = true;
      var _didIteratorError21 = false;
      var _iteratorError21 = undefined;

      try {
        for (var _iterator21 = this.Shots.away_players[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
          var onNet = _step21.value;

          playerOnNet.push(onNet.player_on_net);
        }
      } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion21 && _iterator21.return) {
            _iterator21.return();
          }
        } finally {
          if (_didIteratorError21) {
            throw _iteratorError21;
          }
        }
      }

      var _iteratorNormalCompletion22 = true;
      var _didIteratorError22 = false;
      var _iteratorError22 = undefined;

      try {
        for (var _iterator22 = this.Shots.away_players[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
          var missedNet = _step22.value;

          playerMissedNet.push(missedNet.player_missed_net);
        }
      } catch (err) {
        _didIteratorError22 = true;
        _iteratorError22 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion22 && _iterator22.return) {
            _iterator22.return();
          }
        } finally {
          if (_didIteratorError22) {
            throw _iteratorError22;
          }
        }
      }

      var _iteratorNormalCompletion23 = true;
      var _didIteratorError23 = false;
      var _iteratorError23 = undefined;

      try {
        for (var _iterator23 = this.Shots.away_players[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
          var blocked = _step23.value;

          playerBlocked.push(blocked.player_blocked);
        }
      } catch (err) {
        _didIteratorError23 = true;
        _iteratorError23 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion23 && _iterator23.return) {
            _iterator23.return();
          }
        } finally {
          if (_didIteratorError23) {
            throw _iteratorError23;
          }
        }
      }

      data.datasets = [{
        data: playerOnNet,
        label: 'On Net',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: playerMissedNet,
        label: 'Missed Net',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerBlocked,
        label: 'Blocked',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    shot_player_situational: function shot_player_situational() {
      var playerLabels = [];
      var _iteratorNormalCompletion24 = true;
      var _didIteratorError24 = false;
      var _iteratorError24 = undefined;

      try {
        for (var _iterator24 = this.Shots.home_players[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
          var label = _step24.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError24 = true;
        _iteratorError24 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion24 && _iterator24.return) {
            _iterator24.return();
          }
        } finally {
          if (_didIteratorError24) {
            throw _iteratorError24;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerPPOnNet = [];
      var playerSHOnNet = [];
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = this.Shots.home_players[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var onNetPP = _step25.value;

          playerPPOnNet.push(onNetPP.player_pp_on_net);
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }

      var _iteratorNormalCompletion26 = true;
      var _didIteratorError26 = false;
      var _iteratorError26 = undefined;

      try {
        for (var _iterator26 = this.Shots.home_players[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
          var onNetSH = _step26.value;

          playerSHOnNet.push(onNetSH.player_sh_on_net);
        }
      } catch (err) {
        _didIteratorError26 = true;
        _iteratorError26 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion26 && _iterator26.return) {
            _iterator26.return();
          }
        } finally {
          if (_didIteratorError26) {
            throw _iteratorError26;
          }
        }
      }

      data.datasets = [{
        data: playerPPOnNet,
        label: 'PP On Net',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: playerSHOnNet,
        label: 'SH On Net',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    shot_away_player_situational: function shot_away_player_situational() {
      var playerLabels = [];
      var _iteratorNormalCompletion27 = true;
      var _didIteratorError27 = false;
      var _iteratorError27 = undefined;

      try {
        for (var _iterator27 = this.Shots.away_players[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
          var label = _step27.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError27 = true;
        _iteratorError27 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion27 && _iterator27.return) {
            _iterator27.return();
          }
        } finally {
          if (_didIteratorError27) {
            throw _iteratorError27;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerPPOnNet = [];
      var playerSHOnNet = [];
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = this.Shots.away_players[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var onNetPP = _step28.value;

          playerPPOnNet.push(onNetPP.player_pp_on_net);
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var _iteratorNormalCompletion29 = true;
      var _didIteratorError29 = false;
      var _iteratorError29 = undefined;

      try {
        for (var _iterator29 = this.Shots.away_players[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
          var onNetSH = _step29.value;

          playerSHOnNet.push(onNetSH.player_sh_on_net);
        }
      } catch (err) {
        _didIteratorError29 = true;
        _iteratorError29 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion29 && _iterator29.return) {
            _iterator29.return();
          }
        } finally {
          if (_didIteratorError29) {
            throw _iteratorError29;
          }
        }
      }

      data.datasets = [{
        data: playerPPOnNet,
        label: 'PP On Net',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: playerSHOnNet,
        label: 'SH On Net',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    to_totals: function to_totals() {
      var labels = ['Offensvie', 'Neutral', 'Defensive'];
      var data = [parseInt(this.Turnovers.home_total_offensive), parseInt(this.Turnovers.home_total_neutral), parseInt(this.Turnovers.home_total_defensive)];
      return {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: this.backgroundColor
        }]
      };
    },
    to_player_totals: function to_player_totals() {
      var playerLabels = [];
      var _iteratorNormalCompletion30 = true;
      var _didIteratorError30 = false;
      var _iteratorError30 = undefined;

      try {
        for (var _iterator30 = this.Turnovers.home_players[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
          var label = _step30.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError30 = true;
        _iteratorError30 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion30 && _iterator30.return) {
            _iterator30.return();
          }
        } finally {
          if (_didIteratorError30) {
            throw _iteratorError30;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerOffensive = [];
      var playerNeutral = [];
      var playerDefensive = [];
      var _iteratorNormalCompletion31 = true;
      var _didIteratorError31 = false;
      var _iteratorError31 = undefined;

      try {
        for (var _iterator31 = this.Turnovers.home_players[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
          var offensive = _step31.value;

          playerOffensive.push(offensive.player_offensive);
        }
      } catch (err) {
        _didIteratorError31 = true;
        _iteratorError31 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion31 && _iterator31.return) {
            _iterator31.return();
          }
        } finally {
          if (_didIteratorError31) {
            throw _iteratorError31;
          }
        }
      }

      var _iteratorNormalCompletion32 = true;
      var _didIteratorError32 = false;
      var _iteratorError32 = undefined;

      try {
        for (var _iterator32 = this.Turnovers.home_players[Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
          var neutral = _step32.value;

          playerNeutral.push(neutral.player_neutral);
        }
      } catch (err) {
        _didIteratorError32 = true;
        _iteratorError32 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion32 && _iterator32.return) {
            _iterator32.return();
          }
        } finally {
          if (_didIteratorError32) {
            throw _iteratorError32;
          }
        }
      }

      var _iteratorNormalCompletion33 = true;
      var _didIteratorError33 = false;
      var _iteratorError33 = undefined;

      try {
        for (var _iterator33 = this.Turnovers.home_players[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
          var defensive = _step33.value;

          playerDefensive.push(defensive.player_defensive);
        }
      } catch (err) {
        _didIteratorError33 = true;
        _iteratorError33 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion33 && _iterator33.return) {
            _iterator33.return();
          }
        } finally {
          if (_didIteratorError33) {
            throw _iteratorError33;
          }
        }
      }

      data.datasets = [{
        data: playerOffensive,
        label: 'Offensive',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: playerNeutral,
        label: 'Neutral',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerDefensive,
        label: 'Defensive',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    to_player_situational: function to_player_situational() {
      var playerLabels = [];
      var _iteratorNormalCompletion34 = true;
      var _didIteratorError34 = false;
      var _iteratorError34 = undefined;

      try {
        for (var _iterator34 = this.Turnovers.home_players[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
          var label = _step34.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError34 = true;
        _iteratorError34 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion34 && _iterator34.return) {
            _iterator34.return();
          }
        } finally {
          if (_didIteratorError34) {
            throw _iteratorError34;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerOffensivePP = [];
      var playerNeutralPP = [];
      var playerDefensivePP = [];
      var playerOffensiveSH = [];
      var playerNeutralSH = [];
      var playerDefensiveSH = [];
      var _iteratorNormalCompletion35 = true;
      var _didIteratorError35 = false;
      var _iteratorError35 = undefined;

      try {
        for (var _iterator35 = this.Turnovers.home_players[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
          var offensivePP = _step35.value;

          playerOffensivePP.push(offensivePP.player_pp_offensive);
        }
      } catch (err) {
        _didIteratorError35 = true;
        _iteratorError35 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion35 && _iterator35.return) {
            _iterator35.return();
          }
        } finally {
          if (_didIteratorError35) {
            throw _iteratorError35;
          }
        }
      }

      var _iteratorNormalCompletion36 = true;
      var _didIteratorError36 = false;
      var _iteratorError36 = undefined;

      try {
        for (var _iterator36 = this.Turnovers.home_players[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
          var neutralPP = _step36.value;

          playerNeutralPP.push(neutralPP.player_pp_neutral);
        }
      } catch (err) {
        _didIteratorError36 = true;
        _iteratorError36 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion36 && _iterator36.return) {
            _iterator36.return();
          }
        } finally {
          if (_didIteratorError36) {
            throw _iteratorError36;
          }
        }
      }

      var _iteratorNormalCompletion37 = true;
      var _didIteratorError37 = false;
      var _iteratorError37 = undefined;

      try {
        for (var _iterator37 = this.Turnovers.home_players[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
          var defensivePP = _step37.value;

          playerDefensivePP.push(defensivePP.player_pp_defensive);
        }
      } catch (err) {
        _didIteratorError37 = true;
        _iteratorError37 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion37 && _iterator37.return) {
            _iterator37.return();
          }
        } finally {
          if (_didIteratorError37) {
            throw _iteratorError37;
          }
        }
      }

      var _iteratorNormalCompletion38 = true;
      var _didIteratorError38 = false;
      var _iteratorError38 = undefined;

      try {
        for (var _iterator38 = this.Turnovers.home_players[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
          var offensiveSH = _step38.value;

          playerOffensiveSH.push(offensiveSH.player_sh_offensive);
        }
      } catch (err) {
        _didIteratorError38 = true;
        _iteratorError38 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion38 && _iterator38.return) {
            _iterator38.return();
          }
        } finally {
          if (_didIteratorError38) {
            throw _iteratorError38;
          }
        }
      }

      var _iteratorNormalCompletion39 = true;
      var _didIteratorError39 = false;
      var _iteratorError39 = undefined;

      try {
        for (var _iterator39 = this.Turnovers.home_players[Symbol.iterator](), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
          var neutralSH = _step39.value;

          playerNeutralSH.push(neutralSH.player_sh_neutral);
        }
      } catch (err) {
        _didIteratorError39 = true;
        _iteratorError39 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion39 && _iterator39.return) {
            _iterator39.return();
          }
        } finally {
          if (_didIteratorError39) {
            throw _iteratorError39;
          }
        }
      }

      var _iteratorNormalCompletion40 = true;
      var _didIteratorError40 = false;
      var _iteratorError40 = undefined;

      try {
        for (var _iterator40 = this.Turnovers.home_players[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
          var defensiveSH = _step40.value;

          playerDefensiveSH.push(defensiveSH.player_sh_defensive);
        }
      } catch (err) {
        _didIteratorError40 = true;
        _iteratorError40 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion40 && _iterator40.return) {
            _iterator40.return();
          }
        } finally {
          if (_didIteratorError40) {
            throw _iteratorError40;
          }
        }
      }

      data.datasets = [{
        data: playerOffensivePP,
        label: 'Offensive PP',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: playerNeutralPP,
        label: 'Neutral PP',
        backgroundColor: 'rgba(7, 144, 237, 0.4)',
        borderColor: 'rgba(7, 144, 237, 1)'
      }, {
        data: playerDefensivePP,
        label: 'Defensive PP',
        backgroundColor: 'rgba(0, 112, 188, 0.4)',
        borderColor: 'rgba(0, 112, 188, 1)'
      }, {
        data: playerOffensiveSH,
        label: 'Offensive SH',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerNeutralSH,
        label: 'Neutral SH',
        backgroundColor: 'rgba(193, 31, 65, 0.4)',
        borderColor: 'rgba(193, 31, 65, 1)'
      }, {
        data: playerDefensiveSH,
        label: 'Defensive SH',
        backgroundColor: 'rgba(170, 1, 37, 0.4)',
        borderColor: 'rgba(170, 1, 37, 1)'
      }];
      return data;
    },
    hit_totals: function hit_totals() {
      var labels = ['Hits'];
      var data = [this.Hits.home_total];
      return {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: this.backgroundColor
        }]
      };
    },
    hit_player_totals: function hit_player_totals() {
      var playerLabels = [];
      var _iteratorNormalCompletion41 = true;
      var _didIteratorError41 = false;
      var _iteratorError41 = undefined;

      try {
        for (var _iterator41 = this.Hits.home_players[Symbol.iterator](), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
          var label = _step41.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError41 = true;
        _iteratorError41 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion41 && _iterator41.return) {
            _iterator41.return();
          }
        } finally {
          if (_didIteratorError41) {
            throw _iteratorError41;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerHits = [];
      var _iteratorNormalCompletion42 = true;
      var _didIteratorError42 = false;
      var _iteratorError42 = undefined;

      try {
        for (var _iterator42 = this.Hits.home_players[Symbol.iterator](), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
          var hits = _step42.value;

          playerHits.push(hits.player_total);
        }
      } catch (err) {
        _didIteratorError42 = true;
        _iteratorError42 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion42 && _iterator42.return) {
            _iterator42.return();
          }
        } finally {
          if (_didIteratorError42) {
            throw _iteratorError42;
          }
        }
      }

      data.datasets = [{
        data: playerHits,
        label: 'Hits',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    }
  },
  methods: {
    fetchTeams: function fetchTeams() {
      var _this = this;

      console.log('Get query');
      this.$http.get('https://devilsapi.roblutken.com/api/teams/get', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        console.log('Fixture Data is ' + response.data);
        _this.Teams = response.data;
        // console.log(this.Teams[0])
      }, function (response) {});
    },
    fetchShotTotals: function fetchShotTotals() {
      var _this2 = this;

      console.log('Get Shots totals');
      this.teamId = this.$route.params.teamId;
      this.$http.get('https://devilsapi.roblutken.com/api/shots/season/get/' + this.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Shot Data is ' + response.data)
        _this2.Shots = response.data;
        // console.log(JSON.stringify(this.Shots))
      }, function (response) {});
    },
    fetchTurnoverTotals: function fetchTurnoverTotals() {
      var _this3 = this;

      console.log('Get Turnover totals');
      this.teamId = this.$route.params.teamId;
      this.$http.get('https://devilsapi.roblutken.com/api/turnovers/season/get/' + this.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Shot Data is ' + response.data)
        _this3.Turnovers = response.data;
        // console.log(JSON.stringify(this.Turnovers))
      }, function (response) {});
    },
    fetchHitTotals: function fetchHitTotals() {
      var _this4 = this;

      console.log('Get Hit totals');
      this.teamId = this.$route.params.teamId;
      this.$http.get('https://devilsapi.roblutken.com/api/hits/season/get/' + this.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Hits Data is ' + response.data)
        _this4.Hits = response.data;
        // console.log(JSON.stringify(this.Hits))
      }, function (response) {});
    },
    fetchFaceoffTotals: function fetchFaceoffTotals() {
      var _this5 = this;

      console.log('Get faceoff totals');
      this.teamId = this.$route.params.teamId;
      this.$http.get('https://devilsapi.roblutken.com/api/faceoffs/season/get/' + this.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Faceoff Data is ' + response.data)
        _this5.Faceoffs = response.data;
        // console.log(JSON.stringify(this.Faceoffs.players.player_vs_player))
      }, function (response) {});
    },
    fetchShotHeatmap: function fetchShotHeatmap(shotType, period) {
      var _this6 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/shots/heatmap/get?id=' + this.teamId + '&teamSelect=' + 14 + '&shotType=' + shotType + '&period=' + period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Response was: ' + JSON.stringify(response.data))
        var shots = JSON.parse(JSON.stringify(response.data));
        setTimeout(function () {
          var canvas = _this6.$refs.home_shots_canvas;
          var heat = __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default()(canvas).data(shots['shot_locations']);
          heat.radius(_this6.heatSize, 30);
          heat.draw();
        }, 3048);
      });
      this.$http.get('https://devilsapi.roblutken.com/api/shots/heatmap/get?id=' + this.teamId + '&teamSelect=' + this.teamId + '&shotType=' + shotType + '&period=' + period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Response was: ' + response.data)
        var shots = JSON.parse(JSON.stringify(response.data));
        setTimeout(function () {
          var canvas = _this6.$refs.away_shots_canvas;
          var heat = __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default()(canvas).data(shots['shot_locations']);
          heat.radius(_this6.heatSize, 30);
          heat.draw();
        }, 3048);
      });
      this.$http.get('https://devilsapi.roblutken.com/api/shots/heatmap/get/powerplay?id=' + this.teamId + '&teamSelect=' + 14 + '&shotType=' + shotType + '&period=' + period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Response was: ' + response.data)
        var shots = JSON.parse(JSON.stringify(response.data));
        setTimeout(function () {
          var canvas = _this6.$refs.home_shots_canvas_pp;
          var heat = __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default()(canvas).data(shots['shot_locations']);
          heat.radius(_this6.heatSize, 30);
          heat.draw();
        }, 3048);
      });
      this.$http.get('https://devilsapi.roblutken.com/api/shots/heatmap/get/powerplay?id=' + this.teamId + '&teamSelect=' + this.teamId + '&shotType=' + shotType + '&period=' + period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Response was: ' + response.data)
        var shots = JSON.parse(JSON.stringify(response.data));
        setTimeout(function () {
          var canvas = _this6.$refs.away_shots_canvas_pp;
          var heat = __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default()(canvas).data(shots['shot_locations']);
          heat.radius(_this6.heatSize, 30);
          heat.draw();
        }, 3048);
      });
    },
    updateHeatmaps: function updateHeatmaps() {
      console.log('Updating heatmaps' + this.selected + 'Period: ' + this.periodSelect);
      this.fetchShotHeatmap(this.selected, this.periodSelect);
    },
    updateHeatmapSize: function updateHeatmapSize(val) {
      this.heatSize = val;
      this.updateHeatmaps();
    },
    getFoChartTotals: function getFoChartTotals() {
      var foData = [this.Faceoffs.total_wins, this.Faceoffs.total_losses];
      return foData;
    },
    getFoLaneChartTotals: function getFoLaneChartTotals() {
      var foData = [this.Faceoffs.wins_left, this.Faceoffs.wins_center, this.Faceoffs.wins_right];
      return foData;
    },
    getSoTotals: function getSoTotals() {
      var soData = [parseInt(this.Shots.home_total_on_net), parseInt(this.Shots.away_total_on_net)];
      return soData;
    },
    getRandomColor: function getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },

    toggleFaceoffs: function toggleFaceoffs() {
      this.isFaceoffOpen = !this.isFaceoffOpen;
    },
    toggleFaceoffsPvp: function toggleFaceoffsPvp() {
      this.isFaceoffsPvp = !this.isFaceoffsPvp;
    }
  },
  created: function created() {
    console.log(this.$route.params.teamId);
    this.fetchShotTotals();
    this.fetchFaceoffTotals();
    this.fetchTurnoverTotals();
    this.fetchHitTotals();
  },
  updated: function updated() {},
  mounted: function mounted() {
    this.fetchShotHeatmap(0, 0);
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__match_summary_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__match_summary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__match_summary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gamesheet_dynamic_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gamesheet_dynamic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gamesheet_dynamic_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'game-summary': __WEBPACK_IMPORTED_MODULE_0__match_summary_vue___default.a,
    'gamesheet': __WEBPACK_IMPORTED_MODULE_1__gamesheet_dynamic_vue___default.a
  },
  data: function data() {
    return {
      period: 0,
      gameId: 0,
      gameInfo: {}
    };
  },
  methods: {
    getGameData: function getGameData() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games/get/single/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (res) {
        _this.gameInfo = res;
        _this.gameInfo = _this.gameInfo['data'][0];
        console.log('Response for game was: ' + JSON.stringify(_this.gameInfo.home_team.name));
      });
    }
  },
  mounted: function mounted() {
    this.period = parseInt(this.$route.params.period);
    this.gameId = parseInt(this.$route.params.gameId);
    this.getGameData();
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'apex-chart': __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
  },
  data: function data() {
    return {
      url: 'https://devilsapi.roblutken.com/api/season-stats/realtime-test',
      realtimeData: [],
      timer: '',
      index: 0,
      tagData: [{
        event: 'test',
        count: 100
      }, {
        event: 'test2',
        count: 50
      }],
      series: [{
        name: 'Shifts',
        data: []
      }, {
        name: 'Goals',
        data: []
      }, {
        name: 'SOT',
        data: []
      }, {
        name: 'SHOT+/-',
        data: []
      }],
      data: [],
      options: {
        chart: {
          title: 'Shifts / Time',
          align: 'left',
          type: 'line',
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 900
            }
          }
        },
        labels: [],
        toolbar: { show: false },
        zoom: { enabled: false },
        stroke: { curve: 'smooth' },
        xaxis: {},
        yaxis: {}
      }
    };
  },

  computed: {
    chartData: function chartData() {
      this.series[0].data = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.slice(this.realtimeData, 0, 5);
      return this.series;
    }
  },
  methods: {
    updateSeries: function updateSeries() {
      this.series[0].data = [];
      this.series[1].data = [];
      this.series[2].data = [];
      this.series[3].data = [];
      if (this.index++ <= this.realtimeData.length) {
        console.log(this.index + ' ' + JSON.stringify(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.slice(this.realtimeData, 0, this.index)));
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.slice(this.realtimeData, 0, this.index)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var d = _step.value;

            var event = d.match_date + d.vs_team;
            this.series[0].data.push({ x: event, y: d.shifts });
            this.series[1].data.push({ x: event, y: d.goals });
            this.series[2].data.push({ x: event, y: d.shots });
            this.series[3].data.push({ x: event, y: d.corsi_diff });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.$refs.test.updateSeries([{
          data: this.series[0].data
        }, {
          data: this.series[1].data
        }, {
          data: this.series[2].data
        }, {
          data: this.series[3].data
        }]);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  mounted: function mounted() {
    var _this = this;

    this.$http.post(this.url, [], {
      headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
    }).then(function (response) {
      console.log('response was: ' + JSON.stringify(response.data));
      _this.realtimeData = response.data;
    }, function (response) {});
    this.timer = setInterval(this.updateSeries, 900);
    // console.log('Test is : ' + this.$refs.test)
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['heading', 'headers', 'tableData', 'total', 'defaultShow'],
  components: {},
  data: function data() {
    return {
      show: false
    };
  },

  methods: {},
  created: function created() {
    if (this.defaultShow) {
      this.show = true;
    }
    // console.log('Edit Table Data is: ' + this.total)
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['heading', 'headers', 'tableData', 'total', 'defaultShow'],
  components: {
    Chart: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      show: false,
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          enabled: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: false,
          labels: {
            fontColor: 'rgb(255, 99, 132)'
          }
        }
      }
    };
  },

  methods: {},
  created: function created() {
    if (this.defaultShow) {
      this.show = true;
    }
    // console.log('Edit Table Data is: ' + this.total)
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['defaultShow', 'home_name', 'away_name'],
  components: {
    Chart: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      show: true,
      gameId: 1,
      SituationOptions: [],
      PeriodOptions: [],
      PeriodSelected: 0,
      SituationSelected: 0,
      FaceoffsData: [],
      HomePlayers: [],
      AwayPlayers: [],
      HomeTeamOptions: [],
      HomeSelection: 0,
      AwayTeamOptions: [],
      AwaySelection: 0,
      usePercentage: false
    };
  },
  computed: {
    sortHomePlayers: function sortHomePlayers() {
      return this.HomePlayers.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    },
    sortAwayPlayers: function sortAwayPlayers() {
      return this.AwayPlayers.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    }
  },
  methods: {
    fetchFaceoffs: function fetchFaceoffs() {
      var _this = this;

      var canvas = this.$refs.map;
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var postData = {
        'id': this.gameId,
        'period': this.PeriodSelected,
        'situation': this.SituationSelected,
        'home_player': this.HomeSelection,
        'away_player': this.AwaySelection
      };
      this.$http.post('https://devilsapi.roblutken.com/api/app/get/match-stats/faceoff-vs/', postData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.FaceoffsData = response.data.faceoff_vs[0];
        // console.log('FO DATA: ' + JSON.stringify(this.FaceoffsData) + this.FaceoffsData.offensive_left)
        _this.renderCharts();
      }, function (response) {});
    },
    fetchPlayers: function fetchPlayers() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/players/faceoffs/' + this.gameId, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log(JSON.stringify(response.data))
        _this2.HomePlayers = response.data.home_players;
        _this2.AwayPlayers = response.data.away_players;
        // console.log(JSON.stringify(this.HomePlayers))
        _this2.HomeTeamOptions.push({ text: 'All', value: 0 });
        _this2.AwayTeamOptions.push({ text: 'All', value: 0 });

        _this2.HomeTeamOptions.push({ text: 'Forwards', value: 0 });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this2.sortHomePlayers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var i = _step.value;

            if (i.position === 'LW' || i.position === 'C' || i.position === 'RW') {
              if (i.number > 0) {
                _this2.HomeTeamOptions.push({ text: i.number + ' ' + i.surname, value: i.id });
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this2.HomeTeamOptions.push({ text: 'Defense', value: -7 });
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _this2.sortHomePlayers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var d = _step2.value;

            if (d.position === 'LD' || d.position === 'RD') {
              _this2.HomeTeamOptions.push({ text: d.number + ' ' + d.surname, value: d.id });
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this2.AwayTeamOptions.push({ text: 'Forwards', value: -2 });
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = _this2.sortAwayPlayers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var af = _step3.value;

            if (af.position === 'LW' || af.position === 'C' || af.position === 'RW') {
              if (af.number > 0) {
                _this2.AwayTeamOptions.push({ text: af.number + ' ' + af.surname, value: af.id });
              }
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        _this2.AwayTeamOptions.push({ text: 'Defense', value: -3 });
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = _this2.sortAwayPlayers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var ad = _step4.value;

            if (ad.position === 'LD' || ad.position === 'RD') {
              _this2.AwayTeamOptions.push({ text: ad.number + ' ' + ad.surname, value: ad.id });
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      });
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this3 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this3.SituationOptions.push({ text: 'All', value: 0 });
        _this3.SituationOptions.push({ text: 'Even Handed', value: 1 });
        _this3.SituationOptions.push({ text: 'Power Play', value: 2 });
        _this3.SituationOptions.push({ text: 'Short Handed', value: 3 });
        _this3.SituationOptions.push({ text: 'Empty Net', value: 4 });

        _this3.PeriodOptions.push({ text: 'All', value: 0 });
        _this3.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this3.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this3.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this3.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this3.PeriodOptions.push({ text: 'Period Shootout', value: 5 });
      });
    },
    renderCharts: function renderCharts() {
      // console.log('Render Charts')
      var canvas = this.$refs.map;
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var colorList = ['#15607a', '#6bcab6'];
      if (this.usePercentage) {
        // Top Left
        // console.log('FacoffData: ' + this.FaceoffsData.offensive_left_percentage)
        this.pie(ctx, 346, 160, 23, [this.FaceoffsData.offensive_right_percentage, 100 - this.FaceoffsData.offensive_right_percentage], colorList, 2.5, 'white');
        // Bottom Left
        this.pie(ctx, 346, 160, 240, [this.FaceoffsData.offensive_left_percentage, 100 - this.FaceoffsData.offensive_left_percentage], colorList, 2.5, 'white');
        // Top Right
        this.pie(ctx, 1660, 160, 23, [this.FaceoffsData.defensive_right_percentage, 100 - this.FaceoffsData.defensive_right_percentage], colorList, 2.5, 'white');
        // Bottom Right
        this.pie(ctx, 1660, 160, 240, [this.FaceoffsData.defensive_left_percentage, 100 - this.FaceoffsData.defensive_left_percentage], colorList, 2.5, 'white');
        // Neutral Top Left
        this.pie(ctx, 800, 60, 60, [this.FaceoffsData.neutral_offensive_right_percentage, 100 - this.FaceoffsData.neutral_offensive_right_percentage], colorList, 1.5, 'white');
        // Neutral Bottom Left
        this.pie(ctx, 800, 60, 290, [this.FaceoffsData.neutral_offensive_left_percentage, 100 - this.FaceoffsData.neutral_offensive_left_percentage], colorList, 1.5, 'white');
        // Neutral Top Right
        this.pie(ctx, 1210, 60, 60, [this.FaceoffsData.neutral_defensive_right_percentage, 100 - this.FaceoffsData.neutral_defensive_right_percentage], colorList, 1.5, 'white');
        // Neutral Bottom Right
        this.pie(ctx, 1210, 60, 290, [this.FaceoffsData.neutral_defensive_left_percentage, 100 - this.FaceoffsData.neutral_defensive_left_percentage], colorList, 1.5, 'white');
        // Center
        this.pie(ctx, 1002, 161, 130, [this.FaceoffsData.center_percentage, 100 - this.FaceoffsData.center_percentage], colorList, 2, 'white');
      } else {
        // console.log('FacoffData: ' + this.FaceoffsData.offensive_left_taken + '/' + this.FaceoffsData.offensive_left_w)
        this.pie(ctx, 346, 160, 23, [this.FaceoffsData.offensive_right_percentage, 100 - this.FaceoffsData.offensive_right_percentage], colorList, 2.5, 'white', this.FaceoffsData.offensive_right_taken, this.FaceoffsData.offensive_right_w);
        // Bottom Left
        this.pie(ctx, 346, 160, 240, [this.FaceoffsData.offensive_left_percentage, 100 - this.FaceoffsData.offensive_left_percentage], colorList, 2.5, 'white', this.FaceoffsData.offensive_left_taken, this.FaceoffsData.offensive_left_w);
        // Top Right
        this.pie(ctx, 1660, 160, 23, [this.FaceoffsData.defensive_right_percentage, 100 - this.FaceoffsData.defensive_right_percentage], colorList, 2.5, 'white', this.FaceoffsData.defensive_right_taken, this.FaceoffsData.defensive_right_w);
        // Bottom Right
        this.pie(ctx, 1660, 160, 240, [this.FaceoffsData.defensive_left_percentage, 100 - this.FaceoffsData.defensive_left_percentage], colorList, 2.5, 'white', this.FaceoffsData.defensive_left_taken, this.FaceoffsData.defensive_left_w);
        // Neutral Top Left
        this.pie(ctx, 800, 60, 60, [this.FaceoffsData.neutral_offensive_right_percentage, 100 - this.FaceoffsData.neutral_offensive_right_percentage], colorList, 1.5, 'white', this.FaceoffsData.neutral_offensive_right_taken, this.FaceoffsData.neutral_offensive_right_w);
        // Neutral Bottom Left
        this.pie(ctx, 800, 60, 290, [this.FaceoffsData.neutral_offensive_left_percentage, 100 - this.FaceoffsData.neutral_offensive_left_percentage], colorList, 1.5, 'white', this.FaceoffsData.neutral_offensive_left_taken, this.FaceoffsData.neutral_offensive_left_w);
        // Neutral Top Right
        this.pie(ctx, 1210, 60, 60, [this.FaceoffsData.neutral_defensive_right_percentage, 100 - this.FaceoffsData.neutral_defensive_right_percentage], colorList, 1.5, 'white', this.FaceoffsData.neutral_defensive_right_taken, this.FaceoffsData.neutral_defensive_right_w);
        // Neutral Bottom Right
        this.pie(ctx, 1210, 60, 290, [this.FaceoffsData.neutral_defensive_left_percentage, 100 - this.FaceoffsData.neutral_defensive_left_percentage], colorList, 1.5, 'white', this.FaceoffsData.neutral_defensive_left_taken, this.FaceoffsData.neutral_defensive_left_w);
        // Center
        this.pie(ctx, 1002, 161, 130, [this.FaceoffsData.center_percentage, 100 - this.FaceoffsData.center_percentage], colorList, 2, 'white', this.FaceoffsData.center_taken, this.FaceoffsData.center_w);
      }
      this.drawText(ctx, this.home_name, [600, 40], '30px', '#15607a');
      this.drawText(ctx, this.away_name, [350, 40], '30px', '#6bcab6');
    },
    calculateDegrees: function calculateDegrees(percent) {
      return percent / 100 * 360;
    },
    drawCircle: function drawCircle(ctx, color, position, radius) {
      var lineWidth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2;

      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = lineWidth;
      ctx.arc(position[0], position[1], radius, 0, 2 * Math.PI);
      ctx.fill();
      ctx.stroke();
      ctx.closePath();
    },
    drawSector: function drawSector(ctx, color, position, radius, start, amount) {
      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = 2;
      ctx.arc(position[0], position[1], radius, 0, this.toRadians(amount));
      ctx.fill();
      ctx.stroke();
      ctx.closePath();
    },
    toRadians: function toRadians(degrees) {
      return degrees * Math.PI / 180;
    },
    pie: function pie(ctx, w, h, yOffset, datalist, colorList, textSize, textColor) {
      var foTaken = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
      var foWin = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;

      var radius = h / 2 - 2;
      var centerx = w / 2;
      var centery = h / 2 + yOffset;
      var total = 0;
      var labelxy = [];

      for (var y = 0; y < datalist.length; y++) {
        total += datalist[y];
      }
      var lastend = 0;
      var offset = Math.PI / 2;
      for (var x = 0; x < datalist.length; x++) {
        var thispart = datalist[x];
        ctx.beginPath();
        ctx.fillStyle = colorList[x];
        ctx.moveTo(centerx, centery);
        var arcsector = Math.PI * (2 * thispart / total);
        ctx.arc(centerx, centery, radius, lastend - offset, lastend + arcsector - offset, false);
        ctx.lineTo(centerx, centery);
        ctx.fill();
        ctx.closePath();
        if (thispart > total / 20) {
          labelxy.push(lastend + arcsector / 2 + Math.PI + offset);
        }
        lastend += arcsector;
      }
      var lradius = radius * 3 / 5;
      ctx.strokeStyle = textColor;
      ctx.fillStyle = textColor;
      for (var i = 0; i < labelxy.length; i++) {
        var fontSize = lradius / textSize;
        ctx.textAlign = 'center';
        ctx.font = fontSize + 'px sans-serif';
        var langle = labelxy[i];
        var dx = centerx + lradius * Math.cos(langle);
        var dy = centery + lradius * Math.sin(langle);
        if (this.usePercentage) {
          ctx.fillText(datalist[i] + '%', dx, dy);
        } else {
          // console.log('DX: ' + lradius)
          if (i % 2 === 0) {
            ctx.fillText(foWin + '/' + foTaken, dx, dy);
          } else {
            ctx.fillText(foTaken - foWin + '/' + foTaken, dx, dy);
          }
        }
      }
    },
    drawText: function drawText(ctx, text, textPosition) {
      var textSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '26px';
      var color = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'white';

      ctx.beginPath();
      ctx.font = textSize + ' sans-serif';
      ctx.fillStyle = color;
      ctx.fillText(text, textPosition[0], textPosition[1]);
      ctx.closePath();
    }
  },
  mounted: function mounted() {
    if (this.defaultShow) {
      this.show = true;
    }
    this.gameId = this.$route.params.gameId;
    this.fetchFaceoffs();
    this.fetchPlayers();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sort_table__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    gameId: { type: Number, required: true },
    period: { type: Number, required: true },
    team: { type: Number, required: true },
    // Object with a default value
    gameInfo: {
      type: Object,
      // Object or array defaults must be returned from
      // a factory function. The function receives the raw
      // props received by the component as the argument.
      default: function _default(rawProps) {
        return {};
      }
    }
  },
  data: function data() {
    return {
      teamId: 0,
      teamName: 0
    };
  },
  components: {
    SortTable: __WEBPACK_IMPORTED_MODULE_0__sort_table___default.a
  },
  methods: {
    gameDataLoaded: function gameDataLoaded() {
      // console.log('Loaded')
      if (this.team === 0) {
        this.teamId = this.gameInfo.home_team.id;
        this.teamName = this.gameInfo.home_team.name;
      } else {
        this.teamId = this.gameInfo.away_team.id;
        this.teamName = this.gameInfo.away_team.name;
      }
      console.log('Prop value: ' + this.team + ' teamId Set: ' + this.teamId + ' Home: ' + this.gameInfo.home_team.id + ' Away: ' + this.gameInfo.away_team.id);
      console.log(JSON.stringify(this.gameInfo));
    },
    filterChange: function filterChange() {
      // console.log('Filter update: ' + this.PenaltySelected)
    }
  },
  mounted: function mounted() {
    console.log('Game Id: ' + this.gameId);
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sort_table__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    gameId: { type: Number, required: true },
    period: { type: Number, required: true }
  },
  components: {
    SortTable: __WEBPACK_IMPORTED_MODULE_0__sort_table___default.a
  },
  methods: {
    gameDataLoaded: function gameDataLoaded() {
      // console.log('Loaded')
    },
    filterChange: function filterChange() {
      // console.log('Filter update: ' + this.PenaltySelected)
    }
  },
  mounted: function mounted() {
    console.log('Game Id: ' + this.gameId);
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sort_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    gameId: { type: Number, required: true },
    period: { type: Number, required: true }
  },
  components: {
    SortTable: __WEBPACK_IMPORTED_MODULE_0__sort_table___default.a,
    'chart': __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a,
    'sort-table': __WEBPACK_IMPORTED_MODULE_0__sort_table___default.a
  },
  data: function data() {
    return {
      FaceoffsChart: [],
      apex_fo_series: [{
        name: 'Wins',
        data: []
      }, {
        name: 'Losses',
        data: []
      }],
      apex_fo_ro_series: [{
        name: 'Wins',
        data: []
      }, {
        name: 'Losses',
        data: []
      }],
      apex_fo_rd_series: [{
        name: 'Wins',
        data: []
      }, {
        name: 'Losses',
        data: []
      }],
      apex_fo_lo_series: [{
        name: 'Wins',
        data: []
      }, {
        name: 'Losses',
        data: []
      }],
      apex_fo_ld_series: [{
        name: 'Wins',
        data: []
      }, {
        name: 'Losses',
        data: []
      }],
      apex_fo_options: {
        colors: ['#8b0505d1', '#000000'],
        chart: { type: 'bar', height: 900, stacked: true },
        plotOptions: { bar: { horizontal: true } }
      }
    };
  },

  computed: {},
  watch: {
    endpoint: {
      handler: function handler(endpoint) {
        this.url = endpoint;
      },
      immediate: true
    },
    gameId: {
      handler: function handler(postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
        this.fetchFaceoffChart();
      },
      immediate: true
    }
  },
  methods: {
    gameDataLoaded: function gameDataLoaded() {
      // onsole.log('Loaded')
    },
    filterChange: function filterChange() {
      // console.log('Filter update: ' + this.PenaltySelected)
    },
    fetchFaceoffChart: function fetchFaceoffChart() {
      var _this = this;

      if (this.gameId !== 0) {
        this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/faceoffs-short/' + this.gameId + '/' + 0, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          // console.log('Faceoff Data is ' + JSON.stringify(response.data))
          _this.FaceoffsChart = response.data;
          var players = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = _this.FaceoffsChart.all_situations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var fo = _step.value;

              // Totals
              _this.apex_fo_series[0].data.push(fo.total_win);
              _this.apex_fo_series[1].data.push(fo.total_loss);
              // Left Defensive
              _this.apex_fo_ld_series[0].data.push(fo.left_win_dz);
              _this.apex_fo_ld_series[1].data.push(fo.left_loss_dz);
              // Left Offensive
              _this.apex_fo_lo_series[0].data.push(fo.left_win_oz);
              _this.apex_fo_lo_series[1].data.push(fo.left_loss_oz);
              // Right Defensive
              _this.apex_fo_rd_series[0].data.push(fo.right_win_dz);
              _this.apex_fo_rd_series[1].data.push(fo.right_loss_dz);
              // Right Offensive
              _this.apex_fo_ro_series[0].data.push(fo.right_win_oz);
              _this.apex_fo_ro_series[1].data.push(fo.right_loss_oz);
              players.push(fo.player_id);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var newOptions = { xaxis: { categories: players } };
          _this.$refs.apex_fo_chart.updateOptions(newOptions);
          _this.$refs.apex_fo_ld_chart.updateOptions(newOptions);
          _this.$refs.apex_fo_lo_chart.updateOptions(newOptions);
          _this.$refs.apex_fo_rd_chart.updateOptions(newOptions);
          _this.$refs.apex_fo_ro_chart.updateOptions(newOptions);
        }, function (response) {});
      }
    },
    resetData: function resetData() {
      this.apex_fo_chart[0].data = [];
      this.apex_fo_chart[1].data = [];
    }
  },
  mounted: function mounted() {
    // console.log('Fetch Faceoffs: ' + this.gameId)
    this.fetchFaceoffChart();
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sort_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    gameId: { type: Number, required: true },
    period: { type: Number, required: true }
  },
  components: {
    SortTable: __WEBPACK_IMPORTED_MODULE_0__sort_table___default.a,
    'chart': __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a
  },
  data: function data() {
    return {
      HitsChart: [],
      apex_hit_series: [{
        name: 'Hits',
        data: []
      }],
      apex_hit_options: {
        colors: ['#8b0505d1', '#000000'],
        chart: { type: 'bar', stacked: false },
        plotOptions: { bar: { horizontal: false } }
      }
    };
  },

  computed: {},
  watch: {
    endpoint: {
      handler: function handler(endpoint) {
        this.url = endpoint;
      },
      immediate: true
    },
    gameId: {
      handler: function handler(postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
        this.fetchHitsChart();
      },
      immediate: true
    }
  },
  methods: {
    gameDataLoaded: function gameDataLoaded() {
      console.log('Loaded');
    },
    filterChange: function filterChange() {},
    fetchHitsChart: function fetchHitsChart() {
      var _this = this;

      if (this.gameId !== 0) {
        this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/hits/' + this.gameId + '/' + 0, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          // console.log('Hit Data is ' + JSON.stringify(response.data))
          _this.HitsChart = response.data;
          var players = [];
          var allSeries = [];
          var sortedHits = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(_this.HitsChart.home_players, function (o) {
            return o.hit_total;
          }, ['desc']);
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = sortedHits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var hit = _step.value;

              // Totals
              // this.apex_hit_series[0].data.push(total)
              allSeries.push(hit.hit_total);
              players.push(hit.player_id);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.apex_hit_series[0].data = allSeries;
          var newOptions = { xaxis: { categories: players } };
          _this.$refs.apex_hit_chart.updateOptions(newOptions);
        }, function (response) {});
      }
    },
    resetData: function resetData() {
      this.apex_hit_chart[0].data = [];
    }
  },
  mounted: function mounted() {
    // console.log('Fetch Hits: ' + this.gameId)
    this.fetchHitsChart();
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shot_diff_time_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shot_diff_time_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shot_diff_time_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shots_quality_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shots_quality_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shots_quality_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shots_heatmap_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shots_heatmap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shots_heatmap_vue__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    gameId: { type: Number, required: true },
    period: { type: Number, required: true },
    gameInfo: { type: Object, required: true }
  },
  components: {
    'shot-diff-time': __WEBPACK_IMPORTED_MODULE_0__shot_diff_time_vue___default.a,
    'shot-quality': __WEBPACK_IMPORTED_MODULE_1__shots_quality_vue___default.a,
    'shots-heatmap': __WEBPACK_IMPORTED_MODULE_2__shots_heatmap_vue___default.a
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {
    endpoint: {
      handler: function handler(endpoint) {
        this.url = endpoint;
      },
      immediate: true
    },
    gameId: {
      handler: function handler(postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
      },
      immediate: true
    }
  },
  methods: {
    gameDataLoaded: function gameDataLoaded() {
      // console.log('Shots Loaded')
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__match_summary_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__match_summary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__match_summary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gamesheet_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gamesheet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gamesheet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__match_faceoffs_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__match_faceoffs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__match_faceoffs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__match_shots_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__match_shots_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__match_shots_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__match_turnovers_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__match_turnovers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__match_turnovers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__match_hits_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__match_hits_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__match_hits_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__match_zone_entries_vue__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__match_zone_entries_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__match_zone_entries_vue__);
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'game-summary': __WEBPACK_IMPORTED_MODULE_0__match_summary_vue___default.a,
    'gamesheet': __WEBPACK_IMPORTED_MODULE_1__gamesheet_vue___default.a,
    'faceoffs': __WEBPACK_IMPORTED_MODULE_2__match_faceoffs_vue___default.a,
    'shots': __WEBPACK_IMPORTED_MODULE_3__match_shots_vue___default.a,
    'turnovers': __WEBPACK_IMPORTED_MODULE_4__match_turnovers_vue___default.a,
    'hits': __WEBPACK_IMPORTED_MODULE_5__match_hits_vue___default.a,
    'zone-entries': __WEBPACK_IMPORTED_MODULE_6__match_zone_entries_vue___default.a
  },
  data: function data() {
    return {
      period: 0,
      gameId: 0,
      gameInfo: {}
    };
  },
  methods: {
    getGameData: function getGameData() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games/get/single/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (res) {
        _this.gameInfo = res;
        _this.gameInfo = _this.gameInfo['data'][0];
        console.log('Response for game was: ' + JSON.stringify(_this.gameInfo.home_team.name));
      });
    }
  },
  mounted: function mounted() {
    this.period = parseInt(this.$route.params.period);
    this.gameId = parseInt(this.$route.params.gameId);
    this.getGameData();
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sub_table_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sub_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__sub_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shots_heatmap_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shots_heatmap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shots_heatmap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shots_quality_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shots_quality_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shots_quality_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__season_stats_faceoffs_pvp_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__season_stats_faceoffs_pvp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__season_stats_faceoffs_pvp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_bulma_collapse__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
var _computed;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import simpleheat from '../../store/modules/simpleheat/simpleheat'
// import randomColor from '../../store/modules/utils/randomColor'











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'player',
  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_9_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_9_vue_bulma_collapse__["Item"],
    'sub-table': __WEBPACK_IMPORTED_MODULE_3__sub_table_vue___default.a,
    'shot-diff-time': __WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue___default.a,
    'FaceoffTeamVS': __WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue___default.a,
    'ShotsHeatmap': __WEBPACK_IMPORTED_MODULE_6__shots_heatmap_vue___default.a,
    'shot-quality': __WEBPACK_IMPORTED_MODULE_7__shots_quality_vue___default.a,
    'faceoffs-pvp': __WEBPACK_IMPORTED_MODULE_8__season_stats_faceoffs_pvp_vue___default.a
  },
  data: function data() {
    return {
      period: 1,
      Faceoffs: [],
      Shots: [],
      OddmanRushes: [],
      Fixture: [],
      SOT: [],
      Gamesheet: [],
      Hits: [],
      PlusMinus: [],
      PlusMinusAuto: [],
      FaceoffsChart: [],
      homeShotLocationData: [],
      Summary: [],
      bar_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              callback: function callback(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }]
        }
      },
      pie_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        responsive: true
      },
      sot_bar_options: {
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: false,
            barPercentage: 1.4,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: false,
            barPercentage: 1.4,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              callback: function callback(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }]
        }
      },
      fo_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true,
              beginAtZero: true,
              callback: function callback(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }]
        }
      },
      fo_total_options: {},
      shots_horz_bar_options: {
        title: {
          display: false
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true,
              beginAtZero: true,
              callback: function callback(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }]
        }
      },
      backgroundColor: ['#1fc8db', '#fce473', '#42afe3', '#ed6c63', '#97cd76'],
      isFaceoffsPvp: false,
      isFaceoffOpen: true,
      homeZoneShots: [],
      awayZoneShots: [],
      shotmapSituations: [{
        text: 'All',
        value: -1
      }, {
        text: 'Even Handed',
        value: 'EvenHanded'
      }, {
        text: 'Power Play',
        value: 'PowerPlay'
      }, {
        text: 'Short Handed',
        value: 'PenaltyKill'
      }],
      shotTypeOptions: [{
        text: 'All',
        value: -1
      }, {
        text: 'Goals',
        value: 'Goal'
      }, {
        text: 'On Net',
        value: 'OnNet'
      }, {
        text: 'Missed Target',
        value: 'MissedNet'
      }, {
        text: 'Blocked',
        value: 'Blocked'
      }],
      plusMinusOptions: [{
        text: 'Line',
        value: 'line'
      }, {
        text: 'Differential',
        value: 'differential'
      }, {
        text: 'Shots For',
        value: 'for'
      }, {
        text: 'Shots Against',
        value: 'against'
      }],
      sotOptions: [{
        text: 'All Situations',
        value: 'all'
      }, {
        text: 'Even Handed',
        value: 'eh'
      }, {
        text: 'Power Play',
        value: 'pp'
      }, {
        text: 'Short Handed',
        value: 'sh'
      }],
      selectedSOTSort: 'eh',
      selectedPlusMinusSort: 'line',
      selectedShotType: 'OnNet',
      selectedShotSituation: 'EvenHanded',
      selectedHitSort: 'eh',
      Turnovers: []
    };
  },

  computed: (_computed = {
    sortBytimeGT: function sortBytimeGT() {
      /*eslint-disable */
      var gt = this.Gamesheet.filter(function (a) {
        return a.position == 'GT';
      });
      return gt.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortBytimeDefense: function sortBytimeDefense() {
      /*eslint-disable */
      var defense = this.Gamesheet.filter(function (a) {
        return a.position == 'LD' || a.position == 'RD';
      });
      return defense.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortBytimeForwards: function sortBytimeForwards() {
      var forwards = this.Gamesheet.filter(function (a) {
        return a.position == 'LW' || a.position == 'C' || a.position == 'RW';
      });
      return forwards.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortBytimeAll: function sortBytimeAll() {
      var all = this.Gamesheet.filter(function (a) {
        return a.position == 'LW' || a.position == 'C' || a.position == 'RW' || a.position == 'LD' || a.position == 'RD';
      });
      return all.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortFoByDiffLeft: function sortFoByDiffLeft() {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_left'], ['desc']))
      return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.FaceoffsChart.all_situations, ['total_diff_left'], ['desc']);
    },
    sortFoByDiffCenter: function sortFoByDiffCenter() {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_center'], ['desc']))
      return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.FaceoffsChart.all_situations, ['total_diff_center'], ['desc']);
    },
    sortFoByDiffRight: function sortFoByDiffRight() {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_right'], ['desc']))
      return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.FaceoffsChart.all_situations, ['total_diff_right'], ['desc']);
    },
    sortByTOAscEH: function sortByTOAscEH() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.Turnovers.home_players, ['pos', 'total_eh', 'player_defensive_eh', 'player_neutral_eh', 'player_offensive_eh'], ['asc', 'desc', 'desc', 'desc', 'desc']);
    },
    sortByTOAscPP: function sortByTOAscPP() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.Turnovers.home_players, ['pos', 'total_pp', 'player_defensive_pp', 'player_neutral_pp', 'player_offensive_pp'], ['asc', 'desc', 'desc', 'desc', 'desc']);
    },
    sortByTOAscSH: function sortByTOAscSH() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.Turnovers.home_players, ['pos', 'total_sh', 'player_defensive_sh', 'player_neutral_sh', 'player_offensive_sh'], ['asc', 'desc', 'desc', 'desc', 'desc']);
    },
    sortByHits: function sortByHits() {
      if (this.selectedHitSort === 'eh') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.Hits.home_players, ['hits_eh', 'asc']);
      } else if (this.selectedHitSort === 'pp') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.Hits.home_players, ['hits_pp', 'asc']);
      } else if (this.selectedHitSort === 'sh') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.Hits.home_players, ['hits_sh', 'asc']);
      } else if (this.selectedHitSort === 'all') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.Hits.home_players, ['hit_total', 'asc']);
      } else {
        return this.Hits.home_players;
      }
    },
    sortBySOT: function sortBySOT() {
      if (this.selectedSOTSort === 'eh') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.SOT.home_players, ['sot_eh'], ['asc']);
      } else if (this.selectedSOTSort === 'pp') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.SOT.home_players, ['sot_pp'], ['asc']);
      } else if (this.selectedSOTSort === 'sh') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.SOT.home_players, ['sot_sh'], ['asc']);
      } else if (this.selectedSOTSort === 'all') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.SOT.home_players, ['sot_total'], ['asc']);
      } else {
        return this.SOT.home_players;
      }
    },
    sortBySOTAway: function sortBySOTAway() {
      if (this.selectedSOTSort === 'eh') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.SOT.away_players, ['sot_eh'], ['desc']);
      } else if (this.selectedSOTSort === 'pp') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.SOT.away_players, ['sot_pp'], ['desc']);
      } else if (this.selectedSOTSort === 'sh') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.SOT.away_players, ['sot_sh'], ['desc']);
      } else if (this.selectedSOTSort === 'all') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.SOT.away_players, ['sot_total'], ['desc']);
      } else {
        return this.SOT.away_players;
      }
    },
    sortByPlusMinusHomeAuto: function sortByPlusMinusHomeAuto() {
      // console.log('Plus minus sort option is: '  + this.selectedPlusMinusSort)
      if (this.selectedPlusMinusSort === 'line') {
        // console.log('Plus minus data: ' + JSON.stringify(this.PlusMinus.home_players))
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'line_number'], ['asc', 'asc']);
      } else if (this.selectedPlusMinusSort === 'differential') {
        console.log(JSON.stringify(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'diff'], ['asc', 'desc'])));
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'diff'], ['asc', 'desc']);
      } else if (this.selectedPlusMinusSort === 'for') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'shots_for'], ['asc', 'desc']);
      } else if (this.selectedPlusMinusSort === 'against') {
        return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'shots_against'], ['asc', 'desc']);
      } else {
        return this.PlusMinusAuto.home_players;
      }
    },
    sortByPlusMinusHomeAutoDiff: function sortByPlusMinusHomeAutoDiff() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'diff'], ['asc', 'desc']);
    },
    fo_total_chart: function fo_total_chart() {
      return {
        labels: this.fo_total_labels,
        datasets: [{
          data: this.getFoChartTotals(),
          backgroundColor: this.backgroundColor
        }]
      };
    },
    fo_player_l: function fo_player_l() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortFoByDiffLeft[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.sortFoByDiffLeft[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var leftWin = _step2.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.sortFoByDiffLeft[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var leftLoss = _step3.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c: function fo_player_c() {
      var playerLabels = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.sortFoByDiffCenter[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var label = _step4.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.sortFoByDiffCenter[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var center = _step5.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.sortFoByDiffCenter[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var centerLoss = _step6.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r: function fo_player_r() {
      var playerLabels = [];
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.sortFoByDiffRight[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var label = _step7.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.sortFoByDiffRight[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var right = _step8.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.sortFoByDiffRight[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var rightLoss = _step9.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_t: function fo_player_t() {
      if (this.FaceoffsChart.all_situations) {
        var playerLabels = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = this.FaceoffsChart.all_situations[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var label = _step10.value;

            playerLabels.push(label.player_id);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var data = {
          labels: playerLabels
        };
        data.datsets = [];
        var playerTotalWin = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = this.FaceoffsChart.all_situations[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var win = _step11.value;

            playerTotalWin.push(win.total_win);
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        var playerTotalLoss = [];
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
          for (var _iterator12 = this.FaceoffsChart.all_situations[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var loss = _step12.value;

            playerTotalLoss.push(loss.total_loss);
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }

        data.datasets = [{
          data: playerTotalWin,
          label: 'Total Win',
          backgroundColor: 'rgba(255, 206, 86, 1)',
          borderColor: 'rgba(255, 206, 86, 1)'
        }, {
          data: playerTotalLoss,
          label: 'Total Loss',
          backgroundColor: 'rgba(255, 99, 132, 1)',
          borderColor: 'rgba(255, 99, 132, 1)'
        }];
        return data;
      }
    },
    fo_player_l_eh: function fo_player_l_eh() {
      var playerLabels = [];
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var label = _step13.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var leftWin = _step14.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var leftLoss = _step15.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c_eh: function fo_player_c_eh() {
      var playerLabels = [];
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var label = _step16.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var center = _step17.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var centerLoss = _step18.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r_eh: function fo_player_r_eh() {
      var playerLabels = [];
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var label = _step19.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;

      try {
        for (var _iterator20 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var right = _step20.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion21 = true;
      var _didIteratorError21 = false;
      var _iteratorError21 = undefined;

      try {
        for (var _iterator21 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
          var rightLoss = _step21.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion21 && _iterator21.return) {
            _iterator21.return();
          }
        } finally {
          if (_didIteratorError21) {
            throw _iteratorError21;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_l_pp: function fo_player_l_pp() {
      var playerLabels = [];
      var _iteratorNormalCompletion22 = true;
      var _didIteratorError22 = false;
      var _iteratorError22 = undefined;

      try {
        for (var _iterator22 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
          var label = _step22.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError22 = true;
        _iteratorError22 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion22 && _iterator22.return) {
            _iterator22.return();
          }
        } finally {
          if (_didIteratorError22) {
            throw _iteratorError22;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion23 = true;
      var _didIteratorError23 = false;
      var _iteratorError23 = undefined;

      try {
        for (var _iterator23 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
          var leftWin = _step23.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError23 = true;
        _iteratorError23 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion23 && _iterator23.return) {
            _iterator23.return();
          }
        } finally {
          if (_didIteratorError23) {
            throw _iteratorError23;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion24 = true;
      var _didIteratorError24 = false;
      var _iteratorError24 = undefined;

      try {
        for (var _iterator24 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
          var leftLoss = _step24.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError24 = true;
        _iteratorError24 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion24 && _iterator24.return) {
            _iterator24.return();
          }
        } finally {
          if (_didIteratorError24) {
            throw _iteratorError24;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c_pp: function fo_player_c_pp() {
      var playerLabels = [];
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var label = _step25.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion26 = true;
      var _didIteratorError26 = false;
      var _iteratorError26 = undefined;

      try {
        for (var _iterator26 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
          var center = _step26.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError26 = true;
        _iteratorError26 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion26 && _iterator26.return) {
            _iterator26.return();
          }
        } finally {
          if (_didIteratorError26) {
            throw _iteratorError26;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion27 = true;
      var _didIteratorError27 = false;
      var _iteratorError27 = undefined;

      try {
        for (var _iterator27 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
          var centerLoss = _step27.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError27 = true;
        _iteratorError27 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion27 && _iterator27.return) {
            _iterator27.return();
          }
        } finally {
          if (_didIteratorError27) {
            throw _iteratorError27;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r_pp: function fo_player_r_pp() {
      var playerLabels = [];
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var label = _step28.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion29 = true;
      var _didIteratorError29 = false;
      var _iteratorError29 = undefined;

      try {
        for (var _iterator29 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
          var right = _step29.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError29 = true;
        _iteratorError29 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion29 && _iterator29.return) {
            _iterator29.return();
          }
        } finally {
          if (_didIteratorError29) {
            throw _iteratorError29;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion30 = true;
      var _didIteratorError30 = false;
      var _iteratorError30 = undefined;

      try {
        for (var _iterator30 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
          var rightLoss = _step30.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError30 = true;
        _iteratorError30 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion30 && _iterator30.return) {
            _iterator30.return();
          }
        } finally {
          if (_didIteratorError30) {
            throw _iteratorError30;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_l_sh: function fo_player_l_sh() {
      var playerLabels = [];
      var _iteratorNormalCompletion31 = true;
      var _didIteratorError31 = false;
      var _iteratorError31 = undefined;

      try {
        for (var _iterator31 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
          var label = _step31.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError31 = true;
        _iteratorError31 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion31 && _iterator31.return) {
            _iterator31.return();
          }
        } finally {
          if (_didIteratorError31) {
            throw _iteratorError31;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion32 = true;
      var _didIteratorError32 = false;
      var _iteratorError32 = undefined;

      try {
        for (var _iterator32 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
          var leftWin = _step32.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError32 = true;
        _iteratorError32 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion32 && _iterator32.return) {
            _iterator32.return();
          }
        } finally {
          if (_didIteratorError32) {
            throw _iteratorError32;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion33 = true;
      var _didIteratorError33 = false;
      var _iteratorError33 = undefined;

      try {
        for (var _iterator33 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
          var leftLoss = _step33.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError33 = true;
        _iteratorError33 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion33 && _iterator33.return) {
            _iterator33.return();
          }
        } finally {
          if (_didIteratorError33) {
            throw _iteratorError33;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c_sh: function fo_player_c_sh() {
      var playerLabels = [];
      var _iteratorNormalCompletion34 = true;
      var _didIteratorError34 = false;
      var _iteratorError34 = undefined;

      try {
        for (var _iterator34 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
          var label = _step34.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError34 = true;
        _iteratorError34 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion34 && _iterator34.return) {
            _iterator34.return();
          }
        } finally {
          if (_didIteratorError34) {
            throw _iteratorError34;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion35 = true;
      var _didIteratorError35 = false;
      var _iteratorError35 = undefined;

      try {
        for (var _iterator35 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
          var center = _step35.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError35 = true;
        _iteratorError35 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion35 && _iterator35.return) {
            _iterator35.return();
          }
        } finally {
          if (_didIteratorError35) {
            throw _iteratorError35;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion36 = true;
      var _didIteratorError36 = false;
      var _iteratorError36 = undefined;

      try {
        for (var _iterator36 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
          var centerLoss = _step36.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError36 = true;
        _iteratorError36 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion36 && _iterator36.return) {
            _iterator36.return();
          }
        } finally {
          if (_didIteratorError36) {
            throw _iteratorError36;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r_sh: function fo_player_r_sh() {
      var playerLabels = [];
      var _iteratorNormalCompletion37 = true;
      var _didIteratorError37 = false;
      var _iteratorError37 = undefined;

      try {
        for (var _iterator37 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
          var label = _step37.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError37 = true;
        _iteratorError37 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion37 && _iterator37.return) {
            _iterator37.return();
          }
        } finally {
          if (_didIteratorError37) {
            throw _iteratorError37;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion38 = true;
      var _didIteratorError38 = false;
      var _iteratorError38 = undefined;

      try {
        for (var _iterator38 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
          var right = _step38.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError38 = true;
        _iteratorError38 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion38 && _iterator38.return) {
            _iterator38.return();
          }
        } finally {
          if (_didIteratorError38) {
            throw _iteratorError38;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion39 = true;
      var _didIteratorError39 = false;
      var _iteratorError39 = undefined;

      try {
        for (var _iterator39 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
          var rightLoss = _step39.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError39 = true;
        _iteratorError39 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion39 && _iterator39.return) {
            _iterator39.return();
          }
        } finally {
          if (_didIteratorError39) {
            throw _iteratorError39;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    to_player_eh: function to_player_eh() {
      var playerLabels = [];
      var _iteratorNormalCompletion40 = true;
      var _didIteratorError40 = false;
      var _iteratorError40 = undefined;

      try {
        for (var _iterator40 = this.sortByTOAscEH[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
          var label = _step40.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError40 = true;
        _iteratorError40 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion40 && _iterator40.return) {
            _iterator40.return();
          }
        } finally {
          if (_didIteratorError40) {
            throw _iteratorError40;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerOffensive = [];
      var playerNeutral = [];
      var playerDefensive = [];
      var _iteratorNormalCompletion41 = true;
      var _didIteratorError41 = false;
      var _iteratorError41 = undefined;

      try {
        for (var _iterator41 = this.sortByTOAscEH[Symbol.iterator](), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
          var offensive = _step41.value;

          playerOffensive.push(offensive.player_offensive_eh);
        }
      } catch (err) {
        _didIteratorError41 = true;
        _iteratorError41 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion41 && _iterator41.return) {
            _iterator41.return();
          }
        } finally {
          if (_didIteratorError41) {
            throw _iteratorError41;
          }
        }
      }

      var _iteratorNormalCompletion42 = true;
      var _didIteratorError42 = false;
      var _iteratorError42 = undefined;

      try {
        for (var _iterator42 = this.sortByTOAscEH[Symbol.iterator](), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
          var neutral = _step42.value;

          playerNeutral.push(neutral.player_neutral_eh);
        }
      } catch (err) {
        _didIteratorError42 = true;
        _iteratorError42 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion42 && _iterator42.return) {
            _iterator42.return();
          }
        } finally {
          if (_didIteratorError42) {
            throw _iteratorError42;
          }
        }
      }

      var _iteratorNormalCompletion43 = true;
      var _didIteratorError43 = false;
      var _iteratorError43 = undefined;

      try {
        for (var _iterator43 = this.sortByTOAscEH[Symbol.iterator](), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
          var defensive = _step43.value;

          playerDefensive.push(defensive.player_defensive_eh);
        }
      } catch (err) {
        _didIteratorError43 = true;
        _iteratorError43 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion43 && _iterator43.return) {
            _iterator43.return();
          }
        } finally {
          if (_didIteratorError43) {
            throw _iteratorError43;
          }
        }
      }

      data.datasets = [{
        data: playerDefensive,
        label: 'Defensive',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerNeutral,
        label: 'Neutral',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54,162,235, 1)'
      }, {
        data: playerOffensive,
        label: 'Offensive',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    to_player_pp: function to_player_pp() {
      var playerLabels = [];
      var _iteratorNormalCompletion44 = true;
      var _didIteratorError44 = false;
      var _iteratorError44 = undefined;

      try {
        for (var _iterator44 = this.sortByTOAscPP[Symbol.iterator](), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
          var label = _step44.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError44 = true;
        _iteratorError44 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion44 && _iterator44.return) {
            _iterator44.return();
          }
        } finally {
          if (_didIteratorError44) {
            throw _iteratorError44;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerOffensive = [];
      var playerNeutral = [];
      var playerDefensive = [];
      var _iteratorNormalCompletion45 = true;
      var _didIteratorError45 = false;
      var _iteratorError45 = undefined;

      try {
        for (var _iterator45 = this.sortByTOAscPP[Symbol.iterator](), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
          var offensive = _step45.value;

          playerOffensive.push(offensive.player_offensive_pp);
        }
      } catch (err) {
        _didIteratorError45 = true;
        _iteratorError45 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion45 && _iterator45.return) {
            _iterator45.return();
          }
        } finally {
          if (_didIteratorError45) {
            throw _iteratorError45;
          }
        }
      }

      var _iteratorNormalCompletion46 = true;
      var _didIteratorError46 = false;
      var _iteratorError46 = undefined;

      try {
        for (var _iterator46 = this.sortByTOAscPP[Symbol.iterator](), _step46; !(_iteratorNormalCompletion46 = (_step46 = _iterator46.next()).done); _iteratorNormalCompletion46 = true) {
          var neutral = _step46.value;

          playerNeutral.push(neutral.player_neutral_pp);
        }
      } catch (err) {
        _didIteratorError46 = true;
        _iteratorError46 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion46 && _iterator46.return) {
            _iterator46.return();
          }
        } finally {
          if (_didIteratorError46) {
            throw _iteratorError46;
          }
        }
      }

      var _iteratorNormalCompletion47 = true;
      var _didIteratorError47 = false;
      var _iteratorError47 = undefined;

      try {
        for (var _iterator47 = this.sortByTOAscPP[Symbol.iterator](), _step47; !(_iteratorNormalCompletion47 = (_step47 = _iterator47.next()).done); _iteratorNormalCompletion47 = true) {
          var defensive = _step47.value;

          playerDefensive.push(defensive.player_defensive_pp);
        }
      } catch (err) {
        _didIteratorError47 = true;
        _iteratorError47 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion47 && _iterator47.return) {
            _iterator47.return();
          }
        } finally {
          if (_didIteratorError47) {
            throw _iteratorError47;
          }
        }
      }

      data.datasets = [{
        data: playerDefensive,
        label: 'Defensive',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerNeutral,
        label: 'Neutral',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54,162,235, 1)'
      }, {
        data: playerOffensive,
        label: 'Offensive',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    to_player_sh: function to_player_sh() {
      var playerLabels = [];
      var _iteratorNormalCompletion48 = true;
      var _didIteratorError48 = false;
      var _iteratorError48 = undefined;

      try {
        for (var _iterator48 = this.sortByTOAscSH[Symbol.iterator](), _step48; !(_iteratorNormalCompletion48 = (_step48 = _iterator48.next()).done); _iteratorNormalCompletion48 = true) {
          var label = _step48.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError48 = true;
        _iteratorError48 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion48 && _iterator48.return) {
            _iterator48.return();
          }
        } finally {
          if (_didIteratorError48) {
            throw _iteratorError48;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerOffensive = [];
      var playerNeutral = [];
      var playerDefensive = [];
      var _iteratorNormalCompletion49 = true;
      var _didIteratorError49 = false;
      var _iteratorError49 = undefined;

      try {
        for (var _iterator49 = this.sortByTOAscSH[Symbol.iterator](), _step49; !(_iteratorNormalCompletion49 = (_step49 = _iterator49.next()).done); _iteratorNormalCompletion49 = true) {
          var offensive = _step49.value;

          playerOffensive.push(offensive.player_offensive_sh);
        }
      } catch (err) {
        _didIteratorError49 = true;
        _iteratorError49 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion49 && _iterator49.return) {
            _iterator49.return();
          }
        } finally {
          if (_didIteratorError49) {
            throw _iteratorError49;
          }
        }
      }

      var _iteratorNormalCompletion50 = true;
      var _didIteratorError50 = false;
      var _iteratorError50 = undefined;

      try {
        for (var _iterator50 = this.sortByTOAscSH[Symbol.iterator](), _step50; !(_iteratorNormalCompletion50 = (_step50 = _iterator50.next()).done); _iteratorNormalCompletion50 = true) {
          var neutral = _step50.value;

          playerNeutral.push(neutral.player_neutral_sh);
        }
      } catch (err) {
        _didIteratorError50 = true;
        _iteratorError50 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion50 && _iterator50.return) {
            _iterator50.return();
          }
        } finally {
          if (_didIteratorError50) {
            throw _iteratorError50;
          }
        }
      }

      var _iteratorNormalCompletion51 = true;
      var _didIteratorError51 = false;
      var _iteratorError51 = undefined;

      try {
        for (var _iterator51 = this.sortByTOAscSH[Symbol.iterator](), _step51; !(_iteratorNormalCompletion51 = (_step51 = _iterator51.next()).done); _iteratorNormalCompletion51 = true) {
          var defensive = _step51.value;

          playerDefensive.push(defensive.player_defensive_sh);
        }
      } catch (err) {
        _didIteratorError51 = true;
        _iteratorError51 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion51 && _iterator51.return) {
            _iterator51.return();
          }
        } finally {
          if (_didIteratorError51) {
            throw _iteratorError51;
          }
        }
      }

      data.datasets = [{
        data: playerDefensive,
        label: 'Defensive',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerNeutral,
        label: 'Neutral',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54,162,235, 1)'
      }, {
        data: playerOffensive,
        label: 'Offensive',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    hit_player_totals: function hit_player_totals() {
      var playerLabels = [];
      var _iteratorNormalCompletion52 = true;
      var _didIteratorError52 = false;
      var _iteratorError52 = undefined;

      try {
        for (var _iterator52 = this.sortByHits[Symbol.iterator](), _step52; !(_iteratorNormalCompletion52 = (_step52 = _iterator52.next()).done); _iteratorNormalCompletion52 = true) {
          var label = _step52.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError52 = true;
        _iteratorError52 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion52 && _iterator52.return) {
            _iterator52.return();
          }
        } finally {
          if (_didIteratorError52) {
            throw _iteratorError52;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerHits = [];
      var _iteratorNormalCompletion53 = true;
      var _didIteratorError53 = false;
      var _iteratorError53 = undefined;

      try {
        for (var _iterator53 = this.sortByHits[Symbol.iterator](), _step53; !(_iteratorNormalCompletion53 = (_step53 = _iterator53.next()).done); _iteratorNormalCompletion53 = true) {
          var hits = _step53.value;

          if (this.selectedHitSort === 'eh') playerHits.push(hits.hits_eh);
          if (this.selectedHitSort === 'pp') playerHits.push(hits.hits_pp);
          if (this.selectedHitSort === 'sh') playerHits.push(hits.hits_sh);
          if (this.selectedHitSort === 'all') playerHits.push(hits.hit_total);
        }
      } catch (err) {
        _didIteratorError53 = true;
        _iteratorError53 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion53 && _iterator53.return) {
            _iterator53.return();
          }
        } finally {
          if (_didIteratorError53) {
            throw _iteratorError53;
          }
        }
      }

      data.datasets = [{
        data: playerHits,
        label: 'Hits',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    oddman_rushes_totals: function oddman_rushes_totals() {
      var playerLabels = [];
      var _iteratorNormalCompletion54 = true;
      var _didIteratorError54 = false;
      var _iteratorError54 = undefined;

      try {
        for (var _iterator54 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step54; !(_iteratorNormalCompletion54 = (_step54 = _iterator54.next()).done); _iteratorNormalCompletion54 = true) {
          var label = _step54.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError54 = true;
        _iteratorError54 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion54 && _iterator54.return) {
            _iterator54.return();
          }
        } finally {
          if (_didIteratorError54) {
            throw _iteratorError54;
          }
        }
      }

      var data = {
        labels: [this.Fixture[0].home_team.name, this.Fixture[0].away_team.name]
      };
      data.datsets = [];

      data.datasets = [{
        data: [this.OddmanRushes.home_rushes, this.OddmanRushes.away_rushes],
        backgroundColor: ['rgba(255, 206, 86, 1)', 'rgba(54, 162, 235, 1)'],
        borderColor: ['rgba(255, 206, 86, 1)', 'rgba(54, 162, 235, 1)']
      }];
      return data;
    },
    sot_totals_home: function sot_totals_home() {
      var playerLabels = [];
      var _iteratorNormalCompletion55 = true;
      var _didIteratorError55 = false;
      var _iteratorError55 = undefined;

      try {
        for (var _iterator55 = this.sortBySOT[Symbol.iterator](), _step55; !(_iteratorNormalCompletion55 = (_step55 = _iterator55.next()).done); _iteratorNormalCompletion55 = true) {
          var label = _step55.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError55 = true;
        _iteratorError55 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion55 && _iterator55.return) {
            _iterator55.return();
          }
        } finally {
          if (_didIteratorError55) {
            throw _iteratorError55;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var shotsOnTarget = [];
      var _iteratorNormalCompletion56 = true;
      var _didIteratorError56 = false;
      var _iteratorError56 = undefined;

      try {
        for (var _iterator56 = this.sortBySOT[Symbol.iterator](), _step56; !(_iteratorNormalCompletion56 = (_step56 = _iterator56.next()).done); _iteratorNormalCompletion56 = true) {
          var shot = _step56.value;

          shotsOnTarget.push(shot.sot);
        }
      } catch (err) {
        _didIteratorError56 = true;
        _iteratorError56 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion56 && _iterator56.return) {
            _iterator56.return();
          }
        } finally {
          if (_didIteratorError56) {
            throw _iteratorError56;
          }
        }
      }

      data.datasets = [{
        data: shotsOnTarget,
        label: 'Shots On Target - EH',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    sot_totals_away: function sot_totals_away() {
      var playerLabels = [];
      // console.log('SOT AWAY: ' + JSON.stringify(this.SOT.away_players))
      var _iteratorNormalCompletion57 = true;
      var _didIteratorError57 = false;
      var _iteratorError57 = undefined;

      try {
        for (var _iterator57 = this.sortBySOTAway[Symbol.iterator](), _step57; !(_iteratorNormalCompletion57 = (_step57 = _iterator57.next()).done); _iteratorNormalCompletion57 = true) {
          var label = _step57.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError57 = true;
        _iteratorError57 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion57 && _iterator57.return) {
            _iterator57.return();
          }
        } finally {
          if (_didIteratorError57) {
            throw _iteratorError57;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var shotsOnTarget = [];
      var _iteratorNormalCompletion58 = true;
      var _didIteratorError58 = false;
      var _iteratorError58 = undefined;

      try {
        for (var _iterator58 = this.sortBySOTAway[Symbol.iterator](), _step58; !(_iteratorNormalCompletion58 = (_step58 = _iterator58.next()).done); _iteratorNormalCompletion58 = true) {
          var shot = _step58.value;

          shotsOnTarget.push(shot.sot);
        }
      } catch (err) {
        _didIteratorError58 = true;
        _iteratorError58 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion58 && _iterator58.return) {
            _iterator58.return();
          }
        } finally {
          if (_didIteratorError58) {
            throw _iteratorError58;
          }
        }
      }

      data.datasets = [{
        data: shotsOnTarget,
        label: 'Shots On Target - EH',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    sot_totals: function sot_totals() {
      var playerLabels = [];
      var shotsOnTarget = [];
      var shotsOnTargetAway = [];
      // console.log('SOT AWAY: ' + JSON.stringify(this.SOT.away_players))

      var _iteratorNormalCompletion59 = true;
      var _didIteratorError59 = false;
      var _iteratorError59 = undefined;

      try {
        for (var _iterator59 = this.sortBySOT[Symbol.iterator](), _step59; !(_iteratorNormalCompletion59 = (_step59 = _iterator59.next()).done); _iteratorNormalCompletion59 = true) {
          var label = _step59.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError59 = true;
        _iteratorError59 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion59 && _iterator59.return) {
            _iterator59.return();
          }
        } finally {
          if (_didIteratorError59) {
            throw _iteratorError59;
          }
        }
      }

      var _iteratorNormalCompletion60 = true;
      var _didIteratorError60 = false;
      var _iteratorError60 = undefined;

      try {
        for (var _iterator60 = this.sortBySOTAway[Symbol.iterator](), _step60; !(_iteratorNormalCompletion60 = (_step60 = _iterator60.next()).done); _iteratorNormalCompletion60 = true) {
          var label = _step60.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError60 = true;
        _iteratorError60 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion60 && _iterator60.return) {
            _iterator60.return();
          }
        } finally {
          if (_didIteratorError60) {
            throw _iteratorError60;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      var _iteratorNormalCompletion61 = true;
      var _didIteratorError61 = false;
      var _iteratorError61 = undefined;

      try {
        for (var _iterator61 = this.sortBySOT[Symbol.iterator](), _step61; !(_iteratorNormalCompletion61 = (_step61 = _iterator61.next()).done); _iteratorNormalCompletion61 = true) {
          var shot = _step61.value;

          if (this.selectedSOTSort === 'eh') {
            shotsOnTarget.push(shot.sot_eh);
          } else if (this.selectedSOTSort === 'pp') {
            shotsOnTarget.push(shot.sot_pp);
          } else if (this.selectedSOTSort === 'sh') {
            shotsOnTarget.push(shot.sot_sh);
          } else if (this.selectedSOTSort === 'all') {
            shotsOnTarget.push(shot.sot_total);
          }
        }
      } catch (err) {
        _didIteratorError61 = true;
        _iteratorError61 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion61 && _iterator61.return) {
            _iterator61.return();
          }
        } finally {
          if (_didIteratorError61) {
            throw _iteratorError61;
          }
        }
      }

      var _iteratorNormalCompletion62 = true;
      var _didIteratorError62 = false;
      var _iteratorError62 = undefined;

      try {
        for (var _iterator62 = this.sortBySOTAway[Symbol.iterator](), _step62; !(_iteratorNormalCompletion62 = (_step62 = _iterator62.next()).done); _iteratorNormalCompletion62 = true) {
          var shot = _step62.value;

          shotsOnTarget.push(0);
        }
      } catch (err) {
        _didIteratorError62 = true;
        _iteratorError62 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion62 && _iterator62.return) {
            _iterator62.return();
          }
        } finally {
          if (_didIteratorError62) {
            throw _iteratorError62;
          }
        }
      }

      var _iteratorNormalCompletion63 = true;
      var _didIteratorError63 = false;
      var _iteratorError63 = undefined;

      try {
        for (var _iterator63 = this.sortBySOT[Symbol.iterator](), _step63; !(_iteratorNormalCompletion63 = (_step63 = _iterator63.next()).done); _iteratorNormalCompletion63 = true) {
          var shot = _step63.value;

          shotsOnTargetAway.push(0);
        }
      } catch (err) {
        _didIteratorError63 = true;
        _iteratorError63 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion63 && _iterator63.return) {
            _iterator63.return();
          }
        } finally {
          if (_didIteratorError63) {
            throw _iteratorError63;
          }
        }
      }

      var _iteratorNormalCompletion64 = true;
      var _didIteratorError64 = false;
      var _iteratorError64 = undefined;

      try {
        for (var _iterator64 = this.sortBySOTAway[Symbol.iterator](), _step64; !(_iteratorNormalCompletion64 = (_step64 = _iterator64.next()).done); _iteratorNormalCompletion64 = true) {
          var shot = _step64.value;

          if (this.selectedSOTSort === 'eh') {
            shotsOnTargetAway.push(shot.sot_eh);
          } else if (this.selectedSOTSort === 'pp') {
            shotsOnTargetAway.push(shot.sot_pp);
          } else if (this.selectedSOTSort === 'sh') {
            shotsOnTargetAway.push(shot.sot_sh);
          } else if (this.selectedSOTSort === 'all') {
            shotsOnTargetAway.push(shot.sot_total);
          }
        }
      } catch (err) {
        _didIteratorError64 = true;
        _iteratorError64 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion64 && _iterator64.return) {
            _iterator64.return();
          }
        } finally {
          if (_didIteratorError64) {
            throw _iteratorError64;
          }
        }
      }

      data.datsets = [];
      data.datasets = [{
        data: shotsOnTarget,
        label: this.Fixture[0].home_team.name,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: shotsOnTargetAway,
        label: this.Fixture[0].away_team.name,
        backgroundColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    plus_minus_auto_totals: function plus_minus_auto_totals() {
      var playerLabels = [];
      var _iteratorNormalCompletion65 = true;
      var _didIteratorError65 = false;
      var _iteratorError65 = undefined;

      try {
        for (var _iterator65 = this.sortByPlusMinusHomeAuto[Symbol.iterator](), _step65; !(_iteratorNormalCompletion65 = (_step65 = _iterator65.next()).done); _iteratorNormalCompletion65 = true) {
          var label = _step65.value;

          if (label.player_id !== 'Team') playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError65 = true;
        _iteratorError65 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion65 && _iterator65.return) {
            _iterator65.return();
          }
        } finally {
          if (_didIteratorError65) {
            throw _iteratorError65;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var shotsFor = [];
      var shotsAgainst = [];
      var _iteratorNormalCompletion66 = true;
      var _didIteratorError66 = false;
      var _iteratorError66 = undefined;

      try {
        for (var _iterator66 = this.sortByPlusMinusHomeAuto[Symbol.iterator](), _step66; !(_iteratorNormalCompletion66 = (_step66 = _iterator66.next()).done); _iteratorNormalCompletion66 = true) {
          var shots = _step66.value;

          if (shots.player_id !== 'Team') shotsFor.push(shots.shots_for);
        }
      } catch (err) {
        _didIteratorError66 = true;
        _iteratorError66 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion66 && _iterator66.return) {
            _iterator66.return();
          }
        } finally {
          if (_didIteratorError66) {
            throw _iteratorError66;
          }
        }
      }

      var _iteratorNormalCompletion67 = true;
      var _didIteratorError67 = false;
      var _iteratorError67 = undefined;

      try {
        for (var _iterator67 = this.sortByPlusMinusHomeAuto[Symbol.iterator](), _step67; !(_iteratorNormalCompletion67 = (_step67 = _iterator67.next()).done); _iteratorNormalCompletion67 = true) {
          var shotsA = _step67.value;

          if (shotsA.player_id !== 'Team') shotsAgainst.push(shotsA.shots_against);
        }
      } catch (err) {
        _didIteratorError67 = true;
        _iteratorError67 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion67 && _iterator67.return) {
            _iterator67.return();
          }
        } finally {
          if (_didIteratorError67) {
            throw _iteratorError67;
          }
        }
      }

      data.datasets = [{
        data: shotsFor,
        label: 'Shots For',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: shotsAgainst,
        label: 'Shots Against',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    plus_minus_auto_diff: function plus_minus_auto_diff() {
      var playerLabels = [];
      var _iteratorNormalCompletion68 = true;
      var _didIteratorError68 = false;
      var _iteratorError68 = undefined;

      try {
        for (var _iterator68 = this.sortByPlusMinusHomeAutoDiff[Symbol.iterator](), _step68; !(_iteratorNormalCompletion68 = (_step68 = _iterator68.next()).done); _iteratorNormalCompletion68 = true) {
          var label = _step68.value;

          if (label.player_id !== 'Team') playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError68 = true;
        _iteratorError68 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion68 && _iterator68.return) {
            _iterator68.return();
          }
        } finally {
          if (_didIteratorError68) {
            throw _iteratorError68;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var shotsFor = [];
      var shotsAgainst = [];
      var _iteratorNormalCompletion69 = true;
      var _didIteratorError69 = false;
      var _iteratorError69 = undefined;

      try {
        for (var _iterator69 = this.sortByPlusMinusHomeAutoDiff[Symbol.iterator](), _step69; !(_iteratorNormalCompletion69 = (_step69 = _iterator69.next()).done); _iteratorNormalCompletion69 = true) {
          var shots = _step69.value;

          if (shots.player_id !== 'Team') shotsFor.push(shots.diff);
        }
      } catch (err) {
        _didIteratorError69 = true;
        _iteratorError69 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion69 && _iterator69.return) {
            _iterator69.return();
          }
        } finally {
          if (_didIteratorError69) {
            throw _iteratorError69;
          }
        }
      }

      data.datasets = [{
        data: shotsFor,
        label: 'Differential',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    }
  }, _defineProperty(_computed, 'fo_total_chart', function fo_total_chart() {
    return {
      labels: this.fo_total_labels,
      datasets: [{
        data: this.getFoChartTotals(),
        backgroundColor: this.backgroundColor
      }]
    };
  }), _defineProperty(_computed, 'cleanPlusMinusData', function cleanPlusMinusData() {
    var cleanData = [];
    // console.log(this.TOI[0])

    __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(this.sortByPlusMinusHomeAuto, function (object) {
      cleanData.push(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.pick(object, ['player_id', 'shots_for', 'shots_against']));
    });
    return cleanData;
  }), _defineProperty(_computed, 'gameTotals', function gameTotals() {
    var total = [];
    var _iteratorNormalCompletion70 = true;
    var _didIteratorError70 = false;
    var _iteratorError70 = undefined;

    try {
      for (var _iterator70 = this.Gamesheet[Symbol.iterator](), _step70; !(_iteratorNormalCompletion70 = (_step70 = _iterator70.next()).done); _iteratorNormalCompletion70 = true) {
        var v = _step70.value;

        if (v.position === 'total') {
          total.push(v);
        }
      }
    } catch (err) {
      _didIteratorError70 = true;
      _iteratorError70 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion70 && _iterator70.return) {
          _iterator70.return();
        }
      } finally {
        if (_didIteratorError70) {
          throw _iteratorError70;
        }
      }
    }

    return total;
  }), _computed),
  methods: {
    setPeriod: function setPeriod(newPeriod) {
      this.$router.push('/stats/match-stats-opposition/' + this.$route.params.gameId + '/' + newPeriod);
      this.updateRemotes();
      this.$router.go(0);
    },
    fetchGameSummary: function fetchGameSummary() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/game-summary/' + this.$route.params.gameId + '/' + this.$route.params.period, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this.Summary = response.data;
        console.log(JSON.stringify(_this.Summary.situation_opts[0]));
      }, function (response) {});
    },
    fetchGamesheet: function fetchGamesheet() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/opposition/' + this.$route.params.gameId + '/' + this.$route.params.period, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this2.Gamesheet = response.data;
      }, function (response) {});
    },
    fetchHitTotals: function fetchHitTotals() {
      var _this3 = this;

      this.teamId = this.$route.params.teamId;
      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/hits/opposition/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this3.Hits = response.data;
      }, function (response) {});
    },
    fetchTurnoverTotals: function fetchTurnoverTotals() {
      var _this4 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/turnovers/opposition/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this4.Turnovers = response.data;
        // console.log(JSON.stringify(this.Turnovers))
      }, function (response) {});
    },
    fetchPlusMinusTotals: function fetchPlusMinusTotals() {
      var _this5 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/plus_minus/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this5.PlusMinus = response.data;
      }, function (response) {});
    },
    fetchSOTTotals: function fetchSOTTotals() {
      var _this6 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/individualsot/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this6.SOT = response.data;
      }, function (response) {});
    },
    fetchPlusMinusAutoTotals: function fetchPlusMinusAutoTotals() {
      var _this7 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/plus_minus_auto/opposition/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this7.PlusMinusAuto = response.data;
      }, function (response) {});
    },
    fetchFaceoffTotals: function fetchFaceoffTotals() {
      var _this8 = this;

      // console.log('Get faceoff totals')
      this.teamId = this.$route.params.teamId;
      this.$http.get('https://devilsapi.roblutken.com/api/faceoffs/season/get/totals/', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Faceoff Data is ' + response.data)
        _this8.Faceoffs = response.data;
        // console.log(JSON.stringify(this.Faceoffs))
      }, function (response) {});
    },
    fetchFaceoffChart: function fetchFaceoffChart() {
      var _this9 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/faceoffs/opposition/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Faceoff Data is ' + JSON.stringify(response.data))
        _this9.FaceoffsChart = response.data;
        // console.log(JSON.stringify(this.Faceoffs))
      }, function (response) {});
    },
    getFoChartTotals: function getFoChartTotals() {
      var foData = [this.Faceoffs.total_wins, this.Faceoffs.total_losses];
      return foData;
    },
    fetchFixtures: function fetchFixtures() {
      var _this10 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games/get/single/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Data is ' + response.data)
        _this10.Fixture = response.data;
        // console.log(JSON.stringify(this.Fixture))
      }, function (response) {});
    },
    fetchRushes: function fetchRushes() {
      var _this11 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/match-stats/oddman-rushes/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Data is ' + response.data)
        _this11.OddmanRushes = response.data;
        // console.log(JSON.stringify(this.OddmanRushes))
      }, function (response) {});
    },
    updateRemotes: function updateRemotes() {
      this.fetchFixtures();
      this.fetchGameSummary();
      this.fetchFaceoffTotals();
      this.fetchTurnoverTotals();
      this.fetchHitTotals();
      this.fetchGamesheet();
      this.fetchPlusMinusTotals();
      this.fetchPlusMinusAutoTotals();
      this.fetchSOTTotals();
      this.fetchFaceoffChart();
      this.fetchRushes();
    },
    fetchShotmap: function fetchShotmap() {
      var _this12 = this;

      this.awayZoneShots = [];
      this.homeZoneShots = [];
      this.renderKey();
      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/shots/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this12.awayZoneShots = [];
        _this12.homeZoneShots = [];
        setTimeout(function () {
          _this12.renderZoneMap('home', _this12.$refs.home_shots_canvas, response.data.home_shot_locations);
        }, 3050);

        setTimeout(function () {
          _this12.renderZoneMap('away', _this12.$refs.away_shots_canvas, response.data.away_shot_locations);
        }, 3050);
      }, function (response) {});
    },
    renderKey: function renderKey() {
      var canvas = this.$refs.shotmap_key;
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.drawCircle(ctx, '#0fe800', [50, 10], 8);
      this.drawCircle(ctx, '#D90908F2', [100, 10], 6);
      this.drawCircle(ctx, '#e8a600', [150, 10], 4);
      this.drawCircle(ctx, '#6800e8', [200, 10], 4);
      this.drawText(ctx, 'Goal', [35, 30], '12px');
      this.drawText(ctx, 'On Net', [85, 30], '12px');
      this.drawText(ctx, 'Missed', [136, 30], '12px');
      this.drawText(ctx, 'Blocked', [185, 30], '12px');
    },
    renderZoneMap: function renderZoneMap(team, teamShotmap, locatonData) {
      // console.log('Render shotmap' + teamShotmap + locatonData)
      var canvas = teamShotmap;
      var ctx = canvas.getContext('2d');

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var colour = '#2F4858C9';
      var centerPos = [160, 76, 280, 200];
      var centerPosText = [280, 200];
      var centerCount = 0;

      var outsideZonePos = [5, 389, 590, 140];
      var outsideZoneText = [480, 520];
      var outsideCount = 0;

      var behindNetPos = [5, 0, 590, 75];
      var behindNetText = [480, 70];
      var behindNetCount = 0;

      var leftOutsidePos = [5, 76, 160, 200];
      var leftOutsideText = [80, 80];
      var leftOutsideCount = 0;

      var rightOutsidePos = [440, 76, 155, 200];
      var rightOutsideText = [445, 80];
      var rightOutsideCount = 0;

      var leftPointInit = [5, 275];
      var leftPointTextPos = [10, 320];
      var leftPointLines = [{ x: 5, y: 275 }, { x: 165, y: 275 }, { x: 180, y: 385 }, { x: 5, y: 385 }, { x: 5, y: 275 }];
      var leftPointCount = 0;

      var centerPointInit = [165, 275];
      var centerPointTextPos = [230, 320];
      var centerPointLines = [{ x: 165, y: 275 }, { x: 440, y: 275 }, { x: 420, y: 385 }, { x: 180, y: 385 }, { x: 165, y: 275 }];
      var centerPointCount = 0;

      var rightPointInit = [440, 275];
      var rightPointLines = [{ x: 440, y: 275 }, { x: 595, y: 275 }, { x: 595, y: 385 }, { x: 420, y: 385 }, { x: 440, y: 275 }];
      var rightPointTextPos = [445, 320];
      var rightPointCount = 0;

      this.drawRect(ctx, colour, centerPos);
      this.drawRect(ctx, colour, outsideZonePos, '12px', 1);
      this.drawRect(ctx, colour, behindNetPos);
      this.drawRect(ctx, colour, leftOutsidePos);
      this.drawRect(ctx, colour, rightOutsidePos);

      this.drawCustom(ctx, colour, leftPointInit, leftPointLines);
      this.drawCustom(ctx, colour, centerPointInit, centerPointLines);
      this.drawCustom(ctx, colour, rightPointInit, rightPointLines);

      var _iteratorNormalCompletion71 = true;
      var _didIteratorError71 = false;
      var _iteratorError71 = undefined;

      try {
        for (var _iterator71 = locatonData[Symbol.iterator](), _step71; !(_iteratorNormalCompletion71 = (_step71 = _iterator71.next()).done); _iteratorNormalCompletion71 = true) {
          var shots = _step71.value;

          if (this.selectedShotType === -1 && this.selectedShotSituation === -1 || this.selectedShotType === -1 && shots.situation === this.selectedShotSituation || this.selectedShotSituation === -1 && shots.shot_type === this.selectedShotType || shots.shot_type === this.selectedShotType && shots.situation === this.selectedShotSituation || shots.shot_type === 'Goal' && this.selectedShotType === 'OnNet') {
            // console.log('Shot type is: ' + this.selectedShotType + ' and situation is: ' + this.selectedShotSituation)
            // console.log ('Actual : '  + shots.shot_type + ' situation: ' + shots.situation)
            var circlePos = [];
            var decode = JSON.parse(shots.location);
            circlePos[0] = decode[0];
            circlePos[1] = decode[1];
            if (circlePos[0] >= 0.0 && circlePos[0] <= 160.0 && circlePos[1] > 76.0 && circlePos[1] < 270.0) {
              leftOutsideCount++;
            } // Red Zone
            if (circlePos[0] >= 160.0 && circlePos[0] <= 440.0 && circlePos[1] > 76.0 && circlePos[1] < 276.0) {
              centerCount++;
            }
            if (circlePos[0] >= 440.0 && circlePos[0] <= 600.0 && circlePos[1] > 76.0 && circlePos[1] < 276.0) {
              rightOutsideCount++;
            }
            if (circlePos[0] >= 0 && circlePos[0] <= 600.0 && circlePos[1] > 0 && circlePos[1] < 75.0) {
              behindNetCount++;
            }
            if (circlePos[0] >= 0 && circlePos[0] <= 160.0 && circlePos[1] > 276.0 && circlePos[1] < 385.0) {
              leftPointCount++;
            }
            if (circlePos[0] >= 420 && circlePos[0] <= 600.0 && circlePos[1] > 276.0 && circlePos[1] < 385.0) {
              rightPointCount++;
            }
            if (circlePos[0] >= 160.0 && circlePos[0] <= 420.0 && circlePos[1] > 276.0 && circlePos[1] < 385.0) {
              centerPointCount++;
            }
            if (circlePos[0] >= 0 && circlePos[0] <= 600 && circlePos[1] > 389 && circlePos[1] < 529) {
              outsideCount++;
            }

            if (shots.shot_type === 'OnNet') {
              this.drawCircle(ctx, '#D90908F2', circlePos, 6);
            }
            if (shots.shot_type === 'Blocked') {
              this.drawCircle(ctx, '#6800e8', circlePos, 4);
            }
            if (shots.shot_type === 'MissedNet') {
              this.drawCircle(ctx, '#e8a600', circlePos, 4);
            }
            if (shots.shot_type === 'Goal') {
              this.drawCircle(ctx, '#0fe800', circlePos, 8);
            }
          }
        }
      } catch (err) {
        _didIteratorError71 = true;
        _iteratorError71 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion71 && _iterator71.return) {
            _iterator71.return();
          }
        } finally {
          if (_didIteratorError71) {
            throw _iteratorError71;
          }
        }
      }

      if (team === 'home') {
        var shot = {
          zone: "Behind Net",
          count: behindNetCount
        };
        this.homeZoneShots.push(shot);
        shot = {
          zone: "Red Zone",
          count: centerCount
        };
        this.homeZoneShots.push(shot);
        shot = {
          zone: "Left Outside",
          count: leftOutsideCount
        };
        this.homeZoneShots.push(shot);
        shot = {
          zone: "Right Outside",
          count: rightOutsideCount
        };
        this.homeZoneShots.push(shot);
        shot = {
          zone: "Left Point",
          count: leftPointCount
        };
        this.homeZoneShots.push(shot);
        shot = {
          zone: "Center Point",
          count: centerPointCount
        };
        this.homeZoneShots.push(shot);
        shot = {
          zone: "Right Point",
          count: rightPointCount
        };
        this.homeZoneShots.push(shot);
        shot = {
          zone: "Outside Zone",
          count: outsideCount
        };
        this.homeZoneShots.push(shot);
        shot = {
          zone: "Total",
          count: centerCount + rightPointCount + leftPointCount + rightOutsideCount + leftOutsideCount + centerPointCount + behindNetCount + outsideCount
        };
        this.homeZoneShots.push(shot);
      } else {
        var shot = {
          zone: "Behind Net",
          count: behindNetCount
        };
        this.awayZoneShots.push(shot);
        shot = {
          zone: "Red Zone",
          count: centerCount
        };
        this.awayZoneShots.push(shot);
        shot = {
          zone: "Left Outside",
          count: leftOutsideCount
        };
        this.awayZoneShots.push(shot);
        shot = {
          zone: "Right Outside",
          count: rightOutsideCount
        };
        this.awayZoneShots.push(shot);
        shot = {
          zone: "Left Point",
          count: leftPointCount
        };
        this.awayZoneShots.push(shot);
        shot = {
          zone: "Center Point",
          count: centerPointCount
        };
        this.awayZoneShots.push(shot);
        shot = {
          zone: "Right Point",
          count: rightPointCount
        };
        this.awayZoneShots.push(shot);
        shot = {
          zone: "Outside Zone",
          count: outsideCount
        };
        this.awayZoneShots.push(shot);
        shot = {
          zone: "Total",
          count: centerCount + rightPointCount + leftPointCount + rightOutsideCount + leftOutsideCount + centerPointCount + behindNetCount + outsideCount
        };
        this.awayZoneShots.push(shot);
      }
    },
    drawRect: function drawRect(ctx, color, position, text, textPos) {
      var fontSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '26px';
      var lineWidth = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 3;

      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = lineWidth;
      ctx.fillRect(position[0], position[1], position[2], position[3]);
      ctx.strokeRect(position[0], position[1], position[2], position[3]);
      ctx.closePath();
    },
    drawText: function drawText(ctx, text, textPosition) {
      var textSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '26px';

      ctx.beginPath();
      ctx.font = textSize + ' sans-serif';
      ctx.fillStyle = 'rgba(0, 0, 0, 1)';
      ctx.fillText(text, textPosition[0], textPosition[1]);
      ctx.closePath();
    },
    drawCustom: function drawCustom(ctx, color, initPos, movePoints) {
      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = 'white';
      ctx.moveTo(initPos[0], initPos[1]);
      // Loop over move points
      var _iteratorNormalCompletion72 = true;
      var _didIteratorError72 = false;
      var _iteratorError72 = undefined;

      try {
        for (var _iterator72 = movePoints[Symbol.iterator](), _step72; !(_iteratorNormalCompletion72 = (_step72 = _iterator72.next()).done); _iteratorNormalCompletion72 = true) {
          var prop = _step72.value;

          ctx.lineTo(prop.x, prop.y);
        }
      } catch (err) {
        _didIteratorError72 = true;
        _iteratorError72 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion72 && _iterator72.return) {
            _iterator72.return();
          }
        } finally {
          if (_didIteratorError72) {
            throw _iteratorError72;
          }
        }
      }

      ctx.fill();
      ctx.stroke();
      ctx.closePath();
    },
    drawCircle: function drawCircle(ctx, color, position, radius) {
      var lineWidth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2;

      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = lineWidth;
      ctx.arc(position[0], position[1], radius, 0, 2 * Math.PI);
      ctx.fill();
      ctx.stroke();
      ctx.closePath();
    }
  },
  created: function created() {
    // this.fetchShotTotals()
    this.updateRemotes();
    // this.period = this.$route.params.period
  },
  mounted: function mounted() {
    this.fetchShotmap();
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sub_table_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sub_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__sub_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rtable_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rtable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rtable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sort_table_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sort_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__sort_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__season_stats_faceoffs_pvp_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__season_stats_faceoffs_pvp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__season_stats_faceoffs_pvp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_bulma_collapse__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import simpleheat from '../../store/modules/simpleheat/simpleheat'
// import randomColor from '../../store/modules/utils/randomColor'











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'player',
  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_9_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_9_vue_bulma_collapse__["Item"],
    SortTable: __WEBPACK_IMPORTED_MODULE_7__sort_table_vue___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_3__sub_table_vue___default.a,
    'shot-diff-time': __WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue___default.a,
    'FaceoffTeamVS': __WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue___default.a,
    'RTable': __WEBPACK_IMPORTED_MODULE_6__rtable_vue___default.a,
    'faceoffs-pvp': __WEBPACK_IMPORTED_MODULE_8__season_stats_faceoffs_pvp_vue___default.a
  },
  data: function data() {
    return {
      period: 1,
      Faceoffs: [],
      Fixture: [],
      Gamesheet: [],
      FaceoffsChart: [],
      Summary: [],
      bar_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              callback: function callback(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }]
        }
      },
      fo_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true,
              beginAtZero: true,
              callback: function callback(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }]
        }
      },
      fo_total_options: {},
      backgroundColor: ['#1fc8db', '#fce473', '#42afe3', '#ed6c63', '#97cd76'],
      isFaceoffsPvp: false,
      isFaceoffOpen: true,
      homeZoneShots: [],
      awayZoneShots: [],
      selectedSOTSort: 'eh',
      selectedPlusMinusSort: 'line',
      selectedShotType: -1,
      selectedShotSituation: -1,
      selectedHitSort: 'eh'
    };
  },

  computed: {
    sortBytimeGT: function sortBytimeGT() {
      /*eslint-disable */
      var gt = this.Gamesheet.filter(function (a) {
        return a.position == 'GT';
      });
      return gt.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortBytimeDefense: function sortBytimeDefense() {
      /*eslint-disable */
      var defense = this.Gamesheet.filter(function (a) {
        return a.position == 'LD' || a.position == 'RD';
      });
      return defense.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortBytimeForwards: function sortBytimeForwards() {
      var forwards = this.Gamesheet.filter(function (a) {
        return a.position == 'LW' || a.position == 'C' || a.position == 'RW';
      });
      return forwards.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortBytimeAll: function sortBytimeAll() {
      var all = this.Gamesheet.filter(function (a) {
        return a.position == 'LW' || a.position == 'C' || a.position == 'RW' || a.position == 'LD' || a.position == 'RD';
      });
      return all.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortFoByDiffLeft: function sortFoByDiffLeft() {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_left'], ['desc']))
      return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.FaceoffsChart.all_situations, ['total_diff_left'], ['desc']);
    },
    sortFoByDiffCenter: function sortFoByDiffCenter() {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_center'], ['desc']))
      return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.FaceoffsChart.all_situations, ['total_diff_center'], ['desc']);
    },
    sortFoByDiffRight: function sortFoByDiffRight() {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_right'], ['desc']))
      return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.orderBy(this.FaceoffsChart.all_situations, ['total_diff_right'], ['desc']);
    },
    fo_total_chart: function fo_total_chart() {
      return {
        labels: this.fo_total_labels,
        datasets: [{
          data: this.getFoChartTotals(),
          backgroundColor: this.backgroundColor
        }]
      };
    },
    fo_player_l: function fo_player_l() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortFoByDiffLeft[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.sortFoByDiffLeft[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var leftWin = _step2.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.sortFoByDiffLeft[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var leftLoss = _step3.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c: function fo_player_c() {
      var playerLabels = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.sortFoByDiffCenter[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var label = _step4.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.sortFoByDiffCenter[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var center = _step5.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.sortFoByDiffCenter[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var centerLoss = _step6.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r: function fo_player_r() {
      var playerLabels = [];
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.sortFoByDiffRight[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var label = _step7.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.sortFoByDiffRight[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var right = _step8.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.sortFoByDiffRight[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var rightLoss = _step9.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_t: function fo_player_t() {
      if (this.FaceoffsChart.all_situations) {
        var playerLabels = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = this.FaceoffsChart.all_situations[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var label = _step10.value;

            playerLabels.push(label.player_id);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var data = {
          labels: playerLabels
        };
        data.datsets = [];
        var playerTotalWin = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = this.FaceoffsChart.all_situations[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var win = _step11.value;

            playerTotalWin.push(win.total_win);
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        var playerTotalLoss = [];
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
          for (var _iterator12 = this.FaceoffsChart.all_situations[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var loss = _step12.value;

            playerTotalLoss.push(loss.total_loss);
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }

        data.datasets = [{
          data: playerTotalWin,
          label: 'Total Win',
          backgroundColor: 'rgba(255, 206, 86, 1)',
          borderColor: 'rgba(255, 206, 86, 1)'
        }, {
          data: playerTotalLoss,
          label: 'Total Loss',
          backgroundColor: 'rgba(255, 99, 132, 1)',
          borderColor: 'rgba(255, 99, 132, 1)'
        }];
        console.log('FO TOTLA DATA IS: ' + JSON.stringify(data));
        return data;
      }
    },
    fo_player_l_eh: function fo_player_l_eh() {
      var playerLabels = [];
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var label = _step13.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var leftWin = _step14.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var leftLoss = _step15.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c_eh: function fo_player_c_eh() {
      var playerLabels = [];
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var label = _step16.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var center = _step17.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var centerLoss = _step18.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r_eh: function fo_player_r_eh() {
      var playerLabels = [];
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var label = _step19.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;

      try {
        for (var _iterator20 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var right = _step20.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion21 = true;
      var _didIteratorError21 = false;
      var _iteratorError21 = undefined;

      try {
        for (var _iterator21 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
          var rightLoss = _step21.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion21 && _iterator21.return) {
            _iterator21.return();
          }
        } finally {
          if (_didIteratorError21) {
            throw _iteratorError21;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_l_pp: function fo_player_l_pp() {
      var playerLabels = [];
      var _iteratorNormalCompletion22 = true;
      var _didIteratorError22 = false;
      var _iteratorError22 = undefined;

      try {
        for (var _iterator22 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
          var label = _step22.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError22 = true;
        _iteratorError22 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion22 && _iterator22.return) {
            _iterator22.return();
          }
        } finally {
          if (_didIteratorError22) {
            throw _iteratorError22;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion23 = true;
      var _didIteratorError23 = false;
      var _iteratorError23 = undefined;

      try {
        for (var _iterator23 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
          var leftWin = _step23.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError23 = true;
        _iteratorError23 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion23 && _iterator23.return) {
            _iterator23.return();
          }
        } finally {
          if (_didIteratorError23) {
            throw _iteratorError23;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion24 = true;
      var _didIteratorError24 = false;
      var _iteratorError24 = undefined;

      try {
        for (var _iterator24 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
          var leftLoss = _step24.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError24 = true;
        _iteratorError24 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion24 && _iterator24.return) {
            _iterator24.return();
          }
        } finally {
          if (_didIteratorError24) {
            throw _iteratorError24;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c_pp: function fo_player_c_pp() {
      var playerLabels = [];
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var label = _step25.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion26 = true;
      var _didIteratorError26 = false;
      var _iteratorError26 = undefined;

      try {
        for (var _iterator26 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
          var center = _step26.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError26 = true;
        _iteratorError26 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion26 && _iterator26.return) {
            _iterator26.return();
          }
        } finally {
          if (_didIteratorError26) {
            throw _iteratorError26;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion27 = true;
      var _didIteratorError27 = false;
      var _iteratorError27 = undefined;

      try {
        for (var _iterator27 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
          var centerLoss = _step27.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError27 = true;
        _iteratorError27 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion27 && _iterator27.return) {
            _iterator27.return();
          }
        } finally {
          if (_didIteratorError27) {
            throw _iteratorError27;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r_pp: function fo_player_r_pp() {
      var playerLabels = [];
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var label = _step28.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion29 = true;
      var _didIteratorError29 = false;
      var _iteratorError29 = undefined;

      try {
        for (var _iterator29 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
          var right = _step29.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError29 = true;
        _iteratorError29 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion29 && _iterator29.return) {
            _iterator29.return();
          }
        } finally {
          if (_didIteratorError29) {
            throw _iteratorError29;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion30 = true;
      var _didIteratorError30 = false;
      var _iteratorError30 = undefined;

      try {
        for (var _iterator30 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
          var rightLoss = _step30.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError30 = true;
        _iteratorError30 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion30 && _iterator30.return) {
            _iterator30.return();
          }
        } finally {
          if (_didIteratorError30) {
            throw _iteratorError30;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_l_sh: function fo_player_l_sh() {
      var playerLabels = [];
      var _iteratorNormalCompletion31 = true;
      var _didIteratorError31 = false;
      var _iteratorError31 = undefined;

      try {
        for (var _iterator31 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
          var label = _step31.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError31 = true;
        _iteratorError31 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion31 && _iterator31.return) {
            _iterator31.return();
          }
        } finally {
          if (_didIteratorError31) {
            throw _iteratorError31;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion32 = true;
      var _didIteratorError32 = false;
      var _iteratorError32 = undefined;

      try {
        for (var _iterator32 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
          var leftWin = _step32.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError32 = true;
        _iteratorError32 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion32 && _iterator32.return) {
            _iterator32.return();
          }
        } finally {
          if (_didIteratorError32) {
            throw _iteratorError32;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion33 = true;
      var _didIteratorError33 = false;
      var _iteratorError33 = undefined;

      try {
        for (var _iterator33 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
          var leftLoss = _step33.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError33 = true;
        _iteratorError33 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion33 && _iterator33.return) {
            _iterator33.return();
          }
        } finally {
          if (_didIteratorError33) {
            throw _iteratorError33;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c_sh: function fo_player_c_sh() {
      var playerLabels = [];
      var _iteratorNormalCompletion34 = true;
      var _didIteratorError34 = false;
      var _iteratorError34 = undefined;

      try {
        for (var _iterator34 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
          var label = _step34.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError34 = true;
        _iteratorError34 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion34 && _iterator34.return) {
            _iterator34.return();
          }
        } finally {
          if (_didIteratorError34) {
            throw _iteratorError34;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion35 = true;
      var _didIteratorError35 = false;
      var _iteratorError35 = undefined;

      try {
        for (var _iterator35 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
          var center = _step35.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError35 = true;
        _iteratorError35 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion35 && _iterator35.return) {
            _iterator35.return();
          }
        } finally {
          if (_didIteratorError35) {
            throw _iteratorError35;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion36 = true;
      var _didIteratorError36 = false;
      var _iteratorError36 = undefined;

      try {
        for (var _iterator36 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
          var centerLoss = _step36.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError36 = true;
        _iteratorError36 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion36 && _iterator36.return) {
            _iterator36.return();
          }
        } finally {
          if (_didIteratorError36) {
            throw _iteratorError36;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r_sh: function fo_player_r_sh() {
      var playerLabels = [];
      var _iteratorNormalCompletion37 = true;
      var _didIteratorError37 = false;
      var _iteratorError37 = undefined;

      try {
        for (var _iterator37 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
          var label = _step37.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError37 = true;
        _iteratorError37 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion37 && _iterator37.return) {
            _iterator37.return();
          }
        } finally {
          if (_didIteratorError37) {
            throw _iteratorError37;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion38 = true;
      var _didIteratorError38 = false;
      var _iteratorError38 = undefined;

      try {
        for (var _iterator38 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
          var right = _step38.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError38 = true;
        _iteratorError38 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion38 && _iterator38.return) {
            _iterator38.return();
          }
        } finally {
          if (_didIteratorError38) {
            throw _iteratorError38;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion39 = true;
      var _didIteratorError39 = false;
      var _iteratorError39 = undefined;

      try {
        for (var _iterator39 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
          var rightLoss = _step39.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError39 = true;
        _iteratorError39 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion39 && _iterator39.return) {
            _iterator39.return();
          }
        } finally {
          if (_didIteratorError39) {
            throw _iteratorError39;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },

    gameTotals: function gameTotals() {
      var total = [];
      var _iteratorNormalCompletion40 = true;
      var _didIteratorError40 = false;
      var _iteratorError40 = undefined;

      try {
        for (var _iterator40 = this.Gamesheet[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
          var v = _step40.value;

          if (v.position === 'total') {
            total.push(v);
          }
        }
      } catch (err) {
        _didIteratorError40 = true;
        _iteratorError40 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion40 && _iterator40.return) {
            _iterator40.return();
          }
        } finally {
          if (_didIteratorError40) {
            throw _iteratorError40;
          }
        }
      }

      return total;
    }
  },
  methods: {
    setPeriod: function setPeriod(newPeriod) {
      this.$router.push('/stats/match-stats/' + this.$route.params.gameId + '/' + newPeriod);
      this.updateRemotes();
      this.$router.go(0);
    },
    fetchGameSummary: function fetchGameSummary() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/game-summary/' + this.$route.params.gameId + '/' + this.$route.params.period, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this.Summary = response.data;
        console.log(JSON.stringify(_this.Summary.situation_opts[0]));
      }, function (response) {});
    },
    fetchGamesheet: function fetchGamesheet() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/' + this.$route.params.gameId + '/' + this.$route.params.period, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this2.Gamesheet = response.data;
        console.log("Gamesheet data: " + JSON.stringify(_this2.Gamesheet));
      }, function (response) {});
    },
    fetchFaceoffTotals: function fetchFaceoffTotals() {
      var _this3 = this;

      // console.log('Get faceoff totals')
      this.teamId = this.$route.params.teamId;
      this.$http.get('https://devilsapi.roblutken.com/api/faceoffs/season/get/totals/', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Faceoff Data is ' + response.data)
        _this3.Faceoffs = response.data;
        // console.log(JSON.stringify(this.Faceoffs))
      }, function (response) {});
    },
    fetchFaceoffChart: function fetchFaceoffChart() {
      var _this4 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/faceoffs/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Faceoff Data is ' + JSON.stringify(response.data))
        _this4.FaceoffsChart = response.data;
        // console.log(JSON.stringify(this.Faceoffs))
      }, function (response) {});
    },
    getFoChartTotals: function getFoChartTotals() {
      var foData = [this.Faceoffs.total_wins, this.Faceoffs.total_losses];
      return foData;
    },
    fetchFixtures: function fetchFixtures() {
      var _this5 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games/get/single/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Data is ' + response.data)
        _this5.Fixture = response.data;
        // console.log(JSON.stringify(this.Fixture))
      }, function (response) {});
    },
    updateRemotes: function updateRemotes() {
      this.fetchFixtures();
      this.fetchGameSummary();
      this.fetchFaceoffTotals();
      this.fetchGamesheet();
      this.fetchFaceoffChart();
    }
  },
  created: function created() {
    // this.fetchShotTotals()
    this.updateRemotes();
    // this.period = this.$route.params.period
  },
  mounted: function mounted() {
    //   this.fetchShotmap()
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__season_stats_Gamesheet2021_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__season_stats_Gamesheet2021_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__season_stats_Gamesheet2021_vue__);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'player',
  components: {
    Gamesheet: __WEBPACK_IMPORTED_MODULE_0__season_stats_Gamesheet2021_vue___default.a
  },
  data: function data() {
    return {
      period: 1
    };
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sub_table_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sub_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__sub_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shots_heatmap_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shots_heatmap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shots_heatmap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rtable_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rtable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rtable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zone_entries_game_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zone_entries_game_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__zone_entries_game_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shots_quality_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shots_quality_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__shots_quality_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sort_table_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sort_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__sort_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__season_stats_faceoffs_pvp_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__season_stats_faceoffs_pvp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__season_stats_faceoffs_pvp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_bulma_collapse__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import simpleheat from '../../store/modules/simpleheat/simpleheat'
// import randomColor from '../../store/modules/utils/randomColor'














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'player',
  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_slider___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_chartjs___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_12_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_12_vue_bulma_collapse__["Item"],
    SortTable: __WEBPACK_IMPORTED_MODULE_10__sort_table_vue___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_3__sub_table_vue___default.a,
    'shot-diff-time': __WEBPACK_IMPORTED_MODULE_4__shot_diff_time_vue___default.a,
    'FaceoffTeamVS': __WEBPACK_IMPORTED_MODULE_5__faceoff_team_vs_vue___default.a,
    'ShotsHeatmap': __WEBPACK_IMPORTED_MODULE_6__shots_heatmap_vue___default.a,
    'RTable': __WEBPACK_IMPORTED_MODULE_7__rtable_vue___default.a,
    'zone-entries': __WEBPACK_IMPORTED_MODULE_8__zone_entries_game_vue___default.a,
    'shot-quality': __WEBPACK_IMPORTED_MODULE_9__shots_quality_vue___default.a,
    'faceoffs-pvp': __WEBPACK_IMPORTED_MODULE_11__season_stats_faceoffs_pvp_vue___default.a
  },
  data: function data() {
    return {
      period: 1,
      Faceoffs: [],
      Shots: [],
      OddmanRushes: [],
      Fixture: [],
      SOT: [],
      Gamesheet: [],
      Hits: [],
      PlusMinus: [],
      PlusMinusAuto: [],
      FaceoffsChart: [],
      homeShotLocationData: [],
      Summary: [],
      bar_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              callback: function callback(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }]
        }
      },
      pie_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        responsive: true
      },
      sot_bar_options: {
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: false,
            barPercentage: 1.4,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: false,
            barPercentage: 1.4,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              callback: function callback(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }]
        }
      },
      fo_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true,
              beginAtZero: true,
              callback: function callback(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }]
        }
      },
      fo_total_options: {},
      shots_horz_bar_options: {
        title: {
          display: false
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true,
              beginAtZero: true,
              callback: function callback(value) {
                if (value % 1 === 0) {
                  return value;
                }
              }
            }
          }]
        }
      },
      backgroundColor: ['#1fc8db', '#fce473', '#42afe3', '#ed6c63', '#97cd76'],
      isFaceoffsPvp: false,
      isFaceoffOpen: true,
      homeZoneShots: [],
      awayZoneShots: [],
      shotmapSituations: [{
        text: 'All',
        value: -1
      }, {
        text: 'Even Handed',
        value: 'EvenHanded'
      }, {
        text: 'Power Play',
        value: 'PowerPlay'
      }, {
        text: 'Short Handed',
        value: 'PenaltyKill'
      }],
      shotTypeOptions: [{
        text: 'All',
        value: -1
      }, {
        text: 'Goals',
        value: 'Goal'
      }, {
        text: 'On Net',
        value: 'OnNet'
      }, {
        text: 'Missed Target',
        value: 'MissedNet'
      }, {
        text: 'Blocked',
        value: 'Blocked'
      }],
      plusMinusOptions: [{
        text: 'Line',
        value: 'line'
      }, {
        text: 'Differential',
        value: 'differential'
      }, {
        text: 'Shots For',
        value: 'for'
      }, {
        text: 'Shots Against',
        value: 'against'
      }],
      sotOptions: [{
        text: 'All Situations',
        value: 'all'
      }, {
        text: 'Even Handed',
        value: 'eh'
      }, {
        text: 'Power Play',
        value: 'pp'
      }, {
        text: 'Short Handed',
        value: 'sh'
      }],
      selectedSOTSort: 'eh',
      selectedPlusMinusSort: 'line',
      selectedShotType: -1,
      selectedShotSituation: -1,
      selectedHitSort: 'eh'
    };
  },

  computed: {
    sortBytimeGT: function sortBytimeGT() {
      /*eslint-disable */
      var gt = this.Gamesheet.filter(function (a) {
        return a.position == 'GT';
      });
      return gt.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortBytimeDefense: function sortBytimeDefense() {
      /*eslint-disable */
      var defense = this.Gamesheet.filter(function (a) {
        return a.position == 'LD' || a.position == 'RD';
      });
      return defense.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortBytimeForwards: function sortBytimeForwards() {
      var forwards = this.Gamesheet.filter(function (a) {
        return a.position == 'LW' || a.position == 'C' || a.position == 'RW';
      });
      return forwards.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortBytimeAll: function sortBytimeAll() {
      var all = this.Gamesheet.filter(function (a) {
        return a.position == 'LW' || a.position == 'C' || a.position == 'RW' || a.position == 'LD' || a.position == 'RD';
      });
      return all.slice().sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.total_toi, 'HH:mm:ss') - __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.total_toi, 'HH:mm:ss');
      });
    },
    sortFoByDiffLeft: function sortFoByDiffLeft() {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_left'], ['desc']))
      return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.FaceoffsChart.all_situations, ['total_diff_left'], ['desc']);
    },
    sortFoByDiffCenter: function sortFoByDiffCenter() {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_center'], ['desc']))
      return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.FaceoffsChart.all_situations, ['total_diff_center'], ['desc']);
    },
    sortFoByDiffRight: function sortFoByDiffRight() {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_right'], ['desc']))
      return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.FaceoffsChart.all_situations, ['total_diff_right'], ['desc']);
    },
    sortByTOAscEH: function sortByTOAscEH() {

      //return this.Turnovers.home_players
      return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.Turnovers.home_players, ['pos', 'total_eh', 'player_defensive_eh', 'player_neutral_eh', 'player_offensive_eh'], ['asc', 'desc', 'desc', 'desc', 'desc']);
    },
    sortByTOAscPP: function sortByTOAscPP() {
      //return []
      return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.Turnovers.home_players, ['pos', 'total_pp', 'player_defensive_pp', 'player_neutral_pp', 'player_offensive_pp'], ['asc', 'desc', 'desc', 'desc', 'desc']);
    },
    sortByTOAscSH: function sortByTOAscSH() {
      //return []
      return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.Turnovers.home_players, ['pos', 'total_sh', 'player_defensive_sh', 'player_neutral_sh', 'player_offensive_sh'], ['asc', 'desc', 'desc', 'desc', 'desc']);
    },
    sortByHits: function sortByHits() {
      if (this.selectedHitSort === 'eh') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.Hits.home_players, ['hits_eh', 'asc']);
      } else if (this.selectedHitSort === 'pp') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.Hits.home_players, ['hits_pp', 'asc']);
      } else if (this.selectedHitSort === 'sh') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.Hits.home_players, ['hits_sh', 'asc']);
      } else if (this.selectedHitSort === 'all') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.Hits.home_players, ['hit_total', 'asc']);
      } else {
        return this.Hits.home_players;
      }
    },
    sortBySOT: function sortBySOT() {
      if (this.selectedSOTSort === 'eh') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.SOT.home_players, ['sot_eh'], ['asc']);
      } else if (this.selectedSOTSort === 'pp') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.SOT.home_players, ['sot_pp'], ['asc']);
      } else if (this.selectedSOTSort === 'sh') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.SOT.home_players, ['sot_sh'], ['asc']);
      } else if (this.selectedSOTSort === 'all') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.SOT.home_players, ['sot_total'], ['asc']);
      } else {
        return this.SOT.home_players;
      }
    },
    sortBySOTAway: function sortBySOTAway() {
      if (this.selectedSOTSort === 'eh') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.SOT.away_players, ['sot_eh'], ['desc']);
      } else if (this.selectedSOTSort === 'pp') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.SOT.away_players, ['sot_pp'], ['desc']);
      } else if (this.selectedSOTSort === 'sh') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.SOT.away_players, ['sot_sh'], ['desc']);
      } else if (this.selectedSOTSort === 'all') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.SOT.away_players, ['sot_total'], ['desc']);
      } else {
        return this.SOT.away_players;
      }
    },
    sortByPlusMinusHome: function sortByPlusMinusHome() {
      // console.log('Plus minus sort option is: '  + this.selectedPlusMinusSort)
      if (this.selectedPlusMinusSort === 'line') {
        console.log('sort by line');
        // console.log('Plus minus data: ' + JSON.stringify(this.PlusMinus.home_players))
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.PlusMinus.home_players, ['pos', 'line_number'], ['asc', 'asc']);
      } else if (this.selectedPlusMinusSort === 'differential') {
        console.log('sort by diff: ' + JSON.stringify(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.PlusMinus.home_players, ['pos', 'diff'], ['asc', 'asc'])));
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.PlusMinus.home_players, ['pos', 'diff'], ['asc', 'asc']);
      } else if (this.selectedPlusMinusSort === 'for') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.PlusMinus.home_players, ['pos', 'shots_for'], ['asc', 'desc']);
      } else if (this.selectedPlusMinusSort === 'against') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.PlusMinus.home_players, ['pos', 'shots_against'], ['asc', 'desc']);
      } else {
        return this.PlusMinus.home_players;
      }
    },
    sortByPlusMinusHomeAuto: function sortByPlusMinusHomeAuto() {
      // console.log('Plus minus sort option is: '  + this.selectedPlusMinusSort)
      if (this.selectedPlusMinusSort === 'line') {
        // console.log('Plus minus data: ' + JSON.stringify(this.PlusMinus.home_players))
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'line_number'], ['asc', 'asc']);
      } else if (this.selectedPlusMinusSort === 'differential') {
        console.log(JSON.stringify(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'diff'], ['asc', 'desc'])));
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'diff'], ['asc', 'desc']);
      } else if (this.selectedPlusMinusSort === 'for') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'shots_for'], ['asc', 'desc']);
      } else if (this.selectedPlusMinusSort === 'against') {
        return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'shots_against'], ['asc', 'desc']);
      } else {
        return this.PlusMinusAuto.home_players;
      }
    },
    sortByPlusMinusHomeAutoDiff: function sortByPlusMinusHomeAutoDiff() {
      return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.orderBy(this.PlusMinusAuto.home_players, ['pos', 'diff'], ['asc', 'desc']);
    },
    fo_total_chart: function fo_total_chart() {
      return {
        labels: this.fo_total_labels,
        datasets: [{
          data: this.getFoChartTotals(),
          backgroundColor: this.backgroundColor
        }]
      };
    },
    fo_player_l: function fo_player_l() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortFoByDiffLeft[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.sortFoByDiffLeft[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var leftWin = _step2.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.sortFoByDiffLeft[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var leftLoss = _step3.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c: function fo_player_c() {
      var playerLabels = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.sortFoByDiffCenter[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var label = _step4.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.sortFoByDiffCenter[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var center = _step5.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.sortFoByDiffCenter[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var centerLoss = _step6.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r: function fo_player_r() {
      var playerLabels = [];
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.sortFoByDiffRight[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var label = _step7.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.sortFoByDiffRight[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var right = _step8.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.sortFoByDiffRight[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var rightLoss = _step9.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_t: function fo_player_t() {
      if (this.FaceoffsChart.all_situations) {
        var playerLabels = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = this.FaceoffsChart.all_situations[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var label = _step10.value;

            playerLabels.push(label.player_id);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var data = {
          labels: playerLabels
        };
        data.datsets = [];
        var playerTotalWin = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = this.FaceoffsChart.all_situations[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var win = _step11.value;

            playerTotalWin.push(win.total_win);
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        var playerTotalLoss = [];
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
          for (var _iterator12 = this.FaceoffsChart.all_situations[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var loss = _step12.value;

            playerTotalLoss.push(loss.total_loss);
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }

        data.datasets = [{
          data: playerTotalWin,
          label: 'Total Win',
          backgroundColor: 'rgba(255, 206, 86, 1)',
          borderColor: 'rgba(255, 206, 86, 1)'
        }, {
          data: playerTotalLoss,
          label: 'Total Loss',
          backgroundColor: 'rgba(255, 99, 132, 1)',
          borderColor: 'rgba(255, 99, 132, 1)'
        }];
        return data;
      }
    },
    fo_player_l_eh: function fo_player_l_eh() {
      var playerLabels = [];
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var label = _step13.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var leftWin = _step14.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var leftLoss = _step15.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c_eh: function fo_player_c_eh() {
      var playerLabels = [];
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var label = _step16.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var center = _step17.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var centerLoss = _step18.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r_eh: function fo_player_r_eh() {
      var playerLabels = [];
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var label = _step19.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;

      try {
        for (var _iterator20 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var right = _step20.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion21 = true;
      var _didIteratorError21 = false;
      var _iteratorError21 = undefined;

      try {
        for (var _iterator21 = this.FaceoffsChart.eh_situations[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
          var rightLoss = _step21.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion21 && _iterator21.return) {
            _iterator21.return();
          }
        } finally {
          if (_didIteratorError21) {
            throw _iteratorError21;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_l_pp: function fo_player_l_pp() {
      var playerLabels = [];
      var _iteratorNormalCompletion22 = true;
      var _didIteratorError22 = false;
      var _iteratorError22 = undefined;

      try {
        for (var _iterator22 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
          var label = _step22.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError22 = true;
        _iteratorError22 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion22 && _iterator22.return) {
            _iterator22.return();
          }
        } finally {
          if (_didIteratorError22) {
            throw _iteratorError22;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion23 = true;
      var _didIteratorError23 = false;
      var _iteratorError23 = undefined;

      try {
        for (var _iterator23 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
          var leftWin = _step23.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError23 = true;
        _iteratorError23 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion23 && _iterator23.return) {
            _iterator23.return();
          }
        } finally {
          if (_didIteratorError23) {
            throw _iteratorError23;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion24 = true;
      var _didIteratorError24 = false;
      var _iteratorError24 = undefined;

      try {
        for (var _iterator24 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
          var leftLoss = _step24.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError24 = true;
        _iteratorError24 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion24 && _iterator24.return) {
            _iterator24.return();
          }
        } finally {
          if (_didIteratorError24) {
            throw _iteratorError24;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c_pp: function fo_player_c_pp() {
      var playerLabels = [];
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var label = _step25.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion26 = true;
      var _didIteratorError26 = false;
      var _iteratorError26 = undefined;

      try {
        for (var _iterator26 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
          var center = _step26.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError26 = true;
        _iteratorError26 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion26 && _iterator26.return) {
            _iterator26.return();
          }
        } finally {
          if (_didIteratorError26) {
            throw _iteratorError26;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion27 = true;
      var _didIteratorError27 = false;
      var _iteratorError27 = undefined;

      try {
        for (var _iterator27 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
          var centerLoss = _step27.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError27 = true;
        _iteratorError27 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion27 && _iterator27.return) {
            _iterator27.return();
          }
        } finally {
          if (_didIteratorError27) {
            throw _iteratorError27;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r_pp: function fo_player_r_pp() {
      var playerLabels = [];
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var label = _step28.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion29 = true;
      var _didIteratorError29 = false;
      var _iteratorError29 = undefined;

      try {
        for (var _iterator29 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
          var right = _step29.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError29 = true;
        _iteratorError29 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion29 && _iterator29.return) {
            _iterator29.return();
          }
        } finally {
          if (_didIteratorError29) {
            throw _iteratorError29;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion30 = true;
      var _didIteratorError30 = false;
      var _iteratorError30 = undefined;

      try {
        for (var _iterator30 = this.FaceoffsChart.pp_situations[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
          var rightLoss = _step30.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError30 = true;
        _iteratorError30 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion30 && _iterator30.return) {
            _iterator30.return();
          }
        } finally {
          if (_didIteratorError30) {
            throw _iteratorError30;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_l_sh: function fo_player_l_sh() {
      var playerLabels = [];
      var _iteratorNormalCompletion31 = true;
      var _didIteratorError31 = false;
      var _iteratorError31 = undefined;

      try {
        for (var _iterator31 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
          var label = _step31.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError31 = true;
        _iteratorError31 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion31 && _iterator31.return) {
            _iterator31.return();
          }
        } finally {
          if (_didIteratorError31) {
            throw _iteratorError31;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerLeftWin = [];
      var _iteratorNormalCompletion32 = true;
      var _didIteratorError32 = false;
      var _iteratorError32 = undefined;

      try {
        for (var _iterator32 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
          var leftWin = _step32.value;

          playerLeftWin.push(leftWin.left_win);
        }
      } catch (err) {
        _didIteratorError32 = true;
        _iteratorError32 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion32 && _iterator32.return) {
            _iterator32.return();
          }
        } finally {
          if (_didIteratorError32) {
            throw _iteratorError32;
          }
        }
      }

      var playerLeftLoss = [];
      var _iteratorNormalCompletion33 = true;
      var _didIteratorError33 = false;
      var _iteratorError33 = undefined;

      try {
        for (var _iterator33 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
          var leftLoss = _step33.value;

          playerLeftLoss.push(leftLoss.left_loss);
        }
      } catch (err) {
        _didIteratorError33 = true;
        _iteratorError33 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion33 && _iterator33.return) {
            _iterator33.return();
          }
        } finally {
          if (_didIteratorError33) {
            throw _iteratorError33;
          }
        }
      }

      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_c_sh: function fo_player_c_sh() {
      var playerLabels = [];
      var _iteratorNormalCompletion34 = true;
      var _didIteratorError34 = false;
      var _iteratorError34 = undefined;

      try {
        for (var _iterator34 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
          var label = _step34.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError34 = true;
        _iteratorError34 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion34 && _iterator34.return) {
            _iterator34.return();
          }
        } finally {
          if (_didIteratorError34) {
            throw _iteratorError34;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerCenterWin = [];
      var _iteratorNormalCompletion35 = true;
      var _didIteratorError35 = false;
      var _iteratorError35 = undefined;

      try {
        for (var _iterator35 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
          var center = _step35.value;

          playerCenterWin.push(center.center_win);
        }
      } catch (err) {
        _didIteratorError35 = true;
        _iteratorError35 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion35 && _iterator35.return) {
            _iterator35.return();
          }
        } finally {
          if (_didIteratorError35) {
            throw _iteratorError35;
          }
        }
      }

      var playerCenterLoss = [];
      var _iteratorNormalCompletion36 = true;
      var _didIteratorError36 = false;
      var _iteratorError36 = undefined;

      try {
        for (var _iterator36 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
          var centerLoss = _step36.value;

          playerCenterLoss.push(centerLoss.center_loss);
        }
      } catch (err) {
        _didIteratorError36 = true;
        _iteratorError36 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion36 && _iterator36.return) {
            _iterator36.return();
          }
        } finally {
          if (_didIteratorError36) {
            throw _iteratorError36;
          }
        }
      }

      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    fo_player_r_sh: function fo_player_r_sh() {
      var playerLabels = [];
      var _iteratorNormalCompletion37 = true;
      var _didIteratorError37 = false;
      var _iteratorError37 = undefined;

      try {
        for (var _iterator37 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
          var label = _step37.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError37 = true;
        _iteratorError37 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion37 && _iterator37.return) {
            _iterator37.return();
          }
        } finally {
          if (_didIteratorError37) {
            throw _iteratorError37;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerRightWin = [];
      var _iteratorNormalCompletion38 = true;
      var _didIteratorError38 = false;
      var _iteratorError38 = undefined;

      try {
        for (var _iterator38 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
          var right = _step38.value;

          playerRightWin.push(right.right_win);
        }
      } catch (err) {
        _didIteratorError38 = true;
        _iteratorError38 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion38 && _iterator38.return) {
            _iterator38.return();
          }
        } finally {
          if (_didIteratorError38) {
            throw _iteratorError38;
          }
        }
      }

      var playerRightLoss = [];
      var _iteratorNormalCompletion39 = true;
      var _didIteratorError39 = false;
      var _iteratorError39 = undefined;

      try {
        for (var _iterator39 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
          var rightLoss = _step39.value;

          playerRightLoss.push(rightLoss.right_loss);
        }
      } catch (err) {
        _didIteratorError39 = true;
        _iteratorError39 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion39 && _iterator39.return) {
            _iterator39.return();
          }
        } finally {
          if (_didIteratorError39) {
            throw _iteratorError39;
          }
        }
      }

      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }, {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }];
      return data;
    },
    to_player_eh: function to_player_eh() {
      var playerLabels = [];
      var _iteratorNormalCompletion40 = true;
      var _didIteratorError40 = false;
      var _iteratorError40 = undefined;

      try {
        for (var _iterator40 = this.sortByTOAscEH[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
          var label = _step40.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError40 = true;
        _iteratorError40 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion40 && _iterator40.return) {
            _iterator40.return();
          }
        } finally {
          if (_didIteratorError40) {
            throw _iteratorError40;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerOffensive = [];
      var playerNeutral = [];
      var playerDefensive = [];
      var _iteratorNormalCompletion41 = true;
      var _didIteratorError41 = false;
      var _iteratorError41 = undefined;

      try {
        for (var _iterator41 = this.sortByTOAscEH[Symbol.iterator](), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
          var offensive = _step41.value;

          playerOffensive.push(offensive.player_offensive_eh);
        }
      } catch (err) {
        _didIteratorError41 = true;
        _iteratorError41 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion41 && _iterator41.return) {
            _iterator41.return();
          }
        } finally {
          if (_didIteratorError41) {
            throw _iteratorError41;
          }
        }
      }

      var _iteratorNormalCompletion42 = true;
      var _didIteratorError42 = false;
      var _iteratorError42 = undefined;

      try {
        for (var _iterator42 = this.sortByTOAscEH[Symbol.iterator](), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
          var neutral = _step42.value;

          playerNeutral.push(neutral.player_neutral_eh);
        }
      } catch (err) {
        _didIteratorError42 = true;
        _iteratorError42 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion42 && _iterator42.return) {
            _iterator42.return();
          }
        } finally {
          if (_didIteratorError42) {
            throw _iteratorError42;
          }
        }
      }

      var _iteratorNormalCompletion43 = true;
      var _didIteratorError43 = false;
      var _iteratorError43 = undefined;

      try {
        for (var _iterator43 = this.sortByTOAscEH[Symbol.iterator](), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
          var defensive = _step43.value;

          playerDefensive.push(defensive.player_defensive_eh);
        }
      } catch (err) {
        _didIteratorError43 = true;
        _iteratorError43 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion43 && _iterator43.return) {
            _iterator43.return();
          }
        } finally {
          if (_didIteratorError43) {
            throw _iteratorError43;
          }
        }
      }

      data.datasets = [{
        data: playerDefensive,
        label: 'Defensive',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerNeutral,
        label: 'Neutral',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54,162,235, 1)'
      }, {
        data: playerOffensive,
        label: 'Offensive',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    to_player_pp: function to_player_pp() {
      var playerLabels = [];
      var _iteratorNormalCompletion44 = true;
      var _didIteratorError44 = false;
      var _iteratorError44 = undefined;

      try {
        for (var _iterator44 = this.sortByTOAscPP[Symbol.iterator](), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
          var label = _step44.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError44 = true;
        _iteratorError44 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion44 && _iterator44.return) {
            _iterator44.return();
          }
        } finally {
          if (_didIteratorError44) {
            throw _iteratorError44;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerOffensive = [];
      var playerNeutral = [];
      var playerDefensive = [];
      var _iteratorNormalCompletion45 = true;
      var _didIteratorError45 = false;
      var _iteratorError45 = undefined;

      try {
        for (var _iterator45 = this.sortByTOAscPP[Symbol.iterator](), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
          var offensive = _step45.value;

          playerOffensive.push(offensive.player_offensive_pp);
        }
      } catch (err) {
        _didIteratorError45 = true;
        _iteratorError45 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion45 && _iterator45.return) {
            _iterator45.return();
          }
        } finally {
          if (_didIteratorError45) {
            throw _iteratorError45;
          }
        }
      }

      var _iteratorNormalCompletion46 = true;
      var _didIteratorError46 = false;
      var _iteratorError46 = undefined;

      try {
        for (var _iterator46 = this.sortByTOAscPP[Symbol.iterator](), _step46; !(_iteratorNormalCompletion46 = (_step46 = _iterator46.next()).done); _iteratorNormalCompletion46 = true) {
          var neutral = _step46.value;

          playerNeutral.push(neutral.player_neutral_pp);
        }
      } catch (err) {
        _didIteratorError46 = true;
        _iteratorError46 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion46 && _iterator46.return) {
            _iterator46.return();
          }
        } finally {
          if (_didIteratorError46) {
            throw _iteratorError46;
          }
        }
      }

      var _iteratorNormalCompletion47 = true;
      var _didIteratorError47 = false;
      var _iteratorError47 = undefined;

      try {
        for (var _iterator47 = this.sortByTOAscPP[Symbol.iterator](), _step47; !(_iteratorNormalCompletion47 = (_step47 = _iterator47.next()).done); _iteratorNormalCompletion47 = true) {
          var defensive = _step47.value;

          playerDefensive.push(defensive.player_defensive_pp);
        }
      } catch (err) {
        _didIteratorError47 = true;
        _iteratorError47 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion47 && _iterator47.return) {
            _iterator47.return();
          }
        } finally {
          if (_didIteratorError47) {
            throw _iteratorError47;
          }
        }
      }

      data.datasets = [{
        data: playerDefensive,
        label: 'Defensive',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerNeutral,
        label: 'Neutral',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54,162,235, 1)'
      }, {
        data: playerOffensive,
        label: 'Offensive',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    to_player_sh: function to_player_sh() {
      var playerLabels = [];
      var _iteratorNormalCompletion48 = true;
      var _didIteratorError48 = false;
      var _iteratorError48 = undefined;

      try {
        for (var _iterator48 = this.sortByTOAscSH[Symbol.iterator](), _step48; !(_iteratorNormalCompletion48 = (_step48 = _iterator48.next()).done); _iteratorNormalCompletion48 = true) {
          var label = _step48.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError48 = true;
        _iteratorError48 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion48 && _iterator48.return) {
            _iterator48.return();
          }
        } finally {
          if (_didIteratorError48) {
            throw _iteratorError48;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerOffensive = [];
      var playerNeutral = [];
      var playerDefensive = [];
      var _iteratorNormalCompletion49 = true;
      var _didIteratorError49 = false;
      var _iteratorError49 = undefined;

      try {
        for (var _iterator49 = this.sortByTOAscSH[Symbol.iterator](), _step49; !(_iteratorNormalCompletion49 = (_step49 = _iterator49.next()).done); _iteratorNormalCompletion49 = true) {
          var offensive = _step49.value;

          playerOffensive.push(offensive.player_offensive_sh);
        }
      } catch (err) {
        _didIteratorError49 = true;
        _iteratorError49 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion49 && _iterator49.return) {
            _iterator49.return();
          }
        } finally {
          if (_didIteratorError49) {
            throw _iteratorError49;
          }
        }
      }

      var _iteratorNormalCompletion50 = true;
      var _didIteratorError50 = false;
      var _iteratorError50 = undefined;

      try {
        for (var _iterator50 = this.sortByTOAscSH[Symbol.iterator](), _step50; !(_iteratorNormalCompletion50 = (_step50 = _iterator50.next()).done); _iteratorNormalCompletion50 = true) {
          var neutral = _step50.value;

          playerNeutral.push(neutral.player_neutral_sh);
        }
      } catch (err) {
        _didIteratorError50 = true;
        _iteratorError50 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion50 && _iterator50.return) {
            _iterator50.return();
          }
        } finally {
          if (_didIteratorError50) {
            throw _iteratorError50;
          }
        }
      }

      var _iteratorNormalCompletion51 = true;
      var _didIteratorError51 = false;
      var _iteratorError51 = undefined;

      try {
        for (var _iterator51 = this.sortByTOAscSH[Symbol.iterator](), _step51; !(_iteratorNormalCompletion51 = (_step51 = _iterator51.next()).done); _iteratorNormalCompletion51 = true) {
          var defensive = _step51.value;

          playerDefensive.push(defensive.player_defensive_sh);
        }
      } catch (err) {
        _didIteratorError51 = true;
        _iteratorError51 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion51 && _iterator51.return) {
            _iterator51.return();
          }
        } finally {
          if (_didIteratorError51) {
            throw _iteratorError51;
          }
        }
      }

      data.datasets = [{
        data: playerDefensive,
        label: 'Defensive',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: playerNeutral,
        label: 'Neutral',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54,162,235, 1)'
      }, {
        data: playerOffensive,
        label: 'Offensive',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    hit_player_totals: function hit_player_totals() {
      var playerLabels = [];
      var _iteratorNormalCompletion52 = true;
      var _didIteratorError52 = false;
      var _iteratorError52 = undefined;

      try {
        for (var _iterator52 = this.sortByHits[Symbol.iterator](), _step52; !(_iteratorNormalCompletion52 = (_step52 = _iterator52.next()).done); _iteratorNormalCompletion52 = true) {
          var label = _step52.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError52 = true;
        _iteratorError52 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion52 && _iterator52.return) {
            _iterator52.return();
          }
        } finally {
          if (_didIteratorError52) {
            throw _iteratorError52;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var playerHits = [];
      var _iteratorNormalCompletion53 = true;
      var _didIteratorError53 = false;
      var _iteratorError53 = undefined;

      try {
        for (var _iterator53 = this.sortByHits[Symbol.iterator](), _step53; !(_iteratorNormalCompletion53 = (_step53 = _iterator53.next()).done); _iteratorNormalCompletion53 = true) {
          var hits = _step53.value;

          if (this.selectedHitSort === 'eh') playerHits.push(hits.hits_eh);
          if (this.selectedHitSort === 'pp') playerHits.push(hits.hits_pp);
          if (this.selectedHitSort === 'sh') playerHits.push(hits.hits_sh);
          if (this.selectedHitSort === 'all') playerHits.push(hits.hit_total);
        }
      } catch (err) {
        _didIteratorError53 = true;
        _iteratorError53 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion53 && _iterator53.return) {
            _iterator53.return();
          }
        } finally {
          if (_didIteratorError53) {
            throw _iteratorError53;
          }
        }
      }

      data.datasets = [{
        data: playerHits,
        label: 'Hits',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    oddman_rushes_totals: function oddman_rushes_totals() {
      var playerLabels = [];
      var _iteratorNormalCompletion54 = true;
      var _didIteratorError54 = false;
      var _iteratorError54 = undefined;

      try {
        for (var _iterator54 = this.FaceoffsChart.sh_situations[Symbol.iterator](), _step54; !(_iteratorNormalCompletion54 = (_step54 = _iterator54.next()).done); _iteratorNormalCompletion54 = true) {
          var label = _step54.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError54 = true;
        _iteratorError54 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion54 && _iterator54.return) {
            _iterator54.return();
          }
        } finally {
          if (_didIteratorError54) {
            throw _iteratorError54;
          }
        }
      }

      var data = {
        labels: [this.Fixture[0].home_team.name, this.Fixture[0].away_team.name]
      };
      data.datsets = [];

      data.datasets = [{
        data: [this.OddmanRushes.home_rushes, this.OddmanRushes.away_rushes],
        backgroundColor: ['rgba(255, 206, 86, 1)', 'rgba(54, 162, 235, 1)'],
        borderColor: ['rgba(255, 206, 86, 1)', 'rgba(54, 162, 235, 1)']
      }];
      return data;
    },
    sot_totals_home: function sot_totals_home() {
      var playerLabels = [];
      var _iteratorNormalCompletion55 = true;
      var _didIteratorError55 = false;
      var _iteratorError55 = undefined;

      try {
        for (var _iterator55 = this.sortBySOT[Symbol.iterator](), _step55; !(_iteratorNormalCompletion55 = (_step55 = _iterator55.next()).done); _iteratorNormalCompletion55 = true) {
          var label = _step55.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError55 = true;
        _iteratorError55 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion55 && _iterator55.return) {
            _iterator55.return();
          }
        } finally {
          if (_didIteratorError55) {
            throw _iteratorError55;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var shotsOnTarget = [];
      var _iteratorNormalCompletion56 = true;
      var _didIteratorError56 = false;
      var _iteratorError56 = undefined;

      try {
        for (var _iterator56 = this.sortBySOT[Symbol.iterator](), _step56; !(_iteratorNormalCompletion56 = (_step56 = _iterator56.next()).done); _iteratorNormalCompletion56 = true) {
          var shot = _step56.value;

          shotsOnTarget.push(shot.sot);
        }
      } catch (err) {
        _didIteratorError56 = true;
        _iteratorError56 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion56 && _iterator56.return) {
            _iterator56.return();
          }
        } finally {
          if (_didIteratorError56) {
            throw _iteratorError56;
          }
        }
      }

      data.datasets = [{
        data: shotsOnTarget,
        label: 'Shots On Target - EH',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    sot_totals_away: function sot_totals_away() {
      var playerLabels = [];
      // console.log('SOT AWAY: ' + JSON.stringify(this.SOT.away_players))
      var _iteratorNormalCompletion57 = true;
      var _didIteratorError57 = false;
      var _iteratorError57 = undefined;

      try {
        for (var _iterator57 = this.sortBySOTAway[Symbol.iterator](), _step57; !(_iteratorNormalCompletion57 = (_step57 = _iterator57.next()).done); _iteratorNormalCompletion57 = true) {
          var label = _step57.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError57 = true;
        _iteratorError57 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion57 && _iterator57.return) {
            _iterator57.return();
          }
        } finally {
          if (_didIteratorError57) {
            throw _iteratorError57;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var shotsOnTarget = [];
      var _iteratorNormalCompletion58 = true;
      var _didIteratorError58 = false;
      var _iteratorError58 = undefined;

      try {
        for (var _iterator58 = this.sortBySOTAway[Symbol.iterator](), _step58; !(_iteratorNormalCompletion58 = (_step58 = _iterator58.next()).done); _iteratorNormalCompletion58 = true) {
          var shot = _step58.value;

          shotsOnTarget.push(shot.sot);
        }
      } catch (err) {
        _didIteratorError58 = true;
        _iteratorError58 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion58 && _iterator58.return) {
            _iterator58.return();
          }
        } finally {
          if (_didIteratorError58) {
            throw _iteratorError58;
          }
        }
      }

      data.datasets = [{
        data: shotsOnTarget,
        label: 'Shots On Target - EH',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    sot_totals: function sot_totals() {
      var playerLabels = [];
      var shotsOnTarget = [];
      var shotsOnTargetAway = [];
      // console.log('SOT AWAY: ' + JSON.stringify(this.SOT.away_players))

      var _iteratorNormalCompletion59 = true;
      var _didIteratorError59 = false;
      var _iteratorError59 = undefined;

      try {
        for (var _iterator59 = this.sortBySOT[Symbol.iterator](), _step59; !(_iteratorNormalCompletion59 = (_step59 = _iterator59.next()).done); _iteratorNormalCompletion59 = true) {
          var label = _step59.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError59 = true;
        _iteratorError59 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion59 && _iterator59.return) {
            _iterator59.return();
          }
        } finally {
          if (_didIteratorError59) {
            throw _iteratorError59;
          }
        }
      }

      var _iteratorNormalCompletion60 = true;
      var _didIteratorError60 = false;
      var _iteratorError60 = undefined;

      try {
        for (var _iterator60 = this.sortBySOTAway[Symbol.iterator](), _step60; !(_iteratorNormalCompletion60 = (_step60 = _iterator60.next()).done); _iteratorNormalCompletion60 = true) {
          var label = _step60.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError60 = true;
        _iteratorError60 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion60 && _iterator60.return) {
            _iterator60.return();
          }
        } finally {
          if (_didIteratorError60) {
            throw _iteratorError60;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      var _iteratorNormalCompletion61 = true;
      var _didIteratorError61 = false;
      var _iteratorError61 = undefined;

      try {
        for (var _iterator61 = this.sortBySOT[Symbol.iterator](), _step61; !(_iteratorNormalCompletion61 = (_step61 = _iterator61.next()).done); _iteratorNormalCompletion61 = true) {
          var shot = _step61.value;

          if (this.selectedSOTSort === 'eh') {
            shotsOnTarget.push(shot.sot_eh);
          } else if (this.selectedSOTSort === 'pp') {
            shotsOnTarget.push(shot.sot_pp);
          } else if (this.selectedSOTSort === 'sh') {
            shotsOnTarget.push(shot.sot_sh);
          } else if (this.selectedSOTSort === 'all') {
            shotsOnTarget.push(shot.sot_total);
          }
        }
      } catch (err) {
        _didIteratorError61 = true;
        _iteratorError61 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion61 && _iterator61.return) {
            _iterator61.return();
          }
        } finally {
          if (_didIteratorError61) {
            throw _iteratorError61;
          }
        }
      }

      var _iteratorNormalCompletion62 = true;
      var _didIteratorError62 = false;
      var _iteratorError62 = undefined;

      try {
        for (var _iterator62 = this.sortBySOTAway[Symbol.iterator](), _step62; !(_iteratorNormalCompletion62 = (_step62 = _iterator62.next()).done); _iteratorNormalCompletion62 = true) {
          var shot = _step62.value;

          shotsOnTarget.push(0);
        }
      } catch (err) {
        _didIteratorError62 = true;
        _iteratorError62 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion62 && _iterator62.return) {
            _iterator62.return();
          }
        } finally {
          if (_didIteratorError62) {
            throw _iteratorError62;
          }
        }
      }

      var _iteratorNormalCompletion63 = true;
      var _didIteratorError63 = false;
      var _iteratorError63 = undefined;

      try {
        for (var _iterator63 = this.sortBySOT[Symbol.iterator](), _step63; !(_iteratorNormalCompletion63 = (_step63 = _iterator63.next()).done); _iteratorNormalCompletion63 = true) {
          var shot = _step63.value;

          shotsOnTargetAway.push(0);
        }
      } catch (err) {
        _didIteratorError63 = true;
        _iteratorError63 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion63 && _iterator63.return) {
            _iterator63.return();
          }
        } finally {
          if (_didIteratorError63) {
            throw _iteratorError63;
          }
        }
      }

      var _iteratorNormalCompletion64 = true;
      var _didIteratorError64 = false;
      var _iteratorError64 = undefined;

      try {
        for (var _iterator64 = this.sortBySOTAway[Symbol.iterator](), _step64; !(_iteratorNormalCompletion64 = (_step64 = _iterator64.next()).done); _iteratorNormalCompletion64 = true) {
          var shot = _step64.value;

          if (this.selectedSOTSort === 'eh') {
            shotsOnTargetAway.push(shot.sot_eh);
          } else if (this.selectedSOTSort === 'pp') {
            shotsOnTargetAway.push(shot.sot_pp);
          } else if (this.selectedSOTSort === 'sh') {
            shotsOnTargetAway.push(shot.sot_sh);
          } else if (this.selectedSOTSort === 'all') {
            shotsOnTargetAway.push(shot.sot_total);
          }
        }
      } catch (err) {
        _didIteratorError64 = true;
        _iteratorError64 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion64 && _iterator64.return) {
            _iterator64.return();
          }
        } finally {
          if (_didIteratorError64) {
            throw _iteratorError64;
          }
        }
      }

      data.datsets = [];
      data.datasets = [{
        data: shotsOnTarget,
        label: this.Fixture[0].home_team.name,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: shotsOnTargetAway,
        label: this.Fixture[0].away_team.name,
        backgroundColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    plus_minus_totals: function plus_minus_totals() {
      var playerLabels = [];
      var _iteratorNormalCompletion65 = true;
      var _didIteratorError65 = false;
      var _iteratorError65 = undefined;

      try {
        for (var _iterator65 = this.sortByPlusMinusHome[Symbol.iterator](), _step65; !(_iteratorNormalCompletion65 = (_step65 = _iterator65.next()).done); _iteratorNormalCompletion65 = true) {
          var label = _step65.value;

          playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError65 = true;
        _iteratorError65 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion65 && _iterator65.return) {
            _iterator65.return();
          }
        } finally {
          if (_didIteratorError65) {
            throw _iteratorError65;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var shotsFor = [];
      var shotsAgainst = [];
      var _iteratorNormalCompletion66 = true;
      var _didIteratorError66 = false;
      var _iteratorError66 = undefined;

      try {
        for (var _iterator66 = this.sortByPlusMinusHome[Symbol.iterator](), _step66; !(_iteratorNormalCompletion66 = (_step66 = _iterator66.next()).done); _iteratorNormalCompletion66 = true) {
          var shots = _step66.value;

          shotsFor.push(shots.shots_for);
        }
      } catch (err) {
        _didIteratorError66 = true;
        _iteratorError66 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion66 && _iterator66.return) {
            _iterator66.return();
          }
        } finally {
          if (_didIteratorError66) {
            throw _iteratorError66;
          }
        }
      }

      var _iteratorNormalCompletion67 = true;
      var _didIteratorError67 = false;
      var _iteratorError67 = undefined;

      try {
        for (var _iterator67 = this.sortByPlusMinusHome[Symbol.iterator](), _step67; !(_iteratorNormalCompletion67 = (_step67 = _iterator67.next()).done); _iteratorNormalCompletion67 = true) {
          var shotsA = _step67.value;

          shotsAgainst.push(shotsA.shots_against);
        }
      } catch (err) {
        _didIteratorError67 = true;
        _iteratorError67 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion67 && _iterator67.return) {
            _iterator67.return();
          }
        } finally {
          if (_didIteratorError67) {
            throw _iteratorError67;
          }
        }
      }

      data.datasets = [{
        data: shotsFor,
        label: 'Shots For',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: shotsAgainst,
        label: 'Shots Against',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    plus_minus_auto_totals: function plus_minus_auto_totals() {
      var playerLabels = [];
      var _iteratorNormalCompletion68 = true;
      var _didIteratorError68 = false;
      var _iteratorError68 = undefined;

      try {
        for (var _iterator68 = this.sortByPlusMinusHomeAuto[Symbol.iterator](), _step68; !(_iteratorNormalCompletion68 = (_step68 = _iterator68.next()).done); _iteratorNormalCompletion68 = true) {
          var label = _step68.value;

          if (label.player_id !== 'Team') playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError68 = true;
        _iteratorError68 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion68 && _iterator68.return) {
            _iterator68.return();
          }
        } finally {
          if (_didIteratorError68) {
            throw _iteratorError68;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var shotsFor = [];
      var shotsAgainst = [];
      var _iteratorNormalCompletion69 = true;
      var _didIteratorError69 = false;
      var _iteratorError69 = undefined;

      try {
        for (var _iterator69 = this.sortByPlusMinusHomeAuto[Symbol.iterator](), _step69; !(_iteratorNormalCompletion69 = (_step69 = _iterator69.next()).done); _iteratorNormalCompletion69 = true) {
          var shots = _step69.value;

          if (shots.player_id !== 'Team') shotsFor.push(shots.shots_for);
        }
      } catch (err) {
        _didIteratorError69 = true;
        _iteratorError69 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion69 && _iterator69.return) {
            _iterator69.return();
          }
        } finally {
          if (_didIteratorError69) {
            throw _iteratorError69;
          }
        }
      }

      var _iteratorNormalCompletion70 = true;
      var _didIteratorError70 = false;
      var _iteratorError70 = undefined;

      try {
        for (var _iterator70 = this.sortByPlusMinusHomeAuto[Symbol.iterator](), _step70; !(_iteratorNormalCompletion70 = (_step70 = _iterator70.next()).done); _iteratorNormalCompletion70 = true) {
          var shotsA = _step70.value;

          if (shotsA.player_id !== 'Team') shotsAgainst.push(shotsA.shots_against);
        }
      } catch (err) {
        _didIteratorError70 = true;
        _iteratorError70 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion70 && _iterator70.return) {
            _iterator70.return();
          }
        } finally {
          if (_didIteratorError70) {
            throw _iteratorError70;
          }
        }
      }

      data.datasets = [{
        data: shotsFor,
        label: 'Shots For',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }, {
        data: shotsAgainst,
        label: 'Shots Against',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    plus_minus_auto_diff: function plus_minus_auto_diff() {
      var playerLabels = [];
      var _iteratorNormalCompletion71 = true;
      var _didIteratorError71 = false;
      var _iteratorError71 = undefined;

      try {
        for (var _iterator71 = this.sortByPlusMinusHomeAutoDiff[Symbol.iterator](), _step71; !(_iteratorNormalCompletion71 = (_step71 = _iterator71.next()).done); _iteratorNormalCompletion71 = true) {
          var label = _step71.value;

          if (label.player_id !== 'Team') playerLabels.push(label.player_id);
        }
      } catch (err) {
        _didIteratorError71 = true;
        _iteratorError71 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion71 && _iterator71.return) {
            _iterator71.return();
          }
        } finally {
          if (_didIteratorError71) {
            throw _iteratorError71;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var shotsFor = [];
      var shotsAgainst = [];
      var _iteratorNormalCompletion72 = true;
      var _didIteratorError72 = false;
      var _iteratorError72 = undefined;

      try {
        for (var _iterator72 = this.sortByPlusMinusHomeAutoDiff[Symbol.iterator](), _step72; !(_iteratorNormalCompletion72 = (_step72 = _iterator72.next()).done); _iteratorNormalCompletion72 = true) {
          var shots = _step72.value;

          if (shots.player_id !== 'Team') shotsFor.push(shots.diff);
        }
      } catch (err) {
        _didIteratorError72 = true;
        _iteratorError72 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion72 && _iterator72.return) {
            _iterator72.return();
          }
        } finally {
          if (_didIteratorError72) {
            throw _iteratorError72;
          }
        }
      }

      data.datasets = [{
        data: shotsFor,
        label: 'Differential',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    cleanPlusMinusData: function cleanPlusMinusData() {
      var cleanData = [];
      // console.log(this.TOI[0])

      __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.map(this.sortByPlusMinusHomeAuto, function (object) {
        cleanData.push(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.pick(object, ['player_id', 'shots_for', 'shots_against']));
      });
      return cleanData;
    },

    gameTotals: function gameTotals() {
      var total = [];
      var _iteratorNormalCompletion73 = true;
      var _didIteratorError73 = false;
      var _iteratorError73 = undefined;

      try {
        for (var _iterator73 = this.Gamesheet[Symbol.iterator](), _step73; !(_iteratorNormalCompletion73 = (_step73 = _iterator73.next()).done); _iteratorNormalCompletion73 = true) {
          var v = _step73.value;

          if (v.position === 'total') {
            total.push(v);
          }
        }
      } catch (err) {
        _didIteratorError73 = true;
        _iteratorError73 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion73 && _iterator73.return) {
            _iterator73.return();
          }
        } finally {
          if (_didIteratorError73) {
            throw _iteratorError73;
          }
        }
      }

      return total;
    }
  },
  methods: {
    setPeriod: function setPeriod(newPeriod) {
      this.$router.push('/stats/match-stats/' + this.$route.params.gameId + '/' + newPeriod);
      this.updateRemotes();
      this.$router.go(0);
    },
    fetchGameSummary: function fetchGameSummary() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/game-summary/' + this.$route.params.gameId + '/' + this.$route.params.period, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this.Summary = response.data;
        console.log(JSON.stringify(_this.Summary.situation_opts[0]));
      }, function (response) {});
    },
    fetchGamesheet: function fetchGamesheet() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/' + this.$route.params.gameId + '/' + this.$route.params.period, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this2.Gamesheet = response.data;
        console.log("Gamesheet data: " + JSON.stringify(_this2.Gamesheet));
      }, function (response) {});
    },
    fetchHitTotals: function fetchHitTotals() {
      var _this3 = this;

      this.teamId = this.$route.params.teamId;
      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/hits/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this3.Hits = response.data;
      }, function (response) {});
    },
    fetchTurnoverTotals: function fetchTurnoverTotals() {
      var _this4 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/turnovers/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this4.Turnovers = response.data;
        // console.log(JSON.stringify(this.Turnovers))
      }, function (response) {});
    },
    fetchPlusMinusTotals: function fetchPlusMinusTotals() {
      var _this5 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/plus_minus/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this5.PlusMinus = response.data;
      }, function (response) {});
    },
    fetchPlusMinusAutoTotals: function fetchPlusMinusAutoTotals() {
      var _this6 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/plus_minus_auto/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this6.PlusMinusAuto = response.data;
      }, function (response) {});
    },
    fetchPIMSTotals: function fetchPIMSTotals() {
      var _this7 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/penalty-minutes/season/get/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this7.PIM = response.data;
      }, function (response) {});
    },
    fetchSOTTotals: function fetchSOTTotals() {
      var _this8 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/individualsot/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this8.SOT = response.data;
        //this.fetchShotmap()
      }, function (response) {});
    },
    fetchFaceoffTotals: function fetchFaceoffTotals() {
      var _this9 = this;

      // console.log('Get faceoff totals')
      this.teamId = this.$route.params.teamId;
      this.$http.get('https://devilsapi.roblutken.com/api/faceoffs/season/get/totals/', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Faceoff Data is ' + response.data)
        _this9.Faceoffs = response.data;
        // console.log(JSON.stringify(this.Faceoffs))
      }, function (response) {});
    },
    fetchFaceoffChart: function fetchFaceoffChart() {
      var _this10 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/faceoffs/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Faceoff Data is ' + JSON.stringify(response.data))
        _this10.FaceoffsChart = response.data;
        // console.log(JSON.stringify(this.Faceoffs))
      }, function (response) {});
    },
    getFoChartTotals: function getFoChartTotals() {
      var foData = [this.Faceoffs.total_wins, this.Faceoffs.total_losses];
      return foData;
    },
    fetchFixtures: function fetchFixtures() {
      var _this11 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games/get/single/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Data is ' + response.data)
        _this11.Fixture = response.data;
        // console.log(JSON.stringify(this.Fixture))
      }, function (response) {});
    },
    fetchRushes: function fetchRushes() {
      var _this12 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/match-stats/oddman-rushes/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Data is ' + response.data)
        _this12.OddmanRushes = response.data;
        // console.log(JSON.stringify(this.OddmanRushes))
      }, function (response) {});
    },
    updateRemotes: function updateRemotes() {
      this.fetchFixtures();
      this.fetchGameSummary();
      this.fetchFaceoffTotals();
      this.fetchTurnoverTotals();
      this.fetchHitTotals();
      this.fetchGamesheet();
      this.fetchPlusMinusTotals();
      this.fetchPlusMinusAutoTotals();
      this.fetchSOTTotals();
      this.fetchFaceoffChart();
      this.fetchRushes();
    }
  },
  created: function created() {
    // this.fetchShotTotals()
    this.updateRemotes();
    // this.period = this.$route.params.period
  },
  mounted: function mounted() {
    //   this.fetchShotmap()
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    gameId: { type: Number, required: true },
    period: { type: Number, required: true },
    gameInfo: { type: Object, required: true }
  },
  components: {},
  data: function data() {
    return {
      GameSummary: []
    };
  },

  computed: {},
  watch: {
    endpoint: {
      handler: function handler(endpoint) {
        this.url = endpoint;
      },
      immediate: true
    },
    gameId: {
      handler: function handler(postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
        this.fetchGameSummary();
      },
      immediate: true
    }
  },
  methods: {
    gameDataLoaded: function gameDataLoaded() {
      console.log('Loaded');
    },
    filterChange: function filterChange() {},
    fetchGameSummary: function fetchGameSummary() {
      var _this = this;

      if (this.gameId !== 0) {
        this.$http.get('https://devilsapi.roblutken.com/api/app/get/game-summary/' + this.gameId + '/' + 0, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          console.log('Game Summary Data is ' + JSON.stringify(response.data));
          _this.GameSummary = response.data;
        }, function (response) {});
      }
    }
  },
  mounted: function mounted() {
    console.log('Game Summary: ' + this.gameId);
    this.fetchGameSummary();
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sort_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    gameId: { type: Number, required: true },
    period: { type: Number, required: true }
  },
  components: {
    SortTable: __WEBPACK_IMPORTED_MODULE_0__sort_table___default.a,
    'chart': __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a
  },
  data: function data() {
    return {
      TurnoversChart: [],
      apex_to_series: [{
        name: 'Turnovers',
        data: []
      }],
      apex_to_pp_series: [{
        name: 'Turnovers',
        data: []
      }],
      apex_to_sh_series: [{
        name: 'Turnovers',
        data: []
      }],
      apex_to_options: {
        width: '100em',
        height: '2000px',
        colors: ['#8b0505d1', '#000000'],
        chart: { type: 'bar', stacked: false },
        plotOptions: { bar: { horizontal: false } }
      }
    };
  },

  computed: {},
  watch: {
    endpoint: {
      handler: function handler(endpoint) {
        this.url = endpoint;
      },
      immediate: true
    },
    gameId: {
      handler: function handler(postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
        this.fetchTurnoversChart();
      },
      immediate: true
    }
  },
  methods: {
    gameDataLoaded: function gameDataLoaded() {
      console.log('Loaded');
    },
    filterChange: function filterChange() {},
    fetchTurnoversChart: function fetchTurnoversChart() {
      var _this = this;

      if (this.gameId !== 0) {
        this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/turnovers/' + this.gameId + '/' + 0, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          // console.log('Turnovers Data is ' + JSON.stringify(response.data))
          _this.TurnoversChart = response.data;
          var players = [];
          var allSeries = [];
          var playersSH = [];
          var shSeries = [];
          var playersPP = [];
          var ppSeries = [];
          var toEH = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(_this.TurnoversChart.home_players, function (o) {
            return o.total_eh + o.total_pp + o.total_sh;
          }, ['desc']);
          var toPP = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(_this.TurnoversChart.home_players, function (o) {
            return o.total_pp;
          }, ['desc']);
          var toSH = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(_this.TurnoversChart.home_players, function (o) {
            return o.total_sh;
          }, ['desc']);
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = toEH[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var to = _step.value;

              // Totals
              var total = to.total_eh + to.total_pp + to.total_sh;
              // console.log('Total for player: ' + to.player_id + 'Total:' + total + ' EH: ' + to.total_eh + ' PP ' + to.total_pp + ' SH ' + to.total_sh)
              allSeries.push(total);
              // this.apex_to_series[0].data.push(total)
              players.push(to.player_id);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = toPP[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var toP = _step2.value;

              if (toP.total_pp > 0) {
                playersPP.push(toP.player_id);
                ppSeries.push(toP.total_pp);
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = toSH[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var toS = _step3.value;

              if (toS.total_sh > 0) {
                playersSH.push(toS.player_id);
                shSeries.push(toS.total_sh);
              }
            }
            // console.log(allSeries)
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          _this.apex_to_series[0].data = allSeries;
          _this.apex_to_sh_series[0].data = shSeries;
          _this.apex_to_pp_series[0].data = ppSeries;
          var newOptions = { xaxis: { categories: players } };
          _this.$refs.apex_to_chart.updateOptions(newOptions);
          var newOptionsPP = { xaxis: { categories: playersPP } };
          _this.$refs.apex_to_pp_chart.updateOptions(newOptionsPP);
          var newOptionsSH = { xaxis: { categories: playersSH } };
          _this.$refs.apex_to_sh_chart.updateOptions(newOptionsSH);
        }, function (response) {});
      }
    },
    resetData: function resetData() {
      this.apex_to_chart[0].data = [];
    }
  },
  mounted: function mounted() {
    // console.log('Fetch Turnovers: ' + this.gameId)
    this.fetchTurnoversChart();
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditTable_edit_table_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditTable_edit_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EditTable_edit_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditTable_box_score_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditTable_box_score_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EditTable_box_score_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditTable_new_item_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditTable_new_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EditTable_new_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditTable_edit_item_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditTable_edit_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EditTable_edit_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditTable_edit_roster_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditTable_edit_roster_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__EditTable_edit_roster_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shots_heatmap_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shots_heatmap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shots_heatmap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editors_edit_goal_dialog__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editors_edit_goal_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__editors_edit_goal_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var NotificationComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'edit-table': __WEBPACK_IMPORTED_MODULE_0__EditTable_edit_table_vue___default.a,
    'box-score': __WEBPACK_IMPORTED_MODULE_1__EditTable_box_score_vue___default.a,
    'new-item': __WEBPACK_IMPORTED_MODULE_2__EditTable_new_item_vue___default.a,
    'edit-item': __WEBPACK_IMPORTED_MODULE_3__EditTable_edit_item_vue___default.a,
    'edit-roster': __WEBPACK_IMPORTED_MODULE_4__EditTable_edit_roster_vue___default.a,
    'shots-heatmap': __WEBPACK_IMPORTED_MODULE_7__shots_heatmap_vue___default.a,
    'edit-goal-dialog': __WEBPACK_IMPORTED_MODULE_8__editors_edit_goal_dialog___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_notification___default.a
  },
  computed: {
    loadEditGoal: function loadEditGoal(goalData) {
      // console.log('Edit Player' + JSON.stringify(goalData))
      this.$refs.EditGoalData.goalData = goalData;
      this.$refs.EditGoalData.launch();
      // this.$router.push('/editors/player-edit/' + this.$route.params.teamId + '/' + player.id)
    },

    sortByNumber: function sortByNumber(sort) {
      return sort.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    },
    getTotalCount: function getTotalCount() {
      return this.RawData.length;
    },
    getTotalCountFaceoff: function getTotalCountFaceoff() {
      return this.Test.length;
    },
    getTotalCountShots: function getTotalCountShots() {
      return this.CleanShots.length;
    },
    getTotalCountHits: function getTotalCountHits() {
      return this.CleanHits.length;
    },
    getTotalCountTurnovers: function getTotalCountTurnovers() {
      return this.CleanTurnovers.length;
    },
    getTotalCountTOI: function getTotalCountTOI() {
      return this.CleanTOI.length;
    },
    getTotalCountPenaltyMinutes: function getTotalCountPenaltyMinutes() {
      return this.CleanPenaltyMinutes.length;
    },
    getTotalCountGoals: function getTotalCountGoals() {
      return this.CleanGoals.length;
    },
    getTotalCountOddmanRush: function getTotalCountOddmanRush() {
      // return this.OddmanRush[0].length
    }
  },
  data: function data() {
    return {
      Fixture: [],
      RawData: [],
      faceoffHeaders: ['ID', 'Game', 'Time', 'Period', 'Home Player', 'Away Player', 'Lane', 'Zone', 'Result', 'Verified'],
      shotHeaders: ['ID', 'Game', 'Time', 'Period', 'Situation', 'Player', 'Type', 'Location', 'Verified'],
      hitHeaders: ['ID', 'Game', 'Time', 'Period', 'Situation', 'Player', 'Verified'],
      turnoverHeaders: ['ID', 'Game', 'Time', 'Period', 'Situation', 'Player', 'Zone', 'Verified'],
      toiHeaders: ['ID', 'Game', 'Time', 'Period', 'Situation', 'Player', 'Shift Length', 'EH', 'SH', 'PP', 'EH +', 'EH -', 'PP +', 'PP -', 'SH +', 'SH -', 'G EH +', 'G EH -', 'G PP +', 'G PP -', 'G SH +', 'G SH -', 'Verified'],
      peanltyMinutesHeaders: ['ID', 'Game', 'Time', 'Period', 'Situation Before ', 'Drawn Player', 'Taken Player', 'Infraction', 'Type', 'Length', 'Zone', 'Verified'],
      goalHeaders: ['ID', 'Game', 'Time', 'Period', 'Situation', 'GS', 'FA', 'SA', 'Player 1', 'Player 2', 'Player 3', 'Player 4', 'Player 5', 'Player 6', 'Verified'],
      Faceoffs: [],
      Shots: [],
      Hits: [],
      Turnovers: [],
      PenaltyMinutes: [],
      TOI: [],
      OddmanRush: [],
      Goals: [],
      HomePlayerOptions: [],
      AwayPlayerOptions: [],
      AllPlayerOptions: [],
      SituationOptions: [],
      PenaltyOptions: [],
      Test: [],
      CleanShots: [],
      CleanHits: [],
      CleanTurnovers: [],
      CleanTOI: [],
      CleanPenaltyMinutes: [],
      CleanGoals: [],
      newFaceoff: false,
      editFaceoff: false,
      editShot: false,
      editTurnover: false,
      editHit: false,
      editPenaltyMinute: false,
      newPenaltyMinute: false,
      editGoal: false,
      newGoal: false,
      newGoalData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        goal_scorer: 0,
        first_assist: 0,
        second_assist: 0,
        on_ice_1: 0,
        on_ice_2: 0,
        on_ice_3: 0,
        on_ice_4: 0,
        on_ice_5: 0,
        on_ice_6: 0
      },
      editGoalData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        goal_scorer: 0,
        first_assist: 0,
        second_assist: 0,
        on_ice_1: 0,
        on_ice_2: 0,
        on_ice_3: 0,
        on_ice_4: 0,
        on_ice_5: 0,
        on_ice_6: 0
      },
      newPenaltyMinuteData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        drawn_player: 0,
        taken_player: 0,
        penalty_for: 0,
        penlaty_type: 0,
        penlaty_length: 0,
        penalty_zone: ''
      },
      editPenaltyMinuteData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        drawn_player: 0,
        taken_player: 0,
        penalty_for: 0,
        penlaty_type: 0,
        penlaty_length: 0,
        penalty_zone: ''
      },
      newFaceoffData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0,
        away_player: 0,
        lane: 0,
        zone: 0,
        result: 0
      },
      editFaceoffData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0,
        away_player: 0,
        lane: 0,
        zone: 0,
        result: 0
      },
      newShot: false,
      newShotData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        shot_type: 0
      },
      editShotData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        shot_type: 0
      },
      newHit: false,
      newHitData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0
      },
      editHitData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0
      },
      newTurnover: false,
      newTurnoverData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        zone: ''
      },
      editTurnoverData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        zone: ''
      },
      ValdiationData: [],
      eihlInfo: []
    };
  },

  methods: {
    validateGame: function validateGame() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games/validate/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (res) {
        _this.fetchFixtures();
      });
    },
    fetchFixtures: function fetchFixtures() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/games/get/single/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // // console.log('Data is ' + response.data)
        _this2.Fixture = response.data[0];
        console.log(_this2.Fixture.eihl_id);
        _this2.$http.get('https://devilsapi.roblutken.com/assets/' + _this2.Fixture.eihl_id + '_game_info.json', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
          _this2.eihlInfo = response.data;
          console.log(_this2.eihlInfo['1']);
        }, function (response) {});
        // console.log(this.Fixture)
        // // console.log(JSON.stringify(this.Fixture))
      }, function (response) {});
    },
    fetchPlayers: function fetchPlayers() {
      var _this3 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/players/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        var homePlayers = response.data.home_players;
        var awayPlayers = response.data.away_players;
        homePlayers = homePlayers.slice().sort(function (a, b) {
          return a.number - b.number;
        });
        awayPlayers = awayPlayers.slice().sort(function (a, b) {
          return a.number - b.number;
        });
        // // console.log(this.Players)
        // this.playerOptions.push({text: '-', value: -1})
        _this3.AllPlayerOptions.push({ text: 'Home Team', value: -2 });
        _this3.HomePlayerOptions.push({ text: 'Home Team', value: -2 });
        _this3.AllPlayerOptions.push({ text: 'Forwards', value: -2 });
        _this3.HomePlayerOptions.push({ text: 'Forwards', value: -2 });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = homePlayers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var i = _step.value;

            if (i.position === 'LW' || i.position === 'C' || i.position === 'RW') {
              _this3.AllPlayerOptions.push({ text: '#' + i.number + ' ' + i.surname, value: i.id });
              _this3.HomePlayerOptions.push({ text: '#' + i.number + ' ' + i.surname, value: i.id });
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this3.AllPlayerOptions.push({ text: 'Defense', value: -2 });
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = homePlayers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var d = _step2.value;

            if (d.position === 'LD' || d.position === 'RD') {
              _this3.AllPlayerOptions.push({ text: '#' + d.number + ' ' + d.surname, value: d.id });
              _this3.HomePlayerOptions.push({ text: '#' + d.number + ' ' + d.surname, value: d.id });
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this3.AllPlayerOptions.push({ text: 'Goaltenders', value: -2 });
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = homePlayers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var g = _step3.value;

            if (g.position === 'GT' || g.position === 'BKGT') {
              _this3.HomePlayerOptions.push({ text: '#' + g.number + ' ' + g.surname, value: g.id });
              _this3.AllPlayerOptions.push({ text: '#' + g.number + ' ' + g.surname, value: g.id });
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        _this3.AllPlayerOptions.push({ text: 'Away Team', value: -2 });
        _this3.AwayPlayerOptions.push({ text: 'Away Team', value: -2 });
        _this3.AwayPlayerOptions.push({ text: 'Forwards', value: -2 });
        _this3.AllPlayerOptions.push({ text: 'Forwards', value: -2 });
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = awayPlayers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var ai = _step4.value;

            if (ai.position === 'LW' || ai.position === 'C' || ai.position === 'RW') {
              _this3.AllPlayerOptions.push({ text: '#' + ai.number + ' ' + ai.surname, value: ai.id });
              _this3.AwayPlayerOptions.push({ text: '#' + ai.number + ' ' + ai.surname, value: ai.id });
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        _this3.AllPlayerOptions.push({ text: 'Defense', value: -2 });
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = awayPlayers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var ad = _step5.value;

            if (ad.position === 'LD' || ad.position === 'RD') {
              _this3.AllPlayerOptions.push({ text: '#' + ad.number + ' ' + ad.surname, value: ad.id });
              _this3.AwayPlayerOptions.push({ text: '#' + ad.number + ' ' + ad.surname, value: ad.id });
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        _this3.AllPlayerOptions.push({ text: 'Goaltenders', value: -2 });
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = awayPlayers[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var ag = _step6.value;

            if (ag.position === 'GT' || ag.position === 'BKGT') {
              _this3.AwayPlayerOptions.push({ text: '#' + ag.number + ' ' + ag.surname, value: ag.id });
              _this3.AllPlayerOptions.push({ text: '#' + ag.number + ' ' + ag.surname, value: ag.id });
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }, function (response) {});
    },
    fetchRawGameData: function fetchRawGameData() {
      var _this4 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/verify/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('RawData is ' + JSON.stringify(response.data))
        _this4.RawData = response.data.raw;
        _this4.Faceoffs = response.data.faceoffs;
        _this4.Shots = response.data.shots;
        _this4.Hits = response.data.hits;
        _this4.Turnovers = response.data.turnovers;
        _this4.PenaltyMinutes = response.data.penalty_minutes;
        _this4.OddmanRush = response.data.oddman_rush;
        _this4.Goals = response.data.goals;
        var situations = response.data.situations[0];
        // console.log('Situations:' + JSON.stringify(situations))
        for (var k = 0; k < situations.length; k++) {
          _this4.SituationOptions.push({ text: situations[k].secondary_situation, value: situations[k].id });
        }
        if (_this4.AllPlayerOptions.length <= 0) {
          var homePlayers = response.data.home_players[0];
          var awayPlayers = response.data.away_players[0];
          for (var i = 0; i < homePlayers.length; i++) {
            // this.HomePlayerOptions.push({text: 'Forwards', value: -1})
            // this.AllPlayerOptions.push({text: 'Forwards', value: -1})
            var pos = homePlayers[i].position;
            if (pos === 'LW' || pos === 'RW' || pos === 'C') {
              //  this.HomePlayerOptions.push({text: homePlayers[i].number + ' ' + homePlayers[i].surname, value: homePlayers[i].id})
              //  this.AllPlayerOptions.push({text: homePlayers[i].number + ' ' + homePlayers[i].surname, value: homePlayers[i].id})
            }
          }
          for (var j = 0; j < awayPlayers.length; j++) {
            //  this.AwayPlayerOptions.push({text: awayPlayers[j].number + ' ' + awayPlayers[j].surname, value: awayPlayers[j].id})
            //  this.AllPlayerOptions.push({text: awayPlayers[j].number + ' ' + awayPlayers[j].surname, value: awayPlayers[j].id})
          }
        }
        var pimOpt = response.data.penalty_options[0];
        for (var l = 0; l < pimOpt.length; l++) {
          _this4.PenaltyOptions.push({ text: pimOpt[l].option, value: pimOpt[l].id });
        }
        _this4.TOI = response.data.toi;
        _this4.Test = _this4.cleanFaceoffData();
        _this4.CleanShots = _this4.cleanShotData();
        _this4.CleanHits = _this4.cleanHitData();
        _this4.CleanTurnovers = _this4.cleanTurnoverData();
        _this4.CleanTOI = _this4.cleanTOIData();
        _this4.CleanPenaltyMinutes = _this4.cleanPenaltyMinutesData();
        _this4.CleanGoals = _this4.cleanGoalData();
      }, function (response) {});
    },
    openNewFaceoff: function openNewFaceoff() {
      this.newFaceoff = !this.newFaceoff;
    },
    openNewShot: function openNewShot() {
      this.newShot = !this.newShot;
    },
    openNewHit: function openNewHit() {
      this.newHit = !this.newHit;
    },
    openNewTurnover: function openNewTurnover() {
      this.newTurnover = !this.newTurnover;
    },
    openNewPenaltyMinute: function openNewPenaltyMinute() {
      this.newPenaltyMinute = !this.newPenaltyMinute;
    },
    openNewGoal: function openNewGoal() {
      this.newGoal = !this.newGoal;
    },
    openEditFaceoff: function openEditFaceoff(input) {
      this.editFaceoff = !this.editFaceoff;
      this.editFaceoffData = this.getFaceoff(input.id);
    },
    openEditShot: function openEditShot(input) {
      this.editShot = !this.editShot;
      this.editShotData = this.getShot(input.id);
    },
    openEditHit: function openEditHit(input) {
      this.editHit = !this.editHit;
      // // console.log('Returned: ' + JSON.stringify(input))
      this.editHitData = this.getHit(input.id);
      // // console.log(this.editFaceoffData)
    },
    openEditTurnover: function openEditTurnover(input) {
      this.editTurnover = !this.editTurnover;
      // // console.log(JSON.stringify(this.getTurnover(input.id)))
      this.editTurnoverData = this.getTurnover(input.id);
    },
    openEditPenaltyMinutes: function openEditPenaltyMinutes(input) {
      this.editPenaltyMinute = !this.editPenaltyMinute;
      // console.log(JSON.stringify(this.getPenaltyMinutes(input.id)))
      this.editPenaltyMinuteData = this.getPenaltyMinutes(input.id);
    },
    openEditGoal: function openEditGoal(input) {
      this.editGoal = !this.editGoal;
      // console.log(JSON.stringify(this.getGoal(input.id)))
      this.editGoalData = this.getGoal(input.id);
      this.loadEditGoal(this.editGoal);
    },
    submitNewGoal: function submitNewGoal() {
      var _this5 = this;

      // console.log(this.newGoalData)
      this.newGoalData.game_id = this.$route.params.gameId;
      this.$http.post('https://devilsapi.roblutken.com/api/web/goals/add', this.newGoalData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        _this5.fetchRawGameData();
      });
      this.newGoal = false;
      this.newGoalData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        goal_scorer: 0,
        first_assist: 0,
        second_assist: 0,
        on_ice_1: 0,
        on_ice_2: 0,
        on_ice_3: 0,
        on_ice_4: 0,
        on_ice_5: 0,
        on_ice_6: 0
      };
    },
    submitNewPenaltyMinute: function submitNewPenaltyMinute() {
      var _this6 = this;

      // console.log(this.newPenaltyMinuteData)
      this.newPenaltyMinuteData.game_id = this.$route.params.gameId;
      this.$http.post('https://devilsapi.roblutken.com/api/web/penalty-minutes/add', this.newPenaltyMinuteData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        _this6.fetchRawGameData();
      });
      this.newPenaltyMinute = false;
      this.newPenaltyMinuteData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        drawn_player: 0,
        taken_player: 0,
        penalty_for: 0,
        penlaty_type: 0,
        penlaty_length: 0,
        penalty_zone: ''
      };
    },
    submitEditPenaltyMinute: function submitEditPenaltyMinute() {
      var _this7 = this;

      // console.log(this.editPenaltyMinuteData)
      this.editPenaltyMinuteData.game_id = this.$route.params.gameId;
      this.$http.post('https://devilsapi.roblutken.com/api/web/penalty-minutes/edit', this.editPenaltyMinuteData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        _this7.fetchRawGameData();
      });
      this.editPenaltyMinute = false;
      this.editPenaltyMinuteData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        drawn_player: 0,
        taken_player: 0,
        penalty_for: 0,
        penlaty_type: 0,
        penlaty_length: 0,
        penalty_zone: ''
      };
    },
    submitEditGoal: function submitEditGoal() {
      var _this8 = this;

      // console.log(this.editGoalData)
      this.editGoalData.game_id = this.$route.params.gameId;
      this.$http.post('https://devilsapi.roblutken.com/api/web/goals/edit', this.editGoalData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        _this8.fetchRawGameData();
      });
      this.editGoal = false;
      this.editGoalData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        goal_scorer: 0,
        first_assist: 0,
        second_assist: 0,
        on_ice_1: 0,
        on_ice_2: 0,
        on_ice_3: 0,
        on_ice_4: 0,
        on_ice_5: 0,
        on_ice_6: 0
      };
    },
    submitNewFaceoff: function submitNewFaceoff() {
      // console.log(this.newFaceoffData)
      this.newFaceoffData.game_id = this.$route.params.gameId;
      this.$http.post('https://devilsapi.roblutken.com/api/web/faceoffs/add', this.newFaceoffData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
      this.fetchRawGameData();
      this.newFaceoff = false;
      this.newFaceoffData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0,
        away_player: 0,
        lane: 0,
        zone: '',
        result: 0
      };
    },
    submitEditFaceoff: function submitEditFaceoff() {
      // console.log(this.editFaceoffData)
      this.$http.post('https://devilsapi.roblutken.com/api/web/faceoffs/edit', this.editFaceoffData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Updated Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error updating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
      this.fetchRawGameData();
      this.editFaceoff = false;
      this.editFaceoffData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0,
        away_player: 0,
        lane: 0,
        zone: '',
        result: 0
      };
    },
    submitEditShot: function submitEditShot() {
      var _this9 = this;

      this.$http.post('https://devilsapi.roblutken.com/api/web/shots/edit', this.editShotData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Updated Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error updating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        _this9.fetchRawGameData();
      });
      this.editShot = false;
      this.editShotData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0,
        away_player: 0,
        lane: 0,
        zone: '',
        result: 0
      };
    },
    submitEditHit: function submitEditHit() {
      var _this10 = this;

      this.$http.post('https://devilsapi.roblutken.com/api/web/hits/edit', this.editHitData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        if (response.data.status === 202) {
          openNotification({
            title: 'Updated Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error updating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        _this10.fetchRawGameData();
      });

      this.editHit = false;
      this.editHitData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0
      };
    },
    submitEditTurnover: function submitEditTurnover() {
      var _this11 = this;

      this.$http.post('https://devilsapi.roblutken.com/api/web/turnovers/edit', this.editTurnoverData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        if (response.data.status === 202) {
          openNotification({
            title: 'Updated Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error updating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        _this11.fetchRawGameData();
      });

      this.editTurnover = false;
      this.editTurnoverData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        zone: ''
      };
    },
    submitNewShot: function submitNewShot() {
      // console.log(this.newShotData)
      this.newShotData.game_id = this.$route.params.gameId;
      this.$http.post('https://devilsapi.roblutken.com/api/web/shots/add', this.newShotData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
      this.fetchRawGameData();
      this.newShot = false;
      this.newShotData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        shot_type: 0
      };
    },
    submitNewHit: function submitNewHit() {
      // console.log(this.newHitData)
      this.newHitData.game_id = this.$route.params.gameId;
      this.$http.post('https://devilsapi.roblutken.com/api/web/hits/add', this.newHitData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
      this.fetchRawGameData();
      this.newHit = false;
      this.newHitData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0
      };
    },
    submitNewTurnover: function submitNewTurnover() {
      // console.log(this.newTurnoverData)
      this.newTurnoverData.game_id = this.$route.params.gameId;
      this.$http.post('https://devilsapi.roblutken.com/api/web/turnovers/add', this.newTurnoverData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
      });
      this.fetchRawGameData();
      this.newTurnover = false;
      this.newTurnoverData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        zone: ''
      };
    },
    cancelNew: function cancelNew() {
      this.newFaceoff = false;
      this.newShot = false;
      this.newHit = false;
      this.newTurnover = false;
      this.newPenaltyMinute = false;
      this.newGoal = false;
    },
    cancelEdit: function cancelEdit() {
      this.editFaceoff = false;
      this.editShot = false;
      this.editHit = false;
      this.editTurnover = false;
      this.editPenaltyMinute = false;
      this.editGoal = false;
    },
    cleanFaceoffData: function cleanFaceoffData() {
      var cleanData = [];
      // // console.log(this.Faceoffs[0])
      __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.Faceoffs[0], function (object) {
        cleanData.push(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'home_number', 'away_number', 'lane', 'zone', 'result', 'is_verified']));
      });
      return cleanData;
    },
    getFaceoff: function getFaceoff(id) {
      // console.log('GET FACEOFF RCVD: ' + id)
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.Faceoffs[0], function (obj) {
        return obj.id === id;
      });
    },
    getShot: function getShot(id) {
      // console.log('GET Shot RCVD: ' + id)
      // console.log('FOUND: ' + JSON.stringify(_.find(this.Shots[0], function (obj) { return obj.id === id })))
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.Shots[0], function (obj) {
        return obj.id === id;
      });
    },
    getHit: function getHit(id) {
      // console.log('GET HIT RCVD: ' + id)
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.Hits[0], function (obj) {
        return obj.id === id;
      });
    },
    getTurnover: function getTurnover(id) {
      // console.log('GET TURNOVER RCVD: ' + id)
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.Turnovers[0], function (obj) {
        return obj.id === id;
      });
    },
    getPenaltyMinutes: function getPenaltyMinutes(id) {
      // console.log('GET PIMS RCVD: ' + id)
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.PenaltyMinutes[0], function (obj) {
        return obj.id === id;
      });
    },
    getGoal: function getGoal(id) {
      // console.log('GET Goal RCVD: ' + id)
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.Goals[0], function (obj) {
        return obj.goal_id === id;
      });
    },
    cleanShotData: function cleanShotData() {
      var cleanData = [];
      // // console.log(this.Shots[0])
      __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.Shots[0], function (object) {
        cleanData.push(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'player_number', 'shot_type', 'shot_location', 'is_verified']));
      });
      return cleanData;
    },
    cleanHitData: function cleanHitData() {
      var cleanData = [];
      // // console.log(this.Hits[0])
      __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.Hits[0], function (object) {
        cleanData.push(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'home_number', 'is_verified']));
      });
      return cleanData;
    },
    cleanTurnoverData: function cleanTurnoverData() {
      var cleanData = [];
      // // console.log(this.Turnovers[0])
      __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.Turnovers[0], function (object) {
        cleanData.push(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'player_number', 'zone', 'is_verified']));
      });
      return cleanData;
    },
    cleanPenaltyMinutesData: function cleanPenaltyMinutesData() {
      var cleanData = [];
      // // console.log(this.TOI[0])
      __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.PenaltyMinutes[0], function (object) {
        cleanData.push(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'home_number', 'away_number', 'penalty_for', 'penalty_type', 'penalty_length', 'penalty_zone', 'is_verified']));
      });
      return cleanData;
    },
    cleanTOIData: function cleanTOIData() {
      var cleanData = [];
      // // console.log(this.TOI[0])
      __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.TOI[0], function (object) {
        cleanData.push(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'player_number', 'shift_length', 'eh_time', 'sh_time', 'pp_time', 'eh_chance_for', 'eh_chance_against', 'pp_chance_for', 'pp_chance_against', 'sh_chance_for', 'sh_chance_against', 'goals_for_eh', 'goals_against_eh', 'goals_for_pp', 'goals_against_pp', 'goals_for_sh', 'goals_against_sh', 'is_verified']));
      });
      return cleanData;
    },
    cleanGoalData: function cleanGoalData() {
      var cleanData = [];
      // // console.log(this.Shots[0])
      __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.Goals[0], function (object) {
        cleanData.push(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'goal_scorer_number', 'first_assist_number', 'second_assist_number', 'on_ice_1_number', 'on_ice_2_number', 'on_ice_3_number', 'on_ice_4_number', 'on_ice_5_number', 'on_ice_6_number', 'is_verified']));
      });
      return cleanData;
    },
    openNotificationWithType: function openNotificationWithType(type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      }).then(this.fetchRawGameData());
    }
  },
  mounted: function mounted() {
    // // console.log('Route loaded with: ' + this.$route.params.gameId)
    this.fetchFixtures();
    this.fetchRawGameData();
    this.fetchPlayers();
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sort_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    period: { type: Number, required: true }
  },
  components: {
    SortTable: __WEBPACK_IMPORTED_MODULE_0__sort_table___default.a,
    'chart': __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a
  },
  data: function data() {
    return {
      gameId: 0,
      ZoneEntries: [],
      ZEPlayerVS: [],
      apex_ze_series: [{
        name: 'Uncontrolled %',
        data: []
      }],
      apex_ze_options: {
        colors: ['#8b0505d1', '#000000'],
        chart: { type: 'bar', height: 10, stacked: true },
        plotOptions: { bar: { horizontal: true } }
      },
      apex_ze_control_series: [{
        name: 'Successful Entry',
        data: []
      }, {
        name: 'Unsucessful Entry',
        data: []
      }],
      apex_ze_uncontrol_series: [{
        name: 'Successful Entry',
        data: []
      }, {
        name: 'Unsucessful Entry',
        data: []
      }],
      apex_ze_player_options: {
        colors: ['#8b0505d1', '#000000'],
        chart: { type: 'bar', height: 900, stacked: true },
        plotOptions: { bar: { horizontal: true } }
      }
    };
  },

  computed: {},
  watch: {
    endpoint: {
      handler: function handler(endpoint) {
        this.url = endpoint;
      },
      immediate: true
    },
    gameId: {
      handler: function handler(postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
        this.fetchZoneEntries();
      },
      immediate: true
    }
  },
  methods: {
    gameDataLoaded: function gameDataLoaded() {
      console.log('Loaded');
    },
    fetchZoneEntries: function fetchZoneEntries() {
      var _this = this;

      var postData = {
        'game_id': this.gameId,
        'situation': 0
      };
      this.$http.post('https://devilsapi.roblutken.com/api/app/match-stats/team-zone-entries', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        _this.ZoneEntries = response.data;
        _this.apex_ze_series[0].data = [];
        _this.apex_ze_series[0].data.push(_this.ZoneEntries.uncontrolled_percentage);
        var cats = ['Uncontrolled %'];
        var newOptions = { xaxis: { categories: cats, max: 100 } };
        _this.$refs.apex_ze_chart.updateOptions(newOptions);
      });
    },
    fetchZoneEntriesGraph: function fetchZoneEntriesGraph() {
      var _this2 = this;

      var postData = {
        'game_id': this.gameId,
        'situation': 0
      };
      var zoneEntryPlayersC = [];
      var zoneEntryPlayersU = [];
      this.$http.post('https://devilsapi.roblutken.com/api/app/match-stats/zone-entries-graph', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        _this2.ZEPlayerVS = response.data;
        var zeS = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(_this2.ZEPlayerVS, function (ze) {
          return ze.control_success + ze.control_failure;
        }, ['desc']);
        var zeF = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(_this2.ZEPlayerVS, function (ze) {
          return ze.uncontrol_success + ze.uncontrol_failure;
        }, ['desc']);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = zeS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var ze = _step.value;

            // this.apex_ze_uncontrol_series[0].data.push(ze.uncontrol_success)
            // this.apex_ze_uncontrol_series[1].data.push(-ze.uncontrol_failure)
            if (ze.control_failure + ze.control_success > 0) {
              zoneEntryPlayersC.push(ze.player);
              _this2.apex_ze_control_series[0].data.push(ze.control_success);
              _this2.apex_ze_control_series[1].data.push(-ze.control_failure);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = zeF[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var zeU = _step2.value;

            // this.apex_ze_uncontrol_series[0].data.push(ze.uncontrol_success)
            // this.apex_ze_uncontrol_series[1].data.push(-ze.uncontrol_failure)
            if (zeU.uncontrol_success + zeU.uncontrol_failure > 0) {
              zoneEntryPlayersU.push(zeU.player);
              _this2.apex_ze_uncontrol_series[0].data.push(zeU.uncontrol_success);
              _this2.apex_ze_uncontrol_series[1].data.push(-zeU.uncontrol_failure);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var newOptions = { xaxis: { categories: zoneEntryPlayersC } };
        _this2.$refs.apex_ze_control_chart.updateOptions(newOptions);
        var zeUncontrolledOpts = { xaxis: { categories: zoneEntryPlayersU } };
        _this2.$refs.apex_ze_uncontrol_chart.updateOptions(zeUncontrolledOpts);
        console.log('Players for Zone Entries: ' + JSON.stringify(newOptions));
      });
    },
    resetData: function resetData() {
      var newOptions = { xaxis: { categories: [] } };
      this.$refs.apex_ze_chart.updateOptions(newOptions);
      this.$refs.apex_ze_control_chart.updateOptions(newOptions);
      this.$refs.apex_ze_uncontrol_chart.updateOptions(newOptions);
      this.apex_ze_control_series[0].data = [];
      this.apex_ze_control_series[1].data = [];
      this.apex_ze_uncontrol_series[0].data = [];
      this.apex_ze_uncontrol_series[1].data = [];
      this.apex_ze_series[0].data = [];
    }
  },
  mounted: function mounted() {
    // console.log('Fetch ZoneEntries: ' + this.gameId)
    this.gameId = this.$route.params.gameId;
    this.resetData();
    this.fetchZoneEntries();
    this.fetchZoneEntriesGraph();
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditTable_box_score_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditTable_box_score_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EditTable_box_score_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a,
    'box-score': __WEBPACK_IMPORTED_MODULE_1__EditTable_box_score_vue___default.a
  },
  computed: {
    getTotalCountGoals: function getTotalCountGoals() {
      return this.CleanGoals.length;
    }
  },
  data: function data() {
    return {
      Goals: [],
      CleanGoals: [],
      HomePlayerOptions: [],
      AwayPlayerOptions: [],
      AllPlayerOptions: [],
      SituationOptions: [],
      PenaltyOptions: []
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/verify/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Goals = response.data.goals;
        _this.CleanGoals = _this.cleanGoalData();
        console.log('Data: ' + JSON.stringify(_this.CleanGoals));
        if (_this.AllPlayerOptions.length <= 0) {
          var homePlayers = response.data.home_players[0];
          var awayPlayers = response.data.away_players[0];
          for (var i = 0; i < homePlayers.length; i++) {
            _this.HomePlayerOptions.push({ text: homePlayers[i].number + ' ' + homePlayers[i].surname, value: homePlayers[i].id });
            _this.AllPlayerOptions.push({ text: homePlayers[i].number + ' ' + homePlayers[i].surname, value: homePlayers[i].id });
          }
          for (var j = 0; j < awayPlayers.length; j++) {
            _this.AwayPlayerOptions.push({ text: awayPlayers[j].number + ' ' + awayPlayers[j].surname, value: awayPlayers[j].id });
            if (awayPlayers[j].number > 0) {
              _this.AllPlayerOptions.push({ text: awayPlayers[j].number + ' ' + awayPlayers[j].surname, value: awayPlayers[j].id });
            }
          }
          var situations = response.data.situations[0];
          for (var k = 0; k < situations.length; k++) {
            _this.SituationOptions.push({ text: situations[k].secondary_situation, value: situations[k].id });
          }
        }
        var pimOpt = response.data.penalty_options[0];
        for (var l = 0; l < pimOpt.length; l++) {
          _this.PenaltyOptions.push({ text: pimOpt[l].option, value: pimOpt[l].id });
        }
      });
    },
    updateGoal: function updateGoal(record) {
      var _this2 = this;

      var editGoal = {
        game_id: this.$route.params.gameId,
        id: record.goal_id,
        period: record.period,
        game_time: record.game_time_global,
        situation_id: record.situation_id,
        goal_scorer: record.goal_scorer_id,
        first_assist: record.first_assist_id,
        second_assist: record.second_assist_id,
        on_ice_1: record.on_ice_1_id,
        on_ice_2: record.on_ice_2_id,
        on_ice_3: record.on_ice_3_id,
        on_ice_4: record.on_ice_4_id,
        on_ice_5: record.on_ice_5_id,
        on_ice_6: record.on_ice_6_id
      };
      console.log(JSON.stringify(editGoal));
      this.$http.post('https://devilsapi.roblutken.com/api/web/goals/edit', editGoal, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        console.log(response);
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          });
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          });
        }
        _this2.fetchData();
      });
    },
    cleanGoalData: function cleanGoalData() {
      var cleanData = [];
      // console.log(this.Shots[0])
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.Goals[0], function (object) {
        cleanData.push(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(object, ['goal_id', 'goal_team', 'game_time_global', 'period', 'situation_id', 'goal_scorer_id', 'first_assist_id', 'second_assist_id', 'on_ice_1_id', 'on_ice_2_id', 'on_ice_3_id', 'on_ice_4_id', 'on_ice_5_id', 'on_ice_6_id', 'is_verified']));
      });
      return cleanData;
    },
    openNotificationWithType: function openNotificationWithType(type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      }).then(this.fetchRawGameData());
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PlayerEquiv',
  data: function data() {
    return {
      players: [],
      selectedTeam: -1,
      selectedSeason: -1,
      selectedPosition: -1,
      search: '',
      sortSelected: 'g',
      sortOptions: [],
      teamOptions: [{
        text: 'All',
        value: -1
      }, {
        text: 'Manchester Storm',
        value: 'MAN'
      }, {
        text: 'Cardiff Devils',
        value: 'CAR'
      }, {
        text: 'Sheffield Steelers',
        value: 'SHE'
      }, {
        text: 'Belfast Giants',
        value: 'BEL'
      }, {
        text: 'Coventry Blaze',
        value: 'COV'
      }, {
        text: 'Guildford Flames',
        value: 'GUI'
      }, {
        text: 'Milton Keynes Lightning',
        value: 'MKL'
      }, {
        text: 'Nottingham Panthers',
        value: 'NOT'
      }, {
        text: 'Dundee Stars',
        value: 'DUN'
      }, {
        text: 'Braehead / Glasgow Clan',
        value: 'BRA'
      }, {
        text: 'Fife Flyers',
        value: 'FIF'
      }],
      seasonOptions: [{
        text: 'All',
        value: -1
      }, {
        text: '15-16',
        value: '15-16'
      }, {
        text: '16-17',
        value: '16-17'
      }, {
        text: '17-18',
        value: '17-18'
      }, {
        text: '18-19',
        value: '18-19'
      }],
      positionOptions: [{
        text: 'All',
        value: -1
      }, {
        text: 'Forwards',
        value: 'F'
      }, {
        text: 'Defense',
        value: 'D'
      }]
    };
  },

  computed: {
    computed_data: function computed_data() {
      var filterTeam = this.selectedTeam;
      var filterSeason = this.selectedSeason;
      var filterPosition = this.selectedPosition;
      var filterSearch = this.search;
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(this.players.filter(function (itm) {
        var filtered = true;
        if (filterSearch !== '') {
          // console.log('Searching' + filterSearch)
          var lowerName = itm.name.toLowerCase();
          filtered = lowerName.includes(filterSearch.toLowerCase());
        } else if (filterSeason && filterSeason !== -1) {
          filtered = itm.season === filterSeason;
        } else if (filterTeam && filterTeam !== -1) {
          filtered = itm.team === filterTeam;
        } else if (filterPosition && filterPosition !== -1) {
          filtered = itm.position === filterPosition;
        } else {
          return true;
        }
        if (filterPosition && filterPosition !== -1 && filterSeason && filterSeason !== -1) {
          filtered = itm.season === filterSeason && itm.position === filterPosition;
        }
        if (filterTeam && filterTeam !== -1 && filterSeason && filterSeason !== -1) {
          filtered = itm.team === filterTeam && itm.season === filterSeason;
        }
        if (filterTeam && filterTeam !== -1 && filterPosition && filterPosition !== -1) {
          filtered = itm.team === filterTeam && itm.position === filterPosition;
        }
        if (filterTeam && filterTeam !== -1 && filterPosition && filterPosition !== -1 && filterSeason && filterSeason !== -1) {
          filtered = itm.team === filterTeam && itm.position === filterPosition && itm.season === filterSeason;
        }
        return filtered;
      }), this.sortSelected, ['desc']);
    }
  },
  filters: {
    formatDecimal: function formatDecimal(value) {
      return Number(value).toFixed(2);
    }
  },
  methods: {
    fetchPlayerEquiv: function fetchPlayerEquiv() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/player-equiv/', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.players = response.data.players;
      }, function (response) {});
    }
  },
  created: function created() {
    this.fetchPlayerEquiv();
    this.sortOptions.push({ text: 'Team', value: 'team' });
    this.sortOptions.push({ text: 'Season', value: 'season' });
    this.sortOptions.push({ text: 'Nationality', value: 'nationality' });
    this.sortOptions.push({ text: 'Position', value: 'position' });
    this.sortOptions.push({ text: 'Name', value: 'name' });
    this.sortOptions.push({ text: 'GP', value: 'gp' });
    this.sortOptions.push({ text: 'Goals', value: 'g' });
    this.sortOptions.push({ text: 'Assists', value: 'a' });
    this.sortOptions.push({ text: 'Total Points', value: 'tp' });
    this.sortOptions.push({ text: 'Goals Per Game', value: 'gpg' });
    this.sortOptions.push({ text: 'Assists Per Game', value: 'apg' });
    this.sortOptions.push({ text: 'Points Per Game', value: 'ppg' });
    this.sortOptions.push({ text: 'Individual Goals %', value: 'igp' });
    this.sortOptions.push({ text: 'Individual Assists %', value: 'iap' });
    this.sortOptions.push({ text: 'Individual Points %', value: 'ipp' });
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['headings', 'playerData', 'heading', 'redirect', 'logo'],
  methods: {
    onClick: function onClick(id) {
      this.$router.push(this.redirect + id);
      this.$router.go();
    },
    test: function test() {
      console.log(0);
      return 0;
    },
    getChunked: function getChunked() {
      var chunk = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.chunk(this.playerData, 4);
      console.log(' Chunked: ' + JSON.stringify(chunk));
      return chunk;
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['headings', 'tableData', 'heading', 'redirect'],
  methods: {
    onClick: function onClick(id) {
      this.$router.push(this.redirect + id);
      this.$router.go();
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['headings', 'tableData', 'heading']
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shots_heatmap_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shots_heatmap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shots_heatmap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_faceoffs_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_faceoffs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__match_faceoffs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_stats_eihl_shotmap_vue__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_stats_eihl_shotmap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_stats_eihl_shotmap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shots_quality_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shots_quality_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shots_quality_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rtable_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rtable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rtable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__season_stats_eihl_penalties_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__season_stats_eihl_penalties_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__season_stats_eihl_penalties_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__season_stats_faceoffs_pvp_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__season_stats_faceoffs_pvp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__season_stats_faceoffs_pvp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gamesheet_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gamesheet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__gamesheet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__apex_realtime_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__apex_realtime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__apex_realtime_vue__);
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'player',
  components: {
    'shots-heatmap': __WEBPACK_IMPORTED_MODULE_0__shots_heatmap_vue___default.a,
    'eihl-shots': __WEBPACK_IMPORTED_MODULE_2__season_stats_eihl_shotmap_vue___default.a,
    'rtable': __WEBPACK_IMPORTED_MODULE_5__rtable_vue___default.a,
    'shot-quality': __WEBPACK_IMPORTED_MODULE_3__shots_quality_vue___default.a,
    'eihl-penalties': __WEBPACK_IMPORTED_MODULE_6__season_stats_eihl_penalties_vue___default.a,
    'gamesheet': __WEBPACK_IMPORTED_MODULE_8__gamesheet_vue___default.a,
    'realtime': __WEBPACK_IMPORTED_MODULE_9__apex_realtime_vue___default.a,
    'faceoffs-pvp': __WEBPACK_IMPORTED_MODULE_7__season_stats_faceoffs_pvp_vue___default.a,
    'game-faceoffs': __WEBPACK_IMPORTED_MODULE_1__match_faceoffs_vue___default.a
  },
  data: function data() {
    return {
      Gamesheet: [],
      headings: ['#', '+', '-', '+/-', 'SHOTS +', 'SHOTS -', 'SHOTS +/-', 'SOT', 'FO', 'HITS', 'SHIFTS', 'AVG', 'EH', 'PP', 'SH', 'TOTAL']
    };
  },
  computed: {
    orderData: function orderData() {
      var cleanData = [];
      var GamesheetSelection = ['number', 'goals_for', 'goals_against', 'goal_diff', 'shots_for', 'shots_against', 'shots_plus_minus', 'sot', 'fo', 'hits', 'shifts', 'avg_shift', 'eh_time', 'pp_time', 'sh_time', 'total_toi'];
      // console.log(this.Faceoffs[0])
      __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.Gamesheet, function (object) {
        console.log('obj' + object.position);
        if (object.position !== 'false' && object.position !== 'total') {
          cleanData.push(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.pick(object, GamesheetSelection));
        }
      });
      cleanData = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(cleanData, 'shots_for', ['desc']);
      return cleanData;
    }
  },
  methods: {},
  created: function created() {}
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    game_id: { type: Number, required: true },
    period: { type: Number, required: true }
  },
  data: function data() {
    return {
      Gamesheet: []
    };
  },

  methods: {
    fetchStats: function fetchStats() {
      var _this = this;

      this.tableData = [];
      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/' + this.$route.params.gameId + '/' + this.$route.params.period, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this.Gamesheet = response.data;
        console.log('Gamesheet data: ' + JSON.stringify(_this.Gamesheet));
      }, function (response) {});
    }
  },
  watch: {
    game_id: {
      handler: function handler(endpoint) {
        this.fetchStats();
      },
      immediate: true
    }
  },
  created: function created() {
    this.fetchStats();
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sort_table__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SortTable: __WEBPACK_IMPORTED_MODULE_0__sort_table___default.a
  },
  data: function data() {
    return {
      PenaltyOptions: [{ text: 'All', value: 0 }, { text: 'Minor <= 2 mins', value: 1 }, { text: 'Major >= 5 <= 10', value: 2 }, { text: 'Match > 10', value: 3 }, { text: 'Major & Minor', value: 4 }],
      PenaltySelected: 0
    };
  },

  methods: {
    gameDataLoaded: function gameDataLoaded() {
      console.log('Loaded');
    },
    filterChange: function filterChange() {
      console.log('Filter update: ' + this.PenaltySelected);
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleshot_eihl__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleshot_eihl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleshot_eihl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleheat__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleheat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleheat__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      Shots: [],
      XGShots: [],
      shotData: [],
      Squares: [],
      LimitSelected: 999999,
      GridSize: 11,
      GridOptions: [{ 'text': '1x1 - 2', 'value': 1 }, { 'text': '2x2 - 4', 'value': 2 }, { 'text': '4x4 - 8', 'value': 4 }, { 'text': '5x5 - 25', 'value': 5 }, { 'text': '6x6 - 36', 'value': 6 }, { 'text': '8x8 - 64', 'value': 8 }, { 'text': '9x9 - 81', 'value': 9 }, { 'text': '10x10 - 100', 'value': 10 }, { 'text': '11x11 - 121', 'value': 11 }, { 'text': '12x12 - 144', 'value': 12 }, { 'text': '13x13 - 169', 'value': 13 }, { 'text': '14x14 - 196', 'value': 14 }, { 'text': '20x20 - 400', 'value': 20 }],
      TeamSelected: 0,
      TeamOptions: [{ 'text': 'All', 'value': 0 }, { 'text': 'Cardiff Devils', 'value': 92 }, { 'text': 'Belfast Giants', 'value': 91 }, { 'text': 'Coventry Blaze', 'value': 93 }, { 'text': 'Dundee Stars', 'value': 94 }, { 'text': 'Fife Flyers', 'value': 95 }, { 'text': 'Glasgow Clan', 'value': 96 }, { 'text': 'Guildford Flames', 'value': 97 }, { 'text': 'Manchester Storm', 'value': 98 }, { 'text': 'Nottingham Panthers', 'value': 99 }, { 'text': 'Sheffield Steelers', 'value': 100 }],
      LimitOptions: [{ 'text': 0, 'value': 0 }, { 'text': 5, 'value': 5 }, { 'text': 10, 'value': 10 }, { 'text': 15, 'value': 15 }, { 'text': 20, 'value': 20 }, { 'text': 200, 'value': 200 }, { 'text': 'All', 'value': 999999 }],
      PlayerSelected: 0,
      PlayerOptions: [],
      ShotSelected: 4,
      ShotOptions: [{ 'text': 'Blocked', 'value': 3 }, { 'text': 'Wide', 'value': 2 }, { 'text': 'OnNet', 'value': 1 }, { 'text': 'Goal', 'value': 4 }, { 'text': 'OnNet & Goal', 'value': 5 }, { 'text': 'Excluding Goals', 'value': 6 }, { 'text': 'All', 'value': 0 }],
      showGrid: true,
      expectedGoals: 0,
      actualGoals: 0,
      RadiusSelected: 15,
      BlurSelected: 40,
      UseHeatmap: false,
      IntShotData: [],
      deShots: [],
      gridJSON: []
    };
  },

  components: {
    'simpleshot': __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleshot_eihl___default.a,
    'simpleheat': __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleheat___default.a
  },
  methods: {
    fetchShotmap: function fetchShotmap() {
      var _this = this;

      var postData = {
        'id': 1,
        'period': 0,
        'situation': 0,
        'home_player': 0,
        'away_player': 0,
        'shot_type': 0
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/get/match-stats/shotmap/', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.IntShotData = response.data.home_shots;
        _this.formatInterShotData();
      }, function (response) {});
    },

    getShots: function getShots() {
      var _this2 = this;

      var postData = {
        'limit': this.LimitSelected,
        'shot_type': this.ShotSelected,
        'team_selected': this.TeamSelected
      };
      this.$http.post('https://devilsapi.roblutken.com/api/eihl/shots/get', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        _this2.Shots = response.data;
        console.log(_this2.Shots);
      }, function (response) {});
      postData = {
        'limit': 9999999,
        'shot_type': 5,
        'team_selected': 0
      };
      this.$http.post('https://devilsapi.roblutken.com/api/eihl/shots/get', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        _this2.XGShots = response.data;
        _this2.fomratXGData();
        _this2.formatShotData();
        _this2.beginRender();
      }, function (response) {});
    },
    convertLeft: function convertLeft(a, b) {
      var c = (b + 100) / 2;
      return a <= 0 ? c : 100 - c;
    },
    convertTop: function convertTop(xPos) {
      return xPos <= 0 ? xPos + 100 : 100 - xPos;
    },

    fomratXGData: function fomratXGData() {
      var container = document.getElementById('stats-widget-canvas-bg');
      var x = parseInt(container.width);
      var y = parseInt(container.height);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.XGShots[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var xg = _step.value;

          var shot = [];
          shot[0] = x * this.convertTop(xg.location_x) / 100;
          shot[1] = y * this.convertLeft(xg.location_x, xg.location_y) / 100;
          xg.location_x = shot[0];
          xg.location_y = shot[1];

          if (xg.shot_type === 1) {
            xg.color = 'rgb(180, 8, 8)';
          } else if (xg.shot_type === 2) {
            xg.color = 'rgba(95, 93, 93)';
          } else if (xg.shot_type === 3) {
            xg.color = 'rgba(20, 23, 81)';
          } else {
            xg.color = 'rgb(31, 239, 0)';
          }
          // console.log(xg.location_y)
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    formatInterShotData: function formatInterShotData() {
      var container = document.getElementById('stats-widget-canvas-bg');
      var x = parseInt(container.width, 10);
      var y = parseInt(container.height, 10);
      var width = x / 600.0;
      var height = y / 530.0;
      console.log('w: ' + width + ' h: ' + height);
      // var homeShotsCanvas = this.$refs.shot_canvas
      var shots = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.IntShotData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var s = _step2.value;

          var shot = JSON.parse(s.shot_location);
          var loc = JSON.parse(s.shot_location);
          shot[5] = shot[0];
          shot[6] = shot[1];

          shot[0] = parseInt(loc[1], 10);
          shot[1] = parseInt(loc[0], 10);

          shot[2] = 40;
          if (this.UseHeatmap === false) {
            if (s.shot_type === 'OnNet') {
              shot[4] = 'rgb(180, 8, 8)';
              shot[3] = 5;
            } else if (s.shot_type === 'MissedNet') {
              shot[4] = 'rgba(95, 93, 93)';
              shot[3] = 3;
            } else if (s.shot_type === 'Blocked') {
              shot[4] = 'rgba(20, 23, 81)';
              shot[3] = 3;
            } else if (s.shot_type === 'Goal') {
              shot[4] = 'rgb(31, 239, 0)';
              shot[3] = 6;
            } else {
              shot[4] = 'White';
            }
          }
          if (s.shot_type === 'Goal') {
            console.log('CW: ' + width + ' CH: ' + height + 'Width: ' + x + ' Height: ' + y + ' X: ' + shot[0] + ' Y: ' + shot[1] + ' Origin x' + shot[5] + ' y ' + shot[6]);
            shots.push(shot);
            this.deShots.push(shot);
          }
          // console.log('Shot found: ' + shot)
        }
        // console.log('Rendering shots: ' + container.width + ' H: ' + container.height + JSON.stringify(shots))
        // var shotmap = simpleshot(homeShotsCanvas, parseInt(container.width, 10), parseInt(container.height, 10)).data(shots)
        // shotmap.render()
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    formatShotData: function formatShotData() {
      var container = document.getElementById('stats-widget-canvas-bg');
      var x = parseInt(container.width);
      var y = parseInt(container.height);
      this.shotData = [];
      if (this.UseHeatmap === true) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = this.Shots[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var h = _step3.value;

            var shot = [];
            shot[1] = x * this.convertTop(h.location_x) / 100;
            shot[0] = y * this.convertLeft(h.location_x, h.location_y) / 100;
            shot[2] = 40;
            this.shotData.push(shot);
            // console.log(this.shotData)
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      } else {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = this.Shots[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var s = _step4.value;

            var _shot = [];
            _shot[0] = x * this.convertTop(s.location_x) / 100;
            _shot[1] = y * this.convertLeft(s.location_x, s.location_y) / 100;
            _shot[5] = s.shot_type;
            // console.log(s.shot_type)
            if (s.shot_type === 2) {
              _shot[4] = 'rgba(95, 93, 93)';
              _shot[3] = Math.ceil(2 + x / 200 * 1);
            } else if (s.shot_type === 3) {
              _shot[4] = 'rgba(20, 23, 81)';
              _shot[3] = Math.ceil(2 + x / 200 * 1);
            } else if (s.shot_type === 1) {
              _shot[4] = 'rgb(180, 8, 8)';
              _shot[3] = Math.ceil(2 + x / 200 * 1);
            } else if (s.shot_type === 4) {
              _shot[4] = 'rgb(31, 239, 0)';
              _shot[3] = Math.ceil(2 + x / 200 * 1);
            } else {
              _shot[4] = 'rgb(0, 0, 0)';
              _shot[3] = Math.ceil(2 + x / 200 * 1);
            }
            this.shotData.push(_shot);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
      return this.shotData;
    },
    renderGrid: function renderGrid() {
      var container = document.getElementById('stats-widget-canvas-bg');
      var homeShotsCanvas = this.$refs.shot_canvas;
      var ctx = homeShotsCanvas.getContext('2d');
      var rectWidth = container.width;
      var rectHeight = container.height;
      var scaleFactor = this.GridSize;
      this.expectedGoals = 0;
      var json = [];
      for (var y = 0; y < rectHeight; y += rectHeight / scaleFactor) {
        for (var x = 0; x < rectWidth; x += rectWidth / scaleFactor) {
          var xPos = [x, y, rectWidth / scaleFactor, rectHeight / scaleFactor];
          var lastXMax = x + rectWidth / scaleFactor;
          var lastYMax = y + rectHeight / scaleFactor;
          if (this.showGrid === true) {
            json.push(this.drawGridSquare(ctx, xPos, lastXMax, lastYMax));
          }
        }
      }
      console.log('JSON: ' + JSON.stringify(json));
    },
    drawGridSquare: function drawGridSquare(ctx, pos, xMax, yMax) {
      var xG = this.calculateXG(pos[0], pos[1], xMax, yMax, ctx);
      var shots = this.calculateShots(pos[0], pos[1], xMax, yMax, ctx);
      this.expectedGoals += parseFloat(shots);
      var json = { xMin: parseFloat(pos[0]), xMax: parseFloat(xMax), yMin: parseFloat(pos[1]), yMax: parseFloat(yMax), XG: parseFloat(xG) };
      var color = 'rgba(255,0,0,0.1)';
      if (xG > 0.0) {
        var r = shots >= 1.0 ? 255 : shots <= 0.0 ? 0 : Math.floor(shots * 256.0);
        color = 'rgba(' + r * 10 + ', 0,0,.4)';
      }
      this.drawRect(ctx, color, pos);
      this.drawText(ctx, 'white', 'XG' + xG + '-' + shots, [pos[0] + 5, pos[1] + 20]);
      return json;
    },

    calculateXG: function calculateXG(xMin, yMin, xMax, yMax, ctx) {
      var shotCount = 0;
      var goalsCount = 0;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.XGShots[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var shot = _step5.value;

          if (shot.location_y >= xMin && shot.location_y <= xMax && shot.location_x >= yMin && shot.location_x <= yMax) {
            shotCount++;
            if (shot.shot_type === 4) {
              goalsCount++;
            }
            //  this.drawCircle(ctx, shot.location_x, shot.location_y, shot.color, 2)
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      if (goalsCount > 0 && shotCount > 0) {
        var xG = (goalsCount / shotCount).toFixed(2);
        return xG;
      }
      return 0;
    },
    calculateShots: function calculateShots(xMin, yMin, xMax, yMax, ctx) {
      var xG = this.calculateXG(xMin, yMin, xMax, yMax, ctx);
      if (xG > 0) {
        var selectShots = 0;
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = this.deShots[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var ss = _step6.value;

            // this.drawCircle(ctx, ss[0], ss[1], ss[4], 2)
            if (ss[1] >= xMin && ss[1] <= xMax && ss[0] >= yMin && ss[0] <= yMax) {
              selectShots++;
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        return (xG * selectShots).toFixed(2);
      }
      return 0;
    },
    drawCircle: function drawCircle(ctx, posX, posY) {
      var color = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'rgb(0,255,0)';
      var radius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

      ctx.shadowOffsetX = ctx.shadowOffsetY = 0.8;
      ctx.shadowBlur = 4;
      ctx.shadowColor = 'rgb(0, 0, 0)';
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(posY, posX, radius, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
    },
    drawRect: function drawRect(ctx, color, position) {
      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = '#FFFFFF';
      ctx.shadowOffsetX = ctx.shadowOffsetY = 0.0;
      ctx.shadowBlur = 0.2;
      ctx.shadowColor = 'rgb(1, 1, 1)';
      ctx.fillRect(position[0], position[1], position[2], position[3]);
      ctx.strokeRect(position[0], position[1], position[2], position[3]);
      ctx.closePath();
    },
    drawText: function drawText(ctx, colour, text, textPosition) {
      var textSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '16px';
      var lineWidth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 3;

      ctx.beginPath();
      ctx.font = textSize + ' sans-serif';
      ctx.fillStyle = colour;
      ctx.fillText(text, textPosition[0], textPosition[1]);
      ctx.closePath();
    },

    canvasResize: function canvasResize(event) {
      console.log('Resize:' + event);
      this.beginRender();
    },
    beginRender: function beginRender() {
      var homeShotsCanvas = this.$refs.shot_canvas;
      var container = document.getElementById('stats-widget-canvas-bg');

      if (this.UseHeatmap === true) {
        // console.log('Use home heatmap' + this.formatShotData())
        var homeHeatmap = __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleheat___default()(homeShotsCanvas).data(this.formatShotData());
        homeHeatmap.radius(this.RadiusSelected, this.BlurSelected);
        homeHeatmap.draw();
      } else {
        var shotmap = __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleshot_eihl___default()(homeShotsCanvas, parseInt(container.width, 10), parseInt(container.height, 10)).data(this.formatShotData());
        shotmap.render();
        this.renderGrid();
      }
    }
  },
  created: function created() {
    this.getShots();
    this.$nextTick(function () {
      window.addEventListener('resize', this.canvasResize);
      window.addEventListener('resize', this.canvasResize);
    });
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    game_id: { type: Number, required: true },
    opponent: { type: Number, required: true }
  },
  data: function data() {
    return {
      tableData: [],
      lane: 'Left',
      zone: 0,
      url: 'https://devilsapi.roblutken.com/api/app/season-stats/faceoffs-by-player',
      postData: [{
        game_id: 0,
        opponent: 0,
        lane: '',
        zone: ''
      }]
    };
  },

  methods: {
    fetchStats: function fetchStats() {
      var _this = this;

      this.tableData = [];
      this.postData[0].lane = this.lane;
      this.postData[0].zone = this.zone;
      this.postData[0].game_id = this.game_id;
      this.postData[0].opponent = this.opponent;
      console.log(this.postData[0]);
      this.$http.post(this.url, this.postData[0], {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log('response was: ' + response.data);
        _this.tableData = response.data['faceoffs_by_player'];
        console.log(_this.tableData);
      }, function (response) {});
    }
  },
  watch: {
    game_id: {
      handler: function handler(endpoint) {
        this.fetchStats();
      },
      immediate: true
    },
    opponent: {
      handler: function handler(postData) {
        this.fetchStats();
      },
      immediate: true
    }
  },
  created: function created() {
    this.fetchStats();
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      LaneOptions: [],
      ZoneOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 3,
      PeriodSelected: 0,
      SituationSelected: 0,
      LaneSelected: '',
      ZoneSelected: '',
      LimitSelected: 0,
      FilterSelected: 'fo_win_total',
      FaceoffsByPlayer: [],
      FaceoffsPlayerCombo: [],
      FaceoffsTeamTotals: [],
      FaceoffssPlayerData: [],
      FaceoffssPlayerHeadings: ['Player', 'GP', 'Taken', 'Win Win', 'Win Loss', 'Loss Loss', 'Loss Win', 'Win Total', 'Loss Total', 'Win%', 'Taken AVG', 'Win AVG'],
      FaceoffssPlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'Taken', value: 'fo_taken' }, { text: 'Win Win', value: 'fo_win_win_total' }, { text: 'Win Loss', value: 'fo_win_loss' }, { text: 'Loss Loss', value: 'fo_loss_loss' }, { text: 'Loss Win', value: 'fo_loss_win' }, { text: 'Win Total', value: 'fo_win_total' }, { text: 'Loss Total', value: 'fo_loss_total' }, { text: 'Win %', value: 'fo_win_percent' }, { text: 'Taken AVG', value: 'fo_taken_average' }, { text: 'Win AVG', value: 'fo_win_average' }],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    };
  },

  computed: {
    sortByFaceoffssData: function sortByFaceoffssData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.FaceoffssPlayerData, this.FilterSelected, ['desc']);
    },
    sortByFaceoffssDataChart: function sortByFaceoffssDataChart() {
      var orderedData = this.sortByFaceoffssData;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByFaceoffssData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByFaceoffssDataChart,
        label: 'Faceoffs - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    }
  },
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': this.YearSelected,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'lane': this.LaneSelected,
        'zone': this.ZoneSelected,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/faceoffs/team', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.FaceoffsTeamTotals = response.data;
      });
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/faceoffs', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.FaceoffssPlayerData = response.data.faceoffs;
      }, function (response) {});
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/faceoffs-by-player-combo', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.FaceoffsPlayerCombo = response.data.faceoffs_by_player_combo;
      }, function (response) {});
    },
    fetchFaceoffByPlayer: function fetchFaceoffByPlayer() {
      var _this2 = this;

      var postData = {
        'year': this.YearSelected,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'lane': this.LaneSelected,
        'zone': this.ZoneSelected,
        'limit': this.LimitSelected
      };
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/faceoffs-by-player', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log('FO VS PLAYER' + response.data.faceoffs_by_player);
        _this2.FaceoffsByPlayer = response.data.faceoffs_by_player;
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this3 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this3.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this3.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this3.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this3.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var situations = response.data.situations;
        _this3.SituationOptions.push({ text: 'All', value: 0 });
        _this3.SituationOptions.push({ text: 'Even Handed', value: 1 });
        _this3.SituationOptions.push({ text: 'Power Play', value: 2 });
        _this3.SituationOptions.push({ text: 'Short Handed', value: 3 });
        _this3.SituationOptions.push({ text: 'Empty Net', value: 4 });
        _this3.SituationOptions.push({ text: '-- N/A Yet - Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          //  this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
        }
        _this3.CompetitionOptions.push({ text: 'All', value: 0 });
        _this3.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this3.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this3.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this3.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this3.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this3.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this3.PeriodOptions.push({ text: 'All', value: 0 });
        _this3.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this3.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this3.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this3.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this3.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this3.LimitOptions.push({ text: 'All', value: 0 });
        _this3.LimitOptions.push({ text: '5 Games', value: 5 });
        _this3.LimitOptions.push({ text: '10 Games', value: 10 });
        _this3.LimitOptions.push({ text: '20 Games', value: 20 });

        _this3.LaneOptions.push({ text: 'All', value: '' });
        _this3.LaneOptions.push({ text: 'Left', value: 'Left' });
        _this3.LaneOptions.push({ text: 'Center', value: 'Center' });
        _this3.LaneOptions.push({ text: 'Right', value: 'Right' });

        _this3.ZoneOptions.push({ text: 'All', value: '' });
        _this3.ZoneOptions.push({ text: 'Offensive', value: 'Offensive' });
        _this3.ZoneOptions.push({ text: 'Neutral', value: 'Neutral' });
        _this3.ZoneOptions.push({ text: 'Defensive', value: 'Defensive' });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFaceoffByPlayer();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      PlayerOptions: [],
      PlayerSelected: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'total_hits',
      CumulativeHitData: [],
      GameByGameFill: false,
      GameByGameTension: 0,
      RollingLimit: 5,
      FilterHeadings: [],
      GameByGameDataSelected: 'total_hits',
      GameByGameDataOptions: [{ text: 'Hits', value: 'total_hits' }],
      HitPlayerData: [],
      HitPlayerHeadings: ['Player', 'GP', 'T', 'T AVG', 'EH', 'EHAVG', 'PP', 'PPAVG', 'SH', 'SHAVG'],
      HitPlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'Total', value: 'total_hits' }, { text: 'Total AVG', value: 'total_hits_avg' }, { text: 'EH', value: 'eh_hits' }, { text: 'EH AVG', value: 'eh_hits_avg' }, { text: 'PP', value: 'pp_hits' }, { text: 'PP AVG', value: 'pp_hits_avg' }, { text: 'SH', value: 'sh_hits' }, { text: 'SH AVG', value: 'sh_hits_avg' }],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      line_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    };
  },

  computed: {
    sortByHitData: function sortByHitData() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(this.HitPlayerData, this.FilterSelected, ['desc']);
    },
    sortByHitDataChart: function sortByHitDataChart() {
      var orderedData = this.sortByHitData;
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByHitData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByHitDataChart,
        label: 'Hits - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    buildCumulativeChartData: function buildCumulativeChartData() {
      var matchLabels = [];
      var customData = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.CumulativeHitData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var label = _step2.value;

          matchLabels.push(label.formatted_date);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.PlayerSelected[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var player = _step3.value;

          var colour = Math.floor(Math.random() * 16777215).toString(16);
          // console.log(colour)
          customData.push({ data: this.buildCumulativeData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var data = {
        labels: matchLabels,
        datasets: customData
        // console.log(data)
      };return data;
    }
  },
  methods: {
    buildCumulativeData: function buildCumulativeData(_name) {
      var results = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.CumulativeHitData[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var game = _step4.value;

          // console.log('Searching:' + JSON.stringify(game))
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = game.player_data[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var v = _step5.value;

              if (v.player === _name) {
                // console.log('Found Player: ' + v.player)
                switch (this.GameByGameDataSelected) {
                  case 'total_hits':
                    results.push(v.total_hits);
                    break;
                }
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return results;
    },
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 0,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/hits', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.HitPlayerData = response.data.hits;
      }, function (response) {});
    },
    fetchSeasonCumulativeStats: function fetchSeasonCumulativeStats() {
      var _this2 = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/hits-cumulative', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this2.CumulativeHitData = response.data.rolling_games;
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this3 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this3.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this3.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this3.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this3.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var player = response.data.cardiff_players;
        _this3.PlayerOptions.push({ name: 'All', id: 0 });
        for (var p = 0; p < player.length; p++) {
          _this3.PlayerOptions.push({ name: player[p].number + ' ' + player[p].surname, id: player[p].id });
        }
        var situations = response.data.situations;
        _this3.SituationOptions.push({ text: 'All', value: 0 });
        _this3.SituationOptions.push({ text: '--Primary Situations--', value: -6 });
        _this3.SituationOptions.push({ text: 'Even Handed', value: -1 });
        _this3.SituationOptions.push({ text: 'Power Play', value: -2 });
        _this3.SituationOptions.push({ text: 'Short Handed', value: -3 });
        _this3.SituationOptions.push({ text: 'Empty Net', value: -4 });
        _this3.SituationOptions.push({ text: '--Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          _this3.SituationOptions.push({ text: situations[s].secondary_situation, value: situations[s].id });
        }
        _this3.CompetitionOptions.push({ text: 'All', value: 0 });
        _this3.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this3.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this3.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this3.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this3.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this3.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this3.PeriodOptions.push({ text: 'All', value: 0 });
        _this3.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this3.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this3.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this3.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this3.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this3.LimitOptions.push({ text: 'All', value: 0 });
        _this3.LimitOptions.push({ text: '5 Games', value: 5 });
        _this3.LimitOptions.push({ text: '10 Games', value: 10 });
        _this3.LimitOptions.push({ text: '20 Games', value: 20 });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
    this.fetchSeasonCumulativeStats();
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'total_points',
      PointsPlayerData: [],
      Goaltending: [],
      Shooting: [],
      Faceoffs: [],
      PointsPlayerHeadings: ['Player', 'GP', 'G', 'A1', 'A2', 'A', 'PP', 'P'],
      PointsPlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'Goals (G)', value: 'goals' }, { text: 'First Assist (A1)', value: 'first_assists' }, { text: 'Second Assist (A2)', value: 'second_assists' }, { text: 'Total Assists (A)', value: 'total_assists' }, { text: 'Primary Points (PP)', value: 'primary_points' }, { text: 'Points (P)', value: 'total_points' }],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    };
  },

  computed: {
    sortByPointsData: function sortByPointsData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.PointsPlayerData, this.FilterSelected, ['desc']);
    },
    sortByPointsDataChart: function sortByPointsDataChart() {
      var orderedData = this.sortByPointsData;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByPointsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByPointsDataChart,
        label: 'Pointss - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    }
  },
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 0,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/points', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.PointsPlayerData = response.data.points;
      }, function (response) {});
    },
    fetchTeamOverviewStats: function fetchTeamOverviewStats() {
      var _this2 = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 0,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/team-overview/', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this2.GameFilter = response.data.games_filter;
        _this2.Goaltending = response.data.goaltending;
        _this2.Shooting = response.data.shooting;
        _this2.Faceoffs = response.data.faceoffs;
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this3 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this3.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this3.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this3.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this3.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var situations = response.data.situations;
        _this3.SituationOptions.push({ text: 'All', value: 0 });
        _this3.SituationOptions.push({ text: '--Primary Situations--', value: -6 });
        _this3.SituationOptions.push({ text: 'Even Handed', value: -1 });
        _this3.SituationOptions.push({ text: 'Power Play', value: -2 });
        _this3.SituationOptions.push({ text: 'Short Handed', value: -3 });
        _this3.SituationOptions.push({ text: 'Empty Net', value: -4 });
        _this3.SituationOptions.push({ text: '--Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          _this3.SituationOptions.push({ text: situations[s].secondary_situation, value: situations[s].id });
        }
        _this3.CompetitionOptions.push({ text: 'All', value: 0 });
        _this3.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this3.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this3.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this3.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this3.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this3.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this3.PeriodOptions.push({ text: 'All', value: 0 });
        _this3.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this3.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this3.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this3.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this3.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this3.LimitOptions.push({ text: 'All', value: 0 });
        _this3.LimitOptions.push({ text: '5 Games', value: 5 });
        _this3.LimitOptions.push({ text: '10 Games', value: 10 });
        _this3.LimitOptions.push({ text: '20 Games', value: 20 });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
    this.fetchTeamOverviewStats();
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_apexcharts__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_apexcharts__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    apexcharts: __WEBPACK_IMPORTED_MODULE_5_vue_apexcharts___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'total_diff',
      PIMData: [],
      PenaltyTypeOptions: [],
      PenaltyTypeSelected: 0,
      PenaltyByInfraction: [],
      PenaltyByTeam: [],
      PenaltyLastFive: [],
      PIMPlusMinusHeading: [{ text: 'Total +/-', value: 'total_diff' }],
      PIMHeadings: ['#', 'GP', 'Drawn', 'Taken', 'Diff', 'Drawn OZ', 'Taken OZ -', 'OZ Diff', 'Drawn NZ', 'Taken NZ', 'NZ DIFF', 'Taken DZ', 'Drawn DZ', 'DZ Diff'],
      PIMPlayerFilters: [{ text: 'OZ Drawn', value: 'oz_drawn' }, { text: 'OZ Taken', value: 'oz_taken' }, { text: 'OZ Diff', value: 'oz_diff' }, { text: 'NZ Drawn', value: 'nz_drawn' }, { text: 'NZ Taken', value: 'nz_taken' }, { text: 'NZ Diff', value: 'nz_diff' }, { text: 'DZ Drawn', value: 'dz_drawn' }, { text: 'DZ Taken', value: 'dz_taken' }, { text: 'DZ Diff', value: 'dz_diff' }, { text: 'Total Drawn', value: 'total_drawn' }, { text: 'Total Taken', value: 'total_taken' }, { text: 'Total Diff', value: 'total_diff' }],
      PIMChartFilters: [{ text: 'Drawn', value: 'total_drawn' }, { text: 'Taken', value: 'total_taken' }, { text: 'Diff', value: 'total_diff' }],
      sortByPimDiffSelected: 'total_diff',
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: false
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              reverse: true
            }
          }]
        }
      },
      lastFiveSeries: [],
      lastFiveOptions: {
        chart: {
          title: {
            text: 'Taken / Drawn Last 5 Games',
            align: 'left',
            enabled: true
          },
          toolbar: { show: false },
          height: 350,
          zoom: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
            lineCap: 'butt'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Season Taken / Drawn',
          align: 'left'
        },
        markers: {
          size: 6,
          shape: 'circle',
          radius: 4,
          hover: {
            sizeOffset: 3
          }
        },
        xaxis: {
          type: 'category',
          categories: []
        },
        plotOptions: {}
      }
    };
  },

  computed: {
    sortByPIMData: function sortByPIMData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.PIMData, this.FilterSelected, ['desc']);
    },
    sortByPIMTeam: function sortByPIMTeam() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.PenaltyByTeam, this.FilterSelected, ['desc']);
    },
    sortByPIMInfraction: function sortByPIMInfraction() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.PenaltyByInfraction, this.FilterSelected, ['desc']);
    },
    pim_by_team: function pim_by_team() {
      var labels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByPIMTeam[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          labels.push(label.team);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: labels
      };
      data.datasets = [];
      var drawn = [];
      var taken = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.sortByPIMTeam[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var pen = _step2.value;

          drawn.push(pen.total_drawn);
          taken.push(-pen.total_taken);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      data.datasets = [{
        data: taken,
        label: 'Taken',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: drawn,
        label: 'Drawn',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    pim_by_infraction: function pim_by_infraction() {
      var infractionLabels = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.sortByPIMInfraction[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var label = _step3.value;

          infractionLabels.push(label.penalty_type);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var data = {
        labels: infractionLabels
      };
      data.datasets = [];
      var drawn = [];
      var taken = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.sortByPIMInfraction[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var pen = _step4.value;

          drawn.push(pen.total_drawn);
          taken.push(-pen.total_taken);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      data.datasets = [{
        data: taken,
        label: 'Taken',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: drawn,
        label: 'Drawn',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    pim_chart_totals: function pim_chart_totals() {
      var playerLabels = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.sortByPIMDiffData[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var label = _step5.value;

          if (label.player !== 'Team') {
            playerLabels.push(label.player);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var drawn = [];
      var taken = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.sortByPIMDiffData[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var pen = _step6.value;

          if (pen.player !== 'Team') {
            drawn.push(pen.total_drawn);
            taken.push(-pen.total_taken);
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      data.datasets = [{
        data: taken,
        label: 'Taken',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }, {
        data: drawn,
        label: 'Drawn',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }];
      return data;
    },
    pim_chart_diff: function pim_chart_diff() {
      var playerLabels = [];
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.sortByPIMDiffOnlyData[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var label = _step7.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      var differential = [];

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.sortByPIMDiffOnlyData[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var pen = _step8.value;

          differential.push(pen.total_diff);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      data.datasets = [{
        data: differential,
        label: 'Differential',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },

    sortByPIMDiffOnlyData: function sortByPIMDiffOnlyData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.PIMData, 'total_diff', ['desc']);
    },
    sortByPIMDiffData: function sortByPIMDiffData() {
      // taken, drawn,  diff
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.PIMData, this.FilterSelected, ['desc']);
    },
    sortByPIMDataChart: function sortByPIMDataChart() {
      var orderedData = this.sortByPIMData;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.sortByPIMData[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var label = _step9.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByPIMDataChart,
        label: '+/-  ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    pim_by_last_five: function pim_by_last_five() {
      this.lastFiveSeries = [{ name: 'Drawn', data: [] }];
      this.lastFiveSeries.push({ name: 'Taken', data: [] });
      var cats = [];
      // this.lastFiveSeries.push({name: 'Diff', data: []})
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = this.PenaltyLastFive[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var stat = _step10.value;

          // this.lastFiveOptions.labels.push(stat.match_date)
          cats.push(stat.match_date);
          this.lastFiveSeries[0].data.push(stat.taken);
          this.lastFiveSeries[1].data.push(stat.drawn);
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      this.lastFiveOptions = _extends({}, this.lastFiveOptions, {
        xaxis: {
          categories: cats
        }
      });
      return this.lastFiveSeries;
    }
  },
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 0,
        'limit': this.LimitSelected,
        'type': this.PenaltyTypeSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/penalty-minutes', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.PIMData = response.data.penalty_minutes;
        _this.PenaltyByInfraction = response.data.penalty_minutes_team_by_type;
        _this.PenaltyByTeam = response.data.penalty_minutes_by_team;
        _this.PenaltyLastFive = response.data.penalty_minutes_last_five;
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this2.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this2.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this2.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this2.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var situations = response.data.situations;
        _this2.SituationOptions.push({ text: 'All', value: 0 });
        _this2.SituationOptions.push({ text: '--Primary Situations--', value: -6 });
        _this2.SituationOptions.push({ text: 'Even Handed', value: -1 });
        _this2.SituationOptions.push({ text: 'Power Play', value: -2 });
        _this2.SituationOptions.push({ text: 'Short Handed', value: -3 });
        _this2.SituationOptions.push({ text: 'Empty Net', value: -4 });
        _this2.SituationOptions.push({ text: '--Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          _this2.SituationOptions.push({ text: situations[s].secondary_situation, value: situations[s].id });
        }
        _this2.CompetitionOptions.push({ text: 'All', value: 0 });
        _this2.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this2.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this2.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this2.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this2.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this2.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this2.PeriodOptions.push({ text: 'All', value: 0 });
        _this2.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this2.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this2.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this2.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this2.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this2.LimitOptions.push({ text: 'All', value: 0 });
        _this2.LimitOptions.push({ text: '5 Games', value: 5 });
        _this2.LimitOptions.push({ text: '10 Games', value: 10 });
        _this2.LimitOptions.push({ text: '20 Games', value: 20 });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      StatOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      StatSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'Line',
      SeasonAverageData: [],
      SortOptions: [],
      SortSelected: 'GP',
      PerSixtyData: [],
      TableHeadings: ['Player', 'GP'],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      lineOptions: {
        title: { display: false, text: 'Sessions By Platform' },
        scales: {
          xAxes: [{
            stacked: true,
            display: true,
            ticks: {
              autoSkip: false
            }
          }],
          yAxes: [{
            stacked: true,
            display: true
          }]
        },
        legend: {
          display: true,
          labels: {
            fontColor: 'rgb(255, 99, 132)'
          }
        }
      }
    };
  },

  computed: {
    sortByGameAverageData: function sortByGameAverageData() {
      console.log('Sort selected: ' + this.SortSelected);
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.SeasonAverageData, this.SortSelected, ['desc']);
    },
    sortByPerSixtyData: function sortByPerSixtyData() {
      console.log('Sixty Sort selected: ' + this.SortSelected);
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.PerSixtyData, this.SortSelected, ['desc']);
    },
    sortByZoneStartsDataChart: function sortByZoneStartsDataChart() {
      var orderedData = this.sortByZoneStartsData;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    sortLineData: function sortLineData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.SeasonAverageData, ['defensive_percent', 'neutral_percent', 'offensive_percent'], ['asc', 'asc', 'asc']);
    },
    chartData: function chartData() {
      console.log(this.FilterSelected);
      if (this.FilterSelected === 'Line') {
        console.log('Doing line');
        var playerLabels = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.sortLineData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var lineLabel = _step.value;

            playerLabels.push(lineLabel.player);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var offensive = [];
        var neutral = [];
        var defensive = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.sortLineData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var d = _step2.value;

            offensive.push(d.offensive_percent);
            neutral.push(d.neutral_percent);
            defensive.push(d.defensive_percent);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var data = {
          labels: playerLabels
        };
        data.datsets = [];
        data.datasets = [{
          data: offensive,
          label: 'Offensive',
          backgroundColor: '#42c3ff',
          borderColor: '#42c3ff'
        }, {
          data: neutral,
          label: 'Neutral',
          backgroundColor: '#FEBC38',
          borderColor: '#FEBC38'
        }, {
          data: defensive,
          label: 'Defensive',
          backgroundColor: '#CA3542',
          borderColor: '#CA3542'
        }];
        return data;
      } else {
        var _playerLabels = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = this.sortByZoneStartsData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var label = _step3.value;

            _playerLabels.push(label.player);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var _data = {
          labels: _playerLabels
        };
        _data.datsets = [];
        _data.datasets = [{
          data: this.sortByZoneStartsDataChart,
          label: 'Zone Start - ' + this.FilterSelected,
          backgroundColor: 'rgba(54, 162, 235, 1)',
          borderColor: 'rgba(54, 162, 235, 1)'
        }];
        return _data;
      }
    }
  },
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.StatSelected,
        'category': this.StatSelected,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/per-sixty', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.SeasonAverageData = response.data.season_average;
        _this.PerSixtyData = response.data.per_sixty;
        if (_this.StatSelected === 0) {
          var goalHeading = ['Player', 'GP', 'Goals', 'Primary Assists', 'Secondary Assists', 'Total Assists', 'Points', 'Primary Points'];
          _this.TableHeadings = goalHeading;
          _this.SortOptions = [];
          _this.SortOptions.push({ text: 'Goals', value: 'goals' });
          _this.SortOptions.push({ text: 'Primary Assists', value: 'first_assist' });
          _this.SortOptions.push({ text: 'Second Assists', value: 'second_assist' });
          _this.SortOptions.push({ text: 'Total Assists', value: 'total_assist' });
          _this.SortOptions.push({ text: 'Total Points', value: 'total_points' });
          _this.SortOptions.push({ text: 'Primary Points', value: 'primary_points' });
        } else {
          var shotsHeading = ['Player', 'GP', 'SOT', 'Missed Shots', 'Blocked Shots'];
          _this.TableHeadings = shotsHeading;
        }
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this2.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this2.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this2.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this2.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        // let situations = response.data.situations
        _this2.StatOptions.push({ text: 'Goals & Points', value: 0 });
        _this2.StatOptions.push({ text: 'Shots', value: 1 });

        _this2.CompetitionOptions.push({ text: 'All', value: 0 });
        _this2.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this2.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this2.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this2.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this2.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this2.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this2.PeriodOptions.push({ text: 'All', value: 0 });
        _this2.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this2.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this2.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this2.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this2.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this2.LimitOptions.push({ text: 'All', value: 0 });
        _this2.LimitOptions.push({ text: '5 Games', value: 5 });
        _this2.LimitOptions.push({ text: '10 Games', value: 10 });
        _this2.LimitOptions.push({ text: '20 Games', value: 20 });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sort_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shots_heatmap_single_vue__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shots_heatmap_single_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shots_heatmap_single_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['pID'],
  components: {
    SortTable: __WEBPACK_IMPORTED_MODULE_0__sort_table_vue___default.a,
    apexcharts: __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a,
    'ShotsHeatmap': __WEBPACK_IMPORTED_MODULE_2__shots_heatmap_single_vue___default.a
  },
  data: function data() {
    return {
      selected: 'overview',
      PlayerData: [],
      GameLogs: [],
      GameLogsChartData: [],
      GameLogsCharOptions: {
        chart: {
          title: {
            text: 'Points / Season',
            align: 'left',
            enabled: true
          },
          toolbar: { show: false },
          height: 350,
          zoom: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
            lineCap: 'butt'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        colors: ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800', '#D68910', '#34495E', '#78281F', '#27AE60', '#76448A'],
        title: {
          text: 'Game By Game',
          align: 'left'
        },
        markers: {
          size: 3,
          shape: 'circle',
          radius: 3,
          hover: {
            sizeOffset: 2
          }
        },
        xaxis: {
          type: 'category',
          categories: []
        },
        plotOptions: {}
      }
    };
  },
  computed: {
    gameLogsChart: function gameLogsChart() {
      this.GameLogsChartData = [{ name: 'Points', data: [] }];
      this.GameLogsChartData.push({ name: 'Primary Assists', data: [] });
      this.GameLogsChartData.push({ name: 'Secondary Assists', data: [] });
      this.GameLogsChartData.push({ name: 'Goals', data: [] });
      this.GameLogsChartData.push({ name: 'Toi', data: [] });
      this.GameLogsChartData.push({ name: 'Shifts', data: [] });
      this.GameLogsChartData.push({ name: 'Shots On Net', data: [] });
      this.GameLogsChartData.push({ name: 'Shots +', data: [] });
      this.GameLogsChartData.push({ name: 'Shots -', data: [] });
      this.GameLogsChartData.push({ name: 'PIM Taken', data: [] });
      this.GameLogsChartData.push({ name: 'PIM Drawn', data: [] });
      var cats = [];
      // this.lastFiveSeries.push({name: 'Diff', data: []})
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.GameLogs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var stat = _step.value;

          // this.lastFiveOptions.labels.push(stat.match_date)
          cats.push(stat.game_date + ' ' + stat.opponent);
          this.GameLogsChartData[0].data.push(stat.points);
          this.GameLogsChartData[1].data.push(stat.first_assist);
          this.GameLogsChartData[2].data.push(stat.second_assist);
          this.GameLogsChartData[3].data.push(stat.goals);
          this.GameLogsChartData[4].data.push(stat.toi_total_mins);
          this.GameLogsChartData[5].data.push(stat.toi_shifts);
          this.GameLogsChartData[6].data.push(stat.shots_on_net);
          this.GameLogsChartData[7].data.push(stat.shots_for);
          this.GameLogsChartData[8].data.push(stat.shots_against);
          this.GameLogsChartData[9].data.push(stat.pim_taken);
          this.GameLogsChartData[10].data.push(stat.pim_drawn);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.GameLogsCharOptions = _extends({}, this.GameLogsCharOptions, {
        xaxis: {
          categories: cats
        }
      });
      return this.GameLogsChartData;
    }
  },
  methods: {
    gameDataLoaded: function gameDataLoaded(data) {
      this.GameLogs = data;
    },
    fetchPlayerStats: function fetchPlayerStats() {
      var _this = this;

      var postData = {
        'year': 2022,
        'competition': 'EIHL_Challenge_Cup',
        'venue': 0,
        'opponent': 0,
        'limit': 0,
        'player_id': this.$route.params.player_id,
        'team_id': 1,
        'stat': this.selected
      };
      console.log(this.$route.params.player_id);
      this.$http.post('https://devilsapi.roblutken.com/api/app/player-stats/report-card/', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.PlayerData = response.data;
      }, function (response) {});
    }
  },
  created: function created() {
    console.log('created');
  },
  beforeCreate: function beforeCreate() {
    console.log('before create');
  },
  beforeMount: function beforeMount() {
    console.log('BM FETCH');
    this.fetchPlayerStats();
  },
  mounted: function mounted() {
    console.log('FETCHING......');
    this.fetchPlayerStats();
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_report_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_report_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__player_report_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__playerTable_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__playerTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__playerTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'player-report': __WEBPACK_IMPORTED_MODULE_0__player_report_vue___default.a,
    'player-table': __WEBPACK_IMPORTED_MODULE_1__playerTable_vue___default.a
  },
  data: function data() {
    return {
      Players: [],
      Team: []
    };
  },
  computed: {
    clean: function clean() {
      var cleanData = [];
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.Players, function (object) {
        if (object.number > 0) {
          cleanData.push(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(object, ['id', 'number', 'name']));
        }
      });
      cleanData = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(cleanData, 'number', ['asc']);
      // cleanData = _.orderBy(cleanData, 'number', ['asc'])
      return cleanData;
    }
  },
  methods: {
    fetchPlayers: function fetchPlayers() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/players/get/teams/' + 1, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Players = response.data;
        console.log(_this.Players);
      }, function (response) {});
    },
    fetchTeam: function fetchTeam() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/teams/get/' + 1, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this2.Team = response.data;
        console.log(JSON.stringify(_this2.Team));
      }, function (response) {});
    },
    openReport: function openReport(id) {
      this.$router.push('/season-stats/player-stats/' + id);
    }
  },
  created: function created() {
    this.fetchPlayers();
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: -1,
      LimitSelected: 0,
      FixtureOptions: [],
      FixtureSelected: 0,
      FilterSelected: 'diff',
      FilterHeadings: [],
      GoalDiffData: [],
      EHGoalDiffData: [],
      PPGoalDiffData: [],
      SHGoalDiffData: [],
      GameGoalDiffData: [],
      GameByGameSearch: '',
      GoalDiffHeadings: ['#', 'GP', '+', '-', '+/-'],
      GoalDiffSituationalHeadings: ['#', 'GP', '+', '-', '+/-', 'EH 5v5 +', 'EH 5v5 -', 'EH 4v4 +', 'EH 4v4 -', 'EH 3v3 +', 'EH 3v3 -', 'EH +', 'EH -', 'EH +/-', 'PP 5v4 +', 'PP 5v4 -', 'PP 5v4 +', 'PP 5v3 -', 'PP 4v3 +', 'PP 4v3-', 'PP +', 'PP -', 'PP +/-', 'SH 4v5 +', 'SH 4v5 -', 'SH 3v5 +', 'SH 3v5 -', 'SH 3v4 +', 'SH 3v4 -', 'SH +', 'SH -', 'SH +/-', 'Situational +', 'Situational -', 'Situational +/-', 'Traditional +', 'Traditional -', 'Traditional +/-'],
      GoalDiffPlayerFilters: [{ text: '+', value: 'plus' }, { text: '-', value: 'minus' }, { text: '+/-', value: 'diff' }],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: false
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              reverse: true
            }
          }]
        }
      }
    };
  },

  computed: {
    sortByGoalDiffData: function sortByGoalDiffData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.GoalDiffData, this.FilterSelected, ['desc']);
    },
    sortByGoalDiffSituationalData: function sortByGoalDiffSituationalData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.GoalDiffData, this.FilterSelected, ['desc']);
    },
    sortByEHGoalDiffData: function sortByEHGoalDiffData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.EHGoalDiffData, this.FilterSelected, ['desc']);
    },
    sortByPPGoalDiffData: function sortByPPGoalDiffData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.PPGoalDiffData, this.FilterSelected, ['desc']);
    },
    sortBySHGoalDiffData: function sortBySHGoalDiffData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.SHGoalDiffData, this.FilterSelected, ['desc']);
    },
    sortByGoalDiffDataChart: function sortByGoalDiffDataChart() {
      var orderedData = this.sortByGoalDiffData;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByGoalDiffData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByGoalDiffDataChart,
        label: '+/-  ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    }
  },
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected,
        'fixture': this.FixtureSelected
      };
      console.log(this.FixtureSelected);
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/goal-diff', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.GoalDiffData = response.data.goal_diff;
      }, function (response) {});
    },
    fetchSeasonStatsByGame: function fetchSeasonStatsByGame() {
      var _this2 = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'limit': this.LimitSelected,
        'fixture': this.FixtureSelected
      };
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/goal-diff-game', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this2.GameFilter = response.data.games_filter;
        _this2.GameGoalDiffData = response.data.goal_diff_by_game;
      }, function (response) {});
    },
    fetchSituationalSeasonStats: function fetchSituationalSeasonStats() {
      var _this3 = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 1,
        'limit': this.LimitSelected,
        'fixture': this.FixtureSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/goal-diff', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this3.GameFilter = response.data.games_filter;
        _this3.EHGoalDiffData = response.data.goal_diff;
      }, function (response) {});
      postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 2,
        'limit': this.LimitSelected,
        'fixture': this.FixtureSelected
      };
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/goal-diff', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this3.GameFilter = response.data.games_filter;
        _this3.PPGoalDiffData = response.data.goal_diff;
      }, function (response) {});
      postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 3,
        'limit': this.LimitSelected,
        'fixture': this.FixtureSelected
      };
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/goal-diff', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this3.GameFilter = response.data.games_filter;
        _this3.SHGoalDiffData = response.data.goal_diff;
      }, function (response) {});
    },
    fetchFixtureOptions: function fetchFixtureOptions() {
      var _this4 = this;

      var postData = {
        'season': '2019'
      };
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/fixtures/', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        var fixtures = response.data;
        for (var i = 0; i < fixtures.length; i++) {
          _this4.FixtureOptions.push({ text: fixtures[i].match_date + ' ' + fixtures[i].competition + ' ' + fixtures[i].teams, value: fixtures[i].game_id });
        }
        _this4.FixtureOptions.push({ text: 'All', value: 0 });
      });
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this5 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this5.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this5.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this5.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this5.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        // let situations = response.data.situations
        _this5.SituationOptions.push({ text: 'All', value: 0 });
        _this5.SituationOptions.push({ text: '--Primary Situations--', value: -6 });
        _this5.SituationOptions.push({ text: 'Traditional +/- (EH +SH) - (EH - PP)', value: -1 });
        _this5.SituationOptions.push({ text: 'Even Handed', value: 1 });
        _this5.SituationOptions.push({ text: 'Power Play', value: 2 });
        _this5.SituationOptions.push({ text: 'Short Handed', value: 3 });
        _this5.SituationOptions.push({ text: 'Empty Net', value: 4 });
        _this5.SituationOptions.push({ text: '--Not avalible yet - Secondary Situations--', value: -5 });

        _this5.CompetitionOptions.push({ text: 'All', value: 0 });
        _this5.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this5.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this5.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this5.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this5.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this5.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this5.PeriodOptions.push({ text: 'All', value: 0 });
        _this5.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this5.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this5.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this5.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this5.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this5.LimitOptions.push({ text: 'All', value: 0 });
        _this5.LimitOptions.push({ text: '5 Games', value: 5 });
        _this5.LimitOptions.push({ text: '10 Games', value: 10 });
        _this5.LimitOptions.push({ text: '20 Games', value: 20 });
      });
    }
  },
  created: function created() {
    this.fetchFixtureOptions();
    this.fetchSeasonStatsByGame();
    this.fetchSeasonStats();
    this.fetchFilterOptions();
    // this.fetchSituationalSeasonStats()
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'total_points',
      PointsPlayerData: [],
      PointsPlayerHeadings: ['Player', 'GP', 'G', 'A1', 'A2', 'A', 'PPts', 'Pts', 'IGP', 'IAP', 'IPP'],
      PointsPlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'Goals (G)', value: 'goals' }, { text: 'First Assist (A1)', value: 'first_assists' }, { text: 'Second Assist (A2)', value: 'second_assists' }, { text: 'Total Assists (A)', value: 'total_assists' }, { text: 'Primary Points (PP)', value: 'primary_points' }, { text: 'Points (P)', value: 'total_points' }, { text: 'IGP', value: 'IGP' }, { text: 'IAP', value: 'IAP' }, { text: 'IPP', value: 'IPP' }],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    };
  },

  computed: {
    sortByPointsData: function sortByPointsData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.PointsPlayerData, this.FilterSelected, ['desc']);
    },
    sortByPointsDataChart: function sortByPointsDataChart() {
      var orderedData = this.sortByPointsData;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByPointsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByPointsDataChart,
        label: 'Points - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    }
  },
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 0,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/points', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.PointsPlayerData = response.data.points;
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this2.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this2.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this2.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this2.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var situations = response.data.situations;
        _this2.SituationOptions.push({ text: 'All', value: 0 });
        _this2.SituationOptions.push({ text: '--Primary Situations--', value: -6 });
        _this2.SituationOptions.push({ text: 'Even Handed', value: -1 });
        _this2.SituationOptions.push({ text: 'Power Play', value: -2 });
        _this2.SituationOptions.push({ text: 'Short Handed', value: -3 });
        _this2.SituationOptions.push({ text: 'Empty Net', value: -4 });
        _this2.SituationOptions.push({ text: '--Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          _this2.SituationOptions.push({ text: situations[s].secondary_situation, value: situations[s].id });
        }
        _this2.CompetitionOptions.push({ text: 'All', value: 0 });
        _this2.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this2.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this2.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this2.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this2.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this2.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this2.PeriodOptions.push({ text: 'All', value: 0 });
        _this2.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this2.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this2.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this2.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this2.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this2.LimitOptions.push({ text: 'All', value: 0 });
        _this2.LimitOptions.push({ text: '5 Games', value: 5 });
        _this2.LimitOptions.push({ text: '10 Games', value: 10 });
        _this2.LimitOptions.push({ text: '20 Games', value: 20 });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a
  },
  filters: {
    fixedDP: function fixedDP(value) {
      return value.toFixed(2);
    }
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'total_points',
      PlayerTotals: [],
      sortAsc: false,
      GoalsByGame: []
    };
  },

  computed: {},
  methods: {
    sortDataBy: function sortDataBy(value) {
      this.sortAsc = !this.sortAsc;
      if (this.sortAsc) {
        this.PlayerTotals = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.PlayerTotals, value, ['asc']);
      } else {
        this.PlayerTotals = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.PlayerTotals, value, ['desc']);
      }
    },
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 0,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/season-player-totals/', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.PlayerTotals = response.data.player_totals;
      }, function (response) {});
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/season-goals-by-game/', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GoalsByGame = response.data.goals_by_game;
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this2.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this2.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this2.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this2.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var situations = response.data.situations;
        _this2.SituationOptions.push({ text: 'All', value: 0 });
        _this2.SituationOptions.push({ text: '--Primary Situations--', value: -6 });
        _this2.SituationOptions.push({ text: 'Even Handed', value: -1 });
        _this2.SituationOptions.push({ text: 'Power Play', value: -2 });
        _this2.SituationOptions.push({ text: 'Short Handed', value: -3 });
        _this2.SituationOptions.push({ text: 'Empty Net', value: -4 });
        _this2.SituationOptions.push({ text: '--Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          _this2.SituationOptions.push({ text: situations[s].secondary_situation, value: situations[s].id });
        }
        _this2.CompetitionOptions.push({ text: 'All', value: 0 });
        _this2.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this2.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this2.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this2.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this2.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this2.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this2.PeriodOptions.push({ text: 'All', value: 0 });
        _this2.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this2.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this2.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this2.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this2.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this2.LimitOptions.push({ text: 'All', value: 0 });
        _this2.LimitOptions.push({ text: '5 Games', value: 5 });
        _this2.LimitOptions.push({ text: '10 Games', value: 10 });
        _this2.LimitOptions.push({ text: '20 Games', value: 20 });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_simpleheat_simpleheat__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_simpleheat_simpleheat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__store_modules_simpleheat_simpleheat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    'simpleheat': __WEBPACK_IMPORTED_MODULE_3__store_modules_simpleheat_simpleheat___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      PlayerOptions: [],
      ShotTypeOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 1,
      LimitSelected: 0,
      PlayerSelected: [],
      ShotTypeSelected: 0,
      FilterSelected: 'so_total',
      BlurSelected: 25,
      RadiusSelected: 12,
      UseHeatmap: true,
      ShotsPlayerData: [],
      FilterHeadings: [],
      ShotsPlayerHeadings: ['Player', 'GP', 'G', 'On Net', 'Missed', 'Blocked', 'OnNet%', 'SH%', 'Total', 'OnNetAvg', 'ShotAvg'],
      ShotsPlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'G', value: 'goals' }, { text: 'On Net', value: 'so_on_net' }, { text: 'Missed', value: 'so_missed_net' }, { text: 'Blocked', value: 'so_blocked' }, { text: 'OnNet%', value: 'so_on_net_percentage' }, { text: 'SH%', value: 'so_goal_percentage' }, { text: 'Total', value: 'so_total' }, { text: 'OnNetAvg', value: 'so_on_net_avg' }, { text: 'ShotAvg', value: 'so_total_avg' }],
      TeamShotDiffData: [],
      TeamShotDiffHeadings: ['Player', 'Home Team', 'Away Team', 'Date', 'CF', 'CA', 'Diff', 'CF%'],
      PlayerShotDiffData: [],
      PlayerShotDiffHeadings: ['Player', 'GP', 'CF', 'CA', 'Diff', 'CF%'],
      PlayerShotmapData: [],
      PlayerShotmapHeadings: ['Player', 'Shot Id', 'Shot Type', 'Shot Location'],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      line_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      lastFiveData: [],
      lastFiveDataSeries: [],
      lastFiveChartOptions: {
        chart: {
          toolbar: { show: false },
          colors: [],
          title: { text: 'Last Five Games Shot Differential' },
          markers: { size: 6 },
          theme: {
            palette: 'pallette3'
          },
          yaxis: {
            title: 'Shot Differential'
          },
          xaxis: {
            title: 'Game(s)'
          }
        }
      }
    };
  },

  computed: {
    sortByShotsData: function sortByShotsData() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.orderBy(this.ShotsPlayerData, this.FilterSelected, ['desc']);
    },
    sortByTeamShotDiffData: function sortByTeamShotDiffData() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.orderBy(this.TeamShotDiffData, 'id', ['asc']);
    },
    sortByPlayerShotDiffData: function sortByPlayerShotDiffData() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.orderBy(this.PlayerShotDiffData, 'diff', ['desc']);
    },
    sortByPlayerShotmapData: function sortByPlayerShotmapData() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.orderBy(this.PlayerShotmapData, 'shot_id', ['desc']);
    },
    sortByShotsDataChart: function sortByShotsDataChart() {
      var orderedData = this.sortByShotsData;
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    sortByTeamShotDiffDataChart: function sortByTeamShotDiffDataChart() {
      var orderedData = this.sortByTeamShotDiffData;
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(orderedData, 'cf_percent');
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByShotsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByShotsDataChart,
        label: 'Shots - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    chartTeamDiffData: function chartTeamDiffData() {
      var playerLabels = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.TeamShotDiffData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var label = _step2.value;

          if (label.match_date !== '2018-2019') {
            playerLabels.push(label.match_date);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByTeamShotDiffDataChart,
        label: 'Team Shot Differential - CF % ',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(0, 225, 225, 1)',
        pointBorderColor: 'rgba(0, 225, 255, 1)',
        pointBackgroundColor: 'rgba(0, 225, 255, 1)',
        fill: false
      }];
      return data;
    }
  },
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/shot-diff', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.ShotsPlayerData = response.data.shots;
        _this.PlayerShotDiffData = response.data.shot_differentials_player;
        _this.TeamShotDiffData = response.data.shot_differentials_team;
        _this.lastFiveData = response.data.shot_differentials_last_five;

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = _this.lastFiveData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var d = _step3.value;

            _this.lastFiveDataSeries.data.push({ x: d.game_info, y: d.diff });
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this2.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this2.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }

        var opponent = response.data.teams;
        _this2.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this2.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var player = response.data.cardiff_players;
        _this2.PlayerOptions.push({ name: 'All', id: 0 });
        for (var p = 0; p < player.length; p++) {
          _this2.PlayerOptions.push({ name: player[p].number + ' ' + player[p].surname, id: player[p].id });
        }
        var situations = response.data.situations;
        _this2.SituationOptions.push({ text: 'All', value: 0 });
        _this2.SituationOptions.push({ text: '--Primary Situations--', value: -6 });
        _this2.SituationOptions.push({ text: 'Even Handed', value: 1 });
        _this2.SituationOptions.push({ text: 'Power Play', value: 2 });
        _this2.SituationOptions.push({ text: 'Short Handed', value: 3 });
        _this2.SituationOptions.push({ text: 'Empty Net', value: 4 });
        _this2.SituationOptions.push({ text: '--Not avalible yet - Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          // this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
        }
        _this2.CompetitionOptions.push({ text: 'All', value: 0 });
        _this2.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this2.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this2.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this2.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this2.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this2.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this2.PeriodOptions.push({ text: 'All', value: 0 });
        _this2.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this2.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this2.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this2.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this2.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this2.LimitOptions.push({ text: 'All', value: 0 });
        _this2.LimitOptions.push({ text: '5 Games', value: 5 });
        _this2.LimitOptions.push({ text: '10 Games', value: 10 });
        _this2.LimitOptions.push({ text: '20 Games', value: 20 });

        _this2.ShotTypeOptions.push({ text: 'All', value: 0 });
        _this2.ShotTypeOptions.push({ text: 'Goal', value: 'Goal' });
        _this2.ShotTypeOptions.push({ text: 'On Net', value: 'OnNet' });
        _this2.ShotTypeOptions.push({ text: 'Missed Net', value: 'MissedNet' });
        _this2.ShotTypeOptions.push({ text: 'Blocked', value: 'Blocked' });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_simpleheat_simpleheat__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_simpleheat_simpleheat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__store_modules_simpleheat_simpleheat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shots_heatmap_team__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shots_heatmap_team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shots_heatmap_team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    'simpleheat': __WEBPACK_IMPORTED_MODULE_3__store_modules_simpleheat_simpleheat___default.a,
    TeamShotMap: __WEBPACK_IMPORTED_MODULE_6__shots_heatmap_team___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      PlayerOptions: [],
      ShotTypeOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      PlayerSelected: [],
      ShotTypeSelected: [],
      FilterSelected: 'so_total',
      BlurSelected: 25,
      RadiusSelected: 12,
      UseHeatmap: true,
      ShotsPlayerData: [],
      FilterHeadings: [],
      GameByGameData: [],
      MatchData: [],
      GraphPlayers: [],
      GraphData: [],
      ChunkedData: [],
      ChunkedPlayers: [],
      RollingData: [],
      CumulativeData: [],
      GameByGameFill: true,
      GameByGameTension: 0,
      RollingLimit: 5,
      GameByGameDataOptions: [{ text: 'Goals', value: 'goals' }, { text: 'On Net', value: 'so_on_net' }, { text: 'Missed Net', value: 'so_missed_net' }, { text: 'Blocked', value: 'so_blocked' }, { text: 'Total Attempts', value: 'so_total' }, { text: 'On Net %', value: 'so_on_net_percentage' }, { text: 'SH%', value: 'so_goal_percentage' }],
      GameByGameDataSelected: 'so_total',
      ShotsPlayerHeadings: ['Player', 'GP', 'G', 'On Net', 'Missed', 'Blocked', 'OnNet%', 'SH%', 'Total', 'OnNetAvg', 'ShotAvg'],
      ShotsPlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'G', value: 'goals' }, { text: 'On Net', value: 'so_on_net' }, { text: 'Missed', value: 'so_missed_net' }, { text: 'Blocked', value: 'so_blocked' }, { text: 'OnNet%', value: 'so_on_net_percentage' }, { text: 'SH%', value: 'so_goal_percentage' }, { text: 'Total', value: 'so_total' }, { text: 'OnNetAvg', value: 'so_on_net_avg' }, { text: 'ShotAvg', value: 'so_total_avg' }],
      TeamShotDiffData: [],
      TeamShotDiffHeadings: ['Player', 'Home Team', 'Away Team', 'Date', 'CF', 'CA', 'Diff', 'CF%'],
      PlayerShotDiffData: [],
      PlayerShotDiffHeadings: ['Player', 'GP', 'CF', 'CA', 'Diff', 'CREL', 'CF%'],
      PlayerShotmapData: [],
      PlayerShotmapHeadings: ['Player', 'Shot Id', 'Shot Type', 'Shot Location'],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      line_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    };
  },

  computed: {
    sortByShotsData: function sortByShotsData() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(this.ShotsPlayerData, this.FilterSelected, ['desc']);
    },
    sortByTeamShotDiffData: function sortByTeamShotDiffData() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(this.TeamShotDiffData, 'id', ['asc']);
    },
    sortByPlayerShotDiffData: function sortByPlayerShotDiffData() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(this.PlayerShotDiffData, 'c_rel', ['desc']);
    },
    sortByPlayerShotmapData: function sortByPlayerShotmapData() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(this.PlayerShotmapData, 'shot_id', ['desc']);
    },
    sortGameByGameData: function sortGameByGameData() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(this.GameByGameData, 'shot_id', ['desc']);
    },
    sortByShotsDataChart: function sortByShotsDataChart() {
      var orderedData = this.sortByShotsData;
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    sortByTeamShotDiffDataChart: function sortByTeamShotDiffDataChart() {
      var orderedData = this.sortByTeamShotDiffData;
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.map(orderedData, 'cf_percent');
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByShotsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByShotsDataChart,
        label: 'Shots - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    chartTeamDiffData: function chartTeamDiffData() {
      var playerLabels = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.TeamShotDiffData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var label = _step2.value;

          if (label.match_date !== '2018-2019') {
            playerLabels.push(label.match_date);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByTeamShotDiffDataChart,
        label: 'Team Shot Differential - CF % ',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(0, 225, 225, 1)',
        pointBorderColor: 'rgba(0, 225, 255, 1)',
        pointBackgroundColor: 'rgba(0, 225, 255, 1)',
        fill: false
      }];
      return data;
    },
    buildChartData: function buildChartData() {
      var matchLabels = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.MatchData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var label = _step3.value;

          matchLabels.push(label.formatted_date);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var customData = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.PlayerSelected[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var player = _step4.value;

          var colour = Math.floor(Math.random() * 16777215).toString(16);
          // console.log(colour)
          customData.push({ data: this.buildData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension });
        }
        // console.log(JSON.stringify(customData))
        // data.datasets = customData
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var data = {
        labels: matchLabels,
        datasets: customData
      };
      return data;
    },
    buildChunkedChartData: function buildChunkedChartData() {
      var matchLabels = [];
      var customData = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.ChunkedData[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var label = _step5.value;

          matchLabels.push(label.formatted_date);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.PlayerSelected[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var player = _step6.value;

          var colour = Math.floor(Math.random() * 16777215).toString(16);
          // console.log(colour)
          customData.push({ data: this.buildChunkedData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension });
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var data = {
        labels: matchLabels,
        datasets: customData
        // console.log(data)
      };return data;
    },
    buildRollingChartData: function buildRollingChartData() {
      var matchLabels = [];
      var customData = [];
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.RollingData[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var label = _step7.value;

          matchLabels.push(label.formatted_date);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.PlayerSelected[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var player = _step8.value;

          var colour = Math.floor(Math.random() * 16777215).toString(16);
          // console.log(colour)
          customData.push({ data: this.buildRollingData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension });
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      var data = {
        labels: matchLabels,
        datasets: customData
        // console.log(data)
      };return data;
    },
    buildCumulativeChartData: function buildCumulativeChartData() {
      var matchLabels = [];
      var customData = [];
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.CumulativeData[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var label = _step9.value;

          matchLabels.push(label.formatted_date);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = this.PlayerSelected[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var player = _step10.value;

          var colour = Math.floor(Math.random() * 16777215).toString(16);
          // console.log(colour)
          customData.push({ data: this.buildCumulativeData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension });
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      var data = {
        labels: matchLabels,
        datasets: customData
        // console.log(data)
      };return data;
    }
  },
  methods: {
    buildData: function buildData(_name) {
      var results = [];
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.GraphData, ['player', _name])[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var v = _step11.value;

          switch (this.GameByGameDataSelected) {
            case 'goals':
              results.push(v.goals);
              break;
            case 'so_on_net':
              results.push(v.so_on_net);
              break;
            case 'so_missed_net':
              results.push(v.so_missed_net);
              break;
            case 'so_blocked':
              results.push(v.so_blocked);
              break;
            case 'so_total':
              results.push(v.so_total);
              break;
            case 'so_on_net_percentage':
              results.push(v.so_on_net_percentage);
              break;
            case 'so_goal_percentage':
              results.push(v.so_goal_percentage);
              break;
          }
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      return results;
    },
    buildChunkedData: function buildChunkedData(_name) {
      var results = [];
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.ChunkedPlayers, ['player', _name])[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var v = _step12.value;

          switch (this.GameByGameDataSelected) {
            case 'goals':
              results.push(v.goals);
              break;
            case 'so_on_net':
              results.push(v.so_on_net);
              break;
            case 'so_missed_net':
              results.push(v.so_missed_net);
              break;
            case 'so_blocked':
              results.push(v.so_blocked);
              break;
            case 'so_total':
              results.push(v.so_total);
              break;
            case 'so_on_net_percentage':
              results.push(v.so_on_net_percentage);
              break;
            case 'so_goal_percentage':
              results.push(v.so_goal_percentage);
              break;
          }
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      return results;
    },
    buildRollingData: function buildRollingData(_name) {
      var results = [];
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = this.RollingData[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var game = _step13.value;

          // console.log('Searching:' + JSON.stringify(game))
          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = game.player_data[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var v = _step14.value;

              if (v.player === _name) {
                // console.log('Found Player: ' + v.player)
                switch (this.GameByGameDataSelected) {
                  case 'goals':
                    results.push(v.goals);
                    break;
                  case 'so_on_net':
                    results.push(v.so_on_net);
                    break;
                  case 'so_missed_net':
                    results.push(v.so_missed_net);
                    break;
                  case 'so_blocked':
                    results.push(v.so_blocked);
                    break;
                  case 'so_total':
                    results.push(v.so_total);
                    break;
                  case 'so_on_net_percentage':
                    results.push(v.so_on_net_percentage);
                    break;
                  case 'so_goal_percentage':
                    results.push(v.so_goal_percentage);
                    break;
                }
              }
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      return results;
    },
    buildCumulativeData: function buildCumulativeData(_name) {
      var results = [];
      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = this.CumulativeData[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var game = _step15.value;

          // console.log('Searching:' + JSON.stringify(game))
          var _iteratorNormalCompletion16 = true;
          var _didIteratorError16 = false;
          var _iteratorError16 = undefined;

          try {
            for (var _iterator16 = game.player_data[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
              var v = _step16.value;

              if (v.player === _name) {
                // console.log('Found Player: ' + v.player)
                switch (this.GameByGameDataSelected) {
                  case 'goals':
                    results.push(v.goals);
                    break;
                  case 'so_on_net':
                    results.push(v.so_on_net);
                    break;
                  case 'so_missed_net':
                    results.push(v.so_missed_net);
                    break;
                  case 'so_blocked':
                    results.push(v.so_blocked);
                    break;
                  case 'so_total':
                    results.push(v.so_total);
                    break;
                  case 'so_on_net_percentage':
                    results.push(v.so_on_net_percentage);
                    break;
                  case 'so_goal_percentage':
                    results.push(v.so_goal_percentage);
                    break;
                }
              }
            }
          } catch (err) {
            _didIteratorError16 = true;
            _iteratorError16 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion16 && _iterator16.return) {
                _iterator16.return();
              }
            } finally {
              if (_didIteratorError16) {
                throw _iteratorError16;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }

      return results;
    },
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected
      };

      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/shots', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.ShotsPlayerData = response.data.shots;
        _this.PlayerShotDiffData = response.data.shot_differentials_player;
        _this.TeamShotDiffData = response.data.shot_differentials_team;
        _this.GameByGameData = response.data.game_by_game;
        _this.MatchData = response.data.game_by_game.match_dates;
        _this.GraphPlayers = response.data.game_by_game.graph_players;
        _this.GraphData = response.data.game_by_game.graph_data;
        _this.fetchGraphStats();
      }, function (response) {});
    },
    fetchGraphStats: function fetchGraphStats() {
      this.fetchChunkedStats();
      this.fetchRollingStats();
      this.fetchCumulativeStats();
    },
    fetchChunkedStats: function fetchChunkedStats() {
      var _this2 = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected,
        'rolling_limit': this.RollingLimit
      };

      console.log('Rolling Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/shots-chunked', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this2.ChunkedData = response.data.chunked_data;
        _this2.ChunkedPlayers = response.data.chunked_players;
      }, function (response) {});
    },
    fetchRollingStats: function fetchRollingStats() {
      var _this3 = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected,
        'rolling_limit': this.RollingLimit
      };

      console.log('Rolling Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/shots-rolling', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this3.RollingData = response.data.rolling_games;
        // this.RollingPlayers = response.data.rolling_players
      }, function (response) {});
    },
    fetchCumulativeStats: function fetchCumulativeStats() {
      var _this4 = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected,
        'rolling_limit': this.RollingLimit
      };

      console.log('Rolling Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/shots-cumulative', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this4.CumulativeData = response.data.rolling_games;
        // this.RollingPlayers = response.data.rolling_players
      }, function (response) {});
    },
    fetchSeasonShotmaps: function fetchSeasonShotmaps() {
      var _this5 = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected,
        'player': JSON.stringify(this.PlayerSelected),
        'shot_type': JSON.stringify(this.ShotTypeSelected)
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/shotmaps', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this5.GameFilter = response.data.games_filter;
        _this5.PlayerShotmapData = response.data.player_shot_locations;
        _this5.renderKey();
        if (_this5.UseHeatmap) {
          _this5.renderHeatmap();
        } else {
          _this5.renderZoneMap(_this5.PlayerShotmapData);
        }
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this6 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this6.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this6.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }

        var opponent = response.data.teams;
        _this6.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this6.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var player = response.data.cardiff_players;
        _this6.PlayerOptions.push({ name: 'All', id: 0 });
        for (var p = 0; p < player.length; p++) {
          _this6.PlayerOptions.push({ name: player[p].number + ' ' + player[p].surname, id: player[p].id });
        }
        var situations = response.data.situations;
        _this6.SituationOptions.push({ text: 'All', value: 0 });
        _this6.SituationOptions.push({ text: '--Primary Situations--', value: -6 });
        _this6.SituationOptions.push({ text: 'Even Handed', value: 1 });
        _this6.SituationOptions.push({ text: 'Power Play', value: 2 });
        _this6.SituationOptions.push({ text: 'Short Handed', value: 3 });
        _this6.SituationOptions.push({ text: 'Empty Net', value: 4 });
        _this6.SituationOptions.push({ text: '--Not avalible yet - Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          // this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
        }
        _this6.CompetitionOptions.push({ text: 'All', value: 0 });
        _this6.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this6.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this6.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this6.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this6.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this6.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this6.PeriodOptions.push({ text: 'All', value: 0 });
        _this6.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this6.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this6.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this6.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this6.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this6.LimitOptions.push({ text: 'All', value: 0 });
        _this6.LimitOptions.push({ text: '5 Games', value: 5 });
        _this6.LimitOptions.push({ text: '10 Games', value: 10 });
        _this6.LimitOptions.push({ text: '20 Games', value: 20 });

        _this6.ShotTypeOptions.push({ name: 'All', id: 'All' });
        _this6.ShotTypeOptions.push({ name: 'Goal', id: 'Goal' });
        _this6.ShotTypeOptions.push({ name: 'On Net', id: 'OnNet' });
        _this6.ShotTypeOptions.push({ name: 'Missed Net', id: 'MissedNet' });
        _this6.ShotTypeOptions.push({ name: 'Blocked', id: 'Blocked' });
      });
    },
    renderHeatmap: function renderHeatmap() {
      var _this7 = this;

      var canvas = this.$refs.player_shot_canvas;
      var shotLocations = [];
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = this.PlayerShotmapData[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var shots = _step17.value;

          shotLocations.push(JSON.parse(shots.shot_location));
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }

      setTimeout(function () {
        var heat = __WEBPACK_IMPORTED_MODULE_3__store_modules_simpleheat_simpleheat___default()(canvas).data(shotLocations);
        heat.radius(_this7.RadiusSelected, _this7.BlurSelected);
        heat.draw();
      }, 2004);
    },
    renderZoneMap: function renderZoneMap(locatonData) {
      /*eslint-disable */
      var canvas = this.$refs.player_shot_canvas;
      var ctx = canvas.getContext('2d');

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var colour = '#2F4858C9';
      var centerPos = [160, 76, 280, 200];

      var outsideZonePos = [5, 389, 590, 140];

      var behindNetPos = [5, 0, 590, 75];

      var leftOutsidePos = [5, 76, 160, 200];

      var rightOutsidePos = [440, 76, 155, 200];

      var leftPointInit = [5, 275];
      var leftPointLines = [{ x: 5, y: 275 }, { x: 165, y: 275 }, { x: 180, y: 385 }, { x: 5, y: 385 }, { x: 5, y: 275 }];

      var centerPointInit = [165, 275];
      var centerPointLines = [{ x: 165, y: 275 }, { x: 440, y: 275 }, { x: 420, y: 385 }, { x: 180, y: 385 }, { x: 165, y: 275 }];

      var rightPointInit = [440, 275];
      var rightPointLines = [{ x: 440, y: 275 }, { x: 595, y: 275 }, { x: 595, y: 385 }, { x: 420, y: 385 }, { x: 440, y: 275 }];

      this.drawRect(ctx, colour, centerPos);
      this.drawRect(ctx, colour, outsideZonePos, '12px', 1);
      this.drawRect(ctx, colour, behindNetPos);
      this.drawRect(ctx, colour, leftOutsidePos);
      this.drawRect(ctx, colour, rightOutsidePos);

      this.drawCustom(ctx, colour, leftPointInit, leftPointLines);
      this.drawCustom(ctx, colour, centerPointInit, centerPointLines);
      this.drawCustom(ctx, colour, rightPointInit, rightPointLines);

      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = locatonData[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var shots = _step18.value;

          var circlePos = [];
          var decode = JSON.parse(shots.shot_location);
          // console.log(decode)
          circlePos[0] = decode[0];
          circlePos[1] = decode[1];
          if (shots.shot_type === 'OnNet') {
            this.drawCircle(ctx, '#D90908F2', circlePos, 6);
          }
          if (shots.shot_type === 'Blocked') {
            this.drawCircle(ctx, '#6800e8', circlePos, 4);
          }
          if (shots.shot_type === 'MissedNet') {
            this.drawCircle(ctx, '#e8a600', circlePos, 4);
          }
          if (shots.shot_type === 'Goal') {
            this.drawCircle(ctx, '#0fe800', circlePos, 8);
          }
        }
        /*eslint-enable*/
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }
    },
    renderKey: function renderKey() {
      var canvas = this.$refs.shotmap_key;
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.drawCircle(ctx, '#0fe800', [50, 10], 8);
      this.drawCircle(ctx, '#D90908F2', [100, 10], 6);
      this.drawCircle(ctx, '#e8a600', [150, 10], 4);
      this.drawCircle(ctx, '#6800e8', [200, 10], 4);
      this.drawText(ctx, 'Goal', [35, 30], '12px');
      this.drawText(ctx, 'On Net', [85, 30], '12px');
      this.drawText(ctx, 'Missed', [136, 30], '12px');
      this.drawText(ctx, 'Blocked', [185, 30], '12px');
    },
    drawRect: function drawRect(ctx, color, position, text, textPos) {
      var fontSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '26px';
      var lineWidth = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 3;

      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = lineWidth;
      ctx.fillRect(position[0], position[1], position[2], position[3]);
      ctx.strokeRect(position[0], position[1], position[2], position[3]);
      ctx.closePath();
    },
    drawText: function drawText(ctx, text, textPosition) {
      var textSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '26px';

      ctx.beginPath();
      ctx.font = textSize + ' sans-serif';
      ctx.fillStyle = 'rgba(0, 0, 0, 1)';
      ctx.fillText(text, textPosition[0], textPosition[1]);
      ctx.closePath();
    },
    drawCustom: function drawCustom(ctx, color, initPos, movePoints) {
      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = 'white';
      ctx.moveTo(initPos[0], initPos[1]);
      // Loop over move points
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = movePoints[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var prop = _step19.value;

          ctx.lineTo(prop.x, prop.y);
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }

      ctx.fill();
      ctx.stroke();
      ctx.closePath();
    },
    drawCircle: function drawCircle(ctx, color, position, radius) {
      var lineWidth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2;

      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = lineWidth;
      ctx.arc(position[0], position[1], radius, 0, 2 * Math.PI);
      ctx.fill();
      ctx.stroke();
      ctx.closePath();
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
    // this.fetchSeasonShotmaps()
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      FilterHeadings: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'avg_shift_game',
      TimeOnIcePlayerData: [],
      TimeOnIcePlayerHeadings: ['Player', 'GP', 'TOI', 'Shifts', 'EH', 'PP', 'SH', 'TOI/Shift', 'Shifts/G', 'TOI/G', 'EH/G', 'PP/G', 'SH/G', 'Goals', 'Goals/60'],
      TimeOnIcePlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'TOI', value: 'total_toi' }, { text: 'Shifts', value: 'total_shifts' }, { text: 'EH', value: 'eh_toi_total' }, { text: 'PP', value: 'pp_toi_total' }, { text: 'SH', value: 'sh_toi_total' }, { text: 'TOI/Shift', value: 'avg_shift_length' }, { text: 'Shifts/G', value: 'avg_shift_count' }, { text: 'TOI/G', value: 'avg_shift_game' }, { text: 'EH/G', value: 'eh_toi_avg' }, { text: 'PP/G', value: 'pp_toi_avg' }, { text: 'SH/G', value: 'sh_toi_avg' }, { text: 'Goals', value: 'goals' }, { text: 'Goals / 60', value: 'goals_sixty' }],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    };
  },

  computed: {
    sortByTimeOnIceData: function sortByTimeOnIceData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.TimeOnIcePlayerData, this.FilterSelected, ['desc']);
    },
    sortByTimeOnIceDataChart: function sortByTimeOnIceDataChart() {
      var orderedData = this.sortByTimeOnIceData;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByTimeOnIceData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByTimeOnIceDataChart,
        label: 'TimeOnIce - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    }
  },
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 0,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/toi', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.TimeOnIcePlayerData = response.data.toi;
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this2.VenueOptions.push({ text: 'All', value: 0 });
        _this2.VenueOptions.push({ text: 'Away', value: 'away' });
        for (var i = 0; i < venue.length; i++) {
          _this2.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this2.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this2.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var situations = response.data.situations;
        _this2.SituationOptions.push({ text: 'All', value: 0 });
        _this2.SituationOptions.push({ text: '--Primary Situations--', value: -6 });
        _this2.SituationOptions.push({ text: 'Even Handed', value: -1 });
        _this2.SituationOptions.push({ text: 'Power Play', value: -2 });
        _this2.SituationOptions.push({ text: 'Short Handed', value: -3 });
        _this2.SituationOptions.push({ text: 'Empty Net', value: -4 });
        _this2.SituationOptions.push({ text: '--Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          _this2.SituationOptions.push({ text: situations[s].secondary_situation, value: situations[s].id });
        }
        _this2.CompetitionOptions.push({ text: 'All', value: 0 });
        _this2.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this2.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this2.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this2.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this2.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this2.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this2.PeriodOptions.push({ text: 'All', value: 0 });
        _this2.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this2.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this2.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this2.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this2.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this2.LimitOptions.push({ text: 'All', value: 0 });
        _this2.LimitOptions.push({ text: '5 Games', value: 5 });
        _this2.LimitOptions.push({ text: '10 Games', value: 10 });
        _this2.LimitOptions.push({ text: '20 Games', value: 20 });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      PlayerOptions: [],
      PlayerSelected: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'to_total',
      TurnoverPlayerData: [],
      RollingTurnoverData: [],
      CumulativeTurnoverData: [],
      GameByGameFill: false,
      GameByGameTension: 0,
      RollingLimit: 5,
      FilterHeadings: [],
      GameByGameDataSelected: 'to_total',
      GameByGameDataOptions: [{ text: 'Offensive', value: 'to_offensive' }, { text: 'Neutral', value: 'to_neutral' }, { text: 'Defensive', value: 'to_defensive' }, { text: 'Total', value: 'to_total' }],
      TurnoverPlayerHeadings: ['Player', 'GP', 'Offensive', 'Offensive AVG', 'Neutral', 'Neutral AVG', 'Defensive', 'Defensive AVG', 'Total', 'Average / Game'],
      TurnoverPlayerFilters: [{ text: 'Stacked Totals', value: 'stacked_totals' }, { text: 'Stacked Avg', value: 'stacked_avg' }, { text: 'Offensive', value: 'to_offensive' }, { text: 'Offensive AVG', value: 'to_offensive_avg' }, { text: 'Neutral', value: 'to_neutral' }, { text: 'Neutral AVG', value: 'to_neutral_avg' }, { text: 'Defensive', value: 'to_defensive' }, { text: 'Defensive AVG', value: 'to_defensive_avg' }, { text: 'Total', value: 'to_total' }, { text: 'Average / Game', value: 'to_average' }],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: false
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              reverse: true
            }
          }]
        }
      },
      line_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    };
  },

  computed: {
    sortByTurnoverData: function sortByTurnoverData() {
      if (this.FilterSelected === 'stacked_totals' || this.FilterSelected === 'stacked_avg') {
        return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(this.TurnoverPlayerData, 'to_total', ['desc']);
      }
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(this.TurnoverPlayerData, this.FilterSelected, ['desc']);
    },
    sortByTurnoverDataChart: function sortByTurnoverDataChart() {
      var orderedData = this.sortByTurnoverData;
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    chartStackedData: function chartStackedData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByTurnoverData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var offensive = [];
      var neutral = [];
      var defensive = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.sortByTurnoverData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var d = _step2.value;

          if (this.FilterSelected === 'stacked_avg') {
            offensive.push(d.to_offensive_avg);
            neutral.push(d.to_neutral_avg);
            defensive.push(d.to_defensive_avg);
          } else {
            offensive.push(d.to_offensive);
            neutral.push(d.to_neutral);
            defensive.push(d.to_defensive);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: offensive,
        label: 'Offensive',
        backgroundColor: '#0077cf',
        borderColor: '#0077cf'
      }, {
        data: neutral,
        label: 'Neutral',
        backgroundColor: '#ff9677',
        borderColor: '#ff9677'
      }, {
        data: defensive,
        label: 'Defensive',
        backgroundColor: '#7263bb',
        borderColor: '#7263bb'
      }];
      return data;
    },
    buildRollingChartData: function buildRollingChartData() {
      var matchLabels = [];
      var customData = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.RollingTurnoverData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var label = _step3.value;

          matchLabels.push(label.formatted_date);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.PlayerSelected[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var player = _step4.value;

          var colour = Math.floor(Math.random() * 16777215).toString(16);
          // console.log(colour)
          customData.push({ data: this.buildRollingData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension });
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var data = {
        labels: matchLabels,
        datasets: customData
        // console.log(data)
      };return data;
    },
    buildCumulativeChartData: function buildCumulativeChartData() {
      var matchLabels = [];
      var customData = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.CumulativeTurnoverData[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var label = _step5.value;

          matchLabels.push(label.formatted_date);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.PlayerSelected[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var player = _step6.value;

          var colour = Math.floor(Math.random() * 16777215).toString(16);
          // console.log(colour)
          customData.push({ data: this.buildCumulativeData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension });
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var data = {
        labels: matchLabels,
        datasets: customData
        // console.log(data)
      };return data;
    }
  },
  methods: {
    buildRollingData: function buildRollingData(_name) {
      var results = [];
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.RollingTurnoverData[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var game = _step7.value;

          // console.log('Searching:' + JSON.stringify(game))
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = game.player_data[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var v = _step8.value;

              if (v.player === _name) {
                // console.log('Found Player: ' + v.player)
                switch (this.GameByGameDataSelected) {
                  case 'to_offensive':
                    results.push(v.to_offensive);
                    break;
                  case 'to_neutral':
                    results.push(v.to_neutral);
                    break;
                  case 'to_defensive':
                    results.push(v.to_defensive);
                    break;
                  case 'to_total':
                    results.push(v.to_total);
                    break;
                }
              }
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return results;
    },
    buildCumulativeData: function buildCumulativeData(_name) {
      var results = [];
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.CumulativeTurnoverData[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var game = _step9.value;

          // console.log('Searching:' + JSON.stringify(game))
          var _iteratorNormalCompletion10 = true;
          var _didIteratorError10 = false;
          var _iteratorError10 = undefined;

          try {
            for (var _iterator10 = game.player_data[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
              var v = _step10.value;

              if (v.player === _name) {
                // console.log('Found Player: ' + v.player)
                switch (this.GameByGameDataSelected) {
                  case 'to_offensive':
                    results.push(v.to_offensive);
                    break;
                  case 'to_neutral':
                    results.push(v.to_neutral);
                    break;
                  case 'to_defensive':
                    results.push(v.to_defensive);
                    break;
                  case 'to_total':
                    results.push(v.to_total);
                    break;
                }
              }
            }
          } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
              }
            } finally {
              if (_didIteratorError10) {
                throw _iteratorError10;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return results;
    },
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/turnovers', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.TurnoverPlayerData = response.data.turnovers;
      }, function (response) {});
    },
    fetchSeasonRollingStats: function fetchSeasonRollingStats() {
      var _this2 = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected,
        'rolling_limit': this.RollingLimit
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/turnovers-rolling', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this2.RollingTurnoverData = response.data.rolling_games;
      }, function (response) {});
    },
    fetchSeasonCumulativeStats: function fetchSeasonCumulativeStats() {
      var _this3 = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/turnovers-cumulative', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this3.CumulativeTurnoverData = response.data.rolling_games;
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this4 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this4.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this4.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this4.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this4.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var player = response.data.cardiff_players;
        _this4.PlayerOptions.push({ name: 'All', id: 0 });
        for (var p = 0; p < player.length; p++) {
          _this4.PlayerOptions.push({ name: player[p].number + ' ' + player[p].surname, id: player[p].id });
        }
        _this4.SituationOptions.push({ text: 'All', value: 0 });
        _this4.SituationOptions.push({ text: '--Primary Situations--', value: -6 });
        _this4.SituationOptions.push({ text: 'Even Handed', value: 1 });
        _this4.SituationOptions.push({ text: 'Power Play', value: 2 });
        _this4.SituationOptions.push({ text: 'Short Handed', value: 3 });
        _this4.SituationOptions.push({ text: 'Empty Net', value: 4 });
        _this4.SituationOptions.push({ text: '--Not avalible yet - Secondary Situations--', value: -5 });

        _this4.CompetitionOptions.push({ text: 'All', value: 0 });
        _this4.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this4.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this4.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this4.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this4.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this4.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this4.PeriodOptions.push({ text: 'All', value: 0 });
        _this4.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this4.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this4.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this4.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this4.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this4.LimitOptions.push({ text: 'All', value: 0 });
        _this4.LimitOptions.push({ text: '5 Games', value: 5 });
        _this4.LimitOptions.push({ text: '10 Games', value: 10 });
        _this4.LimitOptions.push({ text: '20 Games', value: 20 });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
    this.fetchSeasonRollingStats();
    this.fetchSeasonCumulativeStats();
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shots_heatmap_team__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shots_heatmap_team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shots_heatmap_team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort_table__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__sort_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__faceoffs_pvp_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__faceoffs_pvp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__faceoffs_pvp_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import _ from 'lodash'
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    TeamShotMap: __WEBPACK_IMPORTED_MODULE_4__shots_heatmap_team___default.a,
    'sort-table': __WEBPACK_IMPORTED_MODULE_5__sort_table___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a,
    'faceoffs-pvp': __WEBPACK_IMPORTED_MODULE_6__faceoffs_pvp_vue___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      FilterHeadings: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 8,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0
    };
  },

  computed: {},
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {},
    fetchFilterOptions: function fetchFilterOptions() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var situations = response.data.situations;
        _this.SituationOptions.push({ text: 'All', value: 0 });
        _this.SituationOptions.push({ text: '--Primary Situations--', value: -6 });
        _this.SituationOptions.push({ text: 'Even Handed', value: -1 });
        _this.SituationOptions.push({ text: 'Power Play', value: -2 });
        _this.SituationOptions.push({ text: 'Short Handed', value: -3 });
        _this.SituationOptions.push({ text: 'Empty Net', value: -4 });
        _this.SituationOptions.push({ text: '--Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          _this.SituationOptions.push({ text: situations[s].secondary_situation, value: situations[s].id });
        }
        _this.CompetitionOptions.push({ text: 'All', value: 0 });
        _this.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this.PeriodOptions.push({ text: 'All', value: 0 });
        _this.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this.LimitOptions.push({ text: 'All', value: 0 });
        _this.LimitOptions.push({ text: '5 Games', value: 5 });
        _this.LimitOptions.push({ text: '10 Games', value: 10 });
        _this.LimitOptions.push({ text: '20 Games', value: 20 });
      });
    }
  },
  created: function created() {
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__embedded_data_graph_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__embedded_data_graph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__embedded_data_graph_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'graph-table': __WEBPACK_IMPORTED_MODULE_5__embedded_data_graph_vue___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      TypeOptions: [],
      ZoneOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      TypeSelected: '',
      ZoneSelected: '',
      LimitSelected: 0,
      FilterSelected: 'total',
      ExitFilterSelected: 'pass',
      ZoneEntriesAutoPlayerData: [],
      ZoneEntriesAutoPlayerHeadings: ['Player', 'GP', 'Controlled Success', 'Controlled Fail', 'Total Controlled', 'Uncontrolled Success', 'Uncontrolled Failed', 'Uncontrolled Dump', 'Offside', 'Total Unontrolled'],
      ZoneEntriesPlayerData: [],
      ZoneEntriesPlayerHeadings: ['Player', 'GP', 'Success', 'Success AVG', 'Success No Possesion', 'Success No Possesion AVG', 'Fail', 'Fail AVG', 'Total', 'Total AVG'],
      ZoneEntriesPlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'Success', value: 'success' }, { text: 'Success AVG', value: 'success_avg' }, { text: 'Success With Pos', value: 'success_with_pos' }, { text: 'Success With Pos AVG', value: 'success_with_pos_avg' }, { text: 'Fail', value: 'fail' }, { text: 'Fail AVG', value: 'fail_avg' }, { text: 'Total', value: 'total' }, { text: 'Total AVG', value: 'total_avg' }],
      ZoneExitPlayerData: [],
      ZoneExitPlayerHeadings: ['Player', 'GP', 'Success (PCD)', 'Pass', 'Carry', 'Dump', 'Clear W/Out Poss', 'Icing', 'Fail'],
      ZoneExitPlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'Pass', value: 'pass' }, { text: 'Carry', value: 'carry' }, { text: 'Dump', value: 'dump_success' }, { text: 'Clear With Pos AVG', value: 'clear' }, { text: 'Icing', value: 'icing' }],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      stacked_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          enabled: true
        },
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              autoSkip: false
            }
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              autoSkip: false
            }
          }]
        }
      },
      multi_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          enabled: true
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              stacked: true
            }
          }],
          yAxes: [{
            categoryPercentage: 0.76,
            barPercentage: 1,
            ticks: {
              autoSkip: false,
              stacked: true
            },
            gridLines: {
              offsetGridLines: true
            }
          }]
        }
      }
    };
  },

  computed: {
    sortByZoneEntriesData: function sortByZoneEntriesData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.ZoneEntriesPlayerData, 'total_success', ['desc']);
    },
    sortByZoneEntriesDataChart: function sortByZoneEntriesDataChart() {
      var orderedData = this.sortByZoneEntriesData;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    sortByZoneExitData: function sortByZoneExitData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.ZoneExitPlayerData, 'total_success', ['desc']);
    },
    sortByZoneExitDataChart: function sortByZoneExitDataChart() {
      var orderedData = this.ZoneExitPlayerData;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(orderedData, 'total_success');
    },
    sortByZoneEntriesAutoData: function sortByZoneEntriesAutoData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.ZoneEntriesAutoPlayerData, 'controlled_total', ['desc']);
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByZoneEntriesData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByZoneEntriesDataChart,
        label: 'Zone Entry - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    chartStackedData: function chartStackedData() {
      var playerLabels = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.sortByZoneExitData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var label = _step2.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var pass = [];
      var carry = [];
      var dumpWithPoss = [];
      var clear = [];
      var icing = [];
      var fail = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.sortByZoneExitData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var d = _step3.value;

          pass.push(d.pass);
          carry.push(d.carry);
          dumpWithPoss.push(d.dump_success);
          clear.push(d.clear);
          icing.push(-d.icing);
          fail.push(-d.fail);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: pass,
        label: 'Pass',
        backgroundColor: '#0077cf',
        borderColor: '#0077cf'
      }, {
        data: carry,
        label: 'Carry',
        backgroundColor: '#00a9e7',
        borderColor: '#00a9e7'
      }, {
        data: dumpWithPoss,
        label: 'Dump With Poss',
        backgroundColor: '#00d4df',
        borderColor: '#00d4df'
      }, {
        data: clear,
        label: 'Clear',
        backgroundColor: '#73fac9',
        borderColor: '#73fac9'
      }, {
        data: icing,
        label: 'Icing',
        backgroundColor: '#9a4e96',
        borderColor: '#9a4e96'
      }, {
        data: fail,
        label: 'Failed Exit',
        backgroundColor: '#a53169',
        borderColor: '#a53169'
      }];
      return data;
    },
    chartZoneEntriesData: function chartZoneEntriesData() {
      var playerLabels = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.sortByZoneEntriesAutoData[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var label = _step4.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var controlledSuccess = [];
      var controlledFailed = [];
      var controlledOffside = [];
      var uncontrolledSuccess = [];
      var uncontrolledFailed = [];
      var uncontrolledOffside = [];
      var uncontrolledDump = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.sortByZoneEntriesAutoData[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var d = _step5.value;

          controlledSuccess.push(d.controlled_success);
          controlledFailed.push(-d.controlled_failed);
          controlledOffside.push(d.controlled_offside);
          uncontrolledSuccess.push(d.uncontrolled_success);
          uncontrolledFailed.push(-d.uncontrolled_failed);
          uncontrolledOffside.push(-d.offside);
          uncontrolledDump.push(-d.uncontrolled_dump);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: controlledSuccess,
        label: 'Controlled Success',
        backgroundColor: '#0077cf',
        borderColor: '#0077cf',
        stack: 'Controlled'
      }, {
        data: controlledFailed,
        label: 'Controlled Failed',
        backgroundColor: '#00a9e7',
        borderColor: '#00a9e7',
        stack: 'Controlled'
      }, {
        data: uncontrolledSuccess,
        label: 'Uncontrolled Success',
        backgroundColor: '#ff9677',
        borderColor: '#ff9677',
        stack: 'Uncontrolled'
      }, {
        data: uncontrolledFailed,
        label: 'Uncontrolled Failed',
        backgroundColor: '#ff7298',
        borderColor: '#ff7298',
        stack: 'Uncontrolled'
      }, {
        data: uncontrolledOffside,
        label: 'Offside',
        backgroundColor: '#c765b3',
        borderColor: '#c765b3',
        stack: 'Uncontrolled'
      }, {
        data: uncontrolledDump,
        label: 'Uncontrolled Dump',
        backgroundColor: '#7263bb',
        borderColor: '#7263bb',
        stack: 'Uncontrolled'
      }];
      return data;
    }
  },
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'type': this.TypeSelected,
        'zone': this.ZoneSelected,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/zone-entries', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.ZoneEntriesPlayerData = response.data.zone_entries;
        _this.ZoneExitPlayerData = response.data.zone_exits;
        _this.ZoneEntriesAutoPlayerData = response.data.zone_entries_new;
        console.log(response.data.zone_exits);
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this2.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this2.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this2.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this2.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var situations = response.data.situations;
        _this2.SituationOptions.push({ text: 'All', value: 0 });
        _this2.SituationOptions.push({ text: 'Even Handed', value: 1 });
        _this2.SituationOptions.push({ text: 'Power Play', value: 2 });
        _this2.SituationOptions.push({ text: 'Short Handed', value: 3 });
        _this2.SituationOptions.push({ text: 'Empty Net', value: 4 });
        _this2.SituationOptions.push({ text: '-- N/A Yet - Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          //  this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
        }
        _this2.CompetitionOptions.push({ text: 'All', value: 0 });
        _this2.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this2.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this2.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this2.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this2.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this2.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });
        _this2.CompetitionOptions.push({ text: 'Test Data', value: 'Test-Season' });

        _this2.PeriodOptions.push({ text: 'All', value: 0 });
        _this2.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this2.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this2.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this2.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this2.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this2.LimitOptions.push({ text: 'All', value: 0 });
        _this2.LimitOptions.push({ text: '5 Games', value: 5 });
        _this2.LimitOptions.push({ text: '10 Games', value: 10 });
        _this2.LimitOptions.push({ text: '20 Games', value: 20 });

        _this2.TypeOptions.push({ text: 'All', value: '' });
        _this2.TypeOptions.push({ text: 'Carry', value: 'Carry' });
        _this2.TypeOptions.push({ text: 'Dump', value: 'Dump' });

        _this2.ZoneOptions.push({ text: 'All', value: '' });
        _this2.ZoneOptions.push({ text: 'Offensive', value: 'Offensive' });
        _this2.ZoneOptions.push({ text: 'Defensive Exit', value: 'DefensiveExit' });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__season_totals_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    'season-totals-menu': __WEBPACK_IMPORTED_MODULE_2__season_totals_menu___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 1,
      LimitSelected: 0,
      FilterSelected: 'Line',
      ZoneStartsPlayerData: [],
      ZoneStartsPlayerHeadings: ['Player', 'GP', 'Offensive', 'Neutral', 'Defensive', 'Offensive Avg', 'Neutral Avg', 'Defensive Avg', 'Offensive %', 'Neutral %', 'Defensive %', 'Offensive Rel %', 'Neutral Rel %', 'Defensive Rel %', 'Total'],
      ZoneStartsPlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'Offensive', value: 'offensive_total' }, { text: 'Neutral', value: 'neutral_total' }, { text: 'Defensive', value: 'defensive_total' }, { text: 'Offensive Average', value: 'offensive_avg' }, { text: 'Neutral Average', value: 'neutral_avg' }, { text: 'Defensive Average', value: 'defensive_avg' }, { text: 'Offensive %', value: 'offensive_percent' }, { text: 'Neutral %', value: 'neutral_percent' }, { text: 'Defensive %', value: 'defensive_percent' }, { text: 'Offensive Relative', value: 'offensive_rel' }, { text: 'Neutral Relative', value: 'neutral_rel' }, { text: 'Defensive Relative', value: 'defensive_rel' }, { text: 'Total', value: 'total' }, { text: 'Line', value: 'Line' }],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      lineOptions: {
        title: { display: false, text: 'Sessions By Platform' },
        scales: {
          xAxes: [{
            stacked: true,
            display: true,
            ticks: {
              autoSkip: false
            }
          }],
          yAxes: [{
            stacked: true,
            display: true
          }]
        },
        legend: {
          display: true,
          labels: {
            fontColor: 'rgb(255, 99, 132)'
          }
        }
      }
    };
  },

  computed: {
    sortByZoneStartsData: function sortByZoneStartsData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.ZoneStartsPlayerData, this.FilterSelected, ['desc']);
    },
    sortByZoneStartsDataChart: function sortByZoneStartsDataChart() {
      var orderedData = this.sortByZoneStartsData;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    sortLineData: function sortLineData() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.ZoneStartsPlayerData, ['defensive_percent', 'neutral_percent', 'offensive_percent'], ['asc', 'asc', 'asc']);
    },
    chartData: function chartData() {
      console.log(this.FilterSelected);
      if (this.FilterSelected === 'Line') {
        console.log('Doing line');
        var playerLabels = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.sortLineData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var lineLabel = _step.value;

            playerLabels.push(lineLabel.player);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var offensive = [];
        var neutral = [];
        var defensive = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.sortLineData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var d = _step2.value;

            offensive.push(d.offensive_percent);
            neutral.push(d.neutral_percent);
            defensive.push(d.defensive_percent);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var data = {
          labels: playerLabels
        };
        data.datsets = [];
        data.datasets = [{
          data: offensive,
          label: 'Offensive',
          backgroundColor: '#42c3ff',
          borderColor: '#42c3ff'
        }, {
          data: neutral,
          label: 'Neutral',
          backgroundColor: '#FEBC38',
          borderColor: '#FEBC38'
        }, {
          data: defensive,
          label: 'Defensive',
          backgroundColor: '#CA3542',
          borderColor: '#CA3542'
        }];
        return data;
      } else {
        var _playerLabels = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = this.sortByZoneStartsData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var label = _step3.value;

            _playerLabels.push(label.player);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var _data = {
          labels: _playerLabels
        };
        _data.datsets = [];
        _data.datasets = [{
          data: this.sortByZoneStartsDataChart,
          label: 'Zone Start - ' + this.FilterSelected,
          backgroundColor: 'rgba(54, 162, 235, 1)',
          borderColor: 'rgba(54, 162, 235, 1)'
        }];
        return _data;
      }
    }
  },
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'type': this.TypeSelected,
        'zone': this.ZoneSelected,
        'limit': this.LimitSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/zone-starts', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.GameFilter = response.data.games_filter;
        _this.ZoneStartsPlayerData = response.data.zone_starts;
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(response.data)
        var venue = response.data.venue;
        _this2.VenueOptions.push({ text: 'All', value: 0 });
        for (var i = 0; i < venue.length; i++) {
          _this2.VenueOptions.push({ text: venue[i].location, value: venue[i].location });
        }
        var opponent = response.data.teams;
        _this2.OpponentOptions.push({ text: 'All', value: 0 });
        for (var j = 0; j < opponent.length; j++) {
          if (opponent[j].id !== '1') {
            _this2.OpponentOptions.push({ text: opponent[j].name, value: opponent[j].id });
          }
        }
        var situations = response.data.situations;
        _this2.SituationOptions.push({ text: 'All', value: 0 });
        _this2.SituationOptions.push({ text: 'Even Handed', value: 1 });
        _this2.SituationOptions.push({ text: 'Power Play', value: 2 });
        _this2.SituationOptions.push({ text: 'Short Handed', value: 3 });
        _this2.SituationOptions.push({ text: 'Empty Net', value: 4 });
        _this2.SituationOptions.push({ text: '-- N/A Yet - Secondary Situations--', value: -5 });
        for (var s = 0; s < situations.length; s++) {
          //  this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
        }
        _this2.CompetitionOptions.push({ text: 'All', value: 0 });
        _this2.CompetitionOptions.push({ text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup' });
        _this2.CompetitionOptions.push({ text: 'EIHL', value: 'EIHL' });
        _this2.CompetitionOptions.push({ text: 'Challenge Cup', value: 'Challenge-Cup' });
        _this2.CompetitionOptions.push({ text: 'Pre-Season', value: 'Pre-Season' });
        _this2.CompetitionOptions.push({ text: 'Playoffs', value: 'Playoffs' });
        _this2.CompetitionOptions.push({ text: 'CHL', value: 'CHL' });

        _this2.PeriodOptions.push({ text: 'All', value: 0 });
        _this2.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this2.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this2.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this2.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this2.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this2.LimitOptions.push({ text: 'All', value: 0 });
        _this2.LimitOptions.push({ text: '5 Games', value: 5 });
        _this2.LimitOptions.push({ text: '10 Games', value: 10 });
        _this2.LimitOptions.push({ text: '20 Games', value: 20 });
      });
    }
  },
  created: function created() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['defaultShow', 'home_name', 'away_name', 'gameId'],
  components: {
    Chart: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs___default.a
  },
  computed: {
    getShotDataHome: function getShotDataHome() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.ShotData, 'home_diff');
    },
    getShotDataAway: function getShotDataAway() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.ShotData, 'away_diff');
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.ShotData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.index);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.getShotDataHome,
        label: this.home_name,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)',
        pointBackgroundColor: 'rgba(0,0,0,1)',
        lineTension: 0,
        fill: this.fillOption
      }, {
        data: this.getShotDataAway,
        label: this.away_name,
        backgroundColor: 'rgba(255, 206, 86, 1)',
        pointBackgroundColor: 'rgba(0,0,0,1)',
        borderColor: 'rgba(255, 206, 86, 1)',
        lineTension: 0,
        fill: this.fillOption
      }];
      return data;
    }
  },
  data: function data() {
    return {
      show: true,
      ShotData: [],
      fillOption: false,
      toggleDifferential: false,
      headers: ['Time', '+', '-', '+/-'],
      interval: 1,
      lines: {
        type: 'line',
        mode: 'vertical',
        scaleID: 'x-axis-0',
        value: '00:40:00',
        borderColor: 'red',
        label: {
          content: '3',
          enabled: true,
          position: 'top'
        }
      },
      line_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        annotation: {
          annotations: []
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    };
  },

  methods: {
    fetchShots: function fetchShots() {
      var _this = this;

      console.log('Get shot diff time: diff is: ' + this.toggleDifferential);
      this.$http.get('https://devilsapi.roblutken.com/api/app/get/match-stats/shot-differentials-time/' + this.gameId + '/0/' + this.interval + '/' + this.toggleDifferential, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Faceoff Data is ' + response.data)
        _this.ShotData = response.data.raw;
        var lineData = response.data.annotations;
        for (var i = 0; i < lineData.length; i++) {
          _this.line_options.annotation.annotations.push(lineData[i]);
        }
        console.log(_this.line_options);
        // console.log(JSON.stringify(this.Faceoffs))
      }, function (response) {});
    }
  },
  created: function created() {
    if (this.defaultShow) {
      this.show = true;
    }
    console.log('Shot-diff-time: game id - ' + this.gameId);
    this.fetchShots();
    // console.log('Edit Table Data is: ' + this.total)
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['defaultShow', 'home_name', 'away_name'],
  components: {
    'simpleheat': __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default.a,
    'simpleshot': __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  data: function data() {
    return {
      show: true,
      gameId: 1,
      SituationOptions: [],
      PeriodOptions: [],
      PeriodSelected: 0,
      SituationSelected: 0,
      HomePlayers: [],
      AwayPlayers: [],
      HomeTeamOptions: [],
      HomeSelection: 0,
      AwayTeamOptions: [],
      AwaySelection: 0,
      ShotTypeSelected: 0,
      ShotTypeOptions: [],
      RadiusSelected: 15,
      BlurSelected: 40,
      UseHeatmap: false,
      UseShotZones: false,
      UseShotZonesText: true,
      HomeMultiSelect: [],
      AwayMultiSelect: []
    };
  },
  computed: {
    sortHomePlayers: function sortHomePlayers() {
      return this.HomePlayers.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    },
    sortAwayPlayers: function sortAwayPlayers() {
      return this.AwayPlayers.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    }
  },
  methods: {
    renderShotZones: function renderShotZones(canvas, shotData) {
      /*eslint-disable */
      var ctx = canvas.getContext('2d');
      var testColor = 'rgba(250, 1, 1, 0.02)';

      var redZoneColour = 'rgba(250, 1, 1, 0.22)';
      var colour = 'rgba(254, 254, 254, 0.22)';
      var centerPos = [105, 76, 205, 170];

      var outsideZonePos = [0, 360, 590, 140];

      var behindNetPos = [0, 0, 590, 75];

      var leftOutsidePos = [0, 76, 105, 170];

      var rightOutsidePos = [310, 76, 155, 170];

      var leftPointInit = [0, 245];
      var leftPointLines = [{ x: 0, y: 245 }, { x: 105, y: 245 }, { x: 130, y: 360 }, { x: 0, y: 360 }, { x: 0, y: 0 }];

      var centerPointInit = [105, 245];
      var centerPointLines = [{ x: 105, y: 245 }, { x: 310, y: 245 }, { x: 280, y: 360 }, { x: 130, y: 360 }, { x: 105, y: 245 }];

      var rightPointInit = [420, 245];
      var rightPointLines = [{ x: 420, y: 245 }, { x: 310, y: 245 }, { x: 280, y: 360 }, { x: 420, y: 360 }, { x: 420, y: 370 }];

      this.drawRect(ctx, colour, outsideZonePos, '12px', 1);
      this.drawRect(ctx, colour, behindNetPos);
      this.drawRect(ctx, colour, leftOutsidePos);
      this.drawRect(ctx, colour, rightOutsidePos);
      this.drawRect(ctx, redZoneColour, centerPos);
      this.drawCustom(ctx, colour, leftPointInit, leftPointLines);
      this.drawCustom(ctx, colour, centerPointInit, centerPointLines);
      this.drawCustom(ctx, colour, rightPointInit, rightPointLines);

      var leftOTCount = 0;
      var rightOTCount = 0;
      var centerCount = 0;
      var behindCount = 0;
      var leftPointCount = 0;
      var rightPointCount = 0;
      var centerPointCount = 0;
      var outsideZoneCount = 0;
      var redZoneCount = 0;
      var behindNetCount = 0;
      var totalShots = 0;
      console.log(JSON.stringify(shotData));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = shotData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var shot = _step.value;

          // let s = JSON.parse(shot.shot_location)
          totalShots++;
          // Left Outside Count         let leftOutsidePos = [0, 76, 105, 170]
          if (shot[0] >= 0.0 && shot[0] <= 105.0 && shot[1] > 76.0 && shot[1] < 246) {
            // console.log('Shot found: ' + shot[0]  + ' '  + shot[1])
            leftOTCount++;
          }
          // Right Outside Count         [310, 76, 155, 170]
          if (shot[0] >= 312 && shot[0] <= 476 && shot[1] > 76.0 && shot[1] < 246) {
            // console.log('Shot found: ' + shot[0]  + ' '  + shot[1])
            rightOTCount++;
          }
          // Cneter Count         [105, 76, 205, 170]
          //  this.drawRect(ctx, testColor, [105, 76, 205, 170])
          if (shot[0] >= 105 && shot[0] <= 310 && shot[1] > 76.0 && shot[1] < 246) {
            redZoneCount++;
          }
          //{x: 0, y: 245}, {x: 105, y: 245}, {x: 160, y: 360}, {x: 0, y: 360}, {x: 0, y: 370}
          // let leftPointLines = [{x: 0, y: 245}, {x: 105, y: 245}, {x: 130, y: 360}, {x: 0, y: 360}, {x: 0, y: 0}]
          // this.drawCustom(ctx, testColor, leftPointInit, leftPointLines)
          if (shot[0] >= 0 && shot[0] <= 115.0 && shot[1] > 245 && shot[1] < 360) {
            leftPointCount++;
          }
          // Right Point  [{x: 420, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 420, y: 360}, {x: 420, y: 370}]
          if (shot[0] >= 280 && shot[0] <= 420 && shot[1] > 245 && shot[1] < 360) {
            rightPointCount++;
          }
          // Center Point  [{x: 105, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 130, y: 360}, {x: 105, y: 245}]
          if (shot[0] >= 116.0 && shot[0] <= 270.0 && shot[1] > 245 && shot[1] < 360) {
            centerPointCount++;
          }
          // Outside Zone  [0, 360, 590, 140]
          if (shot[0] >= 0 && shot[0] <= 420 && shot[1] > 360.1 && shot[1] < 590.0) {
            outsideZoneCount++;
          }
          // Behind Net  [0, 0, 590, 75]
          if (shot[0] >= 0 && shot[0] <= 420 && shot[1] > 0 && shot[1] < 75.0) {
            behindNetCount++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.UseShotZonesText) {
        this.drawText(ctx, leftOTCount + ' ' + (leftOTCount / totalShots * 100).toPrecision(2) + '%', [40, 100], '18px');
        this.drawText(ctx, rightOTCount + ' ' + (rightOTCount / totalShots * 100).toPrecision(2) + '%', [340, 100], '18px');
        this.drawText(ctx, redZoneCount + ' ' + (redZoneCount / totalShots * 100).toPrecision(2) + '%', [180, 95], '18px', 'black');
        this.drawText(ctx, leftPointCount + ' ' + (leftPointCount / totalShots * 100).toPrecision(2) + '%', [40, 270], '18px');
        this.drawText(ctx, rightPointCount + ' ' + (rightPointCount / totalShots * 100).toPrecision(2) + '%', [340, 270], '18px');
        this.drawText(ctx, centerPointCount + ' ' + (centerPointCount / totalShots * 100).toPrecision(2) + '%', [190, 270], '18px');
        this.drawText(ctx, outsideZoneCount + ' ' + (outsideZoneCount / totalShots * 100).toPrecision(2) + '%', [190, 390], '18px');
        this.drawText(ctx, behindNetCount + ' ' + (behindNetCount / totalShots * 100).toPrecision(2) + '%', [190, 30], '18px');
      }
    },
    drawRect: function drawRect(ctx, color, position, text, textPos) {
      var fontSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '26px';
      var lineWidth = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 3;

      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = '#FFFFFF';
      ctx.shadowOffsetX = ctx.shadowOffsetY = .0;
      ctx.shadowBlur = .2;
      ctx.shadowColor = 'rgb(1, 1, 1)';
      ctx.lineWidth = lineWidth;
      ctx.fillRect(position[0], position[1], position[2], position[3]);
      ctx.strokeRect(position[0], position[1], position[2], position[3]);
      ctx.closePath();
    },
    drawText: function drawText(ctx, text, textPosition) {
      var textSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '26px';
      var colour = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'rgba(0,0,0,1)';

      ctx.beginPath();
      ctx.font = textSize + ' sans-serif';
      ctx.fillStyle = colour;
      ctx.fillText(text, textPosition[0], textPosition[1]);
      ctx.closePath();
    },
    drawCustom: function drawCustom(ctx, color, initPos, movePoints) {
      ctx.beginPath();
      ctx.fillStyle = color;
      // ctx.strokeStyle = 'white'
      ctx.moveTo(initPos[0], initPos[1]);
      // Loop over move points
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = movePoints[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var prop = _step2.value;

          ctx.lineTo(prop.x, prop.y);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      ctx.fill();
      ctx.stroke();
      ctx.closePath();
    },
    renderHeatmap: function renderHeatmap() {
      var homeShotsCanvas = this.$refs.home_shot_canvas;
      var homeShots = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.PlayerShotmapData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var shots = _step3.value;

          var shot = JSON.parse(shots.shot_location);
          shot[0] = homeShotsCanvas.width / 600.0 * shot[0];
          shot[1] = homeShotsCanvas.height / 530.0 * shot[1];
          if (this.UseHeatmap === false) {
            if (shots.shot_type === 'OnNet') {
              shot[4] = 'rgb(180, 8, 8)';
              shot[3] = 5;
            } else if (shots.shot_type === 'MissedNet') {
              shot[4] = 'rgba(95, 93, 93)';
              shot[3] = 3;
            } else if (shots.shot_type === 'Blocked') {
              shot[4] = 'rgba(20, 23, 81)';
              shot[3] = 3;
            } else if (shots.shot_type === 'Goal') {
              shot[4] = 'rgb(31, 239, 0)';
              shot[3] = 6;
            } else {
              shot[4] = 'White';
            }
          }
          homeShots.push(shot);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (this.UseHeatmap === true) {
        console.log(homeShots);
        var homeHeatmap = __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default()(homeShotsCanvas).data(homeShots);
        homeHeatmap.radius(this.RadiusSelected, this.BlurSelected);
        homeHeatmap.draw();
      } else {
        homeHeatmap = __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot___default()(homeShotsCanvas).data(homeShots);
        homeHeatmap.render();
      }
      if (this.UseShotZones) {
        this.renderShotZones(homeShotsCanvas, homeShots);
      }
    },
    filterPlayers: function filterPlayers(selectResult) {
      var players = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = selectResult[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var p = _step4.value;

          if (p.id === 0) {
            return 0;
          } else {
            players.push(p.id);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return JSON.stringify(players);
    },
    fetchShotmap: function fetchShotmap() {
      var _this = this;

      var postData = {
        'situation': 2,
        'player': this.player,
        'team_id': 1,
        'shot_type': this.ShotTypeSelected,
        'year': 2019,
        'competition': 'EIHL_Challenge_Cup'
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/player-stats/shotmap', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.PlayerShotmapData = response.data.player_shots;
        _this.renderHeatmap();
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this2.SituationOptions.push({ text: 'All', value: 0 });
        _this2.SituationOptions.push({ text: 'Even Handed', value: 1 });
        _this2.SituationOptions.push({ text: 'Power Play', value: 2 });
        _this2.SituationOptions.push({ text: 'Short Handed', value: 3 });
        _this2.SituationOptions.push({ text: 'Empty Net', value: 4 });

        _this2.PeriodOptions.push({ text: 'All', value: 0 });
        _this2.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this2.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this2.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this2.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this2.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this2.ShotTypeOptions.push({ text: 'All', value: 0 });
        _this2.ShotTypeOptions.push({ text: 'On Net', value: 'OnNet' });
        _this2.ShotTypeOptions.push({ text: 'Off Target', value: 'MissedNet' });
        _this2.ShotTypeOptions.push({ text: 'Blocked', value: 'Blocked' });
        _this2.ShotTypeOptions.push({ text: 'Goal', value: 'Goal' });
      });
    }
  },
  mounted: function mounted() {
    if (this.defaultShow) {
      this.show = true;
    }
    this.player = this.$route.params.player_id;
    this.fetchShotmap();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['defaultShow', 'home_name', 'away_name', 'opponent', 'venue', 'competition', 'year', 'home_id', 'away_id'],
  components: {
    'simpleheat': __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default.a,
    'simpleshot': __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  data: function data() {
    return {
      show: true,
      gameId: 0,
      SituationOptions: [],
      SituationSelected: 0,
      HomePlayers: [],
      AwayPlayers: [],
      HomeTeamOptions: [],
      HomeSelection: 0,
      AwayTeamOptions: [],
      AwaySelection: 0,
      ShotTypeSelected: 0,
      ShotTypeOptions: [],
      RadiusSelected: 15,
      BlurSelected: 40,
      UseHeatmap: false,
      UseShotZones: false,
      UseShotZonesText: true,
      HomeMultiSelect: [],
      AwayMultiSelect: []
    };
  },
  computed: {
    sortHomePlayers: function sortHomePlayers() {
      return this.HomePlayers.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    },
    sortAwayPlayers: function sortAwayPlayers() {
      return this.AwayPlayers.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    }
  },
  methods: {
    renderShotZones: function renderShotZones(canvas, shotData) {
      /*eslint-disable */
      var ctx = canvas.getContext('2d');
      var testColor = 'rgba(250, 1, 1, 0.02)';

      var redZoneColour = 'rgba(250, 1, 1, 0.22)';
      var colour = 'rgba(254, 254, 254, 0.22)';
      var centerPos = [105, 76, 205, 170];

      var outsideZonePos = [0, 360, 590, 140];

      var behindNetPos = [0, 0, 590, 75];

      var leftOutsidePos = [0, 76, 105, 170];

      var rightOutsidePos = [310, 76, 155, 170];

      var leftPointInit = [0, 245];
      var leftPointLines = [{ x: 0, y: 245 }, { x: 105, y: 245 }, { x: 130, y: 360 }, { x: 0, y: 360 }, { x: 0, y: 0 }];

      var centerPointInit = [105, 245];
      var centerPointLines = [{ x: 105, y: 245 }, { x: 310, y: 245 }, { x: 280, y: 360 }, { x: 130, y: 360 }, { x: 105, y: 245 }];

      var rightPointInit = [420, 245];
      var rightPointLines = [{ x: 420, y: 245 }, { x: 310, y: 245 }, { x: 280, y: 360 }, { x: 420, y: 360 }, { x: 420, y: 370 }];

      this.drawRect(ctx, colour, outsideZonePos, '12px', 1);
      this.drawRect(ctx, colour, behindNetPos);
      this.drawRect(ctx, colour, leftOutsidePos);
      this.drawRect(ctx, colour, rightOutsidePos);
      this.drawRect(ctx, redZoneColour, centerPos);
      this.drawCustom(ctx, colour, leftPointInit, leftPointLines);
      this.drawCustom(ctx, colour, centerPointInit, centerPointLines);
      this.drawCustom(ctx, colour, rightPointInit, rightPointLines);

      var leftOTCount = 0;
      var rightOTCount = 0;
      var centerCount = 0;
      var behindCount = 0;
      var leftPointCount = 0;
      var rightPointCount = 0;
      var centerPointCount = 0;
      var outsideZoneCount = 0;
      var redZoneCount = 0;
      var behindNetCount = 0;
      var totalShots = 0;
      console.log(JSON.stringify(shotData));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = shotData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var shot = _step.value;

          // let s = JSON.parse(shot.shot_location)
          totalShots++;
          // Left Outside Count         let leftOutsidePos = [0, 76, 105, 170]
          if (shot[0] >= 0.0 && shot[0] <= 105.0 && shot[1] > 76.0 && shot[1] < 246) {
            // console.log('Shot found: ' + shot[0]  + ' '  + shot[1])
            leftOTCount++;
          }
          // Right Outside Count         [310, 76, 155, 170]
          if (shot[0] >= 312 && shot[0] <= 476 && shot[1] > 76.0 && shot[1] < 246) {
            // console.log('Shot found: ' + shot[0]  + ' '  + shot[1])
            rightOTCount++;
          }
          // Cneter Count         [105, 76, 205, 170]
          //  this.drawRect(ctx, testColor, [105, 76, 205, 170])
          if (shot[0] >= 105 && shot[0] <= 310 && shot[1] > 76.0 && shot[1] < 246) {
            redZoneCount++;
          }
          //{x: 0, y: 245}, {x: 105, y: 245}, {x: 160, y: 360}, {x: 0, y: 360}, {x: 0, y: 370}
          // let leftPointLines = [{x: 0, y: 245}, {x: 105, y: 245}, {x: 130, y: 360}, {x: 0, y: 360}, {x: 0, y: 0}]
          // this.drawCustom(ctx, testColor, leftPointInit, leftPointLines)
          if (shot[0] >= 0 && shot[0] <= 115.0 && shot[1] > 245 && shot[1] < 360) {
            leftPointCount++;
          }
          // Right Point  [{x: 420, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 420, y: 360}, {x: 420, y: 370}]
          if (shot[0] >= 280 && shot[0] <= 420 && shot[1] > 245 && shot[1] < 360) {
            rightPointCount++;
          }
          // Center Point  [{x: 105, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 130, y: 360}, {x: 105, y: 245}]
          if (shot[0] >= 116.0 && shot[0] <= 270.0 && shot[1] > 245 && shot[1] < 360) {
            centerPointCount++;
          }
          // Outside Zone  [0, 360, 590, 140]
          if (shot[0] >= 0 && shot[0] <= 420 && shot[1] > 360.1 && shot[1] < 590.0) {
            outsideZoneCount++;
          }
          // Behind Net  [0, 0, 590, 75]
          if (shot[0] >= 0 && shot[0] <= 420 && shot[1] > 0 && shot[1] < 75.0) {
            behindNetCount++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.UseShotZonesText) {
        this.drawText(ctx, leftOTCount + ' ' + (leftOTCount / totalShots * 100).toPrecision(2) + '%', [40, 100], '18px');
        this.drawText(ctx, rightOTCount + ' ' + (rightOTCount / totalShots * 100).toPrecision(2) + '%', [340, 100], '18px');
        this.drawText(ctx, redZoneCount + ' ' + (redZoneCount / totalShots * 100).toPrecision(2) + '%', [180, 95], '18px', 'black');
        this.drawText(ctx, leftPointCount + ' ' + (leftPointCount / totalShots * 100).toPrecision(2) + '%', [40, 270], '18px');
        this.drawText(ctx, rightPointCount + ' ' + (rightPointCount / totalShots * 100).toPrecision(2) + '%', [340, 270], '18px');
        this.drawText(ctx, centerPointCount + ' ' + (centerPointCount / totalShots * 100).toPrecision(2) + '%', [190, 270], '18px');
        this.drawText(ctx, outsideZoneCount + ' ' + (outsideZoneCount / totalShots * 100).toPrecision(2) + '%', [190, 390], '18px');
        this.drawText(ctx, behindNetCount + ' ' + (behindNetCount / totalShots * 100).toPrecision(2) + '%', [190, 30], '18px');
      }
    },
    drawRect: function drawRect(ctx, color, position, text, textPos) {
      var fontSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '26px';
      var lineWidth = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 3;

      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = '#FFFFFF';
      ctx.shadowOffsetX = ctx.shadowOffsetY = .0;
      ctx.shadowBlur = .2;
      ctx.shadowColor = 'rgb(1, 1, 1)';
      ctx.lineWidth = lineWidth;
      ctx.fillRect(position[0], position[1], position[2], position[3]);
      ctx.strokeRect(position[0], position[1], position[2], position[3]);
      ctx.closePath();
    },
    drawText: function drawText(ctx, text, textPosition) {
      var textSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '26px';
      var colour = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'rgba(0,0,0,1)';

      ctx.beginPath();
      ctx.font = textSize + ' sans-serif';
      ctx.fillStyle = colour;
      ctx.fillText(text, textPosition[0], textPosition[1]);
      ctx.closePath();
    },
    drawCustom: function drawCustom(ctx, color, initPos, movePoints) {
      ctx.beginPath();
      ctx.fillStyle = color;
      // ctx.strokeStyle = 'white'
      ctx.moveTo(initPos[0], initPos[1]);
      // Loop over move points
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = movePoints[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var prop = _step2.value;

          ctx.lineTo(prop.x, prop.y);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      ctx.fill();
      ctx.stroke();
      ctx.closePath();
    },
    renderHeatmap: function renderHeatmap() {
      var homeShotsCanvas = this.$refs.home_shot_canvas;
      var awayShotsCanvas = this.$refs.away_shot_canvas;
      var homeShots = [];
      var awayShots = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.HomeShotmapData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var shots = _step3.value;

          var shot = JSON.parse(shots.shot_location);
          shot[0] = homeShotsCanvas.width / 600.0 * parseInt(shot[0], 10);
          shot[1] = homeShotsCanvas.height / 530.0 * parseInt(shot[1], 10);
          if (this.UseHeatmap === false) {
            if (shots.shot_type === 'OnNet') {
              shot[4] = 'rgb(180, 8, 8)';
              shot[3] = 5;
            } else if (shots.shot_type === 'MissedNet') {
              shot[4] = 'rgba(95, 93, 93)';
              shot[3] = 3;
            } else if (shots.shot_type === 'Blocked') {
              shot[4] = 'rgba(20, 23, 81)';
              shot[3] = 3;
            } else if (shots.shot_type === 'Goal') {
              shot[4] = 'rgb(31, 239, 0)';
              shot[3] = 6;
            } else {
              shot[4] = 'White';
            }
          }
          homeShots.push(shot);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.AwayShotmapData[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          shots = _step4.value;

          var _shot = JSON.parse(shots.shot_location);
          _shot[0] = awayShotsCanvas.width / 600.0 * _shot[0];
          _shot[1] = awayShotsCanvas.height / 530.0 * _shot[1];
          if (this.UseHeatmap === false) {
            if (shots.shot_type === 'OnNet') {
              _shot[4] = 'rgb(180, 8, 8)';
              _shot[3] = 5;
            } else if (shots.shot_type === 'MissedNet') {
              _shot[4] = 'rgba(95, 93, 93)';
              _shot[3] = 3;
            } else if (shots.shot_type === 'Blocked') {
              _shot[4] = 'rgba(20, 23, 81)';
              _shot[3] = 3;
            } else if (shots.shot_type === 'Goal') {
              _shot[4] = 'rgb(31, 239, 0)';
              _shot[3] = 6;
            } else {
              _shot[4] = 'White';
            }
          }
          awayShots.push(_shot);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (this.UseHeatmap === true) {
        var homeHeatmap = __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default()(homeShotsCanvas).data(homeShots);
        homeHeatmap.radius(this.RadiusSelected, this.BlurSelected);
        homeHeatmap.draw();

        var awayHeatmap = __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default()(awayShotsCanvas).data(awayShots);
        awayHeatmap.radius(this.RadiusSelected, this.BlurSelected);
        awayHeatmap.draw();
      } else {
        homeHeatmap = __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot___default()(homeShotsCanvas).data(homeShots);
        homeHeatmap.render();

        awayHeatmap = __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot___default()(awayShotsCanvas).data(awayShots);
        awayHeatmap.render();
      }
      if (this.UseShotZones) {
        this.renderShotZones(homeShotsCanvas, homeShots);
        this.renderShotZones(awayShotsCanvas, awayShots);
      }
    },
    filterPlayers: function filterPlayers(selectResult) {
      var players = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = selectResult[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var p = _step5.value;

          if (p.id === 0) {
            return 0;
          } else {
            players.push(p.id);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return JSON.stringify(players);
    },
    fetchShotmap: function fetchShotmap() {
      var _this = this;

      var postData = {
        'id': this.gameId,
        'period': this.PeriodSelected,
        'situation': this.SituationSelected,
        'home_player': this.filterPlayers(this.HomeMultiSelect),
        'away_player': this.filterPlayers(this.AwayMultiSelect),
        'shot_type': this.ShotTypeSelected,
        'opponent': this.opponent,
        'venue': this.venue,
        'competition': this.competition,
        'year': this.year,
        'home_id': this.home_id,
        'away_id': this.away_id
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/team-shotmap/', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.HomeShotmapData = response.data.home_shots;
        _this.AwayShotmapData = response.data.away_shots;
        _this.renderHeatmap();
      }, function (response) {});
    },
    fetchPlayers: function fetchPlayers() {
      // this.$http.get('https://devilsapi.roblutken.com/api/app/get/players/shots/' + this.gameId, {
      //   headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      // }).then(
      //   response => {
      //     // console.log(JSON.stringify(response.data))
      //     this.HomePlayers = response.data.home_players
      //     this.AwayPlayers = response.data.away_players
      //     // console.log(JSON.stringify(this.HomePlayers))
      //     this.HomeTeamOptions.push({ text: 'All', id: 0 })
      //     this.AwayTeamOptions.push({ text: 'All', id: 0 })

      //     this.HomeTeamOptions.push({ text: 'Forwards', id: 0 })
      //     for (var i of this.sortHomePlayers) {
      //       if (i.position === 'LW' || i.position === 'C' || i.position === 'RW') {
      //         if (i.number > 0) {
      //           this.HomeTeamOptions.push({ text: i.number + ' ' + i.surname, id: i.id })
      //         }
      //       }
      //     }
      //     this.HomeTeamOptions.push({ text: 'Defense', id: -7 })
      //     for (var d of this.sortHomePlayers) {
      //       if (d.position === 'LD' || d.position === 'RD') {
      //         this.HomeTeamOptions.push({ text: d.number + ' ' + d.surname, id: d.id })
      //       }
      //     }
      //     this.AwayTeamOptions.push({ text: 'Forwards', id: -2 })
      //     for (var af of this.sortAwayPlayers) {
      //       if (af.position === 'LW' || af.position === 'C' || af.position === 'RW') {
      //         if (af.number > 0) {
      //           this.AwayTeamOptions.push({ text: af.number + ' ' + af.surname, id: af.id })
      //         }
      //       }
      //     }
      //     this.AwayTeamOptions.push({ text: 'Defense', value: -3 })
      //     for (var ad of this.sortAwayPlayers) {
      //       if (ad.position === 'LD' || ad.position === 'RD') {
      //         this.AwayTeamOptions.push({ text: ad.number + ' ' + ad.surname, id: ad.id })
      //       }
      //     }
      //   })
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this2.SituationOptions.push({ text: 'All', value: 0 });
        _this2.SituationOptions.push({ text: 'Even Handed', value: 1 });
        _this2.SituationOptions.push({ text: 'Power Play', value: 2 });
        _this2.SituationOptions.push({ text: 'Short Handed', value: 3 });
        _this2.SituationOptions.push({ text: 'Empty Net', value: 4 });

        _this2.ShotTypeOptions.push({ text: 'All', value: 0 });
        _this2.ShotTypeOptions.push({ text: 'On Net', value: 'OnNet' });
        _this2.ShotTypeOptions.push({ text: 'Off Target', value: 'MissedNet' });
        _this2.ShotTypeOptions.push({ text: 'Blocked', value: 'Blocked' });
        _this2.ShotTypeOptions.push({ text: 'Goal', value: 'Goal' });
      });
    }
  },
  mounted: function mounted() {
    if (this.defaultShow) {
      this.show = true;
    }
    console.log(this.opponent);
    this.fetchShotmap();
    this.fetchPlayers();
    this.fetchFilterOptions();
  },

  watch: {
    opponent: function opponent(val) {
      this.fetchShotmap();
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['defaultShow', 'home_name', 'away_name', 'gameId'],
  components: {
    'simpleheat': __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default.a,
    'simpleshot': __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  data: function data() {
    return {
      show: true,
      SituationOptions: [],
      PeriodOptions: [],
      PeriodSelected: 0,
      SituationSelected: 0,
      HomePlayers: [],
      AwayPlayers: [],
      HomeTeamOptions: [],
      HomeSelection: 0,
      AwayTeamOptions: [],
      AwaySelection: 0,
      ShotTypeSelected: 0,
      ShotTypeOptions: [],
      RadiusSelected: 15,
      BlurSelected: 40,
      UseHeatmap: false,
      UseShotZones: false,
      UseShotZonesText: true,
      HomeMultiSelect: [],
      AwayMultiSelect: []
    };
  },
  computed: {
    sortHomePlayers: function sortHomePlayers() {
      return this.HomePlayers.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    },
    sortAwayPlayers: function sortAwayPlayers() {
      return this.AwayPlayers.slice().sort(function (a, b) {
        return a.number - b.number;
      });
    }
  },
  methods: {
    renderShotZones: function renderShotZones(canvas, shotData) {
      /*eslint-disable */
      var ctx = canvas.getContext('2d');
      var testColor = 'rgba(250, 1, 1, 0.02)';

      var redZoneColour = 'rgba(250, 1, 1, 0.22)';
      var colour = 'rgba(254, 254, 254, 0.22)';
      var centerPos = [105, 76, 205, 170];

      var outsideZonePos = [0, 360, 590, 140];

      var behindNetPos = [0, 0, 590, 75];

      var leftOutsidePos = [0, 76, 105, 170];

      var rightOutsidePos = [310, 76, 155, 170];

      var leftPointInit = [0, 245];
      var leftPointLines = [{ x: 0, y: 245 }, { x: 105, y: 245 }, { x: 130, y: 360 }, { x: 0, y: 360 }, { x: 0, y: 0 }];

      var centerPointInit = [105, 245];
      var centerPointLines = [{ x: 105, y: 245 }, { x: 310, y: 245 }, { x: 280, y: 360 }, { x: 130, y: 360 }, { x: 105, y: 245 }];

      var rightPointInit = [420, 245];
      var rightPointLines = [{ x: 420, y: 245 }, { x: 310, y: 245 }, { x: 280, y: 360 }, { x: 420, y: 360 }, { x: 420, y: 370 }];

      this.drawRect(ctx, colour, outsideZonePos, '12px', 1);
      this.drawRect(ctx, colour, behindNetPos);
      this.drawRect(ctx, colour, leftOutsidePos);
      this.drawRect(ctx, colour, rightOutsidePos);
      this.drawRect(ctx, redZoneColour, centerPos);
      this.drawCustom(ctx, colour, leftPointInit, leftPointLines);
      this.drawCustom(ctx, colour, centerPointInit, centerPointLines);
      this.drawCustom(ctx, colour, rightPointInit, rightPointLines);

      var leftOTCount = 0;
      var rightOTCount = 0;
      var centerCount = 0;
      var behindCount = 0;
      var leftPointCount = 0;
      var rightPointCount = 0;
      var centerPointCount = 0;
      var outsideZoneCount = 0;
      var redZoneCount = 0;
      var behindNetCount = 0;
      var totalShots = 0;
      // console.log(JSON.stringify(shotData))
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = shotData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var shot = _step.value;

          // let s = JSON.parse(shot.shot_location)
          totalShots++;
          // Left Outside Count         let leftOutsidePos = [0, 76, 105, 170]
          if (shot[0] >= 0.0 && shot[0] <= 105.0 && shot[1] > 76.0 && shot[1] < 246) {
            // console.log('Shot found: ' + shot[0]  + ' '  + shot[1])
            leftOTCount++;
          }
          // Right Outside Count         [310, 76, 155, 170]
          if (shot[0] >= 312 && shot[0] <= 476 && shot[1] > 76.0 && shot[1] < 246) {
            // console.log('Shot found: ' + shot[0]  + ' '  + shot[1])
            rightOTCount++;
          }
          // Cneter Count         [105, 76, 205, 170]
          //  this.drawRect(ctx, testColor, [105, 76, 205, 170])
          if (shot[0] >= 105 && shot[0] <= 310 && shot[1] > 76.0 && shot[1] < 246) {
            redZoneCount++;
          }
          //{x: 0, y: 245}, {x: 105, y: 245}, {x: 160, y: 360}, {x: 0, y: 360}, {x: 0, y: 370}
          // let leftPointLines = [{x: 0, y: 245}, {x: 105, y: 245}, {x: 130, y: 360}, {x: 0, y: 360}, {x: 0, y: 0}]
          // this.drawCustom(ctx, testColor, leftPointInit, leftPointLines)
          if (shot[0] >= 0 && shot[0] <= 115.0 && shot[1] > 245 && shot[1] < 360) {
            leftPointCount++;
          }
          // Right Point  [{x: 420, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 420, y: 360}, {x: 420, y: 370}]
          if (shot[0] >= 280 && shot[0] <= 420 && shot[1] > 245 && shot[1] < 360) {
            rightPointCount++;
          }
          // Center Point  [{x: 105, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 130, y: 360}, {x: 105, y: 245}]
          if (shot[0] >= 116.0 && shot[0] <= 270.0 && shot[1] > 245 && shot[1] < 360) {
            centerPointCount++;
          }
          // Outside Zone  [0, 360, 590, 140]
          if (shot[0] >= 0 && shot[0] <= 420 && shot[1] > 360.1 && shot[1] < 590.0) {
            outsideZoneCount++;
          }
          // Behind Net  [0, 0, 590, 75]
          if (shot[0] >= 0 && shot[0] <= 420 && shot[1] > 0 && shot[1] < 75.0) {
            behindNetCount++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.UseShotZonesText) {
        this.drawText(ctx, leftOTCount + ' ' + (leftOTCount / totalShots * 100).toPrecision(2) + '%', [40, 100], '18px');
        this.drawText(ctx, rightOTCount + ' ' + (rightOTCount / totalShots * 100).toPrecision(2) + '%', [340, 100], '18px');
        this.drawText(ctx, redZoneCount + ' ' + (redZoneCount / totalShots * 100).toPrecision(2) + '%', [180, 95], '18px', 'black');
        this.drawText(ctx, leftPointCount + ' ' + (leftPointCount / totalShots * 100).toPrecision(2) + '%', [40, 270], '18px');
        this.drawText(ctx, rightPointCount + ' ' + (rightPointCount / totalShots * 100).toPrecision(2) + '%', [340, 270], '18px');
        this.drawText(ctx, centerPointCount + ' ' + (centerPointCount / totalShots * 100).toPrecision(2) + '%', [190, 270], '18px');
        this.drawText(ctx, outsideZoneCount + ' ' + (outsideZoneCount / totalShots * 100).toPrecision(2) + '%', [190, 390], '18px');
        this.drawText(ctx, behindNetCount + ' ' + (behindNetCount / totalShots * 100).toPrecision(2) + '%', [190, 30], '18px');
      }
    },
    drawRect: function drawRect(ctx, color, position, text, textPos) {
      var fontSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '26px';
      var lineWidth = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 3;

      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.strokeStyle = '#FFFFFF';
      ctx.shadowOffsetX = ctx.shadowOffsetY = .0;
      ctx.shadowBlur = .2;
      ctx.shadowColor = 'rgb(1, 1, 1)';
      ctx.lineWidth = lineWidth;
      ctx.fillRect(position[0], position[1], position[2], position[3]);
      ctx.strokeRect(position[0], position[1], position[2], position[3]);
      ctx.closePath();
    },
    drawText: function drawText(ctx, text, textPosition) {
      var textSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '26px';
      var colour = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'rgba(0,0,0,1)';

      ctx.beginPath();
      ctx.font = textSize + ' sans-serif';
      ctx.fillStyle = colour;
      ctx.fillText(text, textPosition[0], textPosition[1]);
      ctx.closePath();
    },
    drawCustom: function drawCustom(ctx, color, initPos, movePoints) {
      ctx.beginPath();
      ctx.fillStyle = color;
      // ctx.strokeStyle = 'white'
      ctx.moveTo(initPos[0], initPos[1]);
      // Loop over move points
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = movePoints[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var prop = _step2.value;

          ctx.lineTo(prop.x, prop.y);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      ctx.fill();
      ctx.stroke();
      ctx.closePath();
    },
    renderHeatmap: function renderHeatmap() {
      var homeShotsCanvas = this.$refs.home_shot_canvas;
      var awayShotsCanvas = this.$refs.away_shot_canvas;
      var homeShots = [];
      var awayShots = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.HomeShotmapData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var shots = _step3.value;

          var shot = JSON.parse(shots.shot_location);
          shot[0] = homeShotsCanvas.width / 600.0 * parseInt(shot[0], 10);
          shot[1] = homeShotsCanvas.height / 530.0 * parseInt(shot[1], 10);
          if (this.UseHeatmap === false) {
            if (shots.shot_type === 'OnNet') {
              shot[4] = 'rgb(180, 8, 8)';
              shot[3] = 5;
            } else if (shots.shot_type === 'MissedNet') {
              shot[4] = 'rgba(95, 93, 93)';
              shot[3] = 3;
            } else if (shots.shot_type === 'Blocked') {
              shot[4] = 'rgba(20, 23, 81)';
              shot[3] = 3;
            } else if (shots.shot_type === 'Goal') {
              shot[4] = 'rgb(31, 239, 0)';
              shot[3] = 6;
            } else {
              shot[4] = 'White';
            }
          }
          homeShots.push(shot);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.AwayShotmapData[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          shots = _step4.value;

          var _shot = JSON.parse(shots.shot_location);
          _shot[0] = awayShotsCanvas.width / 600.0 * _shot[0];
          _shot[1] = awayShotsCanvas.height / 530.0 * _shot[1];
          if (this.UseHeatmap === false) {
            if (shots.shot_type === 'OnNet') {
              _shot[4] = 'rgb(180, 8, 8)';
              _shot[3] = 5;
            } else if (shots.shot_type === 'MissedNet') {
              _shot[4] = 'rgba(95, 93, 93)';
              _shot[3] = 3;
            } else if (shots.shot_type === 'Blocked') {
              _shot[4] = 'rgba(20, 23, 81)';
              _shot[3] = 3;
            } else if (shots.shot_type === 'Goal') {
              _shot[4] = 'rgb(31, 239, 0)';
              _shot[3] = 6;
            } else {
              _shot[4] = 'White';
            }
          }
          awayShots.push(_shot);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (this.UseHeatmap === true) {
        var homeHeatmap = __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default()(homeShotsCanvas).data(homeShots);
        homeHeatmap.radius(this.RadiusSelected, this.BlurSelected);
        homeHeatmap.draw();

        var awayHeatmap = __WEBPACK_IMPORTED_MODULE_0__store_modules_simpleheat_simpleheat___default()(awayShotsCanvas).data(awayShots);
        awayHeatmap.radius(this.RadiusSelected, this.BlurSelected);
        awayHeatmap.draw();
      } else {
        homeHeatmap = __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot___default()(homeShotsCanvas).data(homeShots);
        homeHeatmap.render();

        awayHeatmap = __WEBPACK_IMPORTED_MODULE_1__store_modules_simpleheat_simpleshot___default()(awayShotsCanvas).data(awayShots);
        awayHeatmap.render();
      }
      if (this.UseShotZones) {
        this.renderShotZones(homeShotsCanvas, homeShots);
        this.renderShotZones(awayShotsCanvas, awayShots);
      }
    },
    filterPlayers: function filterPlayers(selectResult) {
      var players = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = selectResult[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var p = _step5.value;

          if (p.id === 0) {
            return 0;
          } else {
            players.push(p.id);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return JSON.stringify(players);
    },
    fetchShotmap: function fetchShotmap() {
      var _this = this;

      var postData = {
        'id': this.gameId,
        'period': this.PeriodSelected,
        'situation': this.SituationSelected,
        'home_player': this.filterPlayers(this.HomeMultiSelect),
        'away_player': this.filterPlayers(this.AwayMultiSelect),
        'shot_type': this.ShotTypeSelected
        // console.log('Filter: ' + JSON.stringify(postData))
      };this.$http.post('https://devilsapi.roblutken.com/api/app/get/match-stats/shotmap/', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.HomeShotmapData = response.data.home_shots;
        _this.AwayShotmapData = response.data.away_shots;
        _this.renderHeatmap();
      }, function (response) {});
    },
    fetchPlayers: function fetchPlayers() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/get/players/shots/' + this.gameId, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        // console.log(JSON.stringify(response.data))
        _this2.HomePlayers = response.data.home_players;
        _this2.AwayPlayers = response.data.away_players;
        // console.log(JSON.stringify(this.HomePlayers))
        _this2.HomeTeamOptions.push({ text: 'All', id: 0 });
        _this2.AwayTeamOptions.push({ text: 'All', id: 0 });

        _this2.HomeTeamOptions.push({ text: 'Forwards', id: 0 });
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = _this2.sortHomePlayers[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var i = _step6.value;

            if (i.position === 'LW' || i.position === 'C' || i.position === 'RW') {
              if (i.number > 0) {
                _this2.HomeTeamOptions.push({ text: i.number + ' ' + i.surname, id: i.id });
              }
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        _this2.HomeTeamOptions.push({ text: 'Defense', id: -7 });
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = _this2.sortHomePlayers[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var d = _step7.value;

            if (d.position === 'LD' || d.position === 'RD') {
              _this2.HomeTeamOptions.push({ text: d.number + ' ' + d.surname, id: d.id });
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        _this2.AwayTeamOptions.push({ text: 'Forwards', id: -2 });
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = _this2.sortAwayPlayers[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var af = _step8.value;

            if (af.position === 'LW' || af.position === 'C' || af.position === 'RW') {
              if (af.number > 0) {
                _this2.AwayTeamOptions.push({ text: af.number + ' ' + af.surname, id: af.id });
              }
            }
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }

        _this2.AwayTeamOptions.push({ text: 'Defense', value: -3 });
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = _this2.sortAwayPlayers[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var ad = _step9.value;

            if (ad.position === 'LD' || ad.position === 'RD') {
              _this2.AwayTeamOptions.push({ text: ad.number + ' ' + ad.surname, id: ad.id });
            }
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }
      });
    },
    fetchFilterOptions: function fetchFilterOptions() {
      var _this3 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(function (response) {
        _this3.SituationOptions.push({ text: 'All', value: 0 });
        _this3.SituationOptions.push({ text: 'Even Handed', value: 1 });
        _this3.SituationOptions.push({ text: 'Power Play', value: 2 });
        _this3.SituationOptions.push({ text: 'Short Handed', value: 3 });
        _this3.SituationOptions.push({ text: 'Empty Net', value: 4 });

        _this3.PeriodOptions.push({ text: 'All', value: 0 });
        _this3.PeriodOptions.push({ text: 'Period 1', value: 1 });
        _this3.PeriodOptions.push({ text: 'Period 2', value: 2 });
        _this3.PeriodOptions.push({ text: 'Period 3', value: 3 });
        _this3.PeriodOptions.push({ text: 'Period OT', value: 4 });
        _this3.PeriodOptions.push({ text: 'Period Shootout', value: 5 });

        _this3.ShotTypeOptions.push({ text: 'All', value: 0 });
        _this3.ShotTypeOptions.push({ text: 'On Net', value: 'OnNet' });
        _this3.ShotTypeOptions.push({ text: 'Off Target', value: 'MissedNet' });
        _this3.ShotTypeOptions.push({ text: 'Blocked', value: 'Blocked' });
        _this3.ShotTypeOptions.push({ text: 'Goal', value: 'Goal' });
      });
    }
  },
  mounted: function mounted() {
    if (this.defaultShow) {
      this.show = true;
    }
    this.fetchShotmap();
    this.fetchPlayers();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['home_name', 'away_name', 'game_id'],
  components: {
    Chart: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs___default.a
  },
  computed: {
    getShotDataHome: function getShotDataHome() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.ShotData, 'home_diff');
    },
    getShotDataAway: function getShotDataAway() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.ShotData, 'away_diff');
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.ShotData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.index);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.getShotDataHome,
        label: this.home_name,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)',
        pointBackgroundColor: 'rgba(0,0,0,1)',
        lineTension: 0,
        fill: this.fillOption
      }, {
        data: this.getShotDataAway,
        label: this.away_name,
        backgroundColor: 'rgba(255, 206, 86, 1)',
        pointBackgroundColor: 'rgba(0,0,0,1)',
        borderColor: 'rgba(255, 206, 86, 1)',
        lineTension: 0,
        fill: this.fillOption
      }];
      return data;
    }
  },
  data: function data() {
    return {
      home_shots: [],
      away_shots: [],
      ShotData: [],
      fillOption: false,
      toggleDifferential: false,
      headers: ['Time', '+', '-', '+/-'],
      interval: 1,
      lines: {
        type: 'line',
        mode: 'vertical',
        scaleID: 'x-axis-0',
        value: '00:40:00',
        borderColor: 'red',
        label: {
          content: '3',
          enabled: true,
          position: 'top'
        }
      },
      line_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        annotation: {
          annotations: []
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    };
  },

  methods: {
    fetchShotQuality: function fetchShotQuality() {
      var _this = this;

      var postData = {
        'game_id': this.game_id
      };
      this.$http.post('https://devilsapi.roblutken.com/api/app/get/match-stats/shot-quality', postData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        // console.log('Faceoff Data is ' + response.data)
        _this.home_shots = response.data.home_team;
        _this.away_shots = response.data.away_team;
        _this.ShotData = response.data.xg_time;
        var lineData = response.data.annotations;
        for (var i = 0; i < lineData.length; i++) {
          _this.line_options.annotation.annotations.push(lineData[i]);
        }
        // console.log(JSON.stringify(this.away_shots))
      }, function (response) {});
    }
  },
  created: function created() {
    // console.log('Props' + this.home_name + ' ' + this.away_name + ' id ' + this.game_id)
    this.fetchShotQuality();
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    endpoint: { type: String, required: true },
    selectedData: { type: Array, required: true },
    postData: { type: Array, required: false },
    defaultSort: { type: String, required: false }
  },
  data: function data() {
    return {
      tableData: [],
      columns: [],
      url: '',
      sortedColumn: '',
      test: false,
      order: 'asc'
    };
  },

  watch: {
    endpoint: {
      handler: function handler(endpoint) {
        this.url = endpoint;
      },
      immediate: true
    },
    postData: {
      handler: function handler(postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
        this.fetchData();
      },
      immediate: true
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      if (this.postData != null) {
        // console.log('data: ' + JSON.stringify(this.postData) + ' url: ' + this.url)
        this.$http.post(this.url, this.postData[0], {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        }).then(function (response) {
          // console.log('response was: ' + response.data)
          _this.tableData = response.data;
          _this.$emit('dataLoaded', _this.tableData);
          _this.tableData = _this.mapData();
          _this.test = false;
          _this.sortByColumn('Total TOI');
        }, function (response) {});
      } else {
        this.$http.get(this.url, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' } }).then(function (response) {
          _this.tableData = response.data;
          _this.tableData = _this.mapData();
          // this.sortByColumn(this.defaultSort)
        });
      }
    },
    mapData: function mapData() {
      this.select = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.selectedData, 'prop');
      this.columns = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.selectedData, 'title');
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.reverse(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.tableData, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.partial(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a, this.select)));
    },
    sortByColumn: function sortByColumn(column) {
      // Get keys
      console.log('Column to sort: ' + column);
      var selected = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.selectedData, { 'title': column });
      this.test = !this.test;
      if (this.test) {
        this.order = 'desc';
      } else {
        this.order = 'asc';
      }
      this.tableData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(this.tableData, selected.prop, [this.order]);
      // console.log(JSON.stringify(this.tableData))
      this.sortedColumn = column;
    }
  },
  created: function created() {
    return this.fetchData();
  },

  filters: {
    columnHead: function columnHead(value) {
      return value.split('_').join(' ').toUpperCase();
    }
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['heading', 'headers', 'tableData', 'total'],
  components: {},
  data: function data() {
    return {};
  },

  methods: {},
  mounted: function mounted() {
    // console.log('Edit Table Data is: ' + this.total)
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sub_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sub_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_chartjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__embedded_data_graph_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__embedded_data_graph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__embedded_data_graph_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_0__data_table___default.a,
    'graph-table': __WEBPACK_IMPORTED_MODULE_4__embedded_data_graph_vue___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__sub_table___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_chartjs___default.a
  },
  data: function data() {
    return {
      SituationOptions: [],
      SituationSelected: 0,
      FilterSelected: 'total',
      ExitFilterSelected: 'pass',
      ZoneEntriesAutoPlayerData: [],
      ZoneEntriesAutoPlayerHeadings: ['Player', 'Controlled Success', 'Controlled Fail', 'Total Controlled', 'Uncontrolled Success', 'Uncontrolled Failed', 'Uncontrolled Dump', 'Offside', 'Total Unontrolled'],
      ZoneEntriesPlayerData: [],
      ZoneEntriesPlayerHeadings: ['Player', 'Success', 'Success AVG', 'Success No Possesion', 'Success No Possesion AVG', 'Fail', 'Fail AVG', 'Total', 'Total AVG'],
      ZoneEntriesPlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'Success', value: 'success' }, { text: 'Success AVG', value: 'success_avg' }, { text: 'Success With Pos', value: 'success_with_pos' }, { text: 'Success With Pos AVG', value: 'success_with_pos_avg' }, { text: 'Fail', value: 'fail' }, { text: 'Fail AVG', value: 'fail_avg' }, { text: 'Total', value: 'total' }, { text: 'Total AVG', value: 'total_avg' }],
      ZoneExitPlayerData: [],
      ZoneExitPlayerHeadings: ['Player', 'Success (PCD)', 'Pass', 'Carry', 'Dump', 'Clear W/Out Poss', 'Icing', 'Fail'],
      ZoneExitPlayerFilters: [{ text: 'Player', value: 'player' }, { text: 'GP', value: 'gp' }, { text: 'Pass', value: 'pass' }, { text: 'Carry', value: 'carry' }, { text: 'Dump', value: 'dump_success' }, { text: 'Clear With Pos AVG', value: 'clear' }, { text: 'Icing', value: 'icing' }],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      stacked_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          enabled: true
        },
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              autoSkip: false
            }
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              autoSkip: false
            }
          }]
        }
      },
      multi_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          enabled: true
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              stacked: true
            }
          }],
          yAxes: [{
            categoryPercentage: 0.76,
            barPercentage: 1,
            ticks: {
              autoSkip: false,
              stacked: true
            },
            gridLines: {
              offsetGridLines: true
            }
          }]
        }
      }
    };
  },

  computed: {
    sortByZoneEntriesData: function sortByZoneEntriesData() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(this.ZoneEntriesPlayerData, 'total_success', ['desc']);
    },
    sortByZoneEntriesDataChart: function sortByZoneEntriesDataChart() {
      var orderedData = this.sortByZoneEntriesData;
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(orderedData, this.FilterSelected);
    },
    sortByZoneExitData: function sortByZoneExitData() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(this.ZoneExitPlayerData, 'total_success', ['desc']);
    },
    sortByZoneExitDataChart: function sortByZoneExitDataChart() {
      var orderedData = this.ZoneExitPlayerData;
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(orderedData, 'total_success');
    },
    sortByZoneEntriesAutoData: function sortByZoneEntriesAutoData() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(this.ZoneEntriesAutoPlayerData, 'controlled_total', ['desc']);
    },
    chartData: function chartData() {
      var playerLabels = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sortByZoneEntriesData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var label = _step.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: this.sortByZoneEntriesAutoData,
        label: 'Zone Entry - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }];
      return data;
    },
    chartStackedData: function chartStackedData() {
      var playerLabels = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.sortByZoneExitData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var label = _step2.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var pass = [];
      var carry = [];
      var dumpWithPoss = [];
      var clear = [];
      var icing = [];
      var fail = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.sortByZoneExitData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var d = _step3.value;

          pass.push(d.pass);
          carry.push(d.carry);
          dumpWithPoss.push(d.dump_success);
          clear.push(d.clear);
          icing.push(-d.icing);
          fail.push(-d.fail);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: pass,
        label: 'Pass',
        backgroundColor: '#0077cf',
        borderColor: '#0077cf'
      }, {
        data: carry,
        label: 'Carry',
        backgroundColor: '#00a9e7',
        borderColor: '#00a9e7'
      }, {
        data: dumpWithPoss,
        label: 'Dump With Poss',
        backgroundColor: '#00d4df',
        borderColor: '#00d4df'
      }, {
        data: clear,
        label: 'Clear',
        backgroundColor: '#73fac9',
        borderColor: '#73fac9'
      }, {
        data: icing,
        label: 'Icing',
        backgroundColor: '#9a4e96',
        borderColor: '#9a4e96'
      }, {
        data: fail,
        label: 'Failed Exit',
        backgroundColor: '#a53169',
        borderColor: '#a53169'
      }];
      return data;
    },
    chartZoneEntriesData: function chartZoneEntriesData() {
      var playerLabels = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.sortByZoneEntriesAutoData[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var label = _step4.value;

          playerLabels.push(label.player);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var controlledSuccess = [];
      var controlledFailed = [];
      var controlledOffside = [];
      var uncontrolledSuccess = [];
      var uncontrolledFailed = [];
      var uncontrolledOffside = [];
      var uncontrolledDump = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.sortByZoneEntriesAutoData[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var d = _step5.value;

          controlledSuccess.push(d.controlled_success);
          controlledFailed.push(-d.controlled_failed);
          controlledOffside.push(d.controlled_offside);
          uncontrolledSuccess.push(d.uncontrolled_success);
          uncontrolledFailed.push(-d.uncontrolled_failed);
          uncontrolledOffside.push(-d.offside);
          uncontrolledDump.push(-d.uncontrolled_dump);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var data = {
        labels: playerLabels
      };
      data.datsets = [];
      data.datasets = [{
        data: controlledSuccess,
        label: 'Controlled Success',
        backgroundColor: '#0077cf',
        borderColor: '#0077cf',
        stack: 'Controlled'
      }, {
        data: controlledFailed,
        label: 'Controlled Failed',
        backgroundColor: '#00a9e7',
        borderColor: '#00a9e7',
        stack: 'Controlled'
      }, {
        data: uncontrolledSuccess,
        label: 'Uncontrolled Success',
        backgroundColor: '#ff9677',
        borderColor: '#ff9677',
        stack: 'Uncontrolled'
      }, {
        data: uncontrolledFailed,
        label: 'Uncontrolled Failed',
        backgroundColor: '#ff7298',
        borderColor: '#ff7298',
        stack: 'Uncontrolled'
      }, {
        data: uncontrolledOffside,
        label: 'Offside',
        backgroundColor: '#c765b3',
        borderColor: '#c765b3',
        stack: 'Uncontrolled'
      }, {
        data: uncontrolledDump,
        label: 'Uncontrolled Dump',
        backgroundColor: '#7263bb',
        borderColor: '#7263bb',
        stack: 'Uncontrolled'
      }];
      return data;
    }
  },
  methods: {
    fetchSeasonStats: function fetchSeasonStats() {
      var _this = this;

      var postData = {
        'game_id': this.$route.params.gameId,
        'situation': this.SituationSelected
      };
      console.log('Filter: ' + JSON.stringify(postData));
      this.$http.post('https://devilsapi.roblutken.com/api/app/get/match-stats/zone-entries', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(function (response) {
        console.log(response.data);
        _this.ZoneExitPlayerData = response.data.zone_exits;
        _this.ZoneEntriesAutoPlayerData = response.data.zone_entries;
        console.log(response.data.zone_exits);
      }, function (response) {});
    },
    fetchFilterOptions: function fetchFilterOptions() {
      this.SituationOptions.push({ text: 'All', value: 0 });
      this.SituationOptions.push({ text: 'Even Handed', value: 1 });
      this.SituationOptions.push({ text: 'Power Play', value: 2 });
      this.SituationOptions.push({ text: 'Short Handed', value: 3 });
      this.SituationOptions.push({ text: 'Empty Net', value: 4 });

      this.TypeOptions.push({ text: 'All', value: '' });
      this.TypeOptions.push({ text: 'Carry', value: 'Carry' });
      this.TypeOptions.push({ text: 'Dump', value: 'Dump' });

      this.ZoneOptions.push({ text: 'All', value: '' });
      this.ZoneOptions.push({ text: 'Offensive', value: 'Offensive' });
      this.ZoneOptions.push({ text: 'Defensive Exit', value: 'DefensiveExit' });
    }
  },
  mounted: function mounted() {
    this.fetchSeasonStats();
    this.fetchFilterOptions();
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stats_playerTable_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stats_playerTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stats_playerTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stats_playerCard_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stats_playerCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stats_playerCard_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'players',
  components: {
    'playerTable': __WEBPACK_IMPORTED_MODULE_1__stats_playerTable_vue___default.a,
    'player-card': __WEBPACK_IMPORTED_MODULE_2__stats_playerCard_vue___default.a
  },
  data: function data() {
    return {
      Players: [],
      Team: []
    };
  },

  computed: {
    forwards: function forwards() {
      var cleanData = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.Players, function (object) {
        if (object.number > 0) {
          if (object.position === 'LW' || object.position === 'C' || object.position === 'RW') {
            cleanData.push(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(object, ['id', 'number', 'forename', 'surname']));
          }
        }
      });
      cleanData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(cleanData, 'number', ['asc']);
      return cleanData;
    },
    defense: function defense() {
      var cleanData = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.Players, function (object) {
        if (object.number > 0) {
          if (object.position === 'LD' || object.position === 'RD') {
            cleanData.push(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(object, ['id', 'number', 'forename', 'surname']));
          }
        }
      });
      cleanData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(cleanData, 'number', ['asc']);
      return cleanData;
    },
    goaltending: function goaltending() {
      var cleanData = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.Players, function (object) {
        if (object.number > 0) {
          if (object.position === 'GT' || object.position === 'BKUPGT' || object.position === 'EMRGGT') {
            cleanData.push(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(object, ['id', 'number', 'forename', 'surname']));
          }
        }
      });
      cleanData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(cleanData, 'number', ['asc']);
      return cleanData;
    }
  },
  methods: {
    fetchPlayers: function fetchPlayers() {
      var _this = this;

      this.$http.get('https://devilsapi.roblutken.com/api/players/get/teams/' + this.$route.params.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this.Players = response.data;
      }, function (response) {});
    },
    fetchTeam: function fetchTeam() {
      var _this2 = this;

      this.$http.get('https://devilsapi.roblutken.com/api/teams/get/' + this.$route.params.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(function (response) {
        _this2.Team = response.data;
        console.log(JSON.stringify(_this2.Team));
      }, function (response) {});
    },
    openReport: function openReport(id) {
      this.$router.push('/season-stats/player-stats/' + id);
    }
  },
  created: function created() {
    this.fetchPlayers();
    this.fetchTeam();
  },
  update: function update() {
    this.fetchPlayers();
    this.fetchTeam();
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {},
  computed: {}
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },

  mounted: function mounted() {
    if (this.separator) {
      this.$el.style.setProperty('--separator', '"' + this.separator + '"');
    }
  },


  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
//
//
//
//

 // With moment.js
//import chartjsPluginAnnotation from "chartjs-plugin-annotation";
var types = ['line', 'horizontalBar', 'bar', 'radar', 'polarArea', 'pie', 'doughnut', 'bubble', 'scatter'];

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    width: Number,
    height: Number,
    type: {
      type: String,
      required: true,
      validator: function validator(val) {
        return types.includes(val);
      }
    },
    data: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    plugins: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    }
  },

  mounted: function mounted() {
    this.resetChart();
  },
  data: function data() {
    return {
      chart: null
    };
  },


  methods: {
    resetChart: function resetChart() {
      if (this.chart) this.chart.destroy();

      this.chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(this.$el, {
        type: this.type,
        data: this.data,
        options: this.options,
        plugins: this.plugins
      });
    }
  },

  watch: {
    type: function type() {
      var _this = this;

      this.$nextTick(function () {
        return _this.resetChart();
      });
    },
    data: function data() {
      var _this2 = this;

      this.$nextTick(function () {
        return _this2.resetChart();
      });
      this.chart.update();
    },
    options: function options() {
      var _this3 = this;

      this.$nextTick(function () {
        return _this3.resetChart();
      });
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isFullwidth: Boolean,
    accordion: Boolean
  },

  computed: {
    $collapseItems: function $collapseItems() {
      return this.$children.filter(function (child) {
        return child._isCollapseItem;
      });
    }
  },

  methods: {
    openByIndex: function openByIndex(index) {
      if (this.accordion) {
        this.$collapseItems.forEach(function (item, i) {
          if (i !== index) {
            item.isActived = false;
          }
        });
      }
    }
  }

});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animejs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    selected: Boolean,
    title: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      isActived: this.selected
    };
  },
  created: function created() {
    this._isCollapseItem = true;
  },
  mounted: function mounted() {
    this.$on('open', this.$parent.openByIndex);
    if (this.isActived) {
      this.$emit('open', this.index);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.anime && this.targets) {
      __WEBPACK_IMPORTED_MODULE_0_animejs___default.a.remove(this.targets);
    }
    this.$off('open', this.$parent.openByIndex);
  },


  computed: {
    index: function index() {
      return this.$parent.$collapseItems.indexOf(this);
    }
  },

  methods: {
    toggle: function toggle() {
      if (this.isActived = !this.isActived) {
        this.$emit('open', this.index);
      }
    },
    getAnime: function getAnime(targets) {
      if (this.anime) return this.anime;
      return this.anime = __WEBPACK_IMPORTED_MODULE_0_animejs___default()({ targets: targets });
    },
    cancel: function cancel() {
      this.anime.pause();
    },
    before: function before(targets) {
      if (!this.targets) this.targets = targets;
      targets.removeAttribute('style');
    },
    enter: function enter(targets, done) {
      var height = targets.scrollHeight;
      targets.style.height = 0;
      targets.style.opacity = 0;
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [0, 1],
        height: height,
        complete: function complete() {
          targets.removeAttribute('style');
          done();
        }
      });
    },
    leave: function leave(targets, complete) {
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [1, 0],
        height: 0,
        complete: complete
      });
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__(30);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]]
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__(30);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]],

  props: {
    alignment: String
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SingleInput__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SingleInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WrapperInput__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WrapperInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__WrapperInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatpickr__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flatpickr__);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]],

  props: {
    alignment: String,
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  components: {
    SingleInput: __WEBPACK_IMPORTED_MODULE_1__SingleInput___default.a,
    WrapperInput: __WEBPACK_IMPORTED_MODULE_2__WrapperInput___default.a
  },

  data: function data() {
    return {
      datepicker: null,
      selectedDates: null
    };
  },
  mounted: function mounted() {
    if (!this.datepicker) {
      this.config.onValueUpdate = this.dateUpdated;
      this.datepicker = new __WEBPACK_IMPORTED_MODULE_3_flatpickr___default.a(this.$el, this.config);
      this.setDate(this.value);
    }
    this.$watch('config', this.redraw);
    this.$watch('value', this.setDate);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.datepicker && !this.static) {
      this.datepicker.destroy();
      this.datepicker = null;
    }
  },


  methods: {
    redraw: function redraw(newConfig) {
      this.datepicker.config = Object.assign(this.datepicker.config, newConfig);
      this.datepicker.redraw();
      this.datepicker.jumpToDate();
    },
    setDate: function setDate(newDate, oldDate) {
      newDate && this.datepicker.setDate(newDate);
    },
    dateUpdated: function dateUpdated(selectedDates, dateStr) {
      this.date = dateStr;
    }
  },

  computed: {
    wrap: function wrap() {
      return !!this.config.wrap;
    },
    static: function _static() {
      return !!this.config.static;
    },
    name: function name() {
      return this.wrap ? 'wrapperInput' : 'singleInput';
    },

    date: {
      get: function get() {
        return this.selectedDates || this.value;
      },
      set: function set(newValue) {
        if (this.selectedDates !== newValue) {
          this.selectedDates = newValue;
          this.$emit('input', newValue);
        }
      }
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    type: String,
    title: String,
    message: String,
    direction: {
      type: String,
      default: 'Right'
    },
    duration: {
      type: Number,
      default: 4500
    },
    container: {
      type: String,
      default: '.notifications'
    }
  },

  data: function data() {
    return {
      $_parent_: null,
      show: true
    };
  },
  created: function created() {
    var $parent = this.$parent;
    if (!$parent) {
      var parent = document.querySelector(this.container);
      if (!parent) {
        // Lazy creating `div.notifications` container.
        var className = this.container.replace('.', '');
        var Notifications = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
          name: 'Notifications',
          render: function render(h) {
            return h('div', {
              'class': _defineProperty({}, '' + className, true)
            });
          }
        });
        $parent = new Notifications().$mount();
        document.body.appendChild($parent.$el);
      } else {
        $parent = parent.__vue__;
      }
      // Hacked.
      this.$_parent_ = $parent;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$_parent_) {
      this.$_parent_.$el.appendChild(this.$el);
      this.$parent = this.$_parent_;
      delete this.$_parent_;
    }
    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        return _this.close();
      }, this.duration);
    }
  },
  destroyed: function destroyed() {
    this.$el.remove();
  },


  computed: {
    transition: function transition() {
      return 'bounce-' + this.direction;
    },
    enterClass: function enterClass() {
      return 'bounceIn' + this.direction;
    },
    leaveClass: function leaveClass() {
      return 'bounceOut' + this.direction;
    }
  },

  methods: {
    closedByUser: function closedByUser() {
      this.$emit('closed-by-user');
      clearTimeout(this.timer);
      this.show = false;
    },
    close: function close() {
      this.$emit('closed-automatically');
      clearTimeout(this.timer);
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy();
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: 0.01
    },
    value: {
      type: Number,
      default: 0
    },
    type: String,
    name: String,
    size: String,
    isFullwidth: Boolean,
    disabled: Boolean,
    // orientation:
    vertical: Boolean
  },

  data: function data() {
    return {
      realValue: this.value
    };
  },
  beforeMount: function beforeMount() {
    if (this.max < this.min) {
      throw 'Unexpected range setting: Maximum cannot be less than minimum';
    }

    this.update(this.value);
  },
  mounted: function mounted() {
    this.$el.style.setProperty('--low', this.low);
    this.$el.style.setProperty('--high', this.high);
  },


  watch: {
    realValue: function realValue(newVal, oldVal) {
      if (Number(newVal) !== Number(oldVal)) {
        this.$el.style.setProperty('--high', this.high);
        this.$emit('change', newVal);
      }
    },
    value: function value(val) {
      this.update(val);
    }
  },

  methods: {
    update: function update(val) {
      if (val > this.max) {
        this.realValue = this.max;
      } else if (val < this.min) {
        this.realValue = this.min;
      } else {
        this.realValue = val;
      }
    }
  },

  computed: {
    low: function low() {
      return '0%';
    },
    high: function high() {
      return (this.realValue - this.min) / (this.max - this.min) * 100 + '%';
    },
    classObject: function classObject() {
      var _ref;

      var type = this.type,
          size = this.size,
          isFullwidth = this.isFullwidth;

      return _ref = {
        slider: true
      }, _defineProperty(_ref, 'is-' + type, type), _defineProperty(_ref, 'is-' + size, size), _defineProperty(_ref, 'is-fullwidth', isFullwidth), _ref;
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    alignment: {
      type: String,
      default: ''
    }
  },

  computed: {
    classObject: function classObject() {
      var alignment = this.alignment;

      return _defineProperty({
        'tab-list': true,
        'is-flex': true
      }, 'is-' + alignment, alignment);
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TS = {
  'fade': {
    enterClass: 'fadeIn',
    leaveClass: 'fadeOut'
  },
  'fade-horizontal-rtl': {
    enterClass: 'fadeInRight',
    leaveClass: 'fadeOutLeft'
  },
  'fade-horizontal-ltr': {
    enterClass: 'fadeInLeft',
    leaveClass: 'fadeOutRight'
  },
  'slide-horizontal-rtl': {
    enterClass: 'slideInRight',
    leaveClass: 'slideOutLeft'
  },
  'slide-horizontal-ltr': {
    enterClass: 'slideInLeft',
    leaveClass: 'slideOutRight'
  },
  'fade-vertical-dtu': {
    enterClass: 'fadeInUp',
    leaveClass: 'fadeOutUp'
  },
  'fade-vertical-utd': {
    enterClass: 'fadeInDown',
    leaveClass: 'fadeOutDown'
  },
  'slide-vertical-dtu': {
    enterClass: 'slideInUp',
    leaveClass: 'slideOutUp'
  },
  'slide-vertical-utd': {
    enterClass: 'slideInDown',
    leaveClass: 'slideOutDown'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    icon: String,
    selected: Boolean,
    disabled: Boolean,
    label: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: 'out-in'
    }
  },

  data: function data() {
    return {
      realSelected: this.selected,
      transition: TS['fade']
    };
  },
  created: function created() {
    this.$parent.tabPanes.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.tabPanes.splice(this.index, 1);
  },


  computed: {
    classObject: function classObject() {
      var realSelected = this.realSelected;

      return {
        'tab-pane': true,
        'animated': true,
        'is-active': realSelected,
        'is-deactive': !realSelected
      };
    },
    layout: function layout() {
      return this.$parent.layout;
    },
    direction: function direction() {
      if (this.layout === 'top' || this.layout === 'bottom') {
        return 'horizontal';
      } else if (this.layout === 'left' || this.layout === 'right') {
        return 'vertical';
      }
      return '';
    },
    animation: function animation() {
      return this.$parent.animation;
    },
    onlyFade: function onlyFade() {
      return this.$parent.onlyFade;
    },
    gte: function gte() {
      if (this.direction === 'vertical') {
        return 'utd';
      } else if (this.direction === 'horizontal') {
        return 'ltr';
      }
      return '';
    },
    lt: function lt() {
      if (this.direction === 'vertical') {
        return 'dtu';
      } else if (this.direction === 'horizontal') {
        return 'rtl';
      }
      return '';
    },
    hidden: function hidden() {
      return this.realSelected ? 'false' : 'true';
    },
    index: function index() {
      return this.$parent.tabPanes.indexOf(this);
    }
  },

  watch: {
    '$parent.realSelectedIndex': function $parentRealSelectedIndex(index, prevIndex) {
      if (!this.onlyFade) {
        var transition = void 0;
        if (prevIndex === -1 || prevIndex > index) {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.gte ? '-' + this.gte : '');
        } else {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.lt ? '-' + this.lt : '');
        }
        this.transition = TS[transition] || TS['fade'];
      }
      this.realSelected = this.index === index;
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TabList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TabList: __WEBPACK_IMPORTED_MODULE_0__TabList___default.a
  },

  props: {
    isFullwidth: Boolean,
    layout: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'bottom', 'left', 'right'].indexOf(val) > -1;
      }
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    alignment: {
      type: String,
      default: ''
    },
    selectedIndex: {
      type: Number,
      default: -1
    },
    animation: {
      type: String,
      default: 'fade'
    },
    onlyFade: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      realSelectedIndex: this.selectedIndex,
      tabPanes: []
    };
  },
  mounted: function mounted() {
    this.update();
    if (this.realSelectedIndex === -1) {
      this.select(0);
    }
  },


  methods: {
    update: function update() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.tabPanes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tabPane = _step.value;

          if (!tabPane.disabled && tabPane.realSelected) {
            this.select(tabPane.index);
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isActived: function isActived(index) {
      return index === this.realSelectedIndex;
    },
    select: function select(index) {
      this.$emit('tab-selected', index);
      this.realSelectedIndex = index;
    }
  },
  watch: {
    selectedIndex: function selectedIndex(newIndex) {
      this.select(newIndex);
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cleave_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cleave_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cleave_js__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      cleave: null
    };
  },


  methods: {
    updateValue: function updateValue(value) {
      this.$emit('input', value);
    }
  },

  mounted: function mounted() {
    this.cleave = new __WEBPACK_IMPORTED_MODULE_0_cleave_js___default.a(this.$el, this.options);
  },
  beforeDestroy: function beforeDestroy() {
    this.cleave.destroy();
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nprogress-container'
});

/***/ }),
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */,
/* 549 */,
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 51,
	"./af.js": 51,
	"./ar": 58,
	"./ar-dz": 52,
	"./ar-dz.js": 52,
	"./ar-kw": 53,
	"./ar-kw.js": 53,
	"./ar-ly": 54,
	"./ar-ly.js": 54,
	"./ar-ma": 55,
	"./ar-ma.js": 55,
	"./ar-sa": 56,
	"./ar-sa.js": 56,
	"./ar-tn": 57,
	"./ar-tn.js": 57,
	"./ar.js": 58,
	"./az": 59,
	"./az.js": 59,
	"./be": 60,
	"./be.js": 60,
	"./bg": 61,
	"./bg.js": 61,
	"./bm": 62,
	"./bm.js": 62,
	"./bn": 64,
	"./bn-bd": 63,
	"./bn-bd.js": 63,
	"./bn.js": 64,
	"./bo": 65,
	"./bo.js": 65,
	"./br": 66,
	"./br.js": 66,
	"./bs": 67,
	"./bs.js": 67,
	"./ca": 68,
	"./ca.js": 68,
	"./cs": 69,
	"./cs.js": 69,
	"./cv": 70,
	"./cv.js": 70,
	"./cy": 71,
	"./cy.js": 71,
	"./da": 72,
	"./da.js": 72,
	"./de": 75,
	"./de-at": 73,
	"./de-at.js": 73,
	"./de-ch": 74,
	"./de-ch.js": 74,
	"./de.js": 75,
	"./dv": 76,
	"./dv.js": 76,
	"./el": 77,
	"./el.js": 77,
	"./en-au": 78,
	"./en-au.js": 78,
	"./en-ca": 79,
	"./en-ca.js": 79,
	"./en-gb": 80,
	"./en-gb.js": 80,
	"./en-ie": 81,
	"./en-ie.js": 81,
	"./en-il": 82,
	"./en-il.js": 82,
	"./en-in": 83,
	"./en-in.js": 83,
	"./en-nz": 84,
	"./en-nz.js": 84,
	"./en-sg": 85,
	"./en-sg.js": 85,
	"./eo": 86,
	"./eo.js": 86,
	"./es": 90,
	"./es-do": 87,
	"./es-do.js": 87,
	"./es-mx": 88,
	"./es-mx.js": 88,
	"./es-us": 89,
	"./es-us.js": 89,
	"./es.js": 90,
	"./et": 91,
	"./et.js": 91,
	"./eu": 92,
	"./eu.js": 92,
	"./fa": 93,
	"./fa.js": 93,
	"./fi": 94,
	"./fi.js": 94,
	"./fil": 95,
	"./fil.js": 95,
	"./fo": 96,
	"./fo.js": 96,
	"./fr": 99,
	"./fr-ca": 97,
	"./fr-ca.js": 97,
	"./fr-ch": 98,
	"./fr-ch.js": 98,
	"./fr.js": 99,
	"./fy": 100,
	"./fy.js": 100,
	"./ga": 101,
	"./ga.js": 101,
	"./gd": 102,
	"./gd.js": 102,
	"./gl": 103,
	"./gl.js": 103,
	"./gom-deva": 104,
	"./gom-deva.js": 104,
	"./gom-latn": 105,
	"./gom-latn.js": 105,
	"./gu": 106,
	"./gu.js": 106,
	"./he": 107,
	"./he.js": 107,
	"./hi": 108,
	"./hi.js": 108,
	"./hr": 109,
	"./hr.js": 109,
	"./hu": 110,
	"./hu.js": 110,
	"./hy-am": 111,
	"./hy-am.js": 111,
	"./id": 112,
	"./id.js": 112,
	"./is": 113,
	"./is.js": 113,
	"./it": 115,
	"./it-ch": 114,
	"./it-ch.js": 114,
	"./it.js": 115,
	"./ja": 116,
	"./ja.js": 116,
	"./jv": 117,
	"./jv.js": 117,
	"./ka": 118,
	"./ka.js": 118,
	"./kk": 119,
	"./kk.js": 119,
	"./km": 120,
	"./km.js": 120,
	"./kn": 121,
	"./kn.js": 121,
	"./ko": 122,
	"./ko.js": 122,
	"./ku": 123,
	"./ku.js": 123,
	"./ky": 124,
	"./ky.js": 124,
	"./lb": 125,
	"./lb.js": 125,
	"./lo": 126,
	"./lo.js": 126,
	"./lt": 127,
	"./lt.js": 127,
	"./lv": 128,
	"./lv.js": 128,
	"./me": 129,
	"./me.js": 129,
	"./mi": 130,
	"./mi.js": 130,
	"./mk": 131,
	"./mk.js": 131,
	"./ml": 132,
	"./ml.js": 132,
	"./mn": 133,
	"./mn.js": 133,
	"./mr": 134,
	"./mr.js": 134,
	"./ms": 136,
	"./ms-my": 135,
	"./ms-my.js": 135,
	"./ms.js": 136,
	"./mt": 137,
	"./mt.js": 137,
	"./my": 138,
	"./my.js": 138,
	"./nb": 139,
	"./nb.js": 139,
	"./ne": 140,
	"./ne.js": 140,
	"./nl": 142,
	"./nl-be": 141,
	"./nl-be.js": 141,
	"./nl.js": 142,
	"./nn": 143,
	"./nn.js": 143,
	"./oc-lnc": 144,
	"./oc-lnc.js": 144,
	"./pa-in": 145,
	"./pa-in.js": 145,
	"./pl": 146,
	"./pl.js": 146,
	"./pt": 148,
	"./pt-br": 147,
	"./pt-br.js": 147,
	"./pt.js": 148,
	"./ro": 149,
	"./ro.js": 149,
	"./ru": 150,
	"./ru.js": 150,
	"./sd": 151,
	"./sd.js": 151,
	"./se": 152,
	"./se.js": 152,
	"./si": 153,
	"./si.js": 153,
	"./sk": 154,
	"./sk.js": 154,
	"./sl": 155,
	"./sl.js": 155,
	"./sq": 156,
	"./sq.js": 156,
	"./sr": 158,
	"./sr-cyrl": 157,
	"./sr-cyrl.js": 157,
	"./sr.js": 158,
	"./ss": 159,
	"./ss.js": 159,
	"./sv": 160,
	"./sv.js": 160,
	"./sw": 161,
	"./sw.js": 161,
	"./ta": 162,
	"./ta.js": 162,
	"./te": 163,
	"./te.js": 163,
	"./tet": 164,
	"./tet.js": 164,
	"./tg": 165,
	"./tg.js": 165,
	"./th": 166,
	"./th.js": 166,
	"./tk": 167,
	"./tk.js": 167,
	"./tl-ph": 168,
	"./tl-ph.js": 168,
	"./tlh": 169,
	"./tlh.js": 169,
	"./tr": 170,
	"./tr.js": 170,
	"./tzl": 171,
	"./tzl.js": 171,
	"./tzm": 173,
	"./tzm-latn": 172,
	"./tzm-latn.js": 172,
	"./tzm.js": 173,
	"./ug-cn": 174,
	"./ug-cn.js": 174,
	"./uk": 175,
	"./uk.js": 175,
	"./ur": 176,
	"./ur.js": 176,
	"./uz": 178,
	"./uz-latn": 177,
	"./uz-latn.js": 177,
	"./uz.js": 178,
	"./vi": 179,
	"./vi.js": 179,
	"./x-pseudo": 180,
	"./x-pseudo.js": 180,
	"./yo": 181,
	"./yo.js": 181,
	"./zh-cn": 182,
	"./zh-cn.js": 182,
	"./zh-hk": 183,
	"./zh-hk.js": 183,
	"./zh-mo": 184,
	"./zh-mo.js": 184,
	"./zh-tw": 185,
	"./zh-tw.js": 185
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 550;

/***/ }),
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(492)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(611),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(488)
__webpack_require__(487)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(607),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(464)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(580),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(617),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(537)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(660),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(455)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(571),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(670),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(664),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(493)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(612),
  /* scopeId */
  "data-v-43331adf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(603),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(463)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(579),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(672),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card collapse-item",
    class: {
      'is-fullwidth': _vm.$parent.isFullwidth,
      'is-active': _vm.isActived
    }
  }, [_c('header', {
    staticClass: "card-header touchable",
    attrs: {
      "role": "tab",
      "aria-expanded": _vm.selected ? 'true' : 'fase'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('h3', {
    staticClass: "card-header-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapsed-fade",
      "css": false,
      "appear": ""
    },
    on: {
      "before-appear": _vm.before,
      "appear": _vm.enter,
      "appear-cancel": _vm.cancel,
      "before-enter": _vm.before,
      "enter": _vm.enter,
      "enter-cancel": _vm.cancel,
      "leave": _vm.leave,
      "leave-cancel": _vm.cancel
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActived),
      expression: "isActived"
    }],
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-content-box"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-header-icon"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
}]}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "display": "none",
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_total_chart,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture[0].match_date))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('img', {
    staticClass: "team_logo",
    attrs: {
      "src": _vm.Fixture[0].home_team.logo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title has-text-left"
  }, [_vm._v(_vm._s(_vm.Fixture[0].home_team.name) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('img', {
    staticClass: "team_logo",
    attrs: {
      "src": _vm.Fixture[0].away_team.logo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title has-text-left"
  }, [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture[0].competition))]), _vm._v(" "), _c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture[0].location))]), _vm._v(" "), (_vm.Fixture[0].is_stream == 1) ? _c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Stream")]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Live")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "button is-success is-small",
    attrs: {
      "to": '/stats/match-stats-opposition/' + this.$route.params.gameId + '/0'
    }
  }, [_vm._v("Opposition Report")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-6 is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Game Summary")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_ot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_pp) + " / " + _vm._s(_vm.Summary.situation_opts[0].PPTotal))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_goals_total))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_ot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_pp) + " /  " + _vm._s(_vm.Summary.situation_opts[0].SHTotal))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_goals_total))])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("All Attempts")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_shots_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_total - _vm.Summary.away_shots_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_shots_total))])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("On Target")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_sot_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_total - _vm.Summary.away_sot_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_sot_total))])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_fo_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_total - _vm.Summary.away_fo_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_fo_total))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Filters")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 1,
      'is-primary': this.$route.params.period != 1
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(1)
      }
    }
  }, [_vm._v("Period 1")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 2,
      'is-primary': this.$route.params.period != 2
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(2)
      }
    }
  }, [_vm._v("Period 2")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 3,
      'is-primary': this.$route.params.period != 3
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(3)
      }
    }
  }, [_vm._v("Period 3")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 4,
      'is-primary': this.$route.params.period != 4
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(4)
      }
    }
  }, [_vm._v("Overtime")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 0,
      'is-primary': this.$route.params.period != 0
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(0)
      }
    }
  }, [_vm._v("Total")])]), _vm._v(" "), _c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Quicklinks")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#Gamesheet'),
      expression: "'#Gamesheet'"
    }],
    staticClass: "button is-large"
  }, [_vm._v("Gamesheet")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#Turnovers'),
      expression: "'#Turnovers'"
    }],
    staticClass: "button is-large"
  }, [_vm._v("Turnovers")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#Shots'),
      expression: "'#Shots'"
    }],
    staticClass: "button is-large"
  }, [_vm._v("Shots")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#Hits'),
      expression: "'#Hits'"
    }],
    staticClass: "button is-large"
  }, [_vm._v("Hits")])])])]), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-vertical"
  }), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Player Totals")]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_t,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', _vm._l((this.FaceoffsChart.all_situations), function(result) {
    return _c('tr', {
      key: result.player_id
    }, [_c('td', [_vm._v(_vm._s(result.player_id))]), _vm._v(" "), _c('td', {
      staticClass: "fo-left has-text-centered"
    }, [_vm._v(_vm._s(result.left_win) + " / " + _vm._s(-result.left_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-left has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.left_win - (-result.left_loss)))])]), _vm._v(" "), _c('td', {
      staticClass: "fo-center has-text-centered"
    }, [_vm._v(_vm._s(result.center_win) + " / " + _vm._s(-result.center_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-center has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.center_win - -result.center_loss))])]), _vm._v(" "), _c('td', {
      staticClass: "fo-right has-text-centered"
    }, [_vm._v(_vm._s(result.right_win) + " / " + _vm._s(-result.right_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-right has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.right_win - -result.right_loss))])]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_vm._v(_vm._s(result.total_win + -result.total_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_vm._v(_vm._s(result.total_win) + " / " + _vm._s(-result.total_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_vm._v(_vm._s(result.total_win - (-result.total_loss)))]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.win_percentage))])])])
  }), 0)]), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('collapse-item', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal"
    },
    attrs: {
      "title": "Situational - EH PP SH"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Even Handed")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l_eh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c_eh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r_eh,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Power Play")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l_pp,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c_pp,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r_pp,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Short Handed")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l_sh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c_sh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r_sh,
      "options": _vm.fo_options
    }
  })], 1)])])], 1), _vm._v(" "), _c('FaceoffTeamVS', {
    attrs: {
      "home_name": _vm.Fixture[0].home_team.name,
      "away_name": _vm.Fixture[0].away_team.name
    }
  })], 1)])]), _vm._v(" "), _c('faceoffs-pvp', {
    attrs: {
      "opponent": _vm.Fixture[0].away_team.id,
      "game_id": this.$route.params.gameId
    }
  }), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box",
    attrs: {
      "id": "Turnovers"
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('p', [_vm._v("Even Handed")]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.to_player_eh,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('p', [_vm._v("Power Play")]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.to_player_pp,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('p', [_vm._v("Short Handed")]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.to_player_sh,
      "options": _vm.bar_options
    }
  })], 1)])]), _vm._v(" "), _c('shots-heatmap', {
    attrs: {
      "home_name": _vm.Fixture[0].home_team.name,
      "away_name": _vm.Fixture[0].away_team.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "title is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [(_vm.Fixture[0].is_stream == 0) ? _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('div', {
    staticClass: "tile is-parent is-8 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "is-child"
  }, [_c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("Filters")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPlusMinusSort),
      expression: "selectedPlusMinusSort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPlusMinusSort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.plusMinusOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                              " + _vm._s(option.text) + "\n                            ")])
  }), 0)])])])])]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.plus_minus_auto_totals,
      "options": _vm.shots_horz_bar_options
    }
  }), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.plus_minus_auto_diff,
      "options": _vm.shots_horz_bar_options
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', _vm._l((_vm.sortByPlusMinusHomeAuto), function(player) {
    return _c('tr', {
      key: player.player_id
    }, [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.shots_for))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(-player.shots_against))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.diff))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.percentage))])])
  }), 0)])])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-8 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Shots On Target")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSOTSort),
      expression: "selectedSOTSort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSOTSort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sotOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.text) + "\n                          ")])
  }), 0)])])])]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.sot_totals,
      "options": _vm.sot_bar_options
    }
  })], 1)])])]), _vm._v(" "), _c('shot-diff-time', {
    attrs: {
      "home_name": _vm.Fixture[0].home_team.name,
      "away_name": _vm.Fixture[0].away_team.name
    }
  }), _vm._v(" "), _c('shot-quality', {
    attrs: {
      "game_id": this.$route.params.gameId,
      "home_name": _vm.Fixture[0].home_team.name,
      "away_name": _vm.Fixture[0].away_team.name
    }
  }), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('article', {
    staticClass: "tile is-child box",
    attrs: {
      "id": "OddmanRushes"
    }
  }, [_vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.OddmanRushes.home_rushes))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.OddmanRushes.away_rushes))])])])])])])]) : _vm._e(), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box",
    attrs: {
      "id": "Hits"
    }
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedHitSort),
      expression: "selectedHitSort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedHitSort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sotOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.text) + "\n                          ")])
  }), 0)])])])]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.hit_player_totals,
      "options": _vm.bar_options
    }
  })], 1)])]), _vm._v(" "), _c('zone-entries'), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box",
    attrs: {
      "id": "Gamesheet"
    }
  }, [_vm._m(17), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Forwards")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.sortBytimeForwards), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goal_diff))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.fo))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_plus_minus))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sot))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.avg_shift))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.eh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.pp_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.total_toi))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Defense")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(19), _vm._v(" "), _c('tbody', _vm._l((_vm.sortBytimeDefense), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goal_diff))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.fo))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_plus_minus))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sot))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.avg_shift))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.eh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.pp_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.total_toi))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 1) ? _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Estimated TOI - For Away Games")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(20), _vm._v(" "), _c('tbody', _vm._l((_vm.sortBytimeAll), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.season_average_toi))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.est_toi))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Totals")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(21), _vm._v(" "), _c('tbody', _vm._l((_vm.gameTotals), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal"
    }, [_vm._v(_vm._s(result.total_gf))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal"
    }, [_vm._v(_vm._s(result.total_ga))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal"
    }, [_vm._v(_vm._s(result.total_gdiff))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_fo))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots"
    }, [_vm._v(_vm._s(result.total_shots_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots"
    }, [_vm._v(_vm._s(result.total_shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots"
    }, [_vm._v(_vm._s(result.total_shots_for - result.total_shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_sot))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_eh))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_pp))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_sh))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.total_toi))])])])
  }), 0)])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 09/03/2020 11:22PM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "color": "purple"
    }
  }, [_vm._v(" Site - Added Faceoffs PVP - Will only work when we're the home team!")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "subtitle has-text-centered",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_vm._v("Goals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("PP")]), _vm._v(" "), _c('th', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_c('b', [_vm._v("Shots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_c('b', [_vm._v("Faceoffs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Faceoffs - All Situations")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "testAlign is-capitalized"
  }, [_vm._v("Left W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Center W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Right W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Taken")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total +/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total Win %")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Turnovers - All Situations")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Team - Even Handed Shot Differentials - All Attempts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("CF")]), _vm._v(" "), _c('th', [_vm._v("CA")]), _vm._v(" "), _c('th', [_vm._v("DIFF")]), _vm._v(" "), _c('th', [_vm._v("CF%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Oddman Rushes - All Situations")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-parent",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "is-child",
    staticStyle: {
      "margin": "0 150px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Hits")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Gamesheet")]), _vm._v(" "), _c('p', [_vm._v("Goal +/- is Even Handed ")]), _vm._v(" "), _c('p', [_vm._v("Shot +/- SOT FOT is All Situations")]), _vm._v(" "), _c('p', [_vm._v("FO - Faceoff Wins / Faceoffs Taken")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals for even handed"
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals against even handed"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals +/- even handed"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Faceoffs won / Faceoffs taken all situations"
    }
  }, [_vm._v("FO")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances for even handed"
    }
  }, [_vm._v("Shots For")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances against even handed"
    }
  }, [_vm._v("Shots Against")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances +/- even handed"
    }
  }, [_vm._v("Shots Diff")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Shots on target all situations"
    }
  }, [_vm._v("SOT")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI average shift time all situations"
    }
  }, [_vm._v("AvgShifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI 5v5 time even handed"
    }
  }, [_vm._v("EH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI power play time"
    }
  }, [_vm._v("PP")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI short handed time"
    }
  }, [_vm._v("SH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Total time on ice all situations"
    }
  }, [_vm._v("Total TOI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals for even handed"
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals against even handed"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals +/- even handed"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Faceoffs won / Faceoffs taken all situations"
    }
  }, [_vm._v("FO")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances for even handed"
    }
  }, [_vm._v("Shots For")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances against even handed"
    }
  }, [_vm._v("Shots Against")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances +/- even handed"
    }
  }, [_vm._v("Shots Diff")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Shots on target all situations"
    }
  }, [_vm._v("SOT")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI average shift time all situations"
    }
  }, [_vm._v("AvgShifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI 5v5 time even handed"
    }
  }, [_vm._v("EH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI power play time"
    }
  }, [_vm._v("PP")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI short handed time"
    }
  }, [_vm._v("SH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Total time on ice all situations"
    }
  }, [_vm._v("Total TOI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Season AVG Shift")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Est Time based on season average"
    }
  }, [_vm._v("EST Total TOI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals for even handed"
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals against even handed"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals +/- even handed"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Faceoffs won / Faceoffs taken all situations"
    }
  }, [_vm._v("FO")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances for even handed"
    }
  }, [_vm._v("Shots For")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances against even handed"
    }
  }, [_vm._v("Shots Against")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances +/- even handed"
    }
  }, [_vm._v("Shots Diff")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Shots on target all situations"
    }
  }, [_vm._v("SOT")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI average shift time all situations"
    }
  }, [_vm._v("AvgShifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI 5v5 time even handed"
    }
  }, [_vm._v("EH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI power play time"
    }
  }, [_vm._v("PP")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI short handed time"
    }
  }, [_vm._v("SH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Total time on ice all situations"
    }
  }, [_vm._v("Total TOI")])])
}]}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Game Summary")]), _vm._v(" "), _c('div', {
    staticClass: "small-box"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Goals")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.gameInfo.home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_goals_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_goals_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_goals_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_goals_ot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_goals_pp) + " / " + _vm._s(_vm.GameSummary.situation_opts[0].PPTotal))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.GameSummary.home_goals_total))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.gameInfo.away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_goals_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_goals_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_goals_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_goals_ot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_goals_pp) + " /  " + _vm._s(_vm.GameSummary.situation_opts[0].SHTotal))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.GameSummary.away_goals_total))])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("All Attempts")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.gameInfo.home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_shots_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_shots_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_shots_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_shots_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.GameSummary.home_shots_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_shots_total - _vm.GameSummary.away_shots_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.gameInfo.away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_shots_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_shots_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_shots_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_shots_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.GameSummary.away_shots_total))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("On Target")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.gameInfo.home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_sot_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_sot_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_sot_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_sot_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.GameSummary.home_sot_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_sot_total - _vm.GameSummary.away_sot_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.gameInfo.away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_sot_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_sot_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_sot_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_sot_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.GameSummary.away_sot_total))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.gameInfo.home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_fo_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_fo_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_fo_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_fo_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.GameSummary.home_fo_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.home_fo_total - _vm.GameSummary.away_fo_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.gameInfo.away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_fo_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_fo_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_fo_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GameSummary.away_fo_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.GameSummary.away_fo_total))])]), _vm._v(" "), _c('td')])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("PP")]), _vm._v(" "), _c('th', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_c('b', [_vm._v("Shots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_c('b', [_vm._v("Faceoffs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
}]}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view', {
    key: _vm.$route.fullPath
  }), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h4', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "is-mobile"
  }, [_c('router-link', {
    staticClass: "button is-success",
    attrs: {
      "to": "/season-totals/team-select"
    }
  }, [_vm._v("Back to Teams")])], 1), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "title is-child is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('img', {
    staticClass: "player_icon",
    staticStyle: {
      "margin": "0 auto",
      "display": "block"
    },
    attrs: {
      "src": _vm.Faceoffs.team.logo
    }
  }), _c('h1', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.Faceoffs.team.name) + " Stats")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Faceoffs")]), _vm._v(" "), _c('button', {
    staticClass: "button is-default",
    staticStyle: {
      "margin": "0 80%"
    },
    on: {
      "click": function($event) {
        return _vm.toggleFaceoffs()
      }
    }
  }, [_vm._v("Show / Hide")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFaceoffOpen),
      expression: "isFaceoffOpen"
    }],
    staticClass: "faceoffs"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'doughnut',
      "data": _vm.fo_total_chart,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(this.Faceoffs.total_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.total_wins))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.total_losses))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.total_win_percent))])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'doughnut',
      "data": _vm.fo_total_lane_chart,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Left")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.taken_left))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_left))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_left_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.losses_left))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Center")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.taken_center))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_center))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_center_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.losses_center))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Right")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.taken_right))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_right))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_right_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.losses_right))])])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.fo_player_series,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((this.Faceoffs.players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fol))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fow_percent))])])
  }), 0)])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.fo_player_lane,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((this.Faceoffs.players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_left_wins) + " of " + _vm._s(player.player_lane_left_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_left_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_center_wins) + " of " + _vm._s(player.player_lane_center_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_center_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_right_wins) + " of " + _vm._s(player.player_lane_right_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_right_percent))])])
  }), 0)])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.fo_player_zone,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(10), _vm._v(" "), _c('tbody', _vm._l((this.Faceoffs.players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_offensive_wins) + " of " + _vm._s(player.player_zone_offensive_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_offensive_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_neutral_wins) + " of " + _vm._s(player.player_zone_neutral_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_neutral_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_offensive_wins) + " of " + _vm._s(player.player_zone_defensive_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_defensive_percent))])])
  }), 0)])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.fo_player_situation,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(12), _vm._v(" "), _c('tbody', _vm._l((this.Faceoffs.players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_fot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_eh_wins) + " of " + _vm._s(player.player_situation_eh_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_eh_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_pp_wins) + " of " + _vm._s(player.player_situation_pp_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_pp_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_sh_wins) + " of " + _vm._s(player.player_situation_sh_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_sh_percent))])])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(13), _vm._v(" "), _c('button', {
    staticClass: "button is-default",
    staticStyle: {
      "margin": "0 80%"
    },
    on: {
      "click": function($event) {
        return _vm.toggleFaceoffsPvp()
      }
    }
  }, [_vm._v("Show / Hide")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFaceoffsPvp),
      expression: "isFaceoffsPvp"
    }]
  }, _vm._l((this.Faceoffs.players), function(player) {
    return _c('div', [_c('div', {
      staticClass: "column",
      staticStyle: {
        "margin": "0 auto"
      }
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(player.player_id))])]), _vm._v(" "), _c('div', {
      staticClass: "block content"
    }, [_c('table', {
      staticClass: "table is-responsive"
    }, [_vm._m(14, true), _vm._v(" "), _c('tbody', _vm._l((player.player_vs_player), function(away_player) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(away_player.away_player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.wins))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.win_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.leftWins) + " of " + _vm._s(away_player.leftTaken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.centerWins) + " of " + _vm._s(away_player.centerTaken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.rightWins) + " of " + _vm._s(away_player.rightTaken))])])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'doughnut',
      "data": _vm.so_total_chart,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(17), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Cardiff Devils")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.home_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.home_total_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.home_total_missed_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.home_total_blocked))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.average_total_home))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(this.Faceoffs.team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.away_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.away_total_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.away_total_missed_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.away_total_blocked))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.average_total_away))])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "away-shots"
    }
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "child is-box box"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateHeatmaps()
      }]
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.text) + "\n                            ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodSelect),
      expression: "periodSelect"
    }],
    staticClass: "select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateHeatmaps()
      }]
    }
  }, _vm._l((_vm.periodOptions), function(pOption) {
    return _c('option', {
      domProps: {
        "value": pOption.value
      }
    }, [_vm._v("\n                          " + _vm._s(pOption.text) + "\n                          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "block styles-box"
  }, [_vm._m(20), _vm._v(" "), _c('p', [_c('slider', {
    staticClass: "slider is-primary",
    attrs: {
      "type": "primary",
      "value": 10,
      "max": 24,
      "min": 5,
      "step": 2
    },
    on: {
      "change": _vm.updateHeatmapSize
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-6"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Cardiff Devils - All shots")]), _vm._v(" "), _c('canvas', {
    ref: "home_shots_canvas",
    staticClass: "is-canvas-responsive",
    staticStyle: {
      "background": "url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"
    },
    attrs: {
      "width": "600",
      "height": "530"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(this.Faceoffs.team.name) + " - All shots")]), _vm._v(" "), _c('canvas', {
    ref: "away_shots_canvas",
    staticClass: "is-canvas-responsive",
    staticStyle: {
      "background": "url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"
    },
    attrs: {
      "width": "600",
      "height": "530"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-6"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Cardiff Devils - Power Play")]), _vm._v(" "), _c('canvas', {
    ref: "home_shots_canvas_pp",
    staticClass: "is-canvas-responsive",
    staticStyle: {
      "background": "url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"
    },
    attrs: {
      "width": "600",
      "height": "530"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(this.Faceoffs.team.name) + " - Power Play")]), _vm._v(" "), _c('canvas', {
    ref: "away_shots_canvas_pp",
    staticClass: "is-canvas-responsive",
    staticStyle: {
      "background": "url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"
    },
    attrs: {
      "width": "600",
      "height": "530"
    }
  })])])])]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.shot_player_totals,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(22), _vm._v(" "), _c('tbody', _vm._l((this.Shots.home_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_missed_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_blocked))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_avg_game))])])
  }), 0)])]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.shot_away_player_totals,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(24), _vm._v(" "), _c('tbody', _vm._l((this.Shots.away_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_missed_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_blocked))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_avg_game))])])
  }), 0)])]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.shot_player_situational,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(26), _vm._v(" "), _c('tbody', _vm._l((this.Shots.home_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_on_net))])])
  }), 0)])]), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.shot_away_player_situational,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(28), _vm._v(" "), _c('tbody', _vm._l((this.Shots.away_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_on_net))])])
  }), 0)])])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(29), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'doughnut',
      "data": _vm.to_totals,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(31), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(this.Turnovers.home_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Turnovers.home_total_offensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Turnovers.home_total_neutral))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Turnovers.home_total_defensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Turnovers.average_total_home))])])])])]), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.to_player_totals,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(33), _vm._v(" "), _c('tbody', _vm._l((this.Turnovers.home_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_offensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_neutral))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_defensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_avg_game))])])
  }), 0)])]), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.to_player_situational,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content",
    attrs: {
      "id": "pp"
    }
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(35), _vm._v(" "), _c('tbody', _vm._l((this.Turnovers.home_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_offensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_neutral))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_defensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_offensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_neutral))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_defensive))])])
  }), 0)])])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'doughnut',
      "data": _vm.hit_totals,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(38), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(this.Hits.home_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Hits.average_total_home))])])])])]), _vm._v(" "), _vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.hit_player_totals,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(40), _vm._v(" "), _c('tbody', _vm._l((this.Hits.home_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_avg_game))])])
  }), 0)])])]), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "is-child is-vertical",
    staticStyle: {
      "margin": "25px auto"
    }
  }, [_c('p', [_c('b', [_vm._v("Latest Updates:"), _c('br'), _vm._v("Load time increase due to render of heatmaps!?"), _c('br'), _vm._v("Added Faceoff PvP"), _c('br'), _vm._v("Added Graphs for each segment"), _c('br'), _vm._v("Added basic map controls - Shot type, Period, Shot Size")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Teams Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Wins - Losses")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("FOW")]), _vm._v(" "), _c('th', [_vm._v("FOL")]), _vm._v(" "), _c('th', [_vm._v("FOW%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Team By Lane "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Left - Center - Right")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("FOW")]), _vm._v(" "), _c('th', [_vm._v("FOW%")]), _vm._v(" "), _c('th', [_vm._v("FOL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Player Totals")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Taken - Wins - Losses - Win %")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("FOW")]), _vm._v(" "), _c('th', [_vm._v("FOL")]), _vm._v(" "), _c('th', [_vm._v("FOW%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Player By Lane "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Left - Center - Right")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("Left")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Center")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Right")]), _vm._v(" "), _c('th', [_vm._v("%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Player By Zone"), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Offensive - Neutral - Defensive")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("Offensive")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Neutral")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Defensive")]), _vm._v(" "), _c('th', [_vm._v("%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Player By Situation"), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Even Handed - Power Play - Short Handed")]), _c('p')])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("Even Handed")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Power Play")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Short Handed")]), _vm._v(" "), _c('th', [_vm._v("%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_vm._v("Player Vs Player"), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Wins/Losses Lanes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Vs Player")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("Wins")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Left")]), _vm._v(" "), _c('th', [_vm._v("Center")]), _vm._v(" "), _c('th', [_vm._v("Right")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Shots")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Teams Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("On Net - Missed Net - Blocked - Avgerage / Games Played")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("On Net")]), _vm._v(" "), _c('th', [_vm._v("Missed Net")]), _vm._v(" "), _c('th', [_vm._v("Blocked")]), _vm._v(" "), _c('th', [_vm._v("Avg total shots per game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                        Shotmaps "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("All shots, all situations / All shots Powerplay (our Pk)")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "bold-el"
  }, [_vm._v("Map Controls")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Heatmap size:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Player Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("On Net - Missed Net - Blocked - Avgerage / Games Played")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("On Net")]), _vm._v(" "), _c('th', [_vm._v("Missed Net")]), _vm._v(" "), _c('th', [_vm._v("Blocked")]), _vm._v(" "), _c('th', [_vm._v("Avg / Game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                     Against Player Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("On Net - Missed Net - Blocked - Avgerage / Games Played")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("On Net")]), _vm._v(" "), _c('th', [_vm._v("Missed Net")]), _vm._v(" "), _c('th', [_vm._v("Blocked")]), _vm._v(" "), _c('th', [_vm._v("Avg / Game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                     Home Situational  "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Power Play On Net - Short Handed On Net")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Power Play On Net")]), _vm._v(" "), _c('th', [_vm._v("Short Handed On Net")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                     Away Situational "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Power Play On Net - Short Handed On Net")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Power Play On Net")]), _vm._v(" "), _c('th', [_vm._v("Short Handed On Net")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Turnovers")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                     Team totals"), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Offensive - Neutral - Defensive - Average / Game")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Offensive")]), _vm._v(" "), _c('th', [_vm._v("Neutral")]), _vm._v(" "), _c('th', [_vm._v("Defensive")]), _vm._v(" "), _c('th', [_vm._v("Avg total turnovers per game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Player Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Offensive - Neutral - Defensive - Avgerage / Games Played")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Offensive")]), _vm._v(" "), _c('th', [_vm._v("Neutral")]), _vm._v(" "), _c('th', [_vm._v("Defensive")]), _vm._v(" "), _c('th', [_vm._v("Avg / Game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Situational Player Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(" PP / SH Total - Offensive - Neutral - Defensive ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("PP Total")]), _vm._v(" "), _c('th', [_vm._v("PP Offensive")]), _vm._v(" "), _c('th', [_vm._v("PP Neutral")]), _vm._v(" "), _c('th', [_vm._v("PP Defensive")]), _vm._v(" "), _c('th', [_vm._v("SH Total")]), _vm._v(" "), _c('th', [_vm._v("SH Offensive")]), _vm._v(" "), _c('th', [_vm._v("SH Neutral")]), _vm._v(" "), _c('th', [_vm._v("SH Defensive")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Hits")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                     Team totals"), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Hit Count - Average / Game")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Avg hits per game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Player Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Hit Count -Avgerage / Games Played")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Hit Count")]), _vm._v(" "), _c('th', [_vm._v("Avg / Game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "tile is-child box"
  }, [_c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Penalty Minutes (PIMS)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "tile is-child box"
  }, [_c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Goals")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  })])
}]}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor is-centered"
  }, [_c('div', {
    staticClass: "tile is-parent is-5"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Edit Faceoff")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.updateFaceoff
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Faceoff.home_player.player_number),
      expression: "Faceoff.home_player.player_number"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Player Number"
    },
    domProps: {
      "value": (_vm.Faceoff.home_player.player_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Faceoff.home_player, "player_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Faceoff.away_player.player_number),
      expression: "Faceoff.away_player.player_number"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Against Player"
    },
    domProps: {
      "value": (_vm.Faceoff.away_player.player_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Faceoff.away_player, "player_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zoneSelect),
      expression: "zoneSelect"
    }],
    staticClass: "select is-fullwidth",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zoneSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.zoneOption), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.laneSelect),
      expression: "laneSelect"
    }],
    staticClass: "select is-fullwidth",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.laneSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.laneOption), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resultSelect),
      expression: "resultSelect"
    }],
    staticClass: "select is-fullwidth",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.resultSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.resultOption), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodSelect),
      expression: "periodSelect"
    }],
    staticClass: "select is-fullwidth",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.periodOption), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Faceoff.situation.secondary_situation),
      expression: "Faceoff.situation.secondary_situation"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Situation of Play i.e. EH5v5"
    },
    domProps: {
      "value": (_vm.Faceoff.situation.secondary_situation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Faceoff.situation, "secondary_situation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Pick game time",
      "config": {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        time_24hr: true
      }
    },
    model: {
      value: (_vm.Faceoff.game_time),
      callback: function($$v) {
        _vm.$set(_vm.Faceoff, "game_time", $$v)
      },
      expression: "Faceoff.game_time"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "name": "submit"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-small",
    attrs: {
      "to": '/editors/faceoff/:gameId'
    }
  }, [_vm._v("Cancel")])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Home Player")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Away Player")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Zone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Lane")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Result")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Period")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Game Time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  })])
}]}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('box-score', {
    attrs: {
      "gameId": this.$route.params.gameId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-12 is-vertical"
  }, [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Goals - " + _vm._s(_vm.getTotalCountGoals))]), _vm._v(" "), _c('button', {
    staticClass: "button is-success is-large"
  }, [_vm._v("New Item")]), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  }, [_c('table', {
    staticClass: "table is-stripped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.CleanGoals), function(record) {
    return _c('tr', {
      key: record.id,
      class: {
        'other': record.goal_team !== 'Cardiff Devils',
        'devils': record.goal_team === 'Cardiff Devils'
      },
      on: {
        "change": function($event) {
          return _vm.updateGoal(record)
        }
      }
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.goal_team),
        expression: "record.goal_team"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": (record.goal_team)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(record, "goal_team", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.game_time_global),
        expression: "record.game_time_global"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (record.game_time_global)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(record, "game_time_global", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.period),
        expression: "record.period"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (record.period)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(record, "period", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.situation_id),
        expression: "record.situation_id"
      }],
      staticClass: "select is-small",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(record, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateGoal(record)
        }]
      }
    }, _vm._l((_vm.SituationOptions), function(option) {
      return _c('option', {
        key: option.text,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.goal_scorer_id),
        expression: "record.goal_scorer_id"
      }],
      staticClass: "select is-small",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(record, "goal_scorer_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateGoal(record)
        }]
      }
    }, _vm._l((_vm.AllPlayerOptions), function(option) {
      return _c('option', {
        key: option.text,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.first_assist_id),
        expression: "record.first_assist_id"
      }],
      staticClass: "select is-small",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(record, "first_assist_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateGoal(record)
        }]
      }
    }, _vm._l((_vm.AllPlayerOptions), function(option) {
      return _c('option', {
        key: option.text,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.second_assist_id),
        expression: "record.second_assist_id"
      }],
      staticClass: "select is-small",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(record, "second_assist_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateGoal(record)
        }]
      }
    }, _vm._l((_vm.AllPlayerOptions), function(option) {
      return _c('option', {
        key: option.text,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.on_ice_1_id),
        expression: "record.on_ice_1_id"
      }],
      staticClass: "select is-small",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(record, "on_ice_1_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateGoal(record)
        }]
      }
    }, _vm._l((_vm.AllPlayerOptions), function(option) {
      return _c('option', {
        key: option.text,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.on_ice_2_id),
        expression: "record.on_ice_2_id"
      }],
      staticClass: "select is-small",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(record, "on_ice_2_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateGoal(record)
        }]
      }
    }, _vm._l((_vm.AllPlayerOptions), function(option) {
      return _c('option', {
        key: option.text,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.on_ice_3_id),
        expression: "record.on_ice_3_id"
      }],
      staticClass: "select is-small",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(record, "on_ice_3_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateGoal(record)
        }]
      }
    }, _vm._l((_vm.AllPlayerOptions), function(option) {
      return _c('option', {
        key: option.text,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.on_ice_4_id),
        expression: "record.on_ice_4_id"
      }],
      staticClass: "select is-small",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(record, "on_ice_4_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateGoal(record)
        }]
      }
    }, _vm._l((_vm.AllPlayerOptions), function(option) {
      return _c('option', {
        key: option.text,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.on_ice_5_id),
        expression: "record.on_ice_5_id"
      }],
      staticClass: "select is-small",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(record, "on_ice_5_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateGoal(record)
        }]
      }
    }, _vm._l((_vm.AllPlayerOptions), function(option) {
      return _c('option', {
        key: option.text,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.on_ice_6_id),
        expression: "record.on_ice_6_id"
      }],
      staticClass: "select is-small",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(record, "on_ice_6_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateGoal(record)
        }]
      }
    }, _vm._l((_vm.AllPlayerOptions), function(option) {
      return _c('option', {
        key: option.text,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    }), 0)]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-small",
      class: {
        'is-success': record.is_verified == 1,
        'is-danger': record.is_verified == 0
      }
    }, [_vm._v("Verify")])]), _vm._v(" "), _vm._m(2, true)])
  }), 0)])])])]), _vm._v(" "), _vm._m(3)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Get Official Data:")]), _vm._v(" "), _c('select', {
    staticClass: "select is-medium"
  }, [_c('option', [_vm._v("Test")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("Time")]), _vm._v(" "), _c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Situation")]), _vm._v(" "), _c('th', [_vm._v("Goal Scorer")]), _vm._v(" "), _c('th', [_vm._v("First Assist")]), _vm._v(" "), _c('th', [_vm._v("Second Assist")]), _vm._v(" "), _c('th', [_vm._v("P1")]), _vm._v(" "), _c('th', [_vm._v("P2")]), _vm._v(" "), _c('th', [_vm._v("P3")]), _vm._v(" "), _c('th', [_vm._v("P4")]), _vm._v(" "), _c('th', [_vm._v("P5")]), _vm._v(" "), _c('th', [_vm._v("P6")]), _vm._v(" "), _c('th', [_vm._v("Verify")]), _vm._v(" "), _c('th', [_vm._v("Del")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('button', {
    staticClass: "button is-danger is-small"
  }, [_vm._v("Delete")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "is-child box",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("PIMS")]), _vm._v(" "), _c('button', {
    staticClass: "button is-success is-large"
  }, [_vm._v("New Item")]), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  })])])
}]}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('shot-quality', {
    attrs: {
      "game_id": this.gameId,
      "home_name": this.gameInfo.home_team.name,
      "away_name": this.gameInfo.away_team.name
    }
  }), _vm._v(" "), _c('shots-heatmap', {
    attrs: {
      "gameId": this.gameId,
      "home_name": this.gameInfo.home_team.name,
      "away_name": this.gameInfo.away_team.name
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Faceoffs - Team vs Team")]), _vm._v(" "), _c('article', {
    staticClass: "is-child box"
  }, [_c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("Filters")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PeriodSelected),
      expression: "PeriodSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.PeriodSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchFaceoffs]
    }
  }, _vm._l((_vm.PeriodOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SituationSelected),
      expression: "SituationSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SituationSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchFaceoffs]
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Home Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.HomeSelection),
      expression: "HomeSelection"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.HomeSelection = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchFaceoffs]
    }
  }, _vm._l((_vm.HomeTeamOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Away Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AwaySelection),
      expression: "AwaySelection"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.AwaySelection = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchFaceoffs]
    }
  }, _vm._l((_vm.AwayTeamOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Percentages?")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usePercentage),
      expression: "usePercentage"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.usePercentage) ? _vm._i(_vm.usePercentage, null) > -1 : (_vm.usePercentage)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.usePercentage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.usePercentage = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.usePercentage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.usePercentage = $$c
        }
      }, _vm.renderCharts]
    }
  })])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("Show / Hide")]), _vm._v(" "), (_vm.show) ? _c('div', [_c('canvas', {
    ref: "map",
    staticClass: "fo_vs",
    attrs: {
      "id": "map",
      "width": "1000",
      "height": "431"
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports={render:function (){
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ( _obj = {
      'vue-bulma-tabs': true
    }, _obj[("is-layout-" + _vm.layout)] = true, _obj )
  }, [_c('div', {
    class: ( _obj$1 = {
      tabs: true
    }, _obj$1[("is-" + _vm.size)] = _vm.size, _obj$1[("is-" + _vm.alignment)] = _vm.alignment, _obj$1[("is-" + _vm.type)] = _vm.type, _obj$1['is-fullwidth'] =  _vm.isFullwidth, _obj$1 )
  }, [_vm._t("left-tab-list"), _vm._v(" "), _c('tab-list', _vm._l((_vm.tabPanes), function(tab, index) {
    return _c('li', {
      class: {
        'is-active': _vm.isActived(index),
        'is-disabled': tab.disabled,
        'is-flex': true
      },
      attrs: {
        "role": "tab",
        "aria-selected": _vm.isActived(index) ? 'true' : 'false',
        "aria-expanded": _vm.isActived(index) ? 'true' : 'false',
        "aria-disabled": tab.disabled ? 'true' : 'false',
        "selected": _vm.isActived(index),
        "disabled": tab.disabled
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('a', {
      staticClass: "is-unselectable"
    }, [(tab.icon) ? _c('span', {
      class: ['icon', {
        'is-small': _vm.size !== 'large'
      }]
    }, [_c('i', {
      class: tab.icon
    })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(tab.label))])])])
  }), 0), _vm._v(" "), _vm._t("right-tab-list")], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content is-flex"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary is-large",
    staticStyle: {
      "margin-bottom": "20px"
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Problem loading? Click me to try again.")]), _vm._v(" "), _c('p', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": 'mailto://admin@roblutken.co.uk'
    }
  }, [_vm._m(0)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://twitter.com/RobLutken93"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-code"
  })]), _vm._v(" with "), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" by "), _c('a', [_vm._v("Robert Lutken")]), _vm._v(".")])
}]}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('button', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("Show / Hide")]), _vm._v(" "), (_vm.show) ? _c('div', [_vm._t("filter"), _vm._v(" "), _vm._t("graph"), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('thead', _vm._l((_vm.headers), function(heading) {
    return _c('th', {
      key: heading
    }, [_vm._v("\n              " + _vm._s(heading) + "\n            ")])
  }), 0), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row) {
    return _c('tr', {
      key: row.id
    }, _vm._l((row), function(data) {
      return _c('td', {
        key: data.id
      }, [_vm._v(_vm._s(data))])
    }), 0)
  }), 0)])])], 2) : _vm._e(), _vm._v(" "), _vm._t("situational"), _vm._v(" "), _vm._t("average_game"), _vm._v(" "), _vm._t("average_sixty")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: _vm.classObject,
    attrs: {
      "role": "tablist"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('graph-table', {
    attrs: {
      "defaultShow": "true",
      "id": "ZoneExits",
      "heading": "Zone Exits",
      "headers": _vm.ZoneExitPlayerHeadings,
      "tableData": _vm.sortByZoneExitData
    }
  }, [_c('template', {
    slot: "filter"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.chartStackedData,
      "options": _vm.stacked_options
    }
  })], 1)], 2)], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Zone",
      "heading": "Zone Entries",
      "headers": _vm.ZoneEntriesAutoPlayerHeadings,
      "tableData": _vm.sortByZoneEntriesAutoData
    }
  }, [_c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.chartZoneEntriesData,
      "options": _vm.multi_options
    }
  })], 1)])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('game-summary', {
    attrs: {
      "gameId": this.gameId,
      "period": 0,
      "gameInfo": this.gameInfo
    }
  }), _vm._v(" "), _c('gamesheet', {
    attrs: {
      "gameId": this.gameId,
      "period": 0
    }
  }), _vm._v(" "), _c('faceoffs', {
    attrs: {
      "gameId": this.gameId,
      "period": 0
    }
  }), _vm._v(" "), _c('shots', {
    attrs: {
      "gameId": this.gameId,
      "period": 0,
      "gameInfo": this.gameInfo
    }
  }), _vm._v(" "), _c('turnovers', {
    attrs: {
      "gameId": this.gameId,
      "period": 0
    }
  }), _vm._v(" "), _c('hits', {
    attrs: {
      "gameId": this.gameId,
      "period": 0
    }
  }), _vm._v(" "), _c('zone-entries', {
    attrs: {
      "period": 0
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "zone-entries"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('graph-table', {
    attrs: {
      "defaultShow": "true",
      "id": "ZoneExits",
      "heading": "Zone Exits",
      "headers": _vm.ZoneExitPlayerHeadings,
      "tableData": _vm.sortByZoneExitData
    }
  }, [_c('template', {
    slot: "filter"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.chartStackedData,
      "options": _vm.stacked_options
    }
  })], 1)], 2)], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Zone",
      "heading": "Zone Entries",
      "headers": _vm.ZoneEntriesAutoPlayerHeadings,
      "tableData": _vm.sortByZoneEntriesAutoData
    }
  }, [_c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.chartZoneEntriesData,
      "options": _vm.multi_options
    }
  })], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 04/02/2019 11:22PM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("Zone Entries: NEW Graph & Chart")]), _vm._v(" "), _c('li', [_vm._v("Zone Entries: Updated graph colours for Controlled / Uncontrolled.")]), _vm._v(" "), _c('li', [_vm._v("Zone Entries: Added total controlled / total uncontrolled (Mostly for sorting the graph).")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
}]}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    staticClass: "chartjs",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  })
},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "shots"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('TeamShotMap'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Shotss",
      "heading": "Shots",
      "headers": _vm.ShotsPlayerHeadings,
      "tableData": _vm.sortByShotsData
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sort")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FilterSelected),
      expression: "FilterSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.FilterSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByShotsData]
    }
  }, _vm._l((_vm.ShotsPlayerFilters), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SituationSelected),
      expression: "SituationSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SituationSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.chartData,
      "options": _vm.bar_options
    }
  })], 1)], 2)], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "player_shotmap"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Shotss",
      "heading": "Player Shotmap",
      "headers": _vm.PlayerShotmapHeadings,
      "tableData": _vm.sortByPlayerShotmapData
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player(s)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.PlayerOptions,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "preserve-search": true,
      "placeholder": "Pick some",
      "label": "name",
      "track-by": "name",
      "preselect-first": true
    },
    on: {
      "close": _vm.fetchSeasonShotmaps
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.PlayerSelected.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(_vm.PlayerSelected.length) + " options selected")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.PlayerSelected),
      callback: function($$v) {
        _vm.PlayerSelected = $$v
      },
      expression: "PlayerSelected"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Shot Type(s)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.ShotTypeOptions,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "preserve-search": true,
      "placeholder": "Select Shot Type(s)",
      "label": "name",
      "track-by": "name",
      "preselect-first": true
    },
    on: {
      "close": _vm.fetchSeasonShotmaps
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.ShotTypeSelected.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(_vm.ShotTypeSelected.length) + " options selected")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.ShotTypeSelected),
      callback: function($$v) {
        _vm.ShotTypeSelected = $$v
      },
      expression: "ShotTypeSelected"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SituationSelected),
      expression: "SituationSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SituationSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonShotmaps]
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.UseHeatmap = !_vm.UseHeatmap;
        _vm.fetchSeasonShotmaps()
      }
    }
  }, [_vm._v("Heatmap / Shotmap")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-centered"
  }, [(_vm.UseHeatmap) ? _c('label', {
    staticClass: "label"
  }, [_vm._v("Point Radius")]) : _vm._e(), _vm._v(" "), (_vm.UseHeatmap) ? _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RadiusSelected),
      expression: "RadiusSelected"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "150"
    },
    domProps: {
      "value": (_vm.RadiusSelected)
    },
    on: {
      "change": _vm.renderHeatmap,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RadiusSelected = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-half is-centered"
  }, [(_vm.UseHeatmap) ? _c('label', {
    staticClass: "label"
  }, [_vm._v("Point Blur")]) : _vm._e(), _vm._v(" "), (_vm.UseHeatmap) ? _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BlurSelected),
      expression: "BlurSelected"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "150"
    },
    domProps: {
      "value": (_vm.BlurSelected)
    },
    on: {
      "change": _vm.renderHeatmap,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BlurSelected = $event.target.value
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('canvas', {
    ref: "shotmap_key",
    attrs: {
      "id": "shotmap_key",
      "height": "50"
    }
  })])]), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('canvas', {
    ref: "player_shot_canvas",
    staticClass: "is-canvas-responsive",
    staticStyle: {
      "background": "url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"
    },
    attrs: {
      "id": "shotmap",
      "width": "600",
      "height": "530"
    }
  })])])])], 2)], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameByGame"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "id": "GameByGame",
      "heading": "Game By Game"
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player(s)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.PlayerOptions,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "preserve-search": true,
      "placeholder": "Pick some",
      "label": "name",
      "track-by": "name",
      "preselect-first": true
    },
    on: {
      "close": _vm.fetchSeasonShotmaps
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.PlayerSelected.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(_vm.PlayerSelected.length) + " options selected")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.PlayerSelected),
      callback: function($$v) {
        _vm.PlayerSelected = $$v
      },
      expression: "PlayerSelected"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Data Selection")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameDataSelected),
      expression: "GameByGameDataSelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.GameByGameDataSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.GameByGameDataOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('h1', {
    staticClass: "label"
  }, [_vm._v("Graph Options")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fill")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameFill),
      expression: "GameByGameFill"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.GameByGameFill) ? _vm._i(_vm.GameByGameFill, null) > -1 : (_vm.GameByGameFill)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.GameByGameFill,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.GameByGameFill = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.GameByGameFill = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.GameByGameFill = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Line Tension")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameTension),
      expression: "GameByGameTension"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "0.0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.GameByGameTension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.GameByGameTension = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'line',
      "data": _vm.buildChartData,
      "options": _vm.line_options
    }
  })], 1)], 2)], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "chunked"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Chunked",
      "heading": "Chunked Shot Data"
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player(s)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.PlayerOptions,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "preserve-search": true,
      "placeholder": "Pick some",
      "label": "name",
      "track-by": "name",
      "preselect-first": true
    },
    on: {
      "close": _vm.fetchSeasonShotmaps
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.PlayerSelected.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(_vm.PlayerSelected.length) + " options selected")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.PlayerSelected),
      callback: function($$v) {
        _vm.PlayerSelected = $$v
      },
      expression: "PlayerSelected"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Data Selection")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameDataSelected),
      expression: "GameByGameDataSelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.GameByGameDataSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.GameByGameDataOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('h1', {
    staticClass: "label"
  }, [_vm._v("Graph Options")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fill")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameFill),
      expression: "GameByGameFill"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.GameByGameFill) ? _vm._i(_vm.GameByGameFill, null) > -1 : (_vm.GameByGameFill)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.GameByGameFill,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.GameByGameFill = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.GameByGameFill = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.GameByGameFill = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Line Tension")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameTension),
      expression: "GameByGameTension"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "0.0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.GameByGameTension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.GameByGameTension = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sample Size")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RollingLimit),
      expression: "RollingLimit"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "5",
      "max": "30",
      "step": "1"
    },
    domProps: {
      "value": (_vm.RollingLimit)
    },
    on: {
      "change": function($event) {
        return _vm.fetchGraphStats()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RollingLimit = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'line',
      "data": _vm.buildChunkedChartData,
      "options": _vm.line_options
    }
  })], 1)], 2)], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "rolling"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Rolling",
      "heading": "Rolling Shot Data"
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player(s)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.PlayerOptions,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "preserve-search": true,
      "placeholder": "Pick some",
      "label": "name",
      "track-by": "name",
      "preselect-first": true
    },
    on: {
      "close": _vm.fetchSeasonShotmaps
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.PlayerSelected.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(_vm.PlayerSelected.length) + " options selected")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.PlayerSelected),
      callback: function($$v) {
        _vm.PlayerSelected = $$v
      },
      expression: "PlayerSelected"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Data Selection")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameDataSelected),
      expression: "GameByGameDataSelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.GameByGameDataSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.GameByGameDataOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('h1', {
    staticClass: "label"
  }, [_vm._v("Graph Options")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fill")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameFill),
      expression: "GameByGameFill"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.GameByGameFill) ? _vm._i(_vm.GameByGameFill, null) > -1 : (_vm.GameByGameFill)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.GameByGameFill,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.GameByGameFill = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.GameByGameFill = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.GameByGameFill = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Line Tension")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameTension),
      expression: "GameByGameTension"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "0.0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.GameByGameTension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.GameByGameTension = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sample Size")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RollingLimit),
      expression: "RollingLimit"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "5",
      "max": "30",
      "step": "1"
    },
    domProps: {
      "value": (_vm.RollingLimit)
    },
    on: {
      "change": function($event) {
        return _vm.fetchGraphStats()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RollingLimit = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'line',
      "data": _vm.buildRollingChartData,
      "options": _vm.line_options
    }
  })], 1)], 2)], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "cumulative"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Cumulative",
      "heading": "Cumulative Shot Data"
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player(s)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.PlayerOptions,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "preserve-search": true,
      "placeholder": "Pick some",
      "label": "name",
      "track-by": "name",
      "preselect-first": true
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.PlayerSelected.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(_vm.PlayerSelected.length) + " options selected")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.PlayerSelected),
      callback: function($$v) {
        _vm.PlayerSelected = $$v
      },
      expression: "PlayerSelected"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Data Selection")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameDataSelected),
      expression: "GameByGameDataSelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.GameByGameDataSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.GameByGameDataOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('h1', {
    staticClass: "label"
  }, [_vm._v("Graph Options")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fill")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameFill),
      expression: "GameByGameFill"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.GameByGameFill) ? _vm._i(_vm.GameByGameFill, null) > -1 : (_vm.GameByGameFill)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.GameByGameFill,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.GameByGameFill = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.GameByGameFill = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.GameByGameFill = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Line Tension")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameTension),
      expression: "GameByGameTension"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "0.0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.GameByGameTension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.GameByGameTension = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'line',
      "data": _vm.buildCumulativeChartData,
      "options": _vm.line_options
    }
  })], 1)], 2)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 23/01/2019 12:36AM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Added Game by Game shots graph."), _c('span', {
    staticStyle: {
      "color": "darkorange"
    }
  }, [_vm._v(" Beware some games are missing data i.e. NOT / GUI / GLAS Away games. Also, Game By Game won't account for the global filter below. TODO!")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Added Chunked 5 Game shots graph."), _c('span', {
    staticStyle: {
      "color": "darkorange"
    }
  }, [_vm._v(" ''")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Added Rolling shots graph."), _c('span', {
    staticStyle: {
      "color": "darkorange"
    }
  }, [_vm._v(" ''")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
}]}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gamesheet', {
    attrs: {
      "gameId": this.gameId,
      "period": 0,
      "gameInfo": this.gameInfo,
      "team": 0
    }
  }), _vm._v(" "), _c('gamesheet', {
    attrs: {
      "gameId": this.gameId,
      "period": 0,
      "gameInfo": this.gameInfo,
      "team": 1
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "time-on-ice"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "TimeOnIce",
      "heading": "Time On Ice",
      "headers": _vm.TimeOnIcePlayerHeadings,
      "tableData": _vm.sortByTimeOnIceData
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sort")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FilterSelected),
      expression: "FilterSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.FilterSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByTimeOnIceData]
    }
  }, _vm._l((_vm.TimeOnIcePlayerFilters), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  })], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 22/10/2018 11:59AM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("Please beware, this is work in progress!")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
}]}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Zone Entries")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-uppercase has-text-centered"
  }, [_vm._v("Even Handed Only")]), _vm._v(" "), _c('div', {
    staticClass: "small-box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Controlled Zone Entries")]), _vm._v(" "), _c('chart', {
    ref: "apex_ze_control_chart",
    attrs: {
      "width": "100%",
      "type": "bar",
      "options": _vm.apex_ze_player_options,
      "series": _vm.apex_ze_control_series
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Uncontrolled Zone Entries")]), _vm._v(" "), _c('chart', {
    ref: "apex_ze_uncontrol_chart",
    attrs: {
      "width": "100%",
      "type": "bar",
      "options": _vm.apex_ze_player_options,
      "series": _vm.apex_ze_uncontrol_series
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('div', [_c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/match-stats/zone-entries",
      "postData": [{
        team_id: 1,
        game_id: this.gameId
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'Control Success',
          prop: 'controlled_success'
        },
        {
          title: 'Control Fail',
          prop: 'controlled_failed'
        },
        {
          title: 'Control Total',
          prop: 'controlled_total'
        },
        {
          title: 'Uncontroled Success',
          prop: 'uncontrolled_success'
        },
        {
          title: 'Uncontroled Fail',
          prop: 'uncontrolled_failed'
        },
        {
          title: 'Uncontroled Dump',
          prop: 'uncontrolled_dump'
        },
        {
          title: 'Uncontrolled Total',
          prop: 'uncontrolled_total'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Team Uncontrolled %")]), _vm._v(" "), _c('chart', {
    ref: "apex_ze_chart",
    attrs: {
      "width": "100%",
      "type": "bar",
      "options": _vm.apex_ze_options,
      "series": _vm.apex_ze_series
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('button', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("Show / Hide")]), _vm._v(" "), (_vm.show) ? _c('div', [_vm._t("filter"), _vm._v(" "), _vm._t("graph"), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('thead', _vm._l((_vm.headers), function(heading) {
    return _c('th', {
      key: heading
    }, [_vm._v("\n              " + _vm._s(heading) + "\n            ")])
  }), 0), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row) {
    return _c('tr', {
      key: row.id
    }, _vm._l((row), function(data) {
      return _c('td', {
        key: data.id
      }, [_vm._v(_vm._s(data))])
    }), 0)
  }), 0)])])], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Per 60 Comparison Tool")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "zone-starts"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Season Avg",
      "heading": "Season Average / Game",
      "headers": _vm.TableHeadings,
      "tableData": _vm.sortByGameAverageData
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Statistic")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.StatSelected),
      expression: "StatSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.StatSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.StatOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sort By")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SortSelected),
      expression: "SortSelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SortSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.SortOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "per_sixty",
      "heading": "Per Sixty Minutes",
      "headers": _vm.TableHeadings,
      "tableData": _vm.sortByPerSixtyData
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Statistic")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.StatSelected),
      expression: "StatSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.StatSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.StatOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sort By")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SortSelected),
      expression: "SortSelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SortSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.SortOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  })], 2)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
}]}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "child is-box box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Game Editor ")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.Fixture.match_date) + " " + _vm._s(_vm.Fixture.home_team) + " VS " + _vm._s(_vm.Fixture.away_team))]), _vm._v(" "), _c('tabs', {
    attrs: {
      "type": "boxed",
      "is-fullwidth": true,
      "alignment": "centered",
      "size": "medium"
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": "Fixture Data"
    }
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("  Fixture Data ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {}
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Home Team")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.Fixture.home_team),
      expression: "this.Fixture.home_team"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (this.Fixture.home_team)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(this.Fixture, "home_team", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Away Team")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.Fixture.away_team),
      expression: "this.Fixture.away_team"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (this.Fixture.away_team)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(this.Fixture, "away_team", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Date")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Pick Date / Time",
      "config": {
        enableTime: true,
        enableSeconds: true,
        noCalendar: false,
        time_24hr: true
      }
    },
    model: {
      value: (this.Fixture.match_date),
      callback: function($$v) {
        _vm.$set(this.Fixture, "match_date", $$v)
      },
      expression: "this.Fixture.match_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Location")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "IAW"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Attendence")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "2300"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.Fixture.leauge),
      expression: "this.Fixture.leauge"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "EIHL"
    },
    domProps: {
      "value": (this.Fixture.leauge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(this.Fixture, "leauge", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "name": "submit"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-small",
    attrs: {
      "to": '/editors/hits/:gameId'
    }
  }, [_vm._v("Cancel")])], 1)])])])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Goals"
    }
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('a', {
    staticClass: "button is-success is-active is-medium",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "href": '/goal/add'
    }
  }, [_vm._v("New Goal")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Goal Id")]), _vm._v(" "), _c('th', [_vm._v("Goal for Team")]), _vm._v(" "), _c('th', [_vm._v("Goal Scorer")]), _vm._v(" "), _c('th', [_vm._v("First Assist")]), _vm._v(" "), _c('th', [_vm._v("Second Assist")]), _vm._v(" "), _c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Game Time")]), _vm._v(" "), _c('th', [_vm._v("Situation")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.Goals), function(goal) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(goal.id))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (goal.for_team.name),
        expression: "goal.for_team.name"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(goal.for_team, "name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.teamOptions), function(teamOption) {
      return _c('option', {
        domProps: {
          "value": teamOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(teamOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (goal.scorer.player_number),
        expression: "goal.scorer.player_number"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (goal.scorer.player_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(goal.scorer, "player_number", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (goal.first_assist.player_number),
        expression: "goal.first_assist.player_number"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (goal.first_assist.player_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(goal.first_assist, "player_number", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (goal.second_assist.player_number),
        expression: "goal.second_assist.player_number"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (goal.second_assist.player_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(goal.second_assist, "player_number", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (goal.period),
        expression: "goal.period"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(goal, "period", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.periodOptions), function(periodOption) {
      return _c('option', {
        domProps: {
          "value": periodOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(periodOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (goal.game_time),
        callback: function($$v) {
          _vm.$set(goal, "game_time", $$v)
        },
        expression: "goal.game_time"
      }
    })], 1), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (goal.situation.secondary_situation),
        expression: "goal.situation.secondary_situation"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(goal.situation, "secondary_situation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.situationOptions), function(situationOption) {
      return _c('option', {
        domProps: {
          "value": situationOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(situationOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-primary is-active is-small",
      on: {
        "click": function($event) {
          return _vm.updateGoalRow(goal)
        }
      }
    }, [_vm._v("Update")])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-success is-active is-small",
      attrs: {
        "to": '/goal-edit/' + goal.id
      }
    }, [_vm._v("Verify")])], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-danger is-active is-small",
      on: {
        "click": function($event) {
          return _vm.deleteGoal(goal.id)
        }
      }
    }, [_vm._v("Delete")])])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Shots"
    }
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('a', {
    staticClass: "button is-success is-active is-medium",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "href": '/shots/add'
    }
  }, [_vm._v("New Shot")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Shots Id")]), _vm._v(" "), _c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Shot Result")]), _vm._v(" "), _c('th', [_vm._v("Shot Location")]), _vm._v(" "), _c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Game Time")]), _vm._v(" "), _c('th', [_vm._v("Situation")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.Shots), function(shot) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(shot.id))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shot.for_team.name),
        expression: "shot.for_team.name"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shot.for_team, "name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.teamOptions), function(teamOption) {
      return _c('option', {
        domProps: {
          "value": teamOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(teamOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shot.home_player),
        expression: "shot.home_player"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (shot.home_player)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shot, "home_player", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shot.result),
        expression: "shot.result"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shot, "result", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.shotResultOptions), function(resultOption) {
      return _c('option', {
        domProps: {
          "value": resultOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(resultOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shot.location),
        expression: "shot.location"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (shot.location)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shot, "location", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shot.period),
        expression: "shot.period"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shot, "period", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.periodOptions), function(periodOption) {
      return _c('option', {
        domProps: {
          "value": periodOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(periodOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (shot.game_time),
        callback: function($$v) {
          _vm.$set(shot, "game_time", $$v)
        },
        expression: "shot.game_time"
      }
    })], 1), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shot.situation.secondary_situation),
        expression: "shot.situation.secondary_situation"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shot.situation, "secondary_situation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.situationOptions), function(situationOption) {
      return _c('option', {
        domProps: {
          "value": situationOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(situationOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-primary is-active is-small",
      on: {
        "click": function($event) {
          return _vm.updateShotRow(shot)
        }
      }
    }, [_vm._v("Update")])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-success is-active is-small",
      attrs: {
        "to": '/shot-edit/' + shot.id
      }
    }, [_vm._v("Verify")])], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-danger is-active is-small",
      on: {
        "click": function($event) {
          return _vm.deleteShot(shot.id)
        }
      }
    }, [_vm._v("Delete")])])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Faceoffs"
    }
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('a', {
    staticClass: "button is-success is-active is-medium",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "href": '/shots/add'
    }
  }, [_vm._v("New Faceoff")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Faceoff Id")]), _vm._v(" "), _c('th', [_vm._v("Home Player")]), _vm._v(" "), _c('th', [_vm._v("Away Player")]), _vm._v(" "), _c('th', [_vm._v("Result")]), _vm._v(" "), _c('th', [_vm._v("Zone")]), _vm._v(" "), _c('th', [_vm._v("Lane")]), _vm._v(" "), _c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Game Time")]), _vm._v(" "), _c('th', [_vm._v("Situation")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.Faceoffs), function(faceoff) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(faceoff.id))]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (faceoff.home_player),
        expression: "faceoff.home_player"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (faceoff.home_player)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(faceoff, "home_player", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (faceoff.away_player),
        expression: "faceoff.away_player"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (faceoff.away_player)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(faceoff, "away_player", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (faceoff.result),
        expression: "faceoff.result"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(faceoff, "result", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.faceoffResultOptions), function(resultOption) {
      return _c('option', {
        domProps: {
          "value": resultOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(resultOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (faceoff.zone),
        expression: "faceoff.zone"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (faceoff.zone)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(faceoff, "zone", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (faceoff.lane),
        expression: "faceoff.lane"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (faceoff.lane)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(faceoff, "lane", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (faceoff.period),
        expression: "faceoff.period"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(faceoff, "period", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.periodOptions), function(periodOption) {
      return _c('option', {
        domProps: {
          "value": periodOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(periodOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (faceoff.game_time),
        callback: function($$v) {
          _vm.$set(faceoff, "game_time", $$v)
        },
        expression: "faceoff.game_time"
      }
    })], 1), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (faceoff.situation.secondary_situation),
        expression: "faceoff.situation.secondary_situation"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(faceoff.situation, "secondary_situation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.situationOptions), function(situationOption) {
      return _c('option', {
        domProps: {
          "value": situationOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(situationOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-primary is-active is-small",
      on: {
        "click": function($event) {
          return _vm.updateFaceoff(faceoff)
        }
      }
    }, [_vm._v("Update")])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-success is-active is-small",
      attrs: {
        "to": '/faceoff-edit/' + faceoff.id
      }
    }, [_vm._v("Verify")])], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-danger is-active is-small",
      on: {
        "click": function($event) {
          return _vm.deleteFaceoff(faceoff.id)
        }
      }
    }, [_vm._v("Delete")])])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Turnovers"
    }
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('a', {
    staticClass: "button is-success is-active is-medium",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "href": '/shots/add'
    }
  }, [_vm._v("New Turnover")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Turnover Id")]), _vm._v(" "), _c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Result")]), _vm._v(" "), _c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Game Time")]), _vm._v(" "), _c('th', [_vm._v("Situation")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.Turnovers), function(turnover) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(turnover.id))]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (turnover.home_player),
        expression: "turnover.home_player"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (turnover.home_player)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(turnover, "home_player", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (turnover.type),
        expression: "turnover.type"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(turnover, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.turnoverResultOptions), function(resultOption) {
      return _c('option', {
        domProps: {
          "value": resultOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(resultOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (turnover.period),
        expression: "turnover.period"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(turnover, "period", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.periodOptions), function(periodOption) {
      return _c('option', {
        domProps: {
          "value": periodOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(periodOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (turnover.game_time),
        callback: function($$v) {
          _vm.$set(turnover, "game_time", $$v)
        },
        expression: "turnover.game_time"
      }
    })], 1), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (turnover.situation.secondary_situation),
        expression: "turnover.situation.secondary_situation"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(turnover.situation, "secondary_situation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.situationOptions), function(situationOption) {
      return _c('option', {
        domProps: {
          "value": situationOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(situationOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-primary is-active is-small",
      on: {
        "click": function($event) {
          return _vm.updateTurnover(turnover)
        }
      }
    }, [_vm._v("Update")])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-success is-active is-small",
      attrs: {
        "to": '/turnover-edit/' + turnover.id
      }
    }, [_vm._v("Verify")])], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-danger is-active is-small",
      on: {
        "click": function($event) {
          return _vm.deleteTurnover(turnover.id)
        }
      }
    }, [_vm._v("Delete")])])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Hits"
    }
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('a', {
    staticClass: "button is-success is-active is-medium",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "href": '/shots/add'
    }
  }, [_vm._v("New Hit")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Hit Id")]), _vm._v(" "), _c('th', [_vm._v("Home Player")]), _vm._v(" "), _c('th', [_vm._v("Away Player")]), _vm._v(" "), _c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Game Time")]), _vm._v(" "), _c('th', [_vm._v("Situation")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.Hits), function(hit) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(hit.id))]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hit.home_player),
        expression: "hit.home_player"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (hit.home_player)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(hit, "home_player", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hit.away_player),
        expression: "hit.away_player"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (hit.away_player)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(hit, "away_player", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hit.period),
        expression: "hit.period"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(hit, "period", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.periodOptions), function(periodOption) {
      return _c('option', {
        domProps: {
          "value": periodOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(periodOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (hit.game_time),
        callback: function($$v) {
          _vm.$set(hit, "game_time", $$v)
        },
        expression: "hit.game_time"
      }
    })], 1), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hit.situation.secondary_situation),
        expression: "hit.situation.secondary_situation"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(hit.situation, "secondary_situation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.situationOptions), function(situationOption) {
      return _c('option', {
        domProps: {
          "value": situationOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(situationOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-primary is-active is-small",
      on: {
        "click": function($event) {
          return _vm.updateHit(hit)
        }
      }
    }, [_vm._v("Update")])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-success is-active is-small",
      attrs: {
        "to": '/hit-edit/' + hit.id
      }
    }, [_vm._v("Verify")])], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-danger is-active is-small",
      on: {
        "click": function($event) {
          return _vm.deleteHit(hit.id)
        }
      }
    }, [_vm._v("Delete")])])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "PIMS"
    }
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('a', {
    staticClass: "button is-success is-active is-medium",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "href": '/shots/add'
    }
  }, [_vm._v("New Penalty")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("PIM Id")]), _vm._v(" "), _c('th', [_vm._v("Taker")]), _vm._v(" "), _c('th', [_vm._v("Drawer")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("For")]), _vm._v(" "), _c('th', [_vm._v("Time")]), _vm._v(" "), _c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Game Time")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', [_vm._l((_vm.Pims), function(pims) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(pims.id))]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pims.taker),
        expression: "pims.taker"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (pims.taker)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pims, "taker", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pims.drawer),
        expression: "pims.drawer"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (pims.drawer)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pims, "drawer", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pims.type),
        expression: "pims.type"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(pims, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.pimTypeOptions), function(resultOption) {
      return _c('option', {
        domProps: {
          "value": resultOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(resultOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pims.for),
        expression: "pims.for"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(pims, "for", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.pimForOptions), function(pimOption) {
      return _c('option', {
        domProps: {
          "value": pimOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(pimOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pims.time),
        expression: "pims.time"
      }],
      staticClass: "input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (pims.time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pims, "time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pims.period),
        expression: "pims.period"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(pims, "period", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.periodOptions), function(periodOption) {
      return _c('option', {
        domProps: {
          "value": periodOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(periodOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (pims.game_time),
        callback: function($$v) {
          _vm.$set(pims, "game_time", $$v)
        },
        expression: "pims.game_time"
      }
    })], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-primary is-active is-small",
      on: {
        "click": function($event) {
          return _vm.updatePIM(pims)
        }
      }
    }, [_vm._v("Update")])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-success is-active is-small",
      attrs: {
        "to": '/pims-edit/' + pims.id
      }
    }, [_vm._v("Verify")])], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-danger is-active is-small",
      on: {
        "click": function($event) {
          return _vm.deletePIM(pims.id)
        }
      }
    }, [_vm._v("Delete")])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('strong', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("New PIM")])]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.NewPim.taker),
      expression: "this.NewPim.taker"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (this.NewPim.taker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(this.NewPim, "taker", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.NewPim.drawer),
      expression: "this.NewPim.drawer"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (this.NewPim.drawer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(this.NewPim, "drawer", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.NewPim.type),
      expression: "this.NewPim.type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(this.NewPim, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.pimTypeOptions), function(resultOption) {
    return _c('option', {
      domProps: {
        "value": resultOption.value
      }
    }, [_vm._v("\n                                  " + _vm._s(resultOption.text) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.NewPim.for),
      expression: "this.NewPim.for"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(this.NewPim, "for", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.pimForOptions), function(pimOption) {
    return _c('option', {
      domProps: {
        "value": pimOption.value
      }
    }, [_vm._v("\n                                  " + _vm._s(pimOption.text) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewPim.time),
      expression: "NewPim.time"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.NewPim.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewPim, "time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewPim.period),
      expression: "NewPim.period"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.NewPim, "period", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.periodOptions), function(periodOption) {
    return _c('option', {
      domProps: {
        "value": periodOption.value
      }
    }, [_vm._v("\n                                  " + _vm._s(periodOption.text) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('td', [_c('datepicker', {
    attrs: {
      "placeholder": "--:--",
      "config": {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        time_24hr: true
      },
      "value": "00:00:00"
    },
    model: {
      value: (_vm.NewPim.game_time),
      callback: function($$v) {
        _vm.$set(_vm.NewPim, "game_time", $$v)
      },
      expression: "NewPim.game_time"
    }
  })], 1), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "button is-primary is-active is-small",
    on: {
      "click": function($event) {
        return _vm.addPIM(_vm.NewPim)
      }
    }
  }, [_vm._v("Add")])])])], 2)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Time On Ice"
    }
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("GP")]), _vm._v(" "), _c('th', [_vm._v("+ Shots")]), _vm._v(" "), _c('th', [_vm._v("- Shots")]), _vm._v(" "), _c('th', [_vm._v("Shifts")]), _vm._v(" "), _c('th', [_vm._v("Time Avg Shift")]), _vm._v(" "), _c('th', [_vm._v("Time Total")]), _vm._v(" "), _c('th', [_vm._v("Time 5v5")]), _vm._v(" "), _c('th', [_vm._v("Time 4v4")]), _vm._v(" "), _c('th', [_vm._v("Time PP")]), _vm._v(" "), _c('th', [_vm._v("Time SH")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.TOI), function(toi) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(toi.player_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(toi.player_forename) + " " + _vm._s(toi.player_surname))]), _vm._v(" "), _c('td', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (toi.played_in_game),
        expression: "toi.played_in_game"
      }],
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox",
        "checked": "checked",
        "value": ""
      },
      domProps: {
        "checked": Array.isArray(toi.played_in_game) ? _vm._i(toi.played_in_game, "") > -1 : (toi.played_in_game)
      },
      on: {
        "change": function($event) {
          var $$a = toi.played_in_game,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(toi, "played_in_game", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(toi, "played_in_game", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(toi, "played_in_game", $$c)
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (toi.shots_for),
        expression: "toi.shots_for"
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "0"
      },
      domProps: {
        "value": (toi.shots_for)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(toi, "shots_for", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (toi.shots_against),
        expression: "toi.shots_against"
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "0"
      },
      domProps: {
        "value": (toi.shots_against)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(toi, "shots_against", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (toi.shifts),
        expression: "toi.shifts"
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "0"
      },
      domProps: {
        "value": (toi.shifts)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(toi, "shifts", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.avg_shift),
        callback: function($$v) {
          _vm.$set(toi, "avg_shift", $$v)
        },
        expression: "toi.avg_shift"
      }
    })], 1), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.total_time),
        callback: function($$v) {
          _vm.$set(toi, "total_time", $$v)
        },
        expression: "toi.total_time"
      }
    })], 1), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.time_5v5),
        callback: function($$v) {
          _vm.$set(toi, "time_5v5", $$v)
        },
        expression: "toi.time_5v5"
      }
    })], 1), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.time_4v4),
        callback: function($$v) {
          _vm.$set(toi, "time_4v4", $$v)
        },
        expression: "toi.time_4v4"
      }
    })], 1), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.time_PP),
        callback: function($$v) {
          _vm.$set(toi, "time_PP", $$v)
        },
        expression: "toi.time_PP"
      }
    })], 1), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.time_SH),
        callback: function($$v) {
          _vm.$set(toi, "time_SH", $$v)
        },
        expression: "toi.time_SH"
      }
    })], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-primary is-active is-small",
      on: {
        "click": function($event) {
          return _vm.updateToi(toi)
        }
      }
    }, [_vm._v("Update")])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-success is-active is-small",
      attrs: {
        "to": '/pims-edit/' + toi.id
      }
    }, [_vm._v("Verify")])], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-danger is-active is-small",
      on: {
        "click": function($event) {
          return _vm.deleteToi(toi.id)
        }
      }
    }, [_vm._v("Clear")])])])
  }), 0)]), _vm._v(" "), _c('form', [_c('p', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "name": "submit"
    }
  }, [_vm._v("Upload All")])])])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "+/-"
    }
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Goal Id")]), _vm._v(" "), _c('th', [_vm._v("Goal for Team")]), _vm._v(" "), _c('th', [_vm._v("Goal Scorer")]), _vm._v(" "), _c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Game Time")]), _vm._v(" "), _c('th', [_vm._v("Situation")]), _vm._v(" "), _c('th', [_vm._v("Player 1")]), _vm._v(" "), _c('th', [_vm._v("Player 2")]), _vm._v(" "), _c('th', [_vm._v("Player 3")]), _vm._v(" "), _c('th', [_vm._v("Player 4")]), _vm._v(" "), _c('th', [_vm._v("Player 5")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.Goals), function(plusMinus) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(plusMinus.id))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (plusMinus.for_team.name),
        expression: "plusMinus.for_team.name"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(plusMinus.for_team, "name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.teamOptions), function(teamOption) {
      return _c('option', {
        domProps: {
          "value": teamOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(teamOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('strong', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (plusMinus.scorer.player_number),
        expression: "plusMinus.scorer.player_number"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (plusMinus.scorer.player_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(plusMinus.scorer, "player_number", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (plusMinus.period),
        expression: "plusMinus.period"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(plusMinus, "period", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.periodOptions), function(periodOption) {
      return _c('option', {
        domProps: {
          "value": periodOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(periodOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (plusMinus.game_time),
        callback: function($$v) {
          _vm.$set(plusMinus, "game_time", $$v)
        },
        expression: "plusMinus.game_time"
      }
    })], 1), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (plusMinus.situation.secondary_situation),
        expression: "plusMinus.situation.secondary_situation"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(plusMinus.situation, "secondary_situation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.situationOptions), function(situationOption) {
      return _c('option', {
        domProps: {
          "value": situationOption.value
        }
      }, [_vm._v("\n                                  " + _vm._s(situationOption.text) + "\n                                ")])
    }), 0)])])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (plusMinus.first_assist.player_number),
        expression: "plusMinus.first_assist.player_number"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (plusMinus.first_assist.player_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(plusMinus.first_assist, "player_number", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (plusMinus.second_assist.player_number),
        expression: "plusMinus.second_assist.player_number"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (plusMinus.second_assist.player_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(plusMinus.second_assist, "player_number", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (plusMinus.second_assist.player_number),
        expression: "plusMinus.second_assist.player_number"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (plusMinus.second_assist.player_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(plusMinus.second_assist, "player_number", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (plusMinus.second_assist.player_number),
        expression: "plusMinus.second_assist.player_number"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (plusMinus.second_assist.player_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(plusMinus.second_assist, "player_number", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (plusMinus.second_assist.player_number),
        expression: "plusMinus.second_assist.player_number"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (plusMinus.second_assist.player_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(plusMinus.second_assist, "player_number", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-primary is-active is-small",
      on: {
        "click": function($event) {
          return _vm.updatePlusMinus(plusMinus)
        }
      }
    }, [_vm._v("Update")])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-success is-active is-small",
      attrs: {
        "to": '/plusMinus-edit/' + plusMinus.id
      }
    }, [_vm._v("Verify")])], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-danger is-active is-small"
    }, [_vm._v("Clear")])])])
  }), 0)])])])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "table__wrapper is-child"
  }, [_c('table', {
    staticClass: "table is-child is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('thead', _vm._l((_vm.headers), function(heading) {
    return _c('th', {
      key: heading
    }, [_vm._v("\n                " + _vm._s(heading) + "\n              ")])
  }), 0), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row) {
    return _c('tr', {
      key: row.id
    }, _vm._l((row), function(data) {
      return _c('td', {
        key: data.id
      }, [_vm._v(_vm._s(data))])
    }), 0)
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Team Shot Diff / Time")]), _vm._v(" "), _c('button', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("Show / Hide")]), _vm._v(" "), (_vm.show) ? _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "number"
    }
  }, [_vm._v("Time Interval")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interval),
      expression: "interval"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "20"
    },
    domProps: {
      "value": (_vm.interval)
    },
    on: {
      "change": function($event) {
        return _vm.fetchShots()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.interval = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "number"
    }
  }, [_vm._v("Fill")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fillOption),
      expression: "fillOption"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.fillOption) ? _vm._i(_vm.fillOption, null) > -1 : (_vm.fillOption)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.fillOption,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.fillOption = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.fillOption = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.fillOption = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "toggle"
    }
  }, [_vm._v("Differential")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toggleDifferential),
      expression: "toggleDifferential"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.toggleDifferential) ? _vm._i(_vm.toggleDifferential, null) > -1 : (_vm.toggleDifferential)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.toggleDifferential,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toggleDifferential = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toggleDifferential = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toggleDifferential = $$c
        }
      }, function($event) {
        return _vm.fetchShots()
      }]
    }
  })])])]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'line',
      "data": _vm.chartData,
      "options": _vm.line_options
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container is-child has-text-centered"
  }, [_c('article', {
    staticClass: "is-parent title"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Live Game")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.startGame()
      }
    }
  }, [_vm._v("Start Game")]), _vm._v(" "), _c('button', {
    staticClass: "button is-warning"
  }, [_vm._v("End Game")])]), _vm._v(" "), _c('article', {
    staticClass: "container is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Game Time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.time))]), _vm._v(" "), _c('button', {
    staticClass: "button is-info"
  }, [_vm._v("Pause")]), _vm._v(" "), _c('button', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    staticClass: "button is-info"
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "button is-info"
  }, [_vm._v("Reset")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "container is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Period - 1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "container is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Situation - Even Handed 5v5")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "container is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Game State - Even")])])
}]}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "faceoffs"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Team Faceoffs")]), _vm._v(" "), _vm._l((_vm.FaceoffsTeamTotals), function(stat) {
    return _c('div', {
      key: stat.total_taken
    }, [_c('h1', {
      staticClass: "title has-text-centered"
    }, [_vm._v("Totals")]), _vm._v(" "), _c('div', {
      staticClass: "table__wrapper"
    }, [_c('table', {
      staticClass: "table is-responsive is-striped is-fullwidth",
      staticStyle: {
        "overflow-x": "auto"
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(stat.total_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.total_won))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.total_loss))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.total_win_percentage))])])])])]), _vm._v(" "), _c('h1', {
      staticClass: "title has-text-centered"
    }, [_vm._v("Lane")]), _vm._v(" "), _c('div', {
      staticClass: "table__wrapper"
    }, [_c('table', {
      staticClass: "table is-responsive is-striped is-fullwidth",
      staticStyle: {
        "overflow-x": "auto"
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Left")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.left_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.left_won))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.left_loss))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.left_win_percentage))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Center")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.center_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.center_won))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.center_loss))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.center_win_percentage))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Right")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.right_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.right_won))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.right_loss))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.right_win_percentage))])])])])]), _vm._v(" "), _c('h1', {
      staticClass: "title has-text-centered"
    }, [_vm._v("Zone")]), _vm._v(" "), _c('div', {
      staticClass: "table__wrapper"
    }, [_c('table', {
      staticClass: "table is-responsive is-striped is-fullwidth",
      staticStyle: {
        "overflow-x": "auto"
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Offensive")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.offensive_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.offensive_won))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.offensive_loss))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.offensive_win_percentage))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Neutral")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.neutral_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.neutral_won))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.neutral_loss))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.neutral_win_percentage))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Defensive")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.defensive_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.defensive_won))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.defensive_loss))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.defensive_win_percentage))])])])])])])
  })], 2)]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Player Totals")]), _vm._v(" "), (this.OpponentSelected === 0) ? _c('h1', {
    staticClass: "subtitle has-text-centered",
    staticStyle: {
      "color": "rgba(54, 162, 235, 1)"
    }
  }, [_c('b', [_vm._v("Please select an opponent team from the global filter above")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.FaceoffsPlayerCombo), function(stat) {
    return _c('tr', {
      key: stat.player
    }, [_c('td', [_vm._v(_vm._s(stat.player))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.gp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_total_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_total_win_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_total_loss_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_total_win_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_total_taken_average))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_total_win_average))])])
  }), 0)])]), _vm._v(" "), _c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Lane")]), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.FaceoffsPlayerCombo), function(stat) {
    return _c('tr', {
      key: stat.player
    }, [_c('td', [_vm._v(_vm._s(stat.player))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.gp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_left_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_left_win_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_left_loss_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_left_win_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_center_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_center_win_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_center_loss_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_center_win_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_right_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_right_win_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_right_loss_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_right_win_percent))])])
  }), 0)])]), _vm._v(" "), _c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Zone")]), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.FaceoffsPlayerCombo), function(stat) {
    return _c('tr', {
      key: stat.player
    }, [_c('td', [_vm._v(_vm._s(stat.player))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.gp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_offensive_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_offensive_win_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_offensive_loss_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_offensive_win_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_offensive_win_average))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_neutral_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_neutral_win_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_neutral_loss_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_neutral_win_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_neutral_win_average))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_defensive_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_defensive_win_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_defensive_loss_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_defensive_win_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(stat.fo_defensive_win_average))])])
  }), 0)])])])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Faceoffs By Player")]), _vm._v(" "), (this.OpponentSelected === 0) ? _c('h1', {
    staticClass: "subtitle has-text-centered",
    staticStyle: {
      "color": "rgba(54, 162, 235, 1)"
    }
  }, [_c('b', [_vm._v("Please select an opponent team from the global filter above")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Zone")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ZoneSelected),
      expression: "ZoneSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ZoneSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchFaceoffByPlayer]
    }
  }, _vm._l((_vm.ZoneOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Lane")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LaneSelected),
      expression: "LaneSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LaneSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchFaceoffByPlayer]
    }
  }, _vm._l((_vm.LaneOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _vm._l((_vm.FaceoffsByPlayer), function(player) {
    return _c('div', {
      key: player.player
    }, [_c('article', {
      staticClass: "is-child box"
    }, [_c('h1', {
      staticClass: "title has-text-centered"
    }, [_vm._v(_vm._s(player.player))]), _vm._v(" "), _c('div', {
      staticClass: "table__wrapper"
    }, [_c('table', {
      staticClass: "table is-responsive is-striped is-fullwidth",
      staticStyle: {
        "overflow-x": "auto"
      }
    }, [_vm._m(8, true), _vm._v(" "), _c('tbody', _vm._l((player.vs), function(away) {
      return _c('tr', {
        key: away.away_player
      }, [_c('td', [_vm._v(_vm._s(away.away_player))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away.fo_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away.fo_win))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away.fo_loss))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away.fo_win_percentage))])])
    }), 0)])])])])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 24/03/2019 01:57AM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("Added Player vs Opposition players. "), _c('b', [_vm._v("Please note, this won't be affected by the gloabl filter i.e. 'Venue','Competition'... only the opponent.")]), _vm._v(" You can also filter by lane and zone but not situation, I can add this if needs be...")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Taken")]), _vm._v(" "), _c('th', [_vm._v("Wins")]), _vm._v(" "), _c('th', [_vm._v("Losses")]), _vm._v(" "), _c('th', [_vm._v("Win %")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Lane")]), _vm._v(" "), _c('th', [_vm._v("Taken")]), _vm._v(" "), _c('th', [_vm._v("Wins")]), _vm._v(" "), _c('th', [_vm._v("Losses")]), _vm._v(" "), _c('th', [_vm._v("Win %")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Zone")]), _vm._v(" "), _c('th', [_vm._v("Taken")]), _vm._v(" "), _c('th', [_vm._v("Wins")]), _vm._v(" "), _c('th', [_vm._v("Losses")]), _vm._v(" "), _c('th', [_vm._v("Win %")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("GP")]), _vm._v(" "), _c('th', [_vm._v("Taken")]), _vm._v(" "), _c('th', [_vm._v("Wins")]), _vm._v(" "), _c('th', [_vm._v("Losses")]), _vm._v(" "), _c('th', [_vm._v("Win %")]), _vm._v(" "), _c('th', [_vm._v("Avg Taken / Game")]), _vm._v(" "), _c('th', [_vm._v("Avg Win / Game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("GP")]), _vm._v(" "), _c('th', [_vm._v("Left T")]), _vm._v(" "), _c('th', [_vm._v("Left W")]), _vm._v(" "), _c('th', [_vm._v("Left L")]), _vm._v(" "), _c('th', [_vm._v("Left W%")]), _vm._v(" "), _c('th', [_vm._v("Center T")]), _vm._v(" "), _c('th', [_vm._v("Center W")]), _vm._v(" "), _c('th', [_vm._v("Center L")]), _vm._v(" "), _c('th', [_vm._v("Center W%")]), _vm._v(" "), _c('th', [_vm._v("Right T")]), _vm._v(" "), _c('th', [_vm._v("Right W")]), _vm._v(" "), _c('th', [_vm._v("Right L")]), _vm._v(" "), _c('th', [_vm._v("Right W%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("GP")]), _vm._v(" "), _c('th', [_vm._v("Offensive T")]), _vm._v(" "), _c('th', [_vm._v("Offensive W")]), _vm._v(" "), _c('th', [_vm._v("Offensive L")]), _vm._v(" "), _c('th', [_vm._v("Offensive W%")]), _vm._v(" "), _c('th', [_vm._v("Offensive W/GP%")]), _vm._v(" "), _c('th', [_vm._v("Neutral T")]), _vm._v(" "), _c('th', [_vm._v("Neutral W")]), _vm._v(" "), _c('th', [_vm._v("Neutral L")]), _vm._v(" "), _c('th', [_vm._v("Neutral W%")]), _vm._v(" "), _c('th', [_vm._v("Neutral W/GP%")]), _vm._v(" "), _c('th', [_vm._v("Defensive T")]), _vm._v(" "), _c('th', [_vm._v("Defensive W")]), _vm._v(" "), _c('th', [_vm._v("Defensive L")]), _vm._v(" "), _c('th', [_vm._v("Defensive W%")]), _vm._v(" "), _c('th', [_vm._v("Defensive W/GP%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("VS")]), _vm._v(" "), _c('th', [_vm._v("Taken")]), _vm._v(" "), _c('th', [_vm._v("Wins")]), _vm._v(" "), _c('th', [_vm._v("Losses")]), _vm._v(" "), _c('th', [_vm._v("Win %")])])
}]}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture.match_date))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('img', {
    staticClass: "team_logo",
    attrs: {
      "src": _vm.Fixture.home_team.logo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle has-text-left"
  }, [_vm._v(_vm._s(_vm.Fixture.home_team.name) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('img', {
    staticClass: "team_logo",
    attrs: {
      "src": _vm.Fixture.away_team.logo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle has-text-left"
  }, [_vm._v(_vm._s(_vm.Fixture.away_team.name))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture.competition))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture.location))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-parent is-vertical box"
  }, [_c('article', [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Shots - Heatmap")]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "player_shotmap"
    }
  }, [_c('section', {
    attrs: {
      "id": "global_filters"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("Filters")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PeriodSelected),
      expression: "PeriodSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.PeriodSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchShotmap]
    }
  }, _vm._l((_vm.PeriodOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SituationSelected),
      expression: "SituationSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SituationSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchShotmap]
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Home Player(s)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "searchable": true,
      "options": _vm.HomeTeamOptions,
      "max-height": 250,
      "option-height": 30,
      "multiple": true,
      "close-on-select": true,
      "label": "text",
      "track-by": "text",
      "preselect-first": true,
      "hide-selected": false,
      "placeholder": "All"
    },
    on: {
      "close": _vm.fetchShotmap
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.HomeMultiSelect.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(_vm.HomeMultiSelect.length) + " selected")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.HomeMultiSelect),
      callback: function($$v) {
        _vm.HomeMultiSelect = $$v
      },
      expression: "HomeMultiSelect"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Away Player(s)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "searchable": true,
      "options": _vm.AwayTeamOptions,
      "max-height": 250,
      "option-height": 30,
      "multiple": true,
      "close-on-select": true,
      "label": "text",
      "track-by": "text",
      "preselect-first": true,
      "hide-selected": false,
      "placeholder": "All"
    },
    on: {
      "close": _vm.fetchShotmap
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.AwayMultiSelect.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(_vm.AwayMultiSelect.length) + " selected")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.AwayMultiSelect),
      callback: function($$v) {
        _vm.AwayMultiSelect = $$v
      },
      expression: "AwayMultiSelect"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Shot Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShotTypeSelected),
      expression: "ShotTypeSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ShotTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchShotmap]
    }
  }, _vm._l((_vm.ShotTypeOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.UseHeatmap = !_vm.UseHeatmap;
        _vm.renderHeatmap()
      }
    }
  }, [_vm._v("Heatmap")])])]), _vm._v(" "), (_vm.UseHeatmap) ? _c('div', {
    staticClass: "column is-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Blur")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BlurSelected),
      expression: "BlurSelected"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "0.5"
    },
    domProps: {
      "value": (_vm.BlurSelected)
    },
    on: {
      "change": _vm.renderHeatmap,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BlurSelected = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.UseHeatmap) ? _c('div', {
    staticClass: "column is-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Radius")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RadiusSelected),
      expression: "RadiusSelected"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "0.5"
    },
    domProps: {
      "value": (_vm.RadiusSelected)
    },
    on: {
      "change": _vm.renderHeatmap,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RadiusSelected = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.UseShotZones = !_vm.UseShotZones;
        _vm.renderHeatmap()
      }
    }
  }, [_vm._v("Shot Zones")])])]), _vm._v(" "), (_vm.UseShotZones) ? _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.UseShotZonesText = !_vm.UseShotZonesText;
        _vm.renderHeatmap()
      }
    }
  }, [_vm._v("Toggle Zone Count")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-half is-offset-1"
  }, [_c('h1', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.home_name))]), _vm._v(" "), _c('canvas', {
    ref: "home_shot_canvas",
    staticClass: "is-canvas-responsive shotmap",
    attrs: {
      "id": "home_shotmap",
      "width": "412",
      "height": "520"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('h1', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.away_name))]), _vm._v(" "), _c('canvas', {
    ref: "away_shot_canvas",
    staticClass: "is-canvas-responsive shotmap",
    attrs: {
      "id": "away_shotmap",
      "width": "412",
      "height": "520"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "points"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Points",
      "heading": "Points",
      "headers": _vm.PointsPlayerHeadings,
      "tableData": _vm.sortByPointsData
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sort")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FilterSelected),
      expression: "FilterSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.FilterSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByPointsData]
    }
  }, _vm._l((_vm.PointsPlayerFilters), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  })], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 22/10/2018 11:59AM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("Please beware, this is work in progress!")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
}]}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Gamesheet', {
    attrs: {
      "period": 1,
      "game_id": this.$route.params.gameId
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.animation,
      "mode": "out-in",
      "appear": "",
      "appear-active-class": _vm.transition.enterClass,
      "enter-active-class": _vm.transition.enterClass,
      "leave-active-class": _vm.transition.leaveClass
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realSelected),
      expression: "realSelected"
    }],
    class: _vm.classObject,
    attrs: {
      "role": "tabpanel",
      "aria-labelledby": _vm.label,
      "aria-hidden": _vm.hidden
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _vm._l((_vm.getChunked()), function(chunk) {
    return _c('div', {
      key: chunk + Math.random(),
      staticClass: "columns"
    }, _vm._l((chunk), function(player) {
      return _c('div', {
        key: player.id,
        staticClass: "column is-3 player-box"
      }, [_c('div', {
        on: {
          "click": function($event) {
            return _vm.onClick(player.id)
          }
        }
      }, [_c('img', {
        staticClass: "team_logo image is-64x64 has-image-centered",
        attrs: {
          "src": _vm.logo
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "title has-text-centered"
      }, [_vm._v("#" + _vm._s(player.number))]), _vm._v(" "), _c('p', {
        staticClass: "title has-text-centered"
      }, [_vm._v(_vm._s(player.forename) + " "), _c('br'), _vm._v(_vm._s(player.surname))])])])
    }), 0)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns box"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getShots]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Grid Size")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GridSize),
      expression: "GridSize"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.GridSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getShots]
    }
  }, _vm._l((_vm.GridOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Shot Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShotSelected),
      expression: "ShotSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ShotSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getShots]
    }
  }, _vm._l((_vm.ShotOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Team")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TeamSelected),
      expression: "TeamSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.TeamSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getShots]
    }
  }, _vm._l((_vm.TeamOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        _vm.showGrid = !_vm.showGrid;
        _vm.UseHeatmap = false;
        _vm.getShots()
      }
    }
  }, [_vm._v("Show Grid")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('h1', [_vm._v("Goals: " + _vm._s(_vm.actualGoals))]), _vm._v(" "), _c('h1', [_vm._v("Sum XG: " + _vm._s(_vm.expectedGoals.toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-small",
    on: {
      "click": function($event) {
        _vm.UseHeatmap = !_vm.UseHeatmap;
        _vm.beginRender()
      }
    }
  }, [_vm._v("Heatmap")])]), _vm._v(" "), (_vm.UseHeatmap) ? _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Blur")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BlurSelected),
      expression: "BlurSelected"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "0.5"
    },
    domProps: {
      "value": (_vm.BlurSelected)
    },
    on: {
      "change": _vm.beginRender,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BlurSelected = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.UseHeatmap) ? _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Radius")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RadiusSelected),
      expression: "RadiusSelected"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "0.5"
    },
    domProps: {
      "value": (_vm.RadiusSelected)
    },
    on: {
      "change": _vm.beginRender,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RadiusSelected = $event.target.value
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "stats-widget",
    attrs: {
      "id": "widget-shot-map"
    }
  }, [_c('div', {
    staticClass: "stats-widget-canvas-container"
  }, [_c('img', {
    staticClass: "stats-widget-canvas-container-bg",
    attrs: {
      "src": "data:image/svg+xml;base64,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",
      "alt": "",
      "id": "stats-widget-canvas-bg"
    }
  }), _vm._v(" "), _c('canvas', {
    ref: "shot_canvas",
    staticClass: "stats-widget-canvas",
    attrs: {
      "id": "stats-widget-canvas-shot"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stats-widget-tooltip",
    attrs: {
      "id": "tooltip"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs is-large"
  }, [_c('ul', [_c('li', {
    class: [{
      'is-active': this.name == 'overview'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/overview'
    }
  }, [_vm._v("Overview")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'points'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/points'
    }
  }, [_vm._v("Points")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'plus-minus'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/plus-minus'
    }
  }, [_vm._v("Plus / Minus")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'penalty-minutes'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/penalty-minutes'
    }
  }, [_vm._v("Penalty Minutes")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'shots'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/shots'
    }
  }, [_vm._v("Shots")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'shot-differentials'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/shot-differentials'
    }
  }, [_vm._v("Shot Differentials")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'faceoffs'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/faceoffs'
    }
  }, [_vm._v("Faceoffs")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'turnovers'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/turnovers'
    }
  }, [_vm._v("Turnovers")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'hits'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/hits'
    }
  }, [_vm._v("Hits")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'time-on-ice'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/time-on-ice'
    }
  }, [_vm._v("Time On Ice")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'zone-entries'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/zone-entries'
    }
  }, [_vm._v("Zone Entries / Exits")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'zone-starts'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/zone-starts'
    }
  }, [_vm._v("Zone Starts")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'raw-data'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/raw-data'
    }
  }, [_vm._v("Raw Data")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'per-sixty'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/per-sixty'
    }
  }, [_vm._v("Per Sixty Comparison Tool")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'vs-team'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/vs-team'
    }
  }, [_vm._v("VS Team")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main",
    style: ([_vm.hiddenSidebarStyle])
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('levelbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "plus-minus"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Single Fixture")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FixtureSelected),
      expression: "FixtureSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.FixtureSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.FixtureOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "GoalDiff",
      "heading": "Goal +/-",
      "headers": _vm.GoalDiffHeadings,
      "tableData": _vm.sortByGoalDiffData
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sort")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FilterSelected),
      expression: "FilterSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.FilterSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByGoalDiffData]
    }
  }, _vm._l((_vm.GoalDiffPlayerFilters), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SituationSelected),
      expression: "SituationSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SituationSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      },
      on: {
        "change": function($event) {
          return _vm.fetchSeasonStats()
        }
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.chartData,
      "options": _vm.bar_options
    }
  })], 1)], 2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 30/01/2019 10:59PM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("New Content! Still a work in progress.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
}]}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile box",
    staticStyle: {
      "margin": "0 25%"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Edit Goal Information")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.updateGoal
    }
  }, [_c('div', {
    staticClass: "block",
    staticStyle: {
      "margin": "0 25%"
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Team")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Goal Scorer ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Goal[0].scorer.player_number),
      expression: "Goal[0].scorer.player_number"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Player Number"
    },
    domProps: {
      "value": (_vm.Goal[0].scorer.player_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Goal[0].scorer, "player_number", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("First Assist")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Goal[0].first_assist.player_number),
      expression: "Goal[0].first_assist.player_number"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "First Assist"
    },
    domProps: {
      "value": (_vm.Goal[0].first_assist.player_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Goal[0].first_assist, "player_number", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Second Assists")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Goal[0].second_assist.player_number),
      expression: "Goal[0].second_assist.player_number"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Second Assist"
    },
    domProps: {
      "value": (_vm.Goal[0].second_assist.player_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Goal[0].second_assist, "player_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Period")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Goal[0].period),
      expression: "Goal[0].period"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Period"
    },
    domProps: {
      "value": (_vm.Goal[0].period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Goal[0], "period", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Goal[0].situation.secondary_situation),
      expression: "Goal[0].situation.secondary_situation"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Situation of Play i.e. EH5v5"
    },
    domProps: {
      "value": (_vm.Goal[0].situation.secondary_situation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Goal[0].situation, "secondary_situation", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Game Time")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Pick game time",
      "config": {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        time_24hr: true
      }
    },
    model: {
      value: (_vm.Goal[0].game_time),
      callback: function($$v) {
        _vm.$set(_vm.Goal[0], "game_time", $$v)
      },
      expression: "Goal[0].game_time"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "name": "submit"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-small",
    attrs: {
      "to": '/editors/goal/'
    }
  }, [_vm._v("Cancel")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', [_c('option', [_vm._v("CDevils")]), _vm._v(" "), _c('option', [_vm._v("SSteelers")])])])])
}]}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor is-centered"
  }, [_c('div', {
    staticClass: "tile is-parent is-5"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Edit Hit")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.updateHit
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Hit.by),
      expression: "Hit.by"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Who made the hit?"
    },
    domProps: {
      "value": (_vm.Hit.by)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Hit, "by", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Hit.on),
      expression: "Hit.on"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Who was hit?"
    },
    domProps: {
      "value": (_vm.Hit.on)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Hit, "on", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Hit.period),
      expression: "Hit.period"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Period"
    },
    domProps: {
      "value": (_vm.Hit.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Hit, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Hit.situation.secondary_situation),
      expression: "Hit.situation.secondary_situation"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Situation of Play i.e. EH5v5"
    },
    domProps: {
      "value": (_vm.Hit.situation.secondary_situation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Hit.situation, "secondary_situation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Pick game time",
      "config": {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        time_24hr: true
      }
    },
    model: {
      value: (_vm.Hit.game_time),
      callback: function($$v) {
        _vm.$set(_vm.Hit, "game_time", $$v)
      },
      expression: "Hit.game_time"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "name": "submit"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-small",
    attrs: {
      "to": '/editors/hits/:gameId'
    }
  }, [_vm._v("Cancel")])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Hit By")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("On")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Period")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Game Time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  })])
}]}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden
    }
  }), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Faceoffs")]), _vm._v(" "), _c('div', {
    staticClass: "small-box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Game Totals")]), _vm._v(" "), _c('chart', {
    ref: "apex_fo_chart",
    attrs: {
      "width": "100%",
      "type": "bar",
      "options": _vm.apex_fo_options,
      "series": _vm.apex_fo_series
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/faceoffs-per-period",
      "postData": [{
        team_id: 1,
        game_id: this.gameId
      }],
      "selectedData": [{
          title: 'player (Wins / Taken)',
          prop: 'player'
        },
        {
          title: 'P1',
          prop: 'fo_p1'
        },
        {
          title: 'P2',
          prop: 'fo_p2'
        },
        {
          title: 'P3',
          prop: 'fo_p3'
        },
        {
          title: 'OT',
          prop: 'fo_ot'
        },
        {
          title: 'Totals',
          prop: 'fo_total'
        },
        {
          title: 'Win %',
          prop: 'fo_win_percent'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Left Offensive")]), _vm._v(" "), _c('chart', {
    ref: "apex_fo_lo_chart",
    attrs: {
      "width": "100%",
      "type": "bar",
      "options": _vm.apex_fo_options,
      "series": _vm.apex_fo_lo_series
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Left Defensive")]), _vm._v(" "), _c('chart', {
    ref: "apex_fo_ld_chart",
    attrs: {
      "width": "100%",
      "type": "bar",
      "options": _vm.apex_fo_options,
      "series": _vm.apex_fo_ld_series
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Right Offensive")]), _vm._v(" "), _c('chart', {
    ref: "apex_fo_ro_chart",
    attrs: {
      "width": "100%",
      "type": "bar",
      "options": _vm.apex_fo_options,
      "series": _vm.apex_fo_ro_series
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Right Defensive")]), _vm._v(" "), _c('chart', {
    ref: "apex_fo_rd_chart",
    attrs: {
      "width": "100%",
      "type": "bar",
      "options": _vm.apex_fo_options,
      "series": _vm.apex_fo_rd_series
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
  }, [_c('thead', _vm._l((_vm.headings), function(heading) {
    return _c('th', {
      key: heading,
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(heading))])
  }), 0), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row) {
    return _c('tr', {
      key: row.id
    }, _vm._l((row), function(data) {
      return _c('td', {
        key: data.id
      }, [_vm._v(_vm._s(data))])
    }), 0)
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Create Player")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Number #")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.number),
      expression: "formData.number"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "step": "1",
      "placeholder": "88"
    },
    domProps: {
      "value": (_vm.formData.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.forename),
      expression: "formData.forename"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Joey"
    },
    domProps: {
      "value": (_vm.formData.forename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "forename", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.surname),
      expression: "formData.surname"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Martin"
    },
    domProps: {
      "value": (_vm.formData.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "surname", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.dob),
      expression: "formData.dob"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": "Mar 15 2001"
    },
    domProps: {
      "value": (_vm.formData.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "dob", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Place of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.birth_place),
      expression: "formData.birth_place"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Canada"
    },
    domProps: {
      "value": (_vm.formData.birth_place)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "birth_place", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nationality")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.nationality),
      expression: "formData.nationality"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Canada"
    },
    domProps: {
      "value": (_vm.formData.nationality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "nationality", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Position")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-medium"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.position),
      expression: "formData.position"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Forward")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LW"
    }
  }, [_vm._v("Left Forward")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Center Forward")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RW"
    }
  }, [_vm._v("Right Forward")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LD"
    }
  }, [_vm._v("Defense")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LD"
    }
  }, [_vm._v("Left Defense")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RD"
    }
  }, [_vm._v("Right Defense")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GT"
    }
  }, [_vm._v("Goaltender")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BKUPGT"
    }
  }, [_vm._v("Backup Goaltender")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EMRGGT"
    }
  }, [_vm._v("Emergency Goaltender")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "COACH"
    }
  }, [_vm._v("Coach")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ASSCOACH"
    }
  }, [_vm._v("Assistant Coach")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Height (m)")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.height),
      expression: "formData.height"
    }],
    staticClass: "input",
    attrs: {
      "min": "1",
      "max": "6",
      "step": "0.01",
      "type": "number",
      "placeholder": "1.93m"
    },
    domProps: {
      "value": (_vm.formData.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "height", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Weight (kg)")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.weight),
      expression: "formData.weight"
    }],
    staticClass: "input",
    attrs: {
      "min": "30",
      "max": "900",
      "step": "0.01",
      "type": "number",
      "placeholder": "93kg"
    },
    domProps: {
      "value": (_vm.formData.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "weight", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Handedness (Left / Right)")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-medium"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.handedness),
      expression: "formData.handedness"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "handedness", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Left")]), _vm._v(" "), _c('option', [_vm._v("Right")])])])])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: []}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow is-hoverable"
  }, [_c('thead', _vm._l((_vm.headings), function(heading) {
    return _c('th', {
      key: heading,
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(heading))])
  }), 0), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row) {
    return _c('tr', {
      key: row.id,
      on: {
        "click": function($event) {
          return _vm.onClick(row.id)
        }
      }
    }, _vm._l((row), function(data, index) {
      return (index !== 'id') ? _c('td', {
        key: data.id
      }, [_vm._v("\n                " + _vm._s(data) + "\n              ")]) : _vm._e()
    }), 0)
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.wrap ? 'WrapperInput' : 'SingleInput', {
    tag: "component",
    attrs: {
      "value": _vm.date,
      "placeholder": _vm.placeholder,
      "inputClass": _vm.inputClass,
      "alignment": _vm.alignment
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "overview"
    }
  }), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('section', [_c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Home")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.ga_home))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.saves_home))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.ga_save_percentage_home))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.gaa_home))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Away")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.ga_away))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.saves_away))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.ga_save_percentage_away))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.gaa_away))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.ga_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.total_saves))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.ga_save_percentage_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Goaltending.gaa_total))])])])])])])]), _vm._v(" "), _c('section', [_c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "has-text-centered subtitle"
  }, [_vm._v("Shooting - All Situations")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.Shooting), function(team) {
    return _c('tr', {
      key: team
    }, [_c('td', [_vm._v(_vm._s(team.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.shots_for))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.shots_against))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.shots_for - team.shots_against))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.goals_for))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.goals_against))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.goals_for - team.goals_against))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.shooting_percentage))])])
  }), 0)])])])]), _vm._v(" "), _c('section', [_c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "has-text-centered subtitle"
  }, [_vm._v("Faceoffs - All Situations")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.Faceoffs), function(team) {
    return _c('tr', {
      key: team
    }, [_c('td', [_vm._v(_vm._s(team.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.fo_won))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.fo_loss))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.fo_won - team.fo_loss))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.fo_win_percentage))])])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 22/10/2018 11:59AM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("Please beware, this is work in progress!")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_c('b', [_vm._v("2022-2023 SEASON EIHL ONLY")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "has-text-centered subtitle"
  }, [_vm._v("Goaltending "), _c('b', [_vm._v("Estimates only!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("GA")]), _vm._v(" "), _c('th', [_vm._v("Saves Made")]), _vm._v(" "), _c('th', [_vm._v("SVP")]), _vm._v(" "), _c('th', [_vm._v("GAA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("SOT +")]), _vm._v(" "), _c('th', [_vm._v("SOT -")]), _vm._v(" "), _c('th', [_vm._v("SOT +/-")]), _vm._v(" "), _c('th', [_vm._v("G +")]), _vm._v(" "), _c('th', [_vm._v("G -")]), _vm._v(" "), _c('th', [_vm._v("G +/-")]), _vm._v(" "), _c('th', [_vm._v("SH %")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("+")]), _vm._v(" "), _c('th', [_vm._v("-")]), _vm._v(" "), _c('th', [_vm._v("+/-")]), _vm._v(" "), _c('th', [_vm._v("%")])])
}]}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-table"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button devils is-small",
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v(" Load Data ")])]), _vm._v(" "), _c('div', {
    staticClass: "main-table"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(column) {
    return _c('th', {
      key: column,
      staticClass: "table-head",
      attrs: {
        "data-tooltip": "Tooltip"
      },
      on: {
        "click": function($event) {
          return _vm.sortByColumn(column)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm._f("columnHead")(column)) + " \n                        "), (column === _vm.sortedColumn) ? _c('span', [(_vm.order == 'asc') ? _c('i', [_vm._v(" ▲")]) : _c('i', [_vm._v("▼")])]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('tbody', [(_vm.tableData.length === 0) ? _c('tr', {}, [_c('td', {
    staticClass: "lead text-center",
    attrs: {
      "colspan": _vm.columns.length + 1
    }
  }, [_vm._v("No data found.")])]) : _vm._l((_vm.tableData), function(data) {
    return _c('tr', {
      key: data.id
    }, _vm._l((data), function(value, key) {
      return _c('td', {
        key: key
      }, [_vm._v(_vm._s(value))])
    }), 0)
  })], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Gamesheet")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Cardiff Devils")]), _vm._v(" "), _c('div', {
    staticClass: "small-box"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Forwards")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/gamesheet",
      "postData": [{
        team_id: 1,
        game_id: this.gameId,
        position: 'forward'
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'G +/-',
          prop: 'goal_diff'
        },
        {
          title: 'Shots +/-',
          prop: 'shots_diff'
        },
        {
          title: 'SOT',
          prop: 'shots_on_net'
        },
        {
          title: 'FO',
          prop: 'faceoffs'
        },
        {
          title: 'Shifts',
          prop: 'toi_shifts'
        },
        {
          title: 'AVG Shift',
          prop: 'toi_avg_shifts'
        },
        {
          title: 'P1',
          prop: 'toi_p1'
        },
        {
          title: 'P2',
          prop: 'toi_p2'
        },
        {
          title: 'P3',
          prop: 'toi_p3'
        },
        {
          title: 'EH',
          prop: 'toi_eh'
        },
        {
          title: 'PP',
          prop: 'toi_pp'
        },
        {
          title: 'SH',
          prop: 'toi_sh'
        },
        {
          title: 'Total TOI',
          prop: 'toi_total'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Defense")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/gamesheet",
      "postData": [{
        team_id: 1,
        game_id: this.gameId,
        position: 'defense'
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'G +/-',
          prop: 'goal_diff'
        },
        {
          title: 'Shots +/-',
          prop: 'shots_diff'
        },
        {
          title: 'SOT',
          prop: 'shots_on_net'
        },
        {
          title: 'FO',
          prop: 'faceoffs'
        },
        {
          title: 'Shifts',
          prop: 'toi_shifts'
        },
        {
          title: 'AVG Shift',
          prop: 'toi_avg_shifts'
        },
        {
          title: 'P1',
          prop: 'toi_p1'
        },
        {
          title: 'P2',
          prop: 'toi_p2'
        },
        {
          title: 'P3',
          prop: 'toi_p3'
        },
        {
          title: 'EH',
          prop: 'toi_eh'
        },
        {
          title: 'PP',
          prop: 'toi_pp'
        },
        {
          title: 'SH',
          prop: 'toi_sh'
        },
        {
          title: 'Total TOI',
          prop: 'toi_total'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Goaltending")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/gamesheet",
      "postData": [{
        team_id: 1,
        game_id: this.gameId,
        position: 'goaltender'
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'G +/-',
          prop: 'goal_diff'
        },
        {
          title: 'Shots +/-',
          prop: 'shots_diff'
        },
        {
          title: 'SOT',
          prop: 'shots_on_net'
        },
        {
          title: 'FO',
          prop: 'faceoffs'
        },
        {
          title: 'Shifts',
          prop: 'toi_shifts'
        },
        {
          title: 'AVG Shift',
          prop: 'toi_avg_shifts'
        },
        {
          title: 'P1',
          prop: 'toi_p1'
        },
        {
          title: 'P2',
          prop: 'toi_p2'
        },
        {
          title: 'P3',
          prop: 'toi_p3'
        },
        {
          title: 'EH',
          prop: 'toi_eh'
        },
        {
          title: 'PP',
          prop: 'toi_pp'
        },
        {
          title: 'SH',
          prop: 'toi_sh'
        },
        {
          title: 'Total TOI',
          prop: 'toi_total'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h1', {
    staticClass: "is-title is-bold"
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.email),
      expression: "data.body.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "User"
    },
    domProps: {
      "value": (_vm.data.body.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.rememberMe),
      expression: "data.rememberMe"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.rememberMe) ? _vm._i(_vm.data.rememberMe, null) > -1 : (_vm.data.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "rememberMe", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "rememberMe", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "rememberMe", $$c)
        }
      }
    }
  }), _vm._v("\n              Remember me\n            ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('button', {
    staticClass: "button is-default"
  }, [_vm._v("Cancel")])])
}]}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Gamesheet")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v(_vm._s(this.teamName))]), _vm._v(" "), _c('div', {
    staticClass: "small-box"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Forwards")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/gamesheet-away-only",
      "postData": [{
        team_id: this.teamId,
        game_id: this.gameId,
        position: 'forward'
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'Shifts',
          prop: 'toi_shifts'
        },
        {
          title: 'AVG Shift',
          prop: 'toi_avg_shifts'
        },
        {
          title: 'EH',
          prop: 'toi_eh'
        },
        {
          title: 'PP',
          prop: 'toi_pp'
        },
        {
          title: 'SH',
          prop: 'toi_sh'
        },
        {
          title: 'Total TOI',
          prop: 'toi_total'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Defense")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/gamesheet-away-only",
      "postData": [{
        team_id: this.teamId,
        game_id: this.gameId,
        position: 'defense'
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'Shifts',
          prop: 'toi_shifts'
        },
        {
          title: 'AVG Shift',
          prop: 'toi_avg_shifts'
        },
        {
          title: 'EH',
          prop: 'toi_eh'
        },
        {
          title: 'PP',
          prop: 'toi_pp'
        },
        {
          title: 'SH',
          prop: 'toi_sh'
        },
        {
          title: 'Total TOI',
          prop: 'toi_total'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Goaltending")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/gamesheet-away-only",
      "postData": [{
        team_id: this.teamId,
        game_id: this.gameId,
        position: 'goaltender'
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'Shifts',
          prop: 'toi_shifts'
        },
        {
          title: 'AVG Shift',
          prop: 'toi_avg_shifts'
        },
        {
          title: 'EH',
          prop: 'toi_eh'
        },
        {
          title: 'PP',
          prop: 'toi_pp'
        },
        {
          title: 'SH',
          prop: 'toi_sh'
        },
        {
          title: 'Total TOI',
          prop: 'toi_total'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-9"
  }, [_c('player-report')], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "small-segment"
  }, [_c('player-table', {
    attrs: {
      "heading": "Cardiff Devils",
      "tableData": _vm.clean,
      "headings": ['#', ''],
      "redirect": "/season-stats/player-stats/"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "turnovers"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Turnovers",
      "heading": "Turnovers",
      "headers": _vm.TurnoverPlayerHeadings,
      "tableData": _vm.sortByTurnoverData
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sort")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FilterSelected),
      expression: "FilterSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.FilterSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByTurnoverDataChart]
    }
  }, _vm._l((_vm.TurnoverPlayerFilters), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SituationSelected),
      expression: "SituationSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SituationSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      },
      on: {
        "change": function($event) {
          return _vm.fetchSeasonStats()
        }
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.chartStackedData,
      "options": _vm.bar_options
    }
  })], 1)], 2)], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "rolling"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Rolling",
      "heading": "Rolling Turnover Data"
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player(s)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.PlayerOptions,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "preserve-search": true,
      "placeholder": "Pick some",
      "label": "name",
      "track-by": "name",
      "preselect-first": true
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.PlayerSelected.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(_vm.PlayerSelected.length) + " options selected")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.PlayerSelected),
      callback: function($$v) {
        _vm.PlayerSelected = $$v
      },
      expression: "PlayerSelected"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Data Selection")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameDataSelected),
      expression: "GameByGameDataSelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.GameByGameDataSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.GameByGameDataOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('h1', {
    staticClass: "label"
  }, [_vm._v("Graph Options")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fill")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameFill),
      expression: "GameByGameFill"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.GameByGameFill) ? _vm._i(_vm.GameByGameFill, null) > -1 : (_vm.GameByGameFill)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.GameByGameFill,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.GameByGameFill = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.GameByGameFill = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.GameByGameFill = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Line Tension")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameTension),
      expression: "GameByGameTension"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "0.0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.GameByGameTension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.GameByGameTension = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sample Size")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RollingLimit),
      expression: "RollingLimit"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "5",
      "max": "30",
      "step": "1"
    },
    domProps: {
      "value": (_vm.RollingLimit)
    },
    on: {
      "change": function($event) {
        return _vm.fetchGraphStats()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RollingLimit = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'line',
      "data": _vm.buildRollingChartData,
      "options": _vm.line_options
    }
  })], 1)], 2)], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "cumulative"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Hits",
      "heading": "Cumulative Turnover Data"
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player(s)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.PlayerOptions,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "preserve-search": true,
      "placeholder": "Pick some",
      "label": "name",
      "track-by": "name",
      "preselect-first": true
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.PlayerSelected.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(_vm.PlayerSelected.length) + " options selected")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.PlayerSelected),
      callback: function($$v) {
        _vm.PlayerSelected = $$v
      },
      expression: "PlayerSelected"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Data Selection")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameDataSelected),
      expression: "GameByGameDataSelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.GameByGameDataSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.GameByGameDataOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('h1', {
    staticClass: "label"
  }, [_vm._v("Graph Options")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fill")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameFill),
      expression: "GameByGameFill"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.GameByGameFill) ? _vm._i(_vm.GameByGameFill, null) > -1 : (_vm.GameByGameFill)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.GameByGameFill,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.GameByGameFill = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.GameByGameFill = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.GameByGameFill = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Line Tension")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameTension),
      expression: "GameByGameTension"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "0.0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.GameByGameTension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.GameByGameTension = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'line',
      "data": _vm.buildCumulativeChartData,
      "options": _vm.line_options
    }
  })], 1)], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 05/02/2019 12:59AM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("NEW: Added situation drop down.")]), _vm._v(" "), _c('li', [_vm._v("NEW: Stacked Offensive Neutral Defensive chart.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
}]}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Turnovers")]), _vm._v(" "), _c('div', {
    staticClass: "small-box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Game Totals")]), _vm._v(" "), _c('chart', {
    ref: "apex_to_chart",
    attrs: {
      "width": "125%",
      "type": "bar",
      "options": _vm.apex_to_options,
      "series": _vm.apex_to_series
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Powerplay")]), _vm._v(" "), _c('chart', {
    ref: "apex_to_pp_chart",
    attrs: {
      "type": "bar",
      "options": _vm.apex_to_options,
      "series": _vm.apex_to_pp_series
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Short Handed - Clearances")]), _vm._v(" "), _c('chart', {
    ref: "apex_to_sh_chart",
    attrs: {
      "type": "bar",
      "options": _vm.apex_to_options,
      "series": _vm.apex_to_sh_series
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/turnovers-per-period",
      "postData": [{
        team_id: 1,
        game_id: this.gameId
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'P1 Total',
          prop: 'to_p1'
        },
        {
          title: 'P1 OZ',
          prop: 'to_p1_oz'
        },
        {
          title: 'P1 NZ',
          prop: 'to_p1_nz'
        },
        {
          title: 'P1 DZ',
          prop: 'to_p1_dz'
        },
        {
          title: 'P2 Total',
          prop: 'to_p2'
        },
        {
          title: 'P2 OZ',
          prop: 'to_p2_oz'
        },
        {
          title: 'P2 NZ',
          prop: 'to_p2_nz'
        },
        {
          title: 'P2 DZ',
          prop: 'to_p2_dz'
        },
        {
          title: 'P3 Total',
          prop: 'to_p3'
        },
        {
          title: 'P3 OZ',
          prop: 'to_p3_oz'
        },
        {
          title: 'P3 NZ',
          prop: 'to_p3_nz'
        },
        {
          title: 'P3 DZ',
          prop: 'to_p3_dz'
        },
        {
          title: 'P4 Total',
          prop: 'to_ot'
        },
        {
          title: 'Total',
          prop: 'to_total'
        } ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "child is-box box"
  }, [_c('p', {
    staticStyle: {
      "font-size": "1.5rem"
    }
  }, [_vm._v("Create Fixture")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFixture.home_team),
      expression: "newFixture.home_team"
    }],
    staticClass: "select is-fullwidth",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newFixture, "home_team", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.teamOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFixture.away_team),
      expression: "newFixture.away_team"
    }],
    staticClass: "select is-fullwidth",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newFixture, "away_team", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.teamOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFixture.competition),
      expression: "newFixture.competition"
    }],
    staticClass: "select is-fullwidth",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newFixture, "competition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.competitionOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "--:--",
      "config": {
        dateFormat: 'Y-m-d',
        maxDate: '2025-06-01',
        minDate: '2021-09-01',
        enableTime: false,
        enableSeconds: true,
        noCalendar: false,
        time_24hr: true
      }
    },
    model: {
      value: (_vm.newFixture.match_date),
      callback: function($$v) {
        _vm.$set(_vm.newFixture, "match_date", $$v)
      },
      expression: "newFixture.match_date"
    }
  })], 1)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFixture.location),
      expression: "newFixture.location"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "IAW Skydome...etc",
      "required": ""
    },
    domProps: {
      "value": (_vm.newFixture.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newFixture, "location", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFixture.eihl_id),
      expression: "newFixture.eihl_id"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "1099",
      "required": ""
    },
    domProps: {
      "value": (_vm.newFixture.eihl_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newFixture, "eihl_id", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFixture.is_stream),
      expression: "newFixture.is_stream"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.newFixture.is_stream) ? _vm._i(_vm.newFixture.is_stream, null) > -1 : (_vm.newFixture.is_stream)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newFixture.is_stream,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newFixture, "is_stream", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newFixture, "is_stream", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newFixture, "is_stream", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "name": "submit"
    },
    on: {
      "click": _vm.createFixture
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-default"
  }, [_vm._v("Clear")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('table', {
    staticClass: "table is-child box is-responsive"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', [_c('tr'), _vm._l((_vm.Fixtures), function(fixture) {
    return _c('tr', {
      key: fixture.id,
      class: {
        'unverified': fixture.is_validated == 0,
        'verified': fixture.is_validated == 1
      }
    }, [_c('td', [_vm._v(_vm._s(fixture.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fixture.match_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fixture.competition))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fixture.location))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fixture.home_team.name) + " ")]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "team_logo",
      attrs: {
        "src": fixture.home_team.logo
      }
    })]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "team_logo",
      attrs: {
        "src": fixture.away_team.logo
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fixture.away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fixture.is_stream))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fixture.eihl_id))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-success",
      attrs: {
        "to": '../../stats/match-verifier/' + fixture.id
      }
    }, [_vm._v("Verifier")])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-success",
      attrs: {
        "to": '../../stats/match-verifier-official/' + fixture.id
      }
    }, [_vm._v("Official Stats Verifier")])], 1), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-danger",
      on: {
        "submit": function($event) {
          $event.preventDefault();
        },
        "click": function($event) {
          return _vm.deleteFixture(fixture.id)
        }
      }
    }, [_vm._v("Delete")])])])
  })], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Home Team")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Away Team")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Game Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "disabled": "",
      "type": "text",
      "placeholder": "",
      "value": "2022 - 2023"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Game Venue ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("EIHL ID")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Is Streamed?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Competition")]), _vm._v(" "), _c('th', [_vm._v("Venue")]), _vm._v(" "), _c('th', [_vm._v("Home Team")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Away Team")]), _vm._v(" "), _c('th', [_vm._v("Stream")]), _vm._v(" "), _c('th', [_vm._v("EIHL ID")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor is-centered"
  }, [_c('article', {
    staticClass: "tile is-child box",
    class: {
      'is-active': _vm.isActive
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Add Player")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.addPlayer
    }
  }, [_c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.number),
      expression: "Player.number"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.forename),
      expression: "Player.forename"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.forename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "forename", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.surname),
      expression: "Player.surname"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "surname", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "--:--",
      "config": {
        enableTime: false,
        enableSeconds: true,
        noCalendar: false,
        time_24hr: true
      }
    },
    model: {
      value: (_vm.Player.dob),
      callback: function($$v) {
        _vm.$set(_vm.Player, "dob", $$v)
      },
      expression: "Player.dob"
    }
  })], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.position),
      expression: "Player.position"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Player, "position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.positionOptions), function(pos) {
    return _c('option', {
      domProps: {
        "value": pos.value
      }
    }, [_vm._v("\n                    " + _vm._s(pos.text) + "\n                  ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.birth_place),
      expression: "Player.birth_place"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.birth_place)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "birth_place", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.nationality),
      expression: "Player.nationality"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.nationality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "nationality", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.height),
      expression: "Player.height"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.Player.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "height", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.weight),
      expression: "Player.weight"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.Player.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "weight", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.handedness),
      expression: "Player.handedness"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.handedness)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "handedness", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.external_url),
      expression: "Player.external_url"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.Player.external_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "external_url", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.status),
      expression: "Player.status"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Player, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.statusOptions), function(status) {
    return _c('option', {
      domProps: {
        "value": status.value
      }
    }, [_vm._v("\n                    " + _vm._s(status.text) + "\n                  ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('input', {
    ref: "file",
    staticClass: "input",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "name": "submit"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-medium",
    attrs: {
      "to": '/editors/player-editor/' + this.$route.params.teamId
    }
  }, [_vm._v("Cancel")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Forename")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Surname")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("DOB")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Position")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Birth Place")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nationality")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Height - Meters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Weight - lbs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Handedness - L/R")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("External URL - Elite Prospects etc.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Picture")])])
}]}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show,
      slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebar.hidden),
      expression: "!sidebar.hidden"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(187),
      "alt": _vm.pkginfo.description
    }
  }), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": 'v' + _vm.pkginfo.version,
      "placement": "right",
      "type": "success",
      "size": "small",
      "no-animate": true,
      "always": true,
      "rounded": true
    }
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "vue"
  }, [_vm._v("Devils")]), _c('strong', {
    staticClass: "admin"
  }, [_vm._v("Edge")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex"
  }, [(!_vm.$auth.check()) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]) : _vm._e(), _vm._v(" "), (_vm.$auth.check()) ? _c('a', {
    staticClass: "nav-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]) : _vm._e()], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('article', {
    staticClass: "is-parent"
  }, [_c('img', {
    staticClass: "team_logo image is-96x96",
    attrs: {
      "src": _vm.Team.logo
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.Team.name))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "segment"
  }, [_c('player-card', {
    attrs: {
      "playerData": _vm.forwards,
      "heading": "Forwards",
      "redirect": "/season-stats/player-stats/",
      "logo": _vm.Team.logo
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "segment"
  }, [_c('player-card', {
    attrs: {
      "playerData": _vm.defense,
      "heading": "Defense",
      "redirect": "/season-stats/player-stats/",
      "logo": _vm.Team.logo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "segment"
  }, [_c('player-card', {
    attrs: {
      "playerData": _vm.goaltending,
      "heading": "Goaltending",
      "redirect": "/season-stats/player-stats/",
      "logo": _vm.Team.logo
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor is-centered"
  }, [_c('div', {
    staticClass: "tile is-parent is-5"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Edit Oddman")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.updateOddman
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teamSelect),
      expression: "teamSelect"
    }],
    staticClass: "select is-fullwidth",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.teamSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.teamOption), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodSelect),
      expression: "periodSelect"
    }],
    staticClass: "select is-fullwidth",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.periodOption), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Oddman.situation.secondary_situation),
      expression: "Oddman.situation.secondary_situation"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Situation of Play i.e. EH5v5"
    },
    domProps: {
      "value": (_vm.Oddman.situation.secondary_situation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Oddman.situation, "secondary_situation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Pick game time",
      "config": {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        time_24hr: true
      }
    },
    model: {
      value: (_vm.Oddman.game_time),
      callback: function($$v) {
        _vm.$set(_vm.Oddman, "game_time", $$v)
      },
      expression: "Oddman.game_time"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "name": "submit"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-small",
    attrs: {
      "to": '/editors/oddman/:gameId'
    }
  }, [_vm._v("Cancel")])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Rush for Team:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Period")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Game Time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  })])
}]}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment-main"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Gamesheet Cards ")]), _vm._v(" "), (this.Gamesheet.length <= 0) ? _c('span', [_c('h2', {
    staticClass: "segment title has-text-centered"
  }, [_vm._v("No data or Loading...")])]) : _vm._e(), _vm._v(" "), _vm._l((this.Gamesheet), function(player) {
    return _c('div', {
      key: player.number,
      staticClass: "segment"
    }, [(player.number !== null) ? _c('div', [_c('h2', {
      staticClass: "subtitle has-text-centered devils"
    }, [_vm._v(_vm._s(player.number))]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('h2', {
      staticClass: "subheading has-text-centered"
    }, [_vm._v("Goals")]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("+ " + _vm._s(player.goals_for))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("- " + _vm._s(player.goals_for))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("+/- " + _vm._s(player.goal_diff))])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('h2', {
      staticClass: "subheading has-text-centered"
    }, [_vm._v("Faceoffs")]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v(" Won / Taken " + _vm._s(player.fo))])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('h2', {
      staticClass: "subheading has-text-centered"
    }, [_vm._v("Shots")]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("+ " + _vm._s(player.shots_for))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("- " + _vm._s(player.shots_against))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("+/- " + _vm._s(player.shots_plus_minus))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("On Net " + _vm._s(player.sot))])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('h2', {
      staticClass: "subheading has-text-centered"
    }, [_vm._v("Ice Time")]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Total TOI" + _vm._s(player.total_toi))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Shifts " + _vm._s(player.shifts))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Average " + _vm._s(player.avg_shift))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Even Handed " + _vm._s(player.eh_time))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Power Play " + _vm._s(player.pp_time))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Short Handed " + _vm._s(player.sh_time))])])])]) : _vm._e()])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse is-fullwidth"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('article', {
    staticClass: "title is-parent box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("App Builds")])])])
}]}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content background-slider has-text-centered"
  })
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment"
  }, [_c('h1', [_vm._v("Joey Haddad - 2019 / 2020 Season")]), _vm._v(" "), _c('p', [_vm._v(" All Situations - Goals SOT Shifts")]), _vm._v(" "), _c('p', [_vm._v(" EH - Shot+/-")]), _vm._v(" "), _c('apex-chart', {
    ref: "test",
    attrs: {
      "type": "line",
      "height": "350",
      "series": _vm.chartData,
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.open) ? _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Edit " + _vm._s(_vm.type))]), _vm._v(" "), _vm._t("default")], 2)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('game-faceoffs', {
    attrs: {
      "gameId": 211,
      "period": 0
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Edit Player")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Number #")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.number),
      expression: "formData.number"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "step": "1",
      "placeholder": "88"
    },
    domProps: {
      "value": (_vm.formData.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.forename),
      expression: "formData.forename"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Joey"
    },
    domProps: {
      "value": (_vm.formData.forename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "forename", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.surname),
      expression: "formData.surname"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Martin"
    },
    domProps: {
      "value": (_vm.formData.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "surname", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.age),
      expression: "formData.age"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": "Mar 15 2001"
    },
    domProps: {
      "value": (_vm.formData.age)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "age", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Place of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.birth_place),
      expression: "formData.birth_place"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Canada"
    },
    domProps: {
      "value": (_vm.formData.birth_place)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "birth_place", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nationality")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.nationality),
      expression: "formData.nationality"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Canada"
    },
    domProps: {
      "value": (_vm.formData.nationality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "nationality", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Position")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-medium"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.position),
      expression: "formData.position"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Forward")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LW"
    }
  }, [_vm._v("Left Forward")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Center Forward")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RW"
    }
  }, [_vm._v("Right Forward")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LD"
    }
  }, [_vm._v("Defense")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LD"
    }
  }, [_vm._v("Left Defense")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RD"
    }
  }, [_vm._v("Right Defense")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GT"
    }
  }, [_vm._v("Goaltender")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BKUPGT"
    }
  }, [_vm._v("Backup Goaltender")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EMRGGT"
    }
  }, [_vm._v("Emergency Goaltender")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "COACH"
    }
  }, [_vm._v("Coach")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ASSCOACH"
    }
  }, [_vm._v("Assistant Coach")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Height (m)")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.height),
      expression: "formData.height"
    }],
    staticClass: "input",
    attrs: {
      "min": "1",
      "max": "6",
      "step": "0.01",
      "type": "number",
      "placeholder": "1.93m"
    },
    domProps: {
      "value": (_vm.formData.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "height", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Weight (kg)")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.weight),
      expression: "formData.weight"
    }],
    staticClass: "input",
    attrs: {
      "min": "30",
      "max": "900",
      "step": "0.01",
      "type": "number",
      "placeholder": "93kg"
    },
    domProps: {
      "value": (_vm.formData.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "weight", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Handedness (Left / Right)")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-medium"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.handedness),
      expression: "formData.handedness"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "handedness", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "L"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "R"
    }
  }, [_vm._v("Right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-medium"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.status),
      expression: "formData.status"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Inactvie"
    }
  }, [_vm._v("Inactive")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Retired"
    }
  }, [_vm._v("Retired")])])])])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('NewPlayer', {
    ref: "NewPlayer",
    on: {
      "dataUpdate": _vm.fetchPlayers
    }
  }), _vm._v(" "), _c('EditPlayerDialog', {
    ref: "EditPlayerDialog",
    on: {
      "dataUpdate": _vm.fetchPlayers
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container is-child has-text-centered"
  }, [_c('article', {
    staticClass: "is-parent title"
  }, [_c('img', {
    staticClass: "team_logo image is-96x96",
    attrs: {
      "src": _vm.Team.logo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.Team.name))])]), _vm._v(" "), _c('article', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("App Roster")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.updateRoster
    }
  }, [_c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((4), function(n) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(n))]), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
      return (n == item.line_number && item.position === 'LW') ? _c('td', [_c('p', {
        staticClass: "control"
      }, [_c('span', {
        staticClass: "select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.p_id),
          expression: "item.p_id"
        }],
        attrs: {
          "change": _vm.updateRoster(item, item.p_id)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.activeOptions), function(playerOption) {
        return _c('option', {
          key: playerOption.value,
          domProps: {
            "value": playerOption.value
          }
        }, [_vm._v("\n                              " + _vm._s(playerOption.text) + "\n                            ")])
      }), 0)])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
      return (n == item.line_number && item.position === 'C') ? _c('td', [_c('p', {
        staticClass: "control"
      }, [_c('span', {
        staticClass: "select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.p_id),
          expression: "item.p_id"
        }],
        attrs: {
          "change": _vm.updateRoster(item, item.p_id)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.activeOptions), function(playerOption) {
        return _c('option', {
          key: playerOption.value,
          domProps: {
            "value": playerOption.value
          }
        }, [_vm._v("\n                              " + _vm._s(playerOption.text) + "\n                            ")])
      }), 0)])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
      return (n == item.line_number && item.position === 'RW') ? _c('td', [_c('p', {
        staticClass: "control"
      }, [_c('span', {
        staticClass: "select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.p_id),
          expression: "item.p_id"
        }],
        attrs: {
          "change": _vm.updateRoster(item, item.p_id)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.activeOptions), function(playerOption) {
        return _c('option', {
          key: playerOption.value,
          domProps: {
            "value": playerOption.value
          }
        }, [_vm._v("\n                              " + _vm._s(playerOption.text) + "\n                            ")])
      }), 0)])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
      return (n == item.line_number && item.position === 'LD') ? _c('td', [_c('p', {
        staticClass: "control"
      }, [_c('span', {
        staticClass: "select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.p_id),
          expression: "item.p_id"
        }],
        attrs: {
          "change": _vm.updateRoster(item, item.p_id)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.activeOptions), function(playerOption) {
        return _c('option', {
          key: playerOption.value,
          domProps: {
            "value": playerOption.value
          }
        }, [_vm._v("\n                              " + _vm._s(playerOption.text) + "\n                            ")])
      }), 0)])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
      return (n == item.line_number && item.position === 'RD') ? _c('td', [_c('p', {
        staticClass: "control"
      }, [_c('span', {
        staticClass: "select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.p_id),
          expression: "item.p_id"
        }],
        attrs: {
          "change": _vm.updateRoster(item, item.p_id)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.activeOptions), function(playerOption) {
        return _c('option', {
          key: playerOption.value,
          domProps: {
            "value": playerOption.value
          }
        }, [_vm._v("\n                              " + _vm._s(playerOption.text) + " \n                            ")])
      }), 0)])])]) : _vm._e()
    })], 2)
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
    return (item.line_number == 5 && item.position === 'GT') ? _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.p_id),
        expression: "item.p_id"
      }],
      attrs: {
        "change": _vm.updateRoster(item, item.p_id)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.activeOptions), function(playerOption) {
      return _c('option', {
        key: playerOption.value,
        domProps: {
          "value": playerOption.value
        }
      }, [_vm._v("\n                              " + _vm._s(playerOption.text) + "\n                            ")])
    }), 0)])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
    return (item.line_number == 5 && item.position === 'BKPGT') ? _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.p_id),
        expression: "item.p_id"
      }],
      attrs: {
        "change": _vm.updateRoster(item, item.p_id)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.activeOptions), function(playerOption) {
      return _c('option', {
        key: playerOption.value,
        domProps: {
          "value": playerOption.value
        }
      }, [_vm._v("\n                              " + _vm._s(playerOption.text) + "\n                            ")])
    }), 0)])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
    return (item.line_number == 5 && item.position === 'EMGGT') ? _c('td', [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.p_id),
        expression: "item.p_id"
      }],
      attrs: {
        "change": _vm.updateRoster(item, item.p_id)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.activeOptions), function(playerOption) {
      return _c('option', {
        key: playerOption.value,
        domProps: {
          "value": playerOption.value
        }
      }, [_vm._v("\n                              " + _vm._s(playerOption.text) + "\n                            ")])
    }), 0)])])]) : _vm._e()
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')], 2)])]), _vm._v(" "), _c('p', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "name": "submit"
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.clearRoster
    }
  }, [_vm._v("Clear")])])])])]), _vm._v(" "), _c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "is-child box player",
    on: {
      "click": function($event) {
        return _vm.$refs.NewPlayer.launch()
      }
    }
  }, [_c('p', {
    staticClass: "fa fa-user",
    staticStyle: {
      "font-size": "90px",
      "color": "#00d1b2"
    }
  }), _c('h1', {
    staticClass: "title"
  }, [_vm._v("New Player")])])]), _vm._v(" "), _c('article', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Forwards")]), _vm._v(" "), _c('div', {
    staticClass: "container is-child has-text-centered"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, _vm._l((_vm.Players.length), function(i) {
    return _c('div', _vm._l((_vm.Players.slice((i - 1), i)), function(player) {
      return _c('span', [(player.status === 'Active') ? _c('div', {
        staticClass: "column"
      }, [(player.number > 0 && player.position === 'LW' || player.position === 'C' || player.position === 'RW') ? _c('div', [_c('article', {
        staticClass: "is-child box",
        on: {
          "click": function($event) {
            return _vm.loadEdit(player)
          }
        }
      }, [_c('img', {
        staticClass: "team_logo image is-96x96",
        attrs: {
          "src": player.picture
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "title",
        staticStyle: {
          "margin-top": "20px"
        }
      }, [_vm._v(_vm._s(player.number))]), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(player.forename))]), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(player.surname))])])]) : _vm._e()]) : _vm._e()])
    }), 0)
  }), 0)])]), _vm._v(" "), _c('article', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Defense")]), _vm._v(" "), _c('div', {
    staticClass: "container is-child has-text-centered"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, _vm._l((_vm.Players.length), function(i) {
    return _c('div', _vm._l((_vm.Players.slice((i - 1), i)), function(player) {
      return _c('span', [(player.position === 'LD' || player.position === 'RD') ? _c('div', {
        staticClass: "column"
      }, [(player.status == 'Active') ? _c('div', [_c('article', {
        staticClass: "is-child box player",
        on: {
          "click": function($event) {
            return _vm.loadEdit(player)
          }
        }
      }, [_c('img', {
        staticClass: "team_logo image is-96x96",
        attrs: {
          "src": player.picture
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "title",
        staticStyle: {
          "margin-top": "20px"
        }
      }, [_vm._v(_vm._s(player.number))]), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(player.forename))]), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(player.surname))])])]) : _vm._e()]) : _vm._e()])
    }), 0)
  }), 0)])]), _vm._v(" "), _c('article', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Goaltenders")]), _vm._v(" "), _c('div', {
    staticClass: "container is-child has-text-centered"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, _vm._l((_vm.Players.length), function(i) {
    return _c('div', _vm._l((_vm.Players.slice((i - 1), i)), function(player) {
      return _c('span', [(player.position === 'GT' || player.position === 'BKUPGT' || player.position === 'EMRGGT') ? _c('div', {
        staticClass: "column"
      }, [(player.status == 'Active') ? _c('div', [_c('article', {
        staticClass: "is-child box",
        on: {
          "click": function($event) {
            return _vm.loadEdit(player)
          }
        }
      }, [_c('img', {
        staticClass: "team_logo image is-96x96",
        attrs: {
          "src": player.picture
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "title",
        staticStyle: {
          "margin-top": "20px"
        }
      }, [_vm._v(_vm._s(player.number))]), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(player.forename))]), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(player.surname))])])]) : _vm._e()]) : _vm._e()])
    }), 0)
  }), 0)])]), _vm._v(" "), _c('article', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Inactive / Retired")]), _vm._v(" "), _c('div', {
    staticClass: "container is-child has-text-centered"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, _vm._l((_vm.Players.length), function(i) {
    return _c('div', _vm._l((_vm.Players.slice((i - 1), i)), function(player) {
      return _c('span', [(player.status === 'Inactive' || player.status === 'Retired') ? _c('div', {
        staticClass: "column"
      }, [_c('article', {
        staticClass: "is-child box",
        on: {
          "click": function($event) {
            return _vm.loadEdit(player)
          }
        }
      }, [_c('img', {
        staticClass: "team_logo image is-96x96",
        attrs: {
          "src": player.picture
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "title",
        staticStyle: {
          "margin-top": "20px"
        }
      }, [_vm._v(_vm._s(player.number))]), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(player.forename))]), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(player.surname))])])]) : _vm._e()])
    }), 0)
  }), 0)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("LW")]), _vm._v(" "), _c('th', [_vm._v("C")]), _vm._v(" "), _c('th', [_vm._v("RW")]), _vm._v(" "), _c('th', [_vm._v("LD")]), _vm._v(" "), _c('th', [_vm._v("RD")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Starting Goal Tender")]), _vm._v(" "), _c('th', [_vm._v("Backup Goal Tender")]), _vm._v(" "), _c('th', [_vm._v("Emergency Goal Tender")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])
}]}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title is-uppercase"
  }, [_vm._v(_vm._s(_vm.PlayerData.player.name))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Position: " + _vm._s(_vm.PlayerData.player.position))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Handedness: " + _vm._s(_vm.PlayerData.player.handedness))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Age: " + _vm._s(_vm.PlayerData.player.age))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Nationality: " + _vm._s(_vm.PlayerData.player.birth_place))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tabs is-fullwidth"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.selected == 'overview',
      'is-primary': _vm.selected != 'overview'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'overview';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Overview")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'game-logs',
      'is-primary': _vm.selected != 'game-logs'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'game-logs'
      }
    }
  }, [_vm._v("Game Logs")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'power-play',
      'is-primary': _vm.selected != 'power-play'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'power-play';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Power Play")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'points',
      'is-primary': _vm.selected != 'points'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'points';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Points")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'shots',
      'is-primary': _vm.selected != 'shots'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'shots';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Shooting")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'faceoffs',
      'is-primary': _vm.selected != 'faceoffs'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'faceoffs';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Faceoffs")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'turnovers',
      'is-primary': _vm.selected != 'turnovers'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'turnovers';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Turnovers")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'hits',
      'is-primary': _vm.selected != 'hits'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'hits';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Hits")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'toi',
      'is-primary': _vm.selected != 'toi'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'toi';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Time On Ice")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'pims',
      'is-primary': _vm.selected != 'pims'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'pims';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Penalty Minutes")])])])]), _vm._v(" "), (_vm.selected === 'overview') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_goals))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_total))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_attempts))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_points))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_shifts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_sot))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'game-logs') ? _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('apexchart', {
    ref: "game_logs_chart",
    attrs: {
      "type": "line",
      "height": "350",
      "options": _vm.GameLogsCharOptions,
      "series": _vm.gameLogsChart
    }
  })], 1), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/player-stats/game-logs/",
      "postData": [{
        year: 2021,
        competition: 'EIHL',
        venue: 0,
        player_id: this.$route.params.player_id,
        team_id: 1
      }],
      "selectedData": [{
          title: 'Date',
          prop: 'game_date'
        },
        {
          title: 'G',
          prop: 'goals'
        },
        {
          title: 'PA',
          prop: 'first_assist'
        },
        {
          title: 'SA',
          prop: 'second_assist'
        },
        {
          title: 'PPTS',
          prop: 'primary_points'
        },
        {
          title: 'P',
          prop: 'points',
        },
        {
          title: 'PPG',
          prop: 'pp_goals'
        },
        {
          title: 'PPP',
          prop: 'pp_points'
        },
        {
          title: 'SHG',
          prop: 'sh_goals'
        },
        {
          title: 'SHP',
          prop: 'sh_points'
        },
        {
          title: 'SOG',
          prop: 'shots_on_net'
        },
        {
          title: 'SHOTS +',
          prop: 'shots_for'
        },
        {
          title: 'SHOTS -',
          prop: 'shots_against'
        },
        {
          title: 'SHOTS +/-',
          prop: 'shots_diff'
        },
        {
          title: 'TOI',
          prop: 'toi_total'
        },
        {
          title: 'Shifts',
          prop: 'toi_shifts'
        },
        {
          title: 'PIMT',
          prop: 'pim_taken'
        },
        {
          title: 'PIMD',
          prop: 'pim_drawn'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selected === 'points') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_points))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_goals))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_first_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_second_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_points))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_goals_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_first_assists_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_second_assists_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_assists_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_points_60))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'power-play') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_shots))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_goals))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_first_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_second_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_points))])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_attempts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_sot))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shooting_percentage) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_percentage) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_shifts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_shifts_avg))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_pp_per_game))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('ShotsHeatmap')], 1)])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'shots') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_shots))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_attempts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_percentage))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_sot))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_sot_percentage))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shooting_percentage))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shots_for))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shots_against))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shots_diff))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_goals_percentage))])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_sot_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shots_for_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shots_against_60))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'faceoffs') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_faceoffs))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_taken))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_win))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_loss))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_total_win_percentage) + " %")])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_t_percentage) + " %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_win_percentage) + " %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_loss_percentage) + " %")])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'turnovers') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_turnovers))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_total))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_ozone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_nzone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_dzone))])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_total_percentage) + " %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_ozone_percentage) + " %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_nzone_percentage) + " %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_dzone_percentage) + " %")])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'hits') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_hits))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_sixty))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_vs_team) + "%")])]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_eh))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_pp))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_sh))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'toi') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_toi))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_total))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_avg_shift))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_shifts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_shifts_avg))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_eh))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_pp))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_sh))])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_eh_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_pp_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_sh_per_game))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_eh_shifts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_pp_shifts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_sh_shifts))])]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_eh_shifts_gp))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_pp_shifts_gp))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_sh_shifts_gp))])])]), _vm._v(" "), _c('h2', {
    staticClass: "stat-category has-text-centered"
  }, [_vm._v("Team %")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_eh) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_pp) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_sh) + "%")])]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_shifts) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_shifts_eh) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_shifts_pp) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_shifts_sh) + "%")])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'pims') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_pims))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_count))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_count))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_minor))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_minor))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_major))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_major))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_misconduct))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_misconduct))])]), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_per_game_minor))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_per_game_minor))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_per_game_major))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_per_game_major))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_per_game_misconduct))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_per_game_misconduct))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_per_sixty))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_per_sixty))])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_team_percentage) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_team_percentage) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_team_percentage_minor) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_team_percentage_minor) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_team_percentage_major) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_team_percentage_major) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_team_percentage_misconduct) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_team_percentage_misconduct) + "%")])]), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v("-")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_ozone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_ozone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_nzone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_nzone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_dzone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_dzone))])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("2021 / 2022")])])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("EHIL & Challenge Cup")])])])]), _vm._v(" "), _c('small', [_vm._v("All Situations - Unless specified")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-1"
  }, [_c('figure', {
    staticClass: "image is-128x128"
  }, [_c('img', {
    staticClass: "is-rounded",
    attrs: {
      "src": "https://devils.roblutken.com/devils/assets/player-pictures/Cardiff_Devils.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Goals")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Total Time On Ice")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shot Attempts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Points")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots On Target")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Goals")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Primary Assists")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Secondary Assists")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Assists")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Points")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Goals / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("First Assists / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Second Assists / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Assists / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Points / 60")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Goals")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PA")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SA")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Assists")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Points")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shot Attempts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SOT")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SOT %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("TOI")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("AVG Shift")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("AVG / G")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shot_attempts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Shots")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SOT")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SOT %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots For")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots Against")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots Diff")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Goals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SOT / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots For / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots Against / 60")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Won")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Lost")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Win %")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team FO Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team FO Win")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team FO Lost")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Total")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("O-Zone")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("N-Zone")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("D-Zone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team O-Zone")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team N-Zone")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team D-Zone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Hits")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Hits Per Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Hits Per 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v(" % of Team Hits")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Total TOI")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("AVG TOI")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("AVG Shift")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("AVG Shift / G")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH TOI")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP TOI")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH TOI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-3"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH AVG")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP AVG")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH AVG")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH Shifts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-3"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH Shifts AVG")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP Shifts AVG")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH Shifts AVG")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Total Time")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH Time")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP Time")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH Time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-3"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH Shifts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2 is-3"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("No. Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("No. Drawn")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Minor")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Minor")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Major")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Major")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Misconduct")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Misconduct")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-4"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Minor / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Minor / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Major / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Major / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Misconduct / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Misconduct / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn / 60")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2 is-3"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Drawn")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Taken Minor")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Drawn Minor")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Taken Major")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Drawn Major")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Taken Misconduct")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Drawn Misconduct")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-4"
  }, [_c('h2', {
    staticClass: "stat-category has-text-centered"
  }, [_vm._v("Major & Minor Only")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins O-Zone Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins O-Zone Drawn")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins N-Zone Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins N-Zone Drawn")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins D-Zone Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins D-Zone Drawn")])])
}]}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Penalty Type")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PenaltySelected),
      expression: "PenaltySelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.PenaltySelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.PenaltyOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("League Penalty Differentials")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Last Crawler Run - 18-01-2020")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/eihl/penalties/team-diff",
      "postData": [{
        pen_type: _vm.PenaltySelected,
      }],
      "selectedData": [{
          title: 'Team',
          prop: 'name'
        },
        {
          title: 'Taken',
          prop: 'pims_plus'
        },
        {
          title: 'Drawn',
          prop: 'pims_minus'
        },
        {
          title: '+/-',
          prop: 'pims_diff'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "display": "none",
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_total_chart,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture[0].match_date))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('img', {
    staticClass: "team_logo",
    attrs: {
      "src": _vm.Fixture[0].home_team.logo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title has-text-left"
  }, [_vm._v(_vm._s(_vm.Fixture[0].home_team.name) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('img', {
    staticClass: "team_logo",
    attrs: {
      "src": _vm.Fixture[0].away_team.logo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title has-text-left"
  }, [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture[0].competition))]), _vm._v(" "), _c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture[0].location))]), _vm._v(" "), (_vm.Fixture[0].is_stream == 1) ? _c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Stream")]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Live")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "button is-success is-small",
    attrs: {
      "to": '/stats/match-stats/' + this.$route.params.gameId + '/0'
    }
  }, [_vm._v("Full Report")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-success is-small",
    attrs: {
      "to": '/stats/match-stats-opposition/' + this.$route.params.gameId + '/0'
    }
  }, [_vm._v("Opposition Report")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-6 is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Game Summary")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_ot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_pp) + " / " + _vm._s(_vm.Summary.situation_opts[0].PPTotal))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_goals_total))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_ot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_pp) + " /  " + _vm._s(_vm.Summary.situation_opts[0].SHTotal))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_goals_total))])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("All Attempts")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_shots_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_total - _vm.Summary.away_shots_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_shots_total))])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("On Target")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_sot_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_total - _vm.Summary.away_sot_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_sot_total))])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_fo_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_total - _vm.Summary.away_fo_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_fo_total))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Filters")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 1,
      'is-primary': this.$route.params.period != 1
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(1)
      }
    }
  }, [_vm._v("Period 1")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 2,
      'is-primary': this.$route.params.period != 2
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(2)
      }
    }
  }, [_vm._v("Period 2")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 3,
      'is-primary': this.$route.params.period != 3
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(3)
      }
    }
  }, [_vm._v("Period 3")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 4,
      'is-primary': this.$route.params.period != 4
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(4)
      }
    }
  }, [_vm._v("Overtime")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 0,
      'is-primary': this.$route.params.period != 0
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(0)
      }
    }
  }, [_vm._v("Total")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Player Totals")]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_t,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', _vm._l((this.FaceoffsChart.all_situations), function(result) {
    return _c('tr', {
      key: result.player_id
    }, [_c('td', [_vm._v(_vm._s(result.player_id))]), _vm._v(" "), _c('td', {
      staticClass: "fo-left has-text-centered"
    }, [_vm._v(_vm._s(result.left_win) + " / " + _vm._s(-result.left_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-left has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.left_win - (-result.left_loss)))])]), _vm._v(" "), _c('td', {
      staticClass: "fo-center has-text-centered"
    }, [_vm._v(_vm._s(result.center_win) + " / " + _vm._s(-result.center_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-center has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.center_win - -result.center_loss))])]), _vm._v(" "), _c('td', {
      staticClass: "fo-right has-text-centered"
    }, [_vm._v(_vm._s(result.right_win) + " / " + _vm._s(-result.right_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-right has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.right_win - -result.right_loss))])]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_vm._v(_vm._s(result.total_win + -result.total_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_vm._v(_vm._s(result.total_win) + " / " + _vm._s(-result.total_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_vm._v(_vm._s(result.total_win - (-result.total_loss)))]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.win_percentage))])])])
  }), 0)]), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('collapse-item', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal"
    },
    attrs: {
      "title": "Situational Faceoffs"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Even Handed")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l_eh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c_eh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r_eh,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Power Play")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l_pp,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c_pp,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r_pp,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Short Handed")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l_sh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c_sh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r_sh,
      "options": _vm.fo_options
    }
  })], 1)])])], 1), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('collapse-item', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal"
    },
    attrs: {
      "title": "Faceoff Map"
    }
  }, [_c('FaceoffTeamVS', {
    attrs: {
      "home_name": _vm.Fixture[0].home_team.name,
      "away_name": _vm.Fixture[0].away_team.name
    }
  })], 1)], 1), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('collapse-item', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal"
    },
    attrs: {
      "title": "Faceoff PVP"
    }
  }, [_c('faceoffs-pvp', {
    attrs: {
      "opponent": _vm.Fixture[0].away_team.id,
      "game_id": this.$route.params.gameId
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box",
    attrs: {
      "id": "Gamesheet"
    }
  }, [_vm._m(10), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Forwards")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.sortBytimeForwards), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goal_diff))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.fo))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_plus_minus))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sot))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.avg_shift))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.eh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.pp_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.total_toi))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Defense")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(12), _vm._v(" "), _c('tbody', _vm._l((_vm.sortBytimeDefense), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goal_diff))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.fo))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_plus_minus))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sot))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.avg_shift))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.eh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.pp_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.total_toi))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 1) ? _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Estimated TOI - For Away Games")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', _vm._l((_vm.sortBytimeAll), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.season_average_toi))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.est_toi))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Totals")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(14), _vm._v(" "), _c('tbody', _vm._l((_vm.gameTotals), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal"
    }, [_vm._v(_vm._s(result.total_gf))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal"
    }, [_vm._v(_vm._s(result.total_ga))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal"
    }, [_vm._v(_vm._s(result.total_gdiff))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_fo))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots"
    }, [_vm._v(_vm._s(result.total_shots_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots"
    }, [_vm._v(_vm._s(result.total_shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots"
    }, [_vm._v(_vm._s(result.total_shots_for - result.total_shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_sot))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_eh))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_pp))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_sh))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.total_toi))])])])
  }), 0)])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 09/03/2020 11:22PM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "color": "purple"
    }
  }, [_vm._v(" Site - Added Faceoffs PVP - Will only work when we're the home team!")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "subtitle has-text-centered",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_vm._v("Goals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("PP")]), _vm._v(" "), _c('th', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_c('b', [_vm._v("Shots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_c('b', [_vm._v("Faceoffs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Faceoffs - All Situations")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "testAlign is-capitalized"
  }, [_vm._v("Left W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Center W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Right W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Taken")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total +/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total Win %")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Gamesheet")]), _vm._v(" "), _c('p', [_vm._v("Goal +/- is Even Handed ")]), _vm._v(" "), _c('p', [_vm._v("Shot +/- SOT FOT is All Situations")]), _vm._v(" "), _c('p', [_vm._v("FO - Faceoff Wins / Faceoffs Taken")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals for even handed"
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals against even handed"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals +/- even handed"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Faceoffs won / Faceoffs taken all situations"
    }
  }, [_vm._v("FO")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances for even handed"
    }
  }, [_vm._v("Shots For")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances against even handed"
    }
  }, [_vm._v("Shots Against")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances +/- even handed"
    }
  }, [_vm._v("Shots Diff")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Shots on target all situations"
    }
  }, [_vm._v("SOT")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI average shift time all situations"
    }
  }, [_vm._v("AvgShifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI 5v5 time even handed"
    }
  }, [_vm._v("EH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI power play time"
    }
  }, [_vm._v("PP")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI short handed time"
    }
  }, [_vm._v("SH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Total time on ice all situations"
    }
  }, [_vm._v("Total TOI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals for even handed"
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals against even handed"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals +/- even handed"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Faceoffs won / Faceoffs taken all situations"
    }
  }, [_vm._v("FO")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances for even handed"
    }
  }, [_vm._v("Shots For")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances against even handed"
    }
  }, [_vm._v("Shots Against")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances +/- even handed"
    }
  }, [_vm._v("Shots Diff")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Shots on target all situations"
    }
  }, [_vm._v("SOT")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI average shift time all situations"
    }
  }, [_vm._v("AvgShifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI 5v5 time even handed"
    }
  }, [_vm._v("EH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI power play time"
    }
  }, [_vm._v("PP")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI short handed time"
    }
  }, [_vm._v("SH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Total time on ice all situations"
    }
  }, [_vm._v("Total TOI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Season AVG Shift")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Est Time based on season average"
    }
  }, [_vm._v("EST Total TOI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals for even handed"
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals against even handed"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals +/- even handed"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Faceoffs won / Faceoffs taken all situations"
    }
  }, [_vm._v("FO")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances for even handed"
    }
  }, [_vm._v("Shots For")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances against even handed"
    }
  }, [_vm._v("Shots Against")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances +/- even handed"
    }
  }, [_vm._v("Shots Diff")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Shots on target all situations"
    }
  }, [_vm._v("SOT")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI average shift time all situations"
    }
  }, [_vm._v("AvgShifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI 5v5 time even handed"
    }
  }, [_vm._v("EH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI power play time"
    }
  }, [_vm._v("PP")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI short handed time"
    }
  }, [_vm._v("SH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Total time on ice all situations"
    }
  }, [_vm._v("Total TOI")])])
}]}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "shot-differentials"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "player_shot_diff"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "player_corsi",
      "heading": "Player Shot Differentials - Home games only will be updated with both shortly...",
      "headers": _vm.PlayerShotDiffHeadings,
      "tableData": _vm.sortByPlayerShotDiffData
    }
  }, [_c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "filter"
    },
    slot: "filter"
  }, [_c('div', {
    staticClass: "column is-2 is-small"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SituationSelected),
      expression: "SituationSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SituationSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])])], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "player_last_five"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "player_corsi",
      "heading": "Player Shot Differentials - Home games only will be updated with both shortly...",
      "headers": _vm.PlayerShotDiffHeadings,
      "tableData": _vm.sortByPlayerShotDiffData
    }
  }, [_c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "filter"
    },
    slot: "filter"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 14/11/2019 11:29AM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("Updated calculations for 2019 season - Includes home games only for now...")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
}]}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.realValue),
      expression: "realValue"
    }],
    class: _vm.classObject,
    attrs: {
      "type": "range",
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step,
      "name": _vm.name,
      "orient": _vm.vertical && 'vertical',
      "disabled": _vm.disabled,
      "number": ""
    },
    domProps: {
      "value": (_vm.realValue)
    },
    on: {
      "__r": function($event) {
        _vm.realValue = $event.target.value
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Filters")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('p', {
    staticClass: "subtitle has-text-primary"
  }, [_vm._v("Teams")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTeam),
      expression: "selectedTeam"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTeam = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.teamOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', {
    staticClass: "subtitle has-text-bold"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSeason),
      expression: "selectedSeason"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSeason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.seasonOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', {
    staticClass: "subtitle has-text-primary"
  }, [_vm._v("Position")]), _vm._v(" "), _c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPosition),
      expression: "selectedPosition"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPosition = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.positionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', {
    staticClass: "subtitle has-text-primary"
  }, [_vm._v("Sort By")]), _vm._v(" "), _c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortSelected),
      expression: "sortSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sortSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getSortedData()
      }]
    }
  }, _vm._l((_vm.sortOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', {
    staticClass: "subtitle has-text-primary"
  }, [_vm._v("Find By Player")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "input",
    staticStyle: {
      "height": "3em"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('table', {
    staticClass: "table is-striped is-responsive"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.computed_data), function(player) {
    return _c('tr', {
      key: player.id
    }, [_c('td', [_vm._v(_vm._s(player.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.season))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.nationality))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.position))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.gp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.g))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.a))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.tp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDecimal")(player.gpg)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDecimal")(player.apg)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDecimal")(player.ppg)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.igp) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.iap) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.ipp) + "%")])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 26/08/2019 11:20PM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("Added sort option")]), _vm._v(" "), _c('li', [_vm._v("Historical Data only (2015 - 2018) - No current Season Data")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("Season")]), _vm._v(" "), _c('th', [_vm._v("Nationality")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Position"
    }
  }, [_vm._v("P")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Games Played"
    }
  }, [_vm._v("GP")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Total Goals"
    }
  }, [_vm._v("G")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Total Assists"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Total Points"
    }
  }, [_vm._v("Pts")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Goals Per Game"
    }
  }, [_vm._v("GPG")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Assists Per Game"
    }
  }, [_vm._v("APG")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Points Per Game"
    }
  }, [_vm._v("PPG")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Individual Goal Percentage"
    }
  }, [_vm._v("IGP")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Individual Assists Percentage"
    }
  }, [_vm._v("IAP")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Individual Points Percentage"
    }
  }, [_vm._v("IPP")])])
}]}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container is-child"
  }, [_c('article', {
    staticClass: "segment"
  }, [_c('h1', {
    staticClass: "has-text-centered"
  }, [_vm._v("Shot Quality")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('h2', {
    staticClass: "stat-category has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_name)), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_shots.goals))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_shots.xg))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_shots.shot_on_target))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_shots.shot_attempts))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_shots.shooting_percentage))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('h2', {
    staticClass: "stat-category has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_name) + " "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_shots.goals))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_shots.xg))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_shots.shot_on_target))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_shots.shot_attempts))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_shots.shooting_percentage))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-2"
  }, [_c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("Team "), _c('br')]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("Goals")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("XG")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("SOT")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("Shot Attempts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("SH%")])])
}]}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Hits")]), _vm._v(" "), _c('div', {
    staticClass: "small-box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Game Totals")]), _vm._v(" "), _c('chart', {
    ref: "apex_hit_chart",
    attrs: {
      "width": "100%",
      "type": "bar",
      "options": _vm.apex_hit_options,
      "series": _vm.apex_hit_series
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('season-totals-menu', {
    attrs: {
      "name": "vs-team"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "segment"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Overview")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Cardiff Devils")]), _vm._v(" "), _c('h3', [_vm._v("Forwards")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/season-stats/vs-team/",
      "postData": [{
        year: _vm.YearSelected,
        competition: 'EIHL',
        venue: _vm.VenueSelected,
        team_id: 1,
        opposition: this.OpponentSelected,
        position: 'forwards'
      }],
      "selectedData": [{
          title: 'Player',
          prop: 'player'
        },
        {
          title: 'GP',
          prop: 'gp'
        },
        {
          title: 'G',
          prop: 'goals'
        },
        {
          title: 'PA',
          prop: 'first_assist'
        },
        {
          title: 'SA',
          prop: 'second_assist'
        },
        {
          title: 'PPTS',
          prop: 'primary_points'
        },
        {
          title: 'P',
          prop: 'points',
        },
        {
          title: 'PPG',
          prop: 'pp_goals'
        },
        {
          title: 'PPP',
          prop: 'pp_points'
        },
        {
          title: 'SOG',
          prop: 'shots_on_net'
        },
        {
          title: 'SH%',
          prop: 'shooting'
        },
        {
          title: 'SHOTS +/-',
          prop: 'shots_diff'
        },
        {
          title: 'TOI / GP',
          prop: 'toi_avg'
        },
        {
          title: 'PIMT',
          prop: 'pim_taken'
        },
        {
          title: 'PIMD',
          prop: 'pim_drawn'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Defense")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/season-stats/vs-team/",
      "postData": [{
        year: _vm.YearSelected,
        competition: 'EIHL',
        venue: _vm.VenueSelected,
        team_id: 1,
        opposition: this.OpponentSelected,
        position: 'defense'
      }],
      "selectedData": [{
          title: 'Player',
          prop: 'player'
        },
        {
          title: 'GP',
          prop: 'gp'
        },
        {
          title: 'G',
          prop: 'goals'
        },
        {
          title: 'PA',
          prop: 'first_assist'
        },
        {
          title: 'SA',
          prop: 'second_assist'
        },
        {
          title: 'PPTS',
          prop: 'primary_points'
        },
        {
          title: 'P',
          prop: 'points',
        },
        {
          title: 'PPG',
          prop: 'pp_goals'
        },
        {
          title: 'PPP',
          prop: 'pp_points'
        },
        {
          title: 'SOG',
          prop: 'shots_on_net'
        },
        {
          title: 'SH%',
          prop: 'shooting'
        },
        {
          title: 'SHOTS +/-',
          prop: 'shots_diff'
        },
        {
          title: 'TOI / GP',
          prop: 'toi_avg'
        },
        {
          title: 'PIMT',
          prop: 'pim_taken'
        },
        {
          title: 'PIMD',
          prop: 'pim_drawn'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('h3', [_vm._v("Forwards")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/season-stats/vs-team/",
      "postData": [{
        year: _vm.YearSelected,
        competition: 'EIHL',
        venue: _vm.VenueSelected,
        team_id: this.OpponentSelected,
        opposition: 1,
        position: 'forwards'
      }],
      "selectedData": [{
          title: 'Player',
          prop: 'player'
        },
        {
          title: 'GP',
          prop: 'gp'
        },
        {
          title: 'G',
          prop: 'goals'
        },
        {
          title: 'PA',
          prop: 'first_assist'
        },
        {
          title: 'SA',
          prop: 'second_assist'
        },
        {
          title: 'PPTS',
          prop: 'primary_points'
        },
        {
          title: 'P',
          prop: 'points',
        },
        {
          title: 'PPG',
          prop: 'pp_goals'
        },
        {
          title: 'PPP',
          prop: 'pp_points'
        },
        {
          title: 'SOG',
          prop: 'shots_on_net'
        },
        {
          title: 'SH%',
          prop: 'shooting'
        },
        {
          title: 'SHOTS +/-',
          prop: 'shots_diff'
        },
        {
          title: 'TOI / GP',
          prop: 'toi_avg'
        },
        {
          title: 'PIMT',
          prop: 'pim_taken'
        },
        {
          title: 'PIMD',
          prop: 'pim_drawn'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Defense")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/season-stats/vs-team/",
      "postData": [{
        year: _vm.YearSelected,
        competition: 'EIHL',
        venue: _vm.VenueSelected,
        team_id: this.OpponentSelected,
        opposition: 1,
        position: 'defense'
      }],
      "selectedData": [{
          title: 'Player',
          prop: 'player'
        },
        {
          title: 'GP',
          prop: 'gp'
        },
        {
          title: 'G',
          prop: 'goals'
        },
        {
          title: 'PA',
          prop: 'first_assist'
        },
        {
          title: 'SA',
          prop: 'second_assist'
        },
        {
          title: 'PPTS',
          prop: 'primary_points'
        },
        {
          title: 'P',
          prop: 'points',
        },
        {
          title: 'PPG',
          prop: 'pp_goals'
        },
        {
          title: 'PPP',
          prop: 'pp_points'
        },
        {
          title: 'SOG',
          prop: 'shots_on_net'
        },
        {
          title: 'SH%',
          prop: 'shooting'
        },
        {
          title: 'SHOTS +/-',
          prop: 'shots_diff'
        },
        {
          title: 'TOI / GP',
          prop: 'toi_avg'
        },
        {
          title: 'PIMT',
          prop: 'pim_taken'
        },
        {
          title: 'PIMD',
          prop: 'pim_drawn'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Faceoffs")]), _vm._v(" "), _c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Totals")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Cardiff Devils")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/season-stats/vs-team/faceoffs",
      "postData": [{
        year: _vm.YearSelected,
        competition: 'EIHL',
        venue: _vm.VenueSelected,
        team_id: 1,
        opposition: this.OpponentSelected,
        report_breakdown: 'total'
      }],
      "selectedData": [{
          title: 'Player',
          prop: 'player'
        },
        {
          title: 'GP',
          prop: 'gp'
        },
        {
          title: 'Taken',
          prop: 'fo_total_taken'
        },
        {
          title: 'Wins',
          prop: 'fo_total_win_total'
        },
        {
          title: 'Loss',
          prop: 'fo_total_loss_total'
        },
        {
          title: 'Win%',
          prop: 'fo_total_win_percent'
        },
        {
          title: 'Avg Taken',
          prop: 'fo_total_taken_average'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/season-stats/vs-team/faceoffs",
      "postData": [{
        year: _vm.YearSelected,
        competition: 'EIHL',
        venue: _vm.VenueSelected,
        team_id: this.OpponentSelected,
        opposition: 1,
        report_breakdown: 'total'
      }],
      "selectedData": [{
          title: 'Player',
          prop: 'player'
        },
        {
          title: 'GP',
          prop: 'gp'
        },
        {
          title: 'Taken',
          prop: 'fo_total_taken'
        },
        {
          title: 'Win',
          prop: 'fo_total_win_total'
        },
        {
          title: 'Loss',
          prop: 'fo_total_loss_total'
        },
        {
          title: 'Win%',
          prop: 'fo_total_win_percent'
        },
        {
          title: 'Avg Taken',
          prop: 'fo_total_taken_average'
        }

      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Lane")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Cardiff Devils")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/season-stats/vs-team/faceoffs",
      "postData": [{
        year: _vm.YearSelected,
        competition: 'EIHL',
        venue: _vm.VenueSelected,
        team_id: 1,
        opposition: this.OpponentSelected,
        report_breakdown: 'lane'
      }],
      "selectedData": [{
          title: 'Player',
          prop: 'player'
        },
        {
          title: 'GP',
          prop: 'gp'
        },
        {
          title: 'L Taken',
          prop: 'fo_left_taken'
        },
        {
          title: 'L Win',
          prop: 'fo_left_win_total'
        },
        {
          title: 'L Loss',
          prop: 'fo_left_loss_total'
        },
        {
          title: 'L W%',
          prop: 'fo_left_win_percent'
        },
        {
          title: 'C Taken',
          prop: 'fo_center_taken'
        },
        {
          title: 'C Win',
          prop: 'fo_center_win_total'
        },
        {
          title: 'C Loss',
          prop: 'fo_center_loss_total'
        },
        {
          title: 'C W%',
          prop: 'fo_center_win_percent'
        },
        {
          title: 'R Taken',
          prop: 'fo_right_taken'
        },
        {
          title: 'R Win',
          prop: 'fo_right_win_total'
        },
        {
          title: 'R Loss',
          prop: 'fo_right_loss_total'
        },
        {
          title: 'R W%',
          prop: 'fo_right_win_percent'
        }

      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/season-stats/vs-team/faceoffs",
      "postData": [{
        year: _vm.YearSelected,
        competition: 'EIHL',
        venue: _vm.VenueSelected,
        team_id: this.OpponentSelected,
        opposition: 1,
        report_breakdown: 'lane'
      }],
      "selectedData": [{
          title: 'Player',
          prop: 'player'
        },
        {
          title: 'GP',
          prop: 'gp'
        },
        {
          title: 'L Taken',
          prop: 'fo_left_taken'
        },
        {
          title: 'L Win',
          prop: 'fo_left_win_total'
        },
        {
          title: 'L Loss',
          prop: 'fo_left_loss_total'
        },
        {
          title: 'L W%',
          prop: 'fo_left_win_percent'
        },
        {
          title: 'C Taken',
          prop: 'fo_center_taken'
        },
        {
          title: 'C Win',
          prop: 'fo_center_win_total'
        },
        {
          title: 'C Loss',
          prop: 'fo_center_loss_total'
        },
        {
          title: 'C W%',
          prop: 'fo_center_win_percent'
        },
        {
          title: 'R Taken',
          prop: 'fo_right_taken'
        },
        {
          title: 'R Win',
          prop: 'fo_right_win_total'
        },
        {
          title: 'R Loss',
          prop: 'fo_right_loss_total'
        },
        {
          title: 'R W%',
          prop: 'fo_right_win_percent'
        }

      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "FOPVP"
    }
  }, [_c('faceoffs-pvp', {
    attrs: {
      "opponent": _vm.OpponentSelected,
      "game_id": 0
    }
  })], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "shotmaps"
    }
  }, [_c('TeamShotMap', {
    attrs: {
      "home_name": 'Cardiff Devils',
      "year": _vm.YearSelected,
      "home_id": 1,
      "away_id": _vm.OpponentSelected,
      "competition": _vm.CompetitionSelected,
      "opponent": _vm.OpponentSelected,
      "venue": _vm.VenueSelected
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("2022 / 2023")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-1"
  }, [_c('figure', {
    staticClass: "image is-128x128"
  }, [_c('img', {
    staticClass: "is-rounded",
    attrs: {
      "src": "https://devils.roblutken.com/devils/assets/player-pictures/Cardiff_Devils.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title is-uppercase"
  }, [_vm._v("Cardiff Devils")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Team Comparison Tool")])])])])
}]}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "display": "none",
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_total_chart,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture[0].match_date))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('img', {
    staticClass: "team_logo",
    attrs: {
      "src": _vm.Fixture[0].home_team.logo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title has-text-left"
  }, [_vm._v(_vm._s(_vm.Fixture[0].home_team.name) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('img', {
    staticClass: "team_logo",
    attrs: {
      "src": _vm.Fixture[0].away_team.logo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title has-text-left"
  }, [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture[0].competition))]), _vm._v(" "), _c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture[0].location))]), _vm._v(" "), (_vm.Fixture[0].is_stream == 1) ? _c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Stream")]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Live")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-6 is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Game Summary")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_ot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_goals_pp) + " / " + _vm._s(_vm.Summary.situation_opts[0].PPTotal))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_goals_total))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_ot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_goals_pp) + " /  " + _vm._s(_vm.Summary.situation_opts[0].SHTotal))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_goals_total))])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("All Attempts")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_shots_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_shots_total - _vm.Summary.away_shots_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_shots_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_shots_total))])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("On Target")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_sot_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_sot_total - _vm.Summary.away_sot_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_sot_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_sot_total))])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.home_fo_total))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.home_fo_total - _vm.Summary.away_fo_total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_p1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_p2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_p3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Summary.away_fo_ot))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.Summary.away_fo_total))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Filters")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 1,
      'is-primary': this.$route.params.period != 1
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(1)
      }
    }
  }, [_vm._v("Period 1")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 2,
      'is-primary': this.$route.params.period != 2
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(2)
      }
    }
  }, [_vm._v("Period 2")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 3,
      'is-primary': this.$route.params.period != 3
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(3)
      }
    }
  }, [_vm._v("Period 3")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 4,
      'is-primary': this.$route.params.period != 4
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(4)
      }
    }
  }, [_vm._v("Overtime")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'is-default': this.$route.params.period == 0,
      'is-primary': this.$route.params.period != 0
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod(0)
      }
    }
  }, [_vm._v("Total")])]), _vm._v(" "), _c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Quicklinks")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#Gamesheet'),
      expression: "'#Gamesheet'"
    }],
    staticClass: "button is-large"
  }, [_vm._v("Gamesheet")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#Shots'),
      expression: "'#Shots'"
    }],
    staticClass: "button is-large"
  }, [_vm._v("Shots")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Player Totals")]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_t,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', _vm._l((this.FaceoffsChart.all_situations), function(result) {
    return _c('tr', {
      key: result.player_id
    }, [_c('td', [_vm._v(_vm._s(result.player_id))]), _vm._v(" "), _c('td', {
      staticClass: "fo-left has-text-centered"
    }, [_vm._v(_vm._s(result.left_win) + " / " + _vm._s(-result.left_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-left has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.left_win - (-result.left_loss)))])]), _vm._v(" "), _c('td', {
      staticClass: "fo-center has-text-centered"
    }, [_vm._v(_vm._s(result.center_win) + " / " + _vm._s(-result.center_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-center has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.center_win - -result.center_loss))])]), _vm._v(" "), _c('td', {
      staticClass: "fo-right has-text-centered"
    }, [_vm._v(_vm._s(result.right_win) + " / " + _vm._s(-result.right_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-right has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.right_win - -result.right_loss))])]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_vm._v(_vm._s(result.total_win + -result.total_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_vm._v(_vm._s(result.total_win) + " / " + _vm._s(-result.total_loss))]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_vm._v(_vm._s(result.total_win - (-result.total_loss)))]), _vm._v(" "), _c('td', {
      staticClass: "fo-total has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.win_percentage))])])])
  }), 0)]), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('collapse-item', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal"
    },
    attrs: {
      "title": "Situational - EH PP SH"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Even Handed")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l_eh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c_eh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r_eh,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Power Play")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l_pp,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c_pp,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r_pp,
      "options": _vm.fo_options
    }
  })], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Short Handed")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_l_sh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_c_sh,
      "options": _vm.fo_options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.fo_player_r_sh,
      "options": _vm.fo_options
    }
  })], 1)])])], 1), _vm._v(" "), _c('FaceoffTeamVS', {
    attrs: {
      "home_name": _vm.Fixture[0].home_team.name,
      "away_name": _vm.Fixture[0].away_team.name
    }
  })], 1)])]), _vm._v(" "), _c('faceoffs-pvp', {
    attrs: {
      "opponent": _vm.Fixture[0].home_team.id,
      "game_id": this.$route.params.gameId
    }
  }), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box",
    attrs: {
      "id": "Turnovers"
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('p', [_vm._v("Even Handed")]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.to_player_eh,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('p', [_vm._v("Power Play")]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.to_player_pp,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('p', [_vm._v("Short Handed")]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.to_player_sh,
      "options": _vm.bar_options
    }
  })], 1)])]), _vm._v(" "), _c('shots-heatmap', {
    attrs: {
      "home_name": _vm.Fixture[0].home_team.name,
      "away_name": _vm.Fixture[0].away_team.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-8 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Shots On Target")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSOTSort),
      expression: "selectedSOTSort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSOTSort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sotOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                          " + _vm._s(option.text) + "\n                        ")])
  }), 0)])])])]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.sot_totals,
      "options": _vm.sot_bar_options
    }
  })], 1)]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-8 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "is-child"
  }, [_c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("Filters")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPlusMinusSort),
      expression: "selectedPlusMinusSort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPlusMinusSort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.plusMinusOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.text) + "\n                          ")])
  }), 0)])])])])]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.plus_minus_auto_totals,
      "options": _vm.shots_horz_bar_options
    }
  }), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.plus_minus_auto_diff,
      "options": _vm.shots_horz_bar_options
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(12), _vm._v(" "), _c('tbody', _vm._l((_vm.sortByPlusMinusHomeAuto), function(player) {
    return _c('tr', {
      key: player.player_id
    }, [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.shots_for))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(-player.shots_against))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.diff))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.percentage))])])
  }), 0)])])])], 1)]), _vm._v(" "), _c('shot-diff-time', {
    attrs: {
      "home_name": _vm.Fixture[0].home_team.name,
      "away_name": _vm.Fixture[0].away_team.name
    }
  }), _vm._v(" "), _c('shot-quality', {
    attrs: {
      "game_id": this.$route.params.gameId,
      "home_name": _vm.Fixture[0].home_team.name,
      "away_name": _vm.Fixture[0].away_team.name
    }
  }), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('article', {
    staticClass: "tile is-child box",
    attrs: {
      "id": "OddmanRushes"
    }
  }, [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.Fixture[0].home_team.name))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.Fixture[0].away_team.name))])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.OddmanRushes.home_rushes))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.OddmanRushes.away_rushes))])])])])])])]) : _vm._e(), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box",
    attrs: {
      "id": "Hits"
    }
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedHitSort),
      expression: "selectedHitSort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedHitSort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sotOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                          " + _vm._s(option.text) + "\n                        ")])
  }), 0)])])])]), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.hit_player_totals,
      "options": _vm.bar_options
    }
  })], 1)])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box",
    attrs: {
      "id": "Gamesheet"
    }
  }, [_vm._m(16), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Forwards")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals for even handed"
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals against even handed"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals +/- even handed"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Faceoffs won / Faceoffs taken all situations"
    }
  }, [_vm._v("FO")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances for even handed"
    }
  }, [_vm._v("Shots For")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances against even handed"
    }
  }, [_vm._v("Shots Against")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances +/- even handed"
    }
  }, [_vm._v("Shots Diff")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Shots on target all situations"
    }
  }, [_vm._v("SOT")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI average shift time all situations"
    }
  }, [_vm._v("AvgShifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI 5v5 time even handed"
    }
  }, [_vm._v("EH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI power play time"
    }
  }, [(_vm.Fixture[0].away_team.name === 'Cardiff Devils') ? _c('span', [_vm._v("SH ")]) : _c('span', [_vm._v("PP")])]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI short handed time"
    }
  }, [(_vm.Fixture[0].away_team.name === 'Cardiff Devils') ? _c('span', [_vm._v("PP ")]) : _c('span', [_vm._v("SH")])]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Total time on ice all situations"
    }
  }, [_vm._v("Total TOI")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortBytimeForwards), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goal_diff))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.fo))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_plus_minus))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sot))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.avg_shift))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.eh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.pp_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.total_toi))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.Fixture[0].is_stream == 0) ? _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Defense")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals for even handed"
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals against even handed"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals +/- even handed"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Faceoffs won / Faceoffs taken all situations"
    }
  }, [_vm._v("FO")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances for even handed"
    }
  }, [_vm._v("Shots For")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances against even handed"
    }
  }, [_vm._v("Shots Against")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances +/- even handed"
    }
  }, [_vm._v("Shots Diff")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Shots on target all situations"
    }
  }, [_vm._v("SOT")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI average shift time all situations"
    }
  }, [_vm._v("AvgShifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI 5v5 time even handed"
    }
  }, [_vm._v("EH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI power play time"
    }
  }, [(_vm.Fixture[0].away_team.name === 'Cardiff Devils') ? _c('span', [_vm._v("SH ")]) : _c('span', [_vm._v("PP")])]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI short handed time"
    }
  }, [(_vm.Fixture[0].away_team.name === 'Cardiff Devils') ? _c('span', [_vm._v("PP ")]) : _c('span', [_vm._v("SH")])]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Total time on ice all situations"
    }
  }, [_vm._v("Total TOI")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortBytimeDefense), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goals_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal has-text-centered"
    }, [_vm._v(_vm._s(result.goal_diff))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.fo))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots has-text-centered"
    }, [_vm._v(_vm._s(result.shots_plus_minus))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sot))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.avg_shift))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.eh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.pp_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.sh_time))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.total_toi))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Estimated TOI - For Away Games")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_vm._m(17), _vm._v(" "), _c('tbody', _vm._l((_vm.sortBytimeAll), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.season_average_toi))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.est_toi))])])])
  }), 0)])])]), _vm._v(" "), (_vm.Fixture[0].is_stream == 1) ? _c('div', {
    staticClass: "title is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "block content"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Totals")]), _vm._v(" "), _c('table', {
    staticClass: "table is-responsive is-striped is-hoverable"
  }, [_c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals for even handed"
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals against even handed"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI goals +/- even handed"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Faceoffs won / Faceoffs taken all situations"
    }
  }, [_vm._v("FO")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances for even handed"
    }
  }, [_vm._v("Shots For")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances against even handed"
    }
  }, [_vm._v("Shots Against")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI chances +/- even handed"
    }
  }, [_vm._v("Shots Diff")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Shots on target all situations"
    }
  }, [_vm._v("SOT")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI average shift time all situations"
    }
  }, [_vm._v("AvgShifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI 5v5 time even handed"
    }
  }, [_vm._v("EH")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI power play time"
    }
  }, [(_vm.Fixture[0].away_team.name === 'Cardiff Devils') ? _c('span', [_vm._v("SH ")]) : _c('span', [_vm._v("PP")])]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI short handed time"
    }
  }, [(_vm.Fixture[0].away_team.name === 'Cardiff Devils') ? _c('span', [_vm._v("PP ")]) : _c('span', [_vm._v("SH")])]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Total time on ice all situations"
    }
  }, [_vm._v("Total TOI")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.gameTotals), function(result) {
    return _c('tr', {
      key: result.number
    }, [_c('td', {
      staticClass: "tbl-name has-text-centered"
    }, [_vm._v(_vm._s(result.number))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal"
    }, [_vm._v(_vm._s(result.total_gf))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal"
    }, [_vm._v(_vm._s(result.total_ga))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-goal"
    }, [_vm._v(_vm._s(result.total_gdiff))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_fo))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots"
    }, [_vm._v(_vm._s(result.total_shots_for))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots"
    }, [_vm._v(_vm._s(result.total_shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-shots"
    }, [_vm._v(_vm._s(result.total_shots_for - result.total_shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_sot))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_shifts))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_eh))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_pp))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(result.total_sh))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('b', [_vm._v(_vm._s(result.total_toi))])])])
  }), 0)])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 09/03/2020 11:07PM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "color": "purple"
    }
  }, [_vm._v(" Site - Added Faceoffs PVP - Will only work when we're the away team!")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "subtitle has-text-centered",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_vm._v("Goals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("PP")]), _vm._v(" "), _c('th', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_c('b', [_vm._v("Shots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "subtitle has-text-centered"
  }, [_c('b', [_vm._v("Faceoffs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3")]), _vm._v(" "), _c('th', [_vm._v("OT")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("+/-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Faceoffs - All Situations")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "testAlign is-capitalized"
  }, [_vm._v("Left W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Center W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Right W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("+/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Taken")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total W / L")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total +/-")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total Win %")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Turnovers - All Situations")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("+/-")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("CF")]), _vm._v(" "), _c('th', [_vm._v("CA")]), _vm._v(" "), _c('th', [_vm._v("DIFF")]), _vm._v(" "), _c('th', [_vm._v("CF%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Oddman Rushes - All Situations")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-parent",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "is-child",
    staticStyle: {
      "margin": "0 150px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Hits")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Gamesheet")]), _vm._v(" "), _c('p', [_vm._v("Goal +/- is Even Handed ")]), _vm._v(" "), _c('p', [_vm._v("Shot +/- SOT FOT is All Situations")]), _vm._v(" "), _c('p', [_vm._v("FO - Faceoff Wins / Faceoffs Taken")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Player Number"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "TOI shifts all situations"
    }
  }, [_vm._v("Season AVG Shift")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    attrs: {
      "title": "Est Time based on season average"
    }
  }, [_vm._v("EST Total TOI")])])
}]}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('box-score', {
    attrs: {
      "gameId": this.$route.params.gameId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Quicklinks")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#PIMS'),
      expression: "'#PIMS'"
    }],
    staticClass: "button is-large",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("PIMS")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#TOI'),
      expression: "'#TOI'"
    }],
    staticClass: "button is-large",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("TOI")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#Faceoffs'),
      expression: "'#Faceoffs'"
    }],
    staticClass: "button is-large",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("Faceoffs")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#Turnovers'),
      expression: "'#Turnovers'"
    }],
    staticClass: "button is-large",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("Turnovers")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#Shots'),
      expression: "'#Shots'"
    }],
    staticClass: "button is-large",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("Shots")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#Hits'),
      expression: "'#Hits'"
    }],
    staticClass: "button is-large",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("Hits")])])])]), _vm._v(" "), _c('div', {
    staticClass: "title is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "title is-child box"
  }, [_c('div', {
    staticClass: "container is-child"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Use these stats in Season Totals?")]), _vm._v(" "), _c('button', {
    staticClass: "button is-large",
    class: {
      'unverified': this.Fixture.is_validated == 0,
      'verified': this.Fixture.is_validated != 0
    },
    on: {
      "click": _vm.validateGame
    }
  }, [_vm._v("Validate Game")])])])]), _vm._v(" "), _c('edit-roster', {
    attrs: {
      "game_id": this.$route.params.gameId,
      "team_name": this.Fixture.home_team.name,
      "team_logo": this.Fixture.home_team.logo,
      "team_id": this.Fixture.home_team.id
    }
  }), _vm._v(" "), _c('edit-roster', {
    attrs: {
      "game_id": this.$route.params.gameId,
      "team_name": this.Fixture.away_team.name,
      "team_logo": this.Fixture.away_team.logo,
      "team_id": this.Fixture.away_team.id
    }
  }), _vm._v(" "), _c('edit-item', {
    attrs: {
      "type": "Goal",
      "open": _vm.editGoal
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGoalData.period),
      expression: "editGoalData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.editGoalData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editGoalData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGoalData.situation_id),
      expression: "editGoalData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGoalData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "goal_scorer"
    }
  }, [_vm._v("Goal Scorer")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGoalData.goal_scorer),
      expression: "editGoalData.goal_scorer"
    }],
    attrs: {
      "id": "goal_scorer",
      "name": "goal_scorer",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGoalData, "goal_scorer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "first_assist"
    }
  }, [_vm._v("First Assist")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGoalData.first_assist),
      expression: "editGoalData.first_assist"
    }],
    attrs: {
      "id": "first_assist",
      "name": "first_assist",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGoalData, "first_assist", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "second_assist"
    }
  }, [_vm._v("Second Assist")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGoalData.second_assist),
      expression: "editGoalData.second_assist"
    }],
    attrs: {
      "id": "second_assist",
      "name": "second_assist",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGoalData, "second_assist", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_1"
    }
  }, [_vm._v("P1")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGoalData.on_ice_1),
      expression: "editGoalData.on_ice_1"
    }],
    attrs: {
      "id": "on_ice_1",
      "name": "on_ice_1",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGoalData, "on_ice_1", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_2"
    }
  }, [_vm._v("P2")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGoalData.on_ice_2),
      expression: "editGoalData.on_ice_2"
    }],
    attrs: {
      "id": "on_ice_2",
      "name": "on_ice_2",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGoalData, "on_ice_2", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_3"
    }
  }, [_vm._v("P3")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGoalData.on_ice_3),
      expression: "editGoalData.on_ice_3"
    }],
    attrs: {
      "id": "on_ice_3",
      "name": "on_ice_3",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGoalData, "on_ice_3", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_4"
    }
  }, [_vm._v("P4")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGoalData.on_ice_4),
      expression: "editGoalData.on_ice_4"
    }],
    attrs: {
      "id": "on_ice_4",
      "name": "on_ice_4",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGoalData, "on_ice_4", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_5"
    }
  }, [_vm._v("P5")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGoalData.on_ice_5),
      expression: "editGoalData.on_ice_5"
    }],
    attrs: {
      "id": "on_ice_5",
      "name": "on_ice_5",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGoalData, "on_ice_5", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_6"
    }
  }, [_vm._v("P6")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGoalData.on_ice_6),
      expression: "editGoalData.on_ice_6"
    }],
    attrs: {
      "id": "on_ice_6",
      "name": "on_ice_6",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGoalData, "on_ice_6", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitEditGoal
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('new-item', {
    attrs: {
      "type": "Goal",
      "open": _vm.newGoal
    },
    on: {
      "cancel": _vm.cancelNew
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoalData.period),
      expression: "newGoalData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.newGoalData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoalData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoalData.situation_id),
      expression: "newGoalData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newGoalData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "goal_scorer"
    }
  }, [_vm._v("Goal Scorer")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoalData.goal_scorer),
      expression: "newGoalData.goal_scorer"
    }],
    attrs: {
      "id": "goal_scorer",
      "name": "goal_scorer",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newGoalData, "goal_scorer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "first_assist"
    }
  }, [_vm._v("First Assist")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoalData.first_assist),
      expression: "newGoalData.first_assist"
    }],
    attrs: {
      "id": "first_assist",
      "name": "first_assist",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newGoalData, "first_assist", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "second_assist"
    }
  }, [_vm._v("Second Assist")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoalData.second_assist),
      expression: "newGoalData.second_assist"
    }],
    attrs: {
      "id": "second_assist",
      "name": "second_assist",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newGoalData, "second_assist", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_1"
    }
  }, [_vm._v("P1")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoalData.on_ice_1),
      expression: "newGoalData.on_ice_1"
    }],
    attrs: {
      "id": "on_ice_1",
      "name": "on_ice_1",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newGoalData, "on_ice_1", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_2"
    }
  }, [_vm._v("P2")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoalData.on_ice_2),
      expression: "newGoalData.on_ice_2"
    }],
    attrs: {
      "id": "on_ice_2",
      "name": "on_ice_2",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newGoalData, "on_ice_2", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_3"
    }
  }, [_vm._v("P3")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoalData.on_ice_3),
      expression: "newGoalData.on_ice_3"
    }],
    attrs: {
      "id": "on_ice_3",
      "name": "on_ice_3",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newGoalData, "on_ice_3", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_4"
    }
  }, [_vm._v("P4")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoalData.on_ice_4),
      expression: "newGoalData.on_ice_4"
    }],
    attrs: {
      "id": "on_ice_4",
      "name": "on_ice_4",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newGoalData, "on_ice_4", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_5"
    }
  }, [_vm._v("P5")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoalData.on_ice_5),
      expression: "newGoalData.on_ice_5"
    }],
    attrs: {
      "id": "on_ice_5",
      "name": "on_ice_5",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newGoalData, "on_ice_5", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "on_ice_6"
    }
  }, [_vm._v("P6")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoalData.on_ice_6),
      expression: "newGoalData.on_ice_6"
    }],
    attrs: {
      "id": "on_ice_6",
      "name": "on_ice_6",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newGoalData, "on_ice_6", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitNewGoal
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelNew
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Official Goals")]), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.eihlInfo['1']), function(period_one) {
    return _c('tbody', {
      key: period_one.time * Math.random()
    }, [(period_one.type === 'goal') ? _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.currentScore))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.floor(period_one.data.scoreboardTime / 60)) + ":" + _vm._s(period_one.data.scoreboardTime - Math.floor(period_one.data.scoreboardTime / 60) * 60))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.balance))]), _vm._v(" "), (period_one.data.scorer.jersey != null) ? _c('td', [_vm._v(_vm._s(period_one.data.scorer.jersey))]) : _vm._e(), _vm._v(" "), (period_one.data.assistants[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.assistants[0].jersey))]) : _c('td', [_vm._v("-")]), _vm._v(" "), (period_one.data.assistants[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.assistants[1].jersey))]) : _c('td', [_vm._v("CHECK!")]), _vm._v(" "), (period_one.data.attendants.positive[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[0].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[1].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[2] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[2].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[3] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[3].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[4] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[4].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[5] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[5].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[0].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[1].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[2] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[2].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[3] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[3].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[4] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[4].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[5] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[5].jersey))]) : _c('td', [_vm._v("0")])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.eihlInfo['2']), function(period_one) {
    return _c('tbody', {
      key: period_one
    }, [(period_one.type === 'goal') ? _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.currentScore))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.floor(period_one.data.scoreboardTime / 60)) + ":" + _vm._s(period_one.data.scoreboardTime - Math.floor(period_one.data.scoreboardTime / 60) * 60))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.balance))]), _vm._v(" "), (period_one.data.scorer.jersey != null) ? _c('td', [_vm._v(_vm._s(period_one.data.scorer.jersey))]) : _vm._e(), _vm._v(" "), (period_one.data.assistants[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.assistants[0].jersey))]) : _c('td', [_vm._v("-")]), _vm._v(" "), (period_one.data.assistants[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.assistants[1].jersey))]) : _c('td', [_vm._v("CHECK!")]), _vm._v(" "), (period_one.data.attendants.positive[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[0].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[1].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[2] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[2].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[3] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[3].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[4] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[4].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[5] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[5].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[0].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[1].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[2] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[2].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[3] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[3].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[4] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[4].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[5] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[5].jersey))]) : _c('td', [_vm._v("0")])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.eihlInfo['3']), function(period_one) {
    return _c('tbody', {
      key: period_one
    }, [(period_one.type === 'goal') ? _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.currentScore))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.floor(period_one.data.scoreboardTime / 60)) + ":" + _vm._s(period_one.data.scoreboardTime - Math.floor(period_one.data.scoreboardTime / 60) * 60))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.balance))]), _vm._v(" "), (period_one.data.scorer.jersey != null) ? _c('td', [_vm._v(_vm._s(period_one.data.scorer.jersey))]) : _vm._e(), _vm._v(" "), (period_one.data.assistants[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.assistants[0].jersey))]) : _c('td', [_vm._v("-")]), _vm._v(" "), (period_one.data.assistants[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.assistants[1].jersey))]) : _c('td', [_vm._v("CHECK!")]), _vm._v(" "), (period_one.data.attendants.positive[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[0].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[1].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[2] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[2].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[3] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[3].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[4] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[4].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[5] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[5].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[0].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[1].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[2] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[2].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[3] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[3].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[4] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[4].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[5] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[5].jersey))]) : _c('td', [_vm._v("0")])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.eihlInfo['overtime']), function(period_one) {
    return _c('tbody', {
      key: period_one
    }, [(period_one.type === 'goal') ? _c('tr', [_c('td', [_vm._v("OT")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.currentScore))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.floor(period_one.data.scoreboardTime / 60)) + ":" + _vm._s(period_one.data.scoreboardTime - Math.floor(period_one.data.scoreboardTime / 60) * 60))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.balance))]), _vm._v(" "), (period_one.data.scorer.jersey != null) ? _c('td', [_vm._v(_vm._s(period_one.data.scorer.jersey))]) : _vm._e(), _vm._v(" "), (period_one.data.assistants[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.assistants[0].jersey))]) : _c('td', [_vm._v("-")]), _vm._v(" "), (period_one.data.assistants[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.assistants[1].jersey))]) : _c('td', [_vm._v("CHECK!")]), _vm._v(" "), (period_one.data.attendants.positive[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[0].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[1].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[2] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[2].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[3] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[3].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[4] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[4].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[5] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[5].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[0].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[1].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[2] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[2].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[3] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[3].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[4] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[4].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[5] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[5].jersey))]) : _c('td', [_vm._v("0")])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.eihlInfo['shootout']), function(period_one) {
    return _c('tbody', {
      key: period_one
    }, [(period_one.type === 'goal') ? _c('tr', [_c('td', [_vm._v("SO")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.currentScore))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.floor(period_one.data.scoreboardTime / 60)) + ":" + _vm._s(period_one.data.scoreboardTime - Math.floor(period_one.data.scoreboardTime / 60) * 60))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.balance))]), _vm._v(" "), (period_one.data.scorer.jersey != null) ? _c('td', [_vm._v(_vm._s(period_one.data.scorer.jersey))]) : _vm._e(), _vm._v(" "), (period_one.data.assistants[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.assistants[0].jersey))]) : _c('td', [_vm._v("-")]), _vm._v(" "), (period_one.data.assistants[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.assistants[1].jersey))]) : _c('td', [_vm._v("CHECK!")]), _vm._v(" "), (period_one.data.attendants.positive[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[0].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[1].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[2] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[2].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[3] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[3].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[4] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[4].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.positive[5] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.positive[5].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[0] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[0].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[1] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[1].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[2] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[2].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[3] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[3].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[4] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[4].jersey))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.attendants.negative[5] != null) ? _c('td', [_vm._v(_vm._s(period_one.data.attendants.negative[5].jersey))]) : _c('td', [_vm._v("0")])]) : _vm._e()])
  })], 2)])])])]), _vm._v(" "), _c('edit-table', {
    attrs: {
      "id": "Goals",
      "heading": "Goals",
      "headers": _vm.goalHeaders,
      "total": _vm.getTotalCountGoals,
      "tableData": _vm.CleanGoals
    },
    on: {
      "new": _vm.openNewGoal,
      "edit": _vm.openEditGoal,
      "reload": _vm.fetchRawGameData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Official Penalties")]), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.eihlInfo['1']), function(period_one) {
    return _c('tbody', {
      key: period_one.time * Math.random()
    }, [(period_one.type === 'penalty') ? _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.floor(period_one.data.createTime / 60)) + ":" + _vm._s(period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60))]), _vm._v(" "), (period_one.data.duration != null) ? _c('td', [_vm._v(_vm._s(period_one.data.duration / 60))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.codename != null) ? _c('td', [_vm._v(_vm._s(period_one.data.codename))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.disciplinedPlayer != null) ? _c('td', [_vm._v(_vm._s(period_one.data.disciplinedPlayer.jersey))]) : _c('td', [_vm._v("0")])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.eihlInfo['2']), function(period_one) {
    return _c('tbody', {
      key: period_one.time * Math.random()
    }, [(period_one.type === 'penalty') ? _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.floor(period_one.data.createTime / 60)) + ":" + _vm._s(period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60))]), _vm._v(" "), (period_one.data.duration != null) ? _c('td', [_vm._v(_vm._s(period_one.data.duration / 60))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.codename != null) ? _c('td', [_vm._v(_vm._s(period_one.data.codename))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.disciplinedPlayer != null) ? _c('td', [_vm._v(_vm._s(period_one.data.disciplinedPlayer.jersey))]) : _c('td', [_vm._v("0")])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.eihlInfo['3']), function(period_one) {
    return _c('tbody', {
      key: period_one.time * Math.random()
    }, [(period_one.type === 'penalty') ? _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.floor(period_one.data.createTime / 60)) + ":" + _vm._s(period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60))]), _vm._v(" "), (period_one.data.duration != null) ? _c('td', [_vm._v(_vm._s(period_one.data.duration / 60))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.codename != null) ? _c('td', [_vm._v(_vm._s(period_one.data.codename))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.disciplinedPlayer != null) ? _c('td', [_vm._v(_vm._s(period_one.data.disciplinedPlayer.jersey))]) : _c('td', [_vm._v("0")])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.eihlInfo['3']), function(period_one) {
    return _c('tbody', {
      key: period_one.time * Math.random()
    }, [(period_one.type === 'penalty') ? _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.floor(period_one.data.createTime / 60)) + ":" + _vm._s(period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60))]), _vm._v(" "), (period_one.data.duration != null) ? _c('td', [_vm._v(_vm._s(period_one.data.duration / 60))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.codename != null) ? _c('td', [_vm._v(_vm._s(period_one.data.codename))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.disciplinedPlayer != null) ? _c('td', [_vm._v(_vm._s(period_one.data.disciplinedPlayer.jersey))]) : _c('td', [_vm._v("0")])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.eihlInfo['overtime']), function(period_one) {
    return _c('tbody', {
      key: period_one.time * Math.random()
    }, [(period_one.type === 'penalty') ? _c('tr', [_c('td', [_vm._v("OT")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.floor(period_one.data.createTime / 60)) + ":" + _vm._s(period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60))]), _vm._v(" "), (period_one.data.duration != null) ? _c('td', [_vm._v(_vm._s(period_one.data.duration / 60))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.codename != null) ? _c('td', [_vm._v(_vm._s(period_one.data.codename))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.disciplinedPlayer != null) ? _c('td', [_vm._v(_vm._s(period_one.data.disciplinedPlayer.jersey))]) : _c('td', [_vm._v("0")])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.eihlInfo['SO']), function(period_one) {
    return _c('tbody', {
      key: period_one.time * Math.random()
    }, [(period_one.type === 'penalty') ? _c('tr', [_c('td', [_vm._v("SO")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period_one.data.team))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.floor(period_one.data.createTime / 60)) + ":" + _vm._s(period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60))]), _vm._v(" "), (period_one.data.duration != null) ? _c('td', [_vm._v(_vm._s(period_one.data.duration / 60))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.codename != null) ? _c('td', [_vm._v(_vm._s(period_one.data.codename))]) : _c('td', [_vm._v("0")]), _vm._v(" "), (period_one.data.disciplinedPlayer != null) ? _c('td', [_vm._v(_vm._s(period_one.data.disciplinedPlayer.jersey))]) : _c('td', [_vm._v("0")])]) : _vm._e()])
  })], 2)])])])]), _vm._v(" "), _c('new-item', {
    attrs: {
      "type": "Penalty Minute",
      "open": _vm.newPenaltyMinute
    },
    on: {
      "cancel": _vm.cancelNew
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPenaltyMinuteData.period),
      expression: "newPenaltyMinuteData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.newPenaltyMinuteData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPenaltyMinuteData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPenaltyMinuteData.situation_id),
      expression: "newPenaltyMinuteData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newPenaltyMinuteData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "taken_player"
    }
  }, [_vm._v("Taken Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPenaltyMinuteData.taken_player),
      expression: "newPenaltyMinuteData.taken_player"
    }],
    attrs: {
      "id": "taken_player",
      "name": "taken_player",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newPenaltyMinuteData, "taken_player", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Drawn_player"
    }
  }, [_vm._v("Drawn Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPenaltyMinuteData.drawn_player),
      expression: "newPenaltyMinuteData.drawn_player"
    }],
    attrs: {
      "id": "Drawn_player",
      "name": "Drawn_player",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newPenaltyMinuteData, "drawn_player", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "pen_for"
    }
  }, [_vm._v("Infraction")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPenaltyMinuteData.penalty_for),
      expression: "newPenaltyMinuteData.penalty_for"
    }],
    attrs: {
      "id": "pen_for",
      "name": "pen_for",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newPenaltyMinuteData, "penalty_for", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.PenaltyOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPenaltyMinuteData.penalty_type),
      expression: "newPenaltyMinuteData.penalty_type"
    }],
    attrs: {
      "id": "type",
      "name": "type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newPenaltyMinuteData, "penalty_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Minor")]), _vm._v(" "), _c('option', [_vm._v("Major")]), _vm._v(" "), _c('option', [_vm._v("Misconduct")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Zone")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPenaltyMinuteData.penalty_zone),
      expression: "newPenaltyMinuteData.penalty_zone"
    }],
    attrs: {
      "id": "type",
      "name": "type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newPenaltyMinuteData, "penalty_zone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Offensive")]), _vm._v(" "), _c('option', [_vm._v("Neutral")]), _vm._v(" "), _c('option', [_vm._v("Defensive")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "length"
    }
  }, [_vm._v("Length")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPenaltyMinuteData.penalty_length),
      expression: "newPenaltyMinuteData.penalty_length"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "length",
      "type": "number",
      "name": "length",
      "min": "2",
      "max": "60"
    },
    domProps: {
      "value": (_vm.newPenaltyMinuteData.penalty_length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPenaltyMinuteData, "penalty_length", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitNewPenaltyMinute
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelNew
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('edit-item', {
    attrs: {
      "type": "Penalty Minute",
      "open": _vm.editPenaltyMinute
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPenaltyMinuteData.period),
      expression: "editPenaltyMinuteData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.editPenaltyMinuteData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editPenaltyMinuteData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPenaltyMinuteData.situation_id),
      expression: "editPenaltyMinuteData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editPenaltyMinuteData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "taken_player"
    }
  }, [_vm._v("Taken Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPenaltyMinuteData.taken_player),
      expression: "editPenaltyMinuteData.taken_player"
    }],
    attrs: {
      "id": "taken_player",
      "name": "taken_player",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editPenaltyMinuteData, "taken_player", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Drawn_player"
    }
  }, [_vm._v("Drawn Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPenaltyMinuteData.drawn_player),
      expression: "editPenaltyMinuteData.drawn_player"
    }],
    attrs: {
      "id": "Drawn_player",
      "name": "Drawn_player",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editPenaltyMinuteData, "drawn_player", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "pen_for"
    }
  }, [_vm._v("Infraction")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPenaltyMinuteData.penalty_for),
      expression: "editPenaltyMinuteData.penalty_for"
    }],
    attrs: {
      "id": "pen_for",
      "name": "pen_for",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editPenaltyMinuteData, "penalty_for", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.PenaltyOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPenaltyMinuteData.penalty_type),
      expression: "editPenaltyMinuteData.penalty_type"
    }],
    attrs: {
      "id": "type",
      "name": "type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editPenaltyMinuteData, "penalty_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Minor")]), _vm._v(" "), _c('option', [_vm._v("Major")]), _vm._v(" "), _c('option', [_vm._v("Misconduct")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "length"
    }
  }, [_vm._v("Length")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPenaltyMinuteData.penalty_length),
      expression: "editPenaltyMinuteData.penalty_length"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "length",
      "type": "number",
      "name": "length",
      "min": "2",
      "max": "60"
    },
    domProps: {
      "value": (_vm.editPenaltyMinuteData.penalty_length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editPenaltyMinuteData, "penalty_length", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "zone"
    }
  }, [_vm._v("Zone")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPenaltyMinuteData.penalty_zone),
      expression: "editPenaltyMinuteData.penalty_zone"
    }],
    attrs: {
      "id": "type",
      "name": "type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editPenaltyMinuteData, "penalty_zone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Offensive")]), _vm._v(" "), _c('option', [_vm._v("Neutral")]), _vm._v(" "), _c('option', [_vm._v("Defensive")])])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitEditPenaltyMinute
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('edit-table', {
    attrs: {
      "id": "PIMS",
      "heading": "Penalty Minutes",
      "headers": _vm.peanltyMinutesHeaders,
      "total": _vm.getTotalCountPenaltyMinutes,
      "tableData": _vm.CleanPenaltyMinutes
    },
    on: {
      "new": _vm.openNewPenaltyMinute,
      "edit": _vm.openEditPenaltyMinutes,
      "reload": _vm.fetchRawGameData
    }
  }), _vm._v(" "), _c('new-item', {
    attrs: {
      "type": "Faceoff",
      "open": _vm.newFaceoff
    },
    on: {
      "cancel": _vm.cancelNew
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFaceoffData.period),
      expression: "newFaceoffData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.newFaceoffData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newFaceoffData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFaceoffData.situation_id),
      expression: "newFaceoffData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newFaceoffData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "home_player"
    }
  }, [_vm._v("Home Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFaceoffData.home_player),
      expression: "newFaceoffData.home_player"
    }],
    attrs: {
      "id": "home_player",
      "name": "home_player",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newFaceoffData, "home_player", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.HomePlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "away_player"
    }
  }, [_vm._v("Away Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFaceoffData.away_player),
      expression: "newFaceoffData.away_player"
    }],
    attrs: {
      "id": "away_player",
      "name": "away_player",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newFaceoffData, "away_player", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AwayPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "lane"
    }
  }, [_vm._v("Lane")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFaceoffData.lane),
      expression: "newFaceoffData.lane"
    }],
    attrs: {
      "id": "lane",
      "name": "lane",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newFaceoffData, "lane", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Left")]), _vm._v(" "), _c('option', [_vm._v("Center")]), _vm._v(" "), _c('option', [_vm._v("Right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "zone"
    }
  }, [_vm._v("Zone")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFaceoffData.zone),
      expression: "newFaceoffData.zone"
    }],
    attrs: {
      "id": "zone",
      "name": "zone",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newFaceoffData, "zone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Offensive")]), _vm._v(" "), _c('option', [_vm._v("Neutral")]), _vm._v(" "), _c('option', [_vm._v("Defensive")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "result"
    }
  }, [_vm._v("Result")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFaceoffData.result),
      expression: "newFaceoffData.result"
    }],
    attrs: {
      "id": "result",
      "name": "result",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newFaceoffData, "result", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("WinWin")]), _vm._v(" "), _c('option', [_vm._v("WinLoss")]), _vm._v(" "), _c('option', [_vm._v("LossLoss")]), _vm._v(" "), _c('option', [_vm._v("LossWin")])])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitNewFaceoff
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelNew
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('edit-item', {
    attrs: {
      "type": "Faceoff",
      "open": _vm.editFaceoff
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editFaceoffData.period),
      expression: "editFaceoffData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.editFaceoffData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editFaceoffData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editFaceoffData.situation_id),
      expression: "editFaceoffData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editFaceoffData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "home_player"
    }
  }, [_vm._v("Home Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editFaceoffData.home_player),
      expression: "editFaceoffData.home_player"
    }],
    attrs: {
      "id": "home_player",
      "name": "home_player",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editFaceoffData, "home_player", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.HomePlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "away_player"
    }
  }, [_vm._v("Away Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editFaceoffData.away_player),
      expression: "editFaceoffData.away_player"
    }],
    attrs: {
      "id": "away_player",
      "name": "away_player",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editFaceoffData, "away_player", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AwayPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "lane"
    }
  }, [_vm._v("Lane")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editFaceoffData.lane),
      expression: "editFaceoffData.lane"
    }],
    attrs: {
      "id": "lane",
      "name": "lane",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editFaceoffData, "lane", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Left")]), _vm._v(" "), _c('option', [_vm._v("Center")]), _vm._v(" "), _c('option', [_vm._v("Right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "zone"
    }
  }, [_vm._v("Zone")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editFaceoffData.zone),
      expression: "editFaceoffData.zone"
    }],
    attrs: {
      "id": "zone",
      "name": "zone",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editFaceoffData, "zone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Offensive")]), _vm._v(" "), _c('option', [_vm._v("Neutral")]), _vm._v(" "), _c('option', [_vm._v("Defensive")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "result"
    }
  }, [_vm._v("Result")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editFaceoffData.result),
      expression: "editFaceoffData.result"
    }],
    attrs: {
      "id": "result",
      "name": "result",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editFaceoffData, "result", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("WinWin")]), _vm._v(" "), _c('option', [_vm._v("WinLoss")]), _vm._v(" "), _c('option', [_vm._v("LossLoss")]), _vm._v(" "), _c('option', [_vm._v("LossWin")])])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitEditFaceoff
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('edit-table', {
    attrs: {
      "id": "Faceoffs",
      "heading": "Faceoffs",
      "headers": _vm.faceoffHeaders,
      "total": _vm.getTotalCountFaceoff,
      "tableData": _vm.Test
    },
    on: {
      "new": _vm.openNewFaceoff,
      "edit": _vm.openEditFaceoff,
      "reload": _vm.fetchRawGameData
    }
  }), _vm._v(" "), _c('new-item', {
    attrs: {
      "type": "Shot",
      "open": _vm.newShot
    },
    on: {
      "cancel": _vm.cancelNew
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Location 0,0,40 - Top Left")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newShotData.period),
      expression: "newShotData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.newShotData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newShotData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newShotData.situation_id),
      expression: "newShotData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newShotData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "player"
    }
  }, [_vm._v("Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newShotData.player_id),
      expression: "newShotData.player_id"
    }],
    attrs: {
      "id": "player",
      "name": "player",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newShotData, "player_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "result"
    }
  }, [_vm._v("Shot Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newShotData.shot_type),
      expression: "newShotData.shot_type"
    }],
    attrs: {
      "id": "result",
      "name": "result",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newShotData, "shot_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("OnNet")]), _vm._v(" "), _c('option', [_vm._v("MissedNet")]), _vm._v(" "), _c('option', [_vm._v("Blocked")]), _vm._v(" "), _c('option', [_vm._v("Goal")])])])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitNewShot
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelNew
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('edit-item', {
    attrs: {
      "type": "Shot",
      "open": _vm.editShot
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShotData.period),
      expression: "editShotData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.editShotData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShotData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShotData.situation_id),
      expression: "editShotData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editShotData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "player_id"
    }
  }, [_vm._v("Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShotData.player_id),
      expression: "editShotData.player_id"
    }],
    attrs: {
      "id": "player_id",
      "name": "player_id",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editShotData, "player_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "result"
    }
  }, [_vm._v("Shot Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShotData.shot_type),
      expression: "editShotData.shot_type"
    }],
    attrs: {
      "id": "result",
      "name": "result",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editShotData, "shot_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("OnNet")]), _vm._v(" "), _c('option', [_vm._v("Blocked")]), _vm._v(" "), _c('option', [_vm._v("MissedNet")]), _vm._v(" "), _c('option', [_vm._v("Goal")])])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitEditShot
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('edit-table', {
    attrs: {
      "id": "Shots",
      "heading": "Shots",
      "headers": _vm.shotHeaders,
      "total": _vm.getTotalCountShots,
      "tableData": _vm.CleanShots
    },
    on: {
      "new": _vm.openNewShot,
      "edit": _vm.openEditShot,
      "reload": _vm.fetchRawGameData
    }
  }), _vm._v(" "), _c('new-item', {
    attrs: {
      "type": "Hit",
      "open": _vm.newHit
    },
    on: {
      "cancel": _vm.cancelNew
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newHitData.period),
      expression: "newHitData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.newHitData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newHitData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newHitData.situation_id),
      expression: "newHitData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newHitData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "player"
    }
  }, [_vm._v("Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newHitData.home_player),
      expression: "newHitData.home_player"
    }],
    attrs: {
      "id": "player",
      "name": "player"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newHitData, "home_player", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitNewHit
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelNew
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('edit-item', {
    attrs: {
      "type": "Hit",
      "open": _vm.editHit
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editHitData.period),
      expression: "editHitData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.editHitData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editHitData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editHitData.situation_id),
      expression: "editHitData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editHitData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "player_id"
    }
  }, [_vm._v("Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editHitData.home_player),
      expression: "editHitData.home_player"
    }],
    attrs: {
      "id": "player_id",
      "name": "player_id",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editHitData, "home_player", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitEditHit
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('edit-table', {
    attrs: {
      "id": "Hits",
      "heading": "Hits",
      "headers": _vm.hitHeaders,
      "total": _vm.getTotalCountHits,
      "tableData": _vm.CleanHits
    },
    on: {
      "new": _vm.openNewHit,
      "edit": _vm.openEditHit,
      "reload": _vm.fetchRawGameData
    }
  }), _vm._v(" "), _c('new-item', {
    attrs: {
      "type": "Turnover",
      "open": _vm.newTurnover
    },
    on: {
      "cancel": _vm.cancelNew
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTurnoverData.period),
      expression: "newTurnoverData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.newTurnoverData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTurnoverData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTurnoverData.situation_id),
      expression: "newTurnoverData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newTurnoverData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "home_player"
    }
  }, [_vm._v("Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTurnoverData.player_id),
      expression: "newTurnoverData.player_id"
    }],
    attrs: {
      "id": "home_player",
      "name": "home_player"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newTurnoverData, "player_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "zone"
    }
  }, [_vm._v("Zone")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTurnoverData.zone),
      expression: "newTurnoverData.zone"
    }],
    attrs: {
      "id": "zone",
      "name": "zone"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newTurnoverData, "zone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Offensive")]), _vm._v(" "), _c('option', [_vm._v("Neutral")]), _vm._v(" "), _c('option', [_vm._v("Defensive")])])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitNewTurnover
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelNew
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('edit-item', {
    attrs: {
      "type": "Turnover",
      "open": _vm.editTurnover
    }
  }, [_c('div', {
    staticClass: "columns table__wrapper"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Game ID " + _vm._s(this.$route.params.gameId))]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Time 00:00:00")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "Period"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editTurnoverData.period),
      expression: "editTurnoverData.period"
    }],
    staticClass: "input is-small",
    attrs: {
      "required": "",
      "id": "period",
      "type": "number",
      "name": "period",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": (_vm.editTurnoverData.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editTurnoverData, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "situation"
    }
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editTurnoverData.situation_id),
      expression: "editTurnoverData.situation_id"
    }],
    attrs: {
      "id": "situation",
      "name": "situation",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editTurnoverData, "situation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "player_id"
    }
  }, [_vm._v("Player")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editTurnoverData.player_id),
      expression: "editTurnoverData.player_id"
    }],
    attrs: {
      "id": "player_id",
      "name": "player_id",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editTurnoverData, "player_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.submitEditTurnover
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('edit-table', {
    attrs: {
      "id": "Turnovers",
      "heading": "Turnovers",
      "headers": _vm.turnoverHeaders,
      "total": _vm.getTotalCountTurnovers,
      "tableData": _vm.CleanTurnovers
    },
    on: {
      "edit": _vm.openEditTurnover,
      "new": _vm.openNewTurnover,
      "reload": _vm.fetchRawGameData
    }
  }), _vm._v(" "), _c('edit-table', {
    attrs: {
      "id": "TOI",
      "heading": "Time On Ice",
      "headers": _vm.toiHeaders,
      "total": _vm.getTotalCountTOI,
      "tableData": _vm.CleanTOI
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("Current Score")]), _vm._v(" "), _c('th', [_vm._v("Time")]), _vm._v(" "), _c('th', [_vm._v("Situation")]), _vm._v(" "), _c('th', [_vm._v("GS")]), _vm._v(" "), _c('th', [_vm._v("FA")]), _vm._v(" "), _c('th', [_vm._v("SA")]), _vm._v(" "), _c('th', [_vm._v("Player 1 +")]), _vm._v(" "), _c('th', [_vm._v("Player 2 +")]), _vm._v(" "), _c('th', [_vm._v("Player 3 +")]), _vm._v(" "), _c('th', [_vm._v("Player 4 +")]), _vm._v(" "), _c('th', [_vm._v("Player 5 +")]), _vm._v(" "), _c('th', [_vm._v("Player 6 +")]), _vm._v(" "), _c('th', [_vm._v("Player 1 -")]), _vm._v(" "), _c('th', [_vm._v("Player 2 -")]), _vm._v(" "), _c('th', [_vm._v("Player 3 -")]), _vm._v(" "), _c('th', [_vm._v("Player 4 -")]), _vm._v(" "), _c('th', [_vm._v("Player 5 -")]), _vm._v(" "), _c('th', [_vm._v("Player 6 -")]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("Time")]), _vm._v(" "), _c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Infraction")]), _vm._v(" "), _c('th', [_vm._v("Player")])])
}]}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.open) ? _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("New " + _vm._s(_vm.type))]), _vm._v(" "), _vm._t("default")], 2)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('article', {
    staticClass: "box",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticClass: "columns is-mobile is-centered"
  }, [_c('div', {
    staticClass: "column is-offset-5"
  }, [_c('img', {
    staticClass: "team_logo",
    attrs: {
      "src": _vm.team_logo
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title has-text-left has-text-weight-bold is-uppercase"
  }, [_vm._v(_vm._s(_vm.team_name) + " ")])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.updateRoster
    }
  }, [_c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((4), function(n) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(n))]), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
      return (n == item.line_number && item.position === 'LW') ? _c('td', {
        key: item.id,
        staticClass: "colourdtd",
        class: {
          'unverified': item.is_verified == 0,
          'verified': item.is_verified != 0
        }
      }, [_c('p', {
        staticClass: "control"
      }, [_c('span', {
        staticClass: "select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.p_id),
          expression: "item.p_id"
        }],
        attrs: {
          "change": _vm.updateRoster(item, item.p_id)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.playerOptions), function(playerOption) {
        return _c('option', {
          domProps: {
            "value": playerOption.value
          }
        }, [_vm._v("\n                        " + _vm._s(playerOption.text) + "\n                      ")])
      }), 0)])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
      return (n == item.line_number && item.position === 'C') ? _c('td', {
        key: item.id,
        staticClass: "colourdtd",
        class: {
          'unverified': item.is_verified == 0,
          'verified': item.is_verified != 0
        }
      }, [_c('p', {
        staticClass: "control"
      }, [_c('span', {
        staticClass: "select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.p_id),
          expression: "item.p_id"
        }],
        attrs: {
          "change": _vm.updateRoster(item, item.p_id)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.playerOptions), function(playerOption) {
        return _c('option', {
          domProps: {
            "value": playerOption.value
          }
        }, [_vm._v("\n                        " + _vm._s(playerOption.text) + "\n                      ")])
      }), 0)])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
      return (n == item.line_number && item.position === 'RW') ? _c('td', {
        key: item.id,
        staticClass: "colourdtd",
        class: {
          'unverified': item.is_verified == 0,
          'verified': item.is_verified != 0
        }
      }, [_c('p', {
        staticClass: "control"
      }, [_c('span', {
        staticClass: "select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.p_id),
          expression: "item.p_id"
        }],
        attrs: {
          "change": _vm.updateRoster(item, item.p_id)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.playerOptions), function(playerOption) {
        return _c('option', {
          domProps: {
            "value": playerOption.value
          }
        }, [_vm._v("\n                        " + _vm._s(playerOption.text) + "\n                      ")])
      }), 0)])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
      return (n == item.line_number && item.position === 'LD') ? _c('td', {
        key: item.id,
        staticClass: "colourdtd",
        class: {
          'unverified': item.is_verified == 0,
          'verified': item.is_verified != 0
        }
      }, [_c('p', {
        staticClass: "control"
      }, [_c('span', {
        staticClass: "select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.p_id),
          expression: "item.p_id"
        }],
        attrs: {
          "change": _vm.updateRoster(item, item.p_id)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.playerOptions), function(playerOption) {
        return _c('option', {
          domProps: {
            "value": playerOption.value
          }
        }, [_vm._v("\n                        " + _vm._s(playerOption.text) + "\n                      ")])
      }), 0)])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
      return (n == item.line_number && item.position === 'RD') ? _c('td', {
        key: item.id,
        staticClass: "colourdtd",
        class: {
          'unverified': item.is_verified == 0,
          'verified': item.is_verified != 0
        }
      }, [_c('p', {
        staticClass: "control"
      }, [_c('span', {
        staticClass: "select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.p_id),
          expression: "item.p_id"
        }],
        attrs: {
          "change": _vm.updateRoster(item, item.p_id)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.playerOptions), function(playerOption) {
        return _c('option', {
          domProps: {
            "value": playerOption.value
          }
        }, [_vm._v("\n                        " + _vm._s(playerOption.text) + " \n                      ")])
      }), 0)])])]) : _vm._e()
    })], 2)
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
    return (item.line_number == 5 && item.position === 'GT') ? _c('td', {
      key: item.id,
      staticClass: "colourdtd",
      class: {
        'unverified': item.is_verified == 0,
        'verified': item.is_verified != 0
      }
    }, [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.p_id),
        expression: "item.p_id"
      }],
      attrs: {
        "change": _vm.updateRoster(item, item.p_id)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.playerOptions), function(playerOption) {
      return _c('option', {
        domProps: {
          "value": playerOption.value
        }
      }, [_vm._v("\n                        " + _vm._s(playerOption.text) + "\n                      ")])
    }), 0)])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
    return (item.line_number == 5 && item.position === 'BKPGT') ? _c('td', {
      key: item.id,
      staticClass: "colourdtd",
      class: {
        'unverified': item.is_verified == 0,
        'verified': item.is_verified != 0
      }
    }, [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.p_id),
        expression: "item.p_id"
      }],
      attrs: {
        "change": _vm.updateRoster(item, item.p_id)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.playerOptions), function(playerOption) {
      return _c('option', {
        domProps: {
          "value": playerOption.value
        }
      }, [_vm._v("\n                        " + _vm._s(playerOption.text) + "\n                      ")])
    }), 0)])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.Roster), function(item) {
    return (item.line_number == 5 && item.position === 'EMGGT') ? _c('td', {
      key: item.id,
      staticClass: "colourdtd",
      class: {
        'unverified': item.is_verified == 0,
        'verified': item.is_verified != 0
      }
    }, [_c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.p_id),
        expression: "item.p_id"
      }],
      attrs: {
        "change": _vm.updateRoster(item, item.p_id)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "p_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.playerOptions), function(playerOption) {
      return _c('option', {
        domProps: {
          "value": playerOption.value
        }
      }, [_vm._v("\n                        " + _vm._s(playerOption.text) + "\n                      ")])
    }), 0)])])]) : _vm._e()
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')], 2)])]), _vm._v(" "), _c('p', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "button is-medium is-primary",
    on: {
      "click": _vm.generateRoster
    }
  }, [_vm._v("Clone Template Roster")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-success",
    on: {
      "click": _vm.validateRoster
    }
  }, [_vm._v("Validate")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-warning",
    on: {
      "click": _vm.invalidateRoster
    }
  }, [_vm._v("Invalidate")]), _vm._v(" "), _c('button', {
    staticClass: "button is-medium is-default",
    on: {
      "click": _vm.clearRoster
    }
  }, [_vm._v("Clear")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("LW")]), _vm._v(" "), _c('th', [_vm._v("C")]), _vm._v(" "), _c('th', [_vm._v("RW")]), _vm._v(" "), _c('th', [_vm._v("LD")]), _vm._v(" "), _c('th', [_vm._v("RD")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Starting Goal Tender")]), _vm._v(" "), _c('th', [_vm._v("Backup Goal Tender")]), _vm._v(" "), _c('th', [_vm._v("Emergency Goal Tender")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])
}]}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Shots - Heatmap")]), _vm._v(" "), _c('div', {
    staticClass: "small-box"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Controls")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SituationSelected),
      expression: "SituationSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SituationSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchShotmap]
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Shot type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShotTypeSelected),
      expression: "ShotTypeSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ShotTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchShotmap]
    }
  }, _vm._l((_vm.ShotTypeOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.UseHeatmap = !_vm.UseHeatmap;
        _vm.renderHeatmap()
      }
    }
  }, [_vm._v("Heatmap")])])]), _vm._v(" "), (_vm.UseHeatmap) ? _c('div', {
    staticClass: "column is-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Blur")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BlurSelected),
      expression: "BlurSelected"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "0.5"
    },
    domProps: {
      "value": (_vm.BlurSelected)
    },
    on: {
      "change": _vm.renderHeatmap,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BlurSelected = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.UseHeatmap) ? _c('div', {
    staticClass: "column is-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Radius")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RadiusSelected),
      expression: "RadiusSelected"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "0.5"
    },
    domProps: {
      "value": (_vm.RadiusSelected)
    },
    on: {
      "change": _vm.renderHeatmap,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RadiusSelected = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.UseShotZones = !_vm.UseShotZones;
        _vm.renderHeatmap()
      }
    }
  }, [_vm._v("Shot Zones")])])]), _vm._v(" "), (_vm.UseShotZones) ? _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.UseShotZonesText = !_vm.UseShotZonesText;
        _vm.renderHeatmap()
      }
    }
  }, [_vm._v("Toggle Zone Count")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-half is-offset-1"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.home_name))]), _vm._v(" "), _c('canvas', {
    ref: "home_shot_canvas",
    staticClass: "is-canvas-responsive shotmap",
    attrs: {
      "id": "home_shotmap",
      "width": "412",
      "height": "520"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('h1', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.away_name))]), _vm._v(" "), _c('canvas', {
    ref: "away_shot_canvas",
    staticClass: "is-canvas-responsive shotmap",
    attrs: {
      "id": "away_shotmap",
      "width": "412",
      "height": "520"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "zone-starts"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Zone",
      "heading": "Zone Starts",
      "headers": _vm.ZoneStartsPlayerHeadings,
      "tableData": _vm.sortByZoneStartsData
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SituationSelected),
      expression: "SituationSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SituationSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.SituationOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [(_vm.FilterSelected !== 'Line') ? _c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.chartData,
      "options": _vm.bar_options
    }
  }) : _vm._e(), _vm._v(" "), (_vm.FilterSelected === 'Line') ? _c('chart', {
    attrs: {
      "type": 'line',
      "data": _vm.chartData,
      "options": _vm.lineOptions
    }
  }) : _vm._e()], 1)], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 31/01/2019 08:30PM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("Graph - All Players now displayed on chart (no longer skipping ticks).")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
}]}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Edit Goal")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Game Info")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goalData.period),
      expression: "goalData.period"
    }],
    attrs: {
      "id": "period",
      "name": "period",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.goalData, "period", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.periodOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goalData.situation),
      expression: "goalData.situation"
    }],
    attrs: {
      "id": "situation",
      "name": "situation",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.goalData, "situation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.situationOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Goal Details")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Goal Scorer")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goalData.goal_scorer),
      expression: "goalData.goal_scorer"
    }],
    attrs: {
      "id": "goal_scorer",
      "name": "goal_scorer",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.goalData, "goal_scorer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("First Assist")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goalData.first_assist),
      expression: "goalData.first_assist"
    }],
    attrs: {
      "id": "first_assist",
      "name": "first_assist",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.goalData, "first_assist", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Second Assist")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goalData.second_assist),
      expression: "goalData.second_assist"
    }],
    attrs: {
      "id": "second_assist",
      "name": "second_assist",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.goalData, "second_assist", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(" On Ice +/-")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player 1")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goalData.on_ice_1),
      expression: "goalData.on_ice_1"
    }],
    attrs: {
      "id": "on_ice_1",
      "name": "on_ice_1",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.goalData, "on_ice_1", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player 2")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goalData.on_ice_2),
      expression: "goalData.on_ice_2"
    }],
    attrs: {
      "id": "on_ice_2",
      "name": "on_ice_2",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.goalData, "on_ice_2", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player 3")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goalData.on_ice_3),
      expression: "goalData.on_ice_3"
    }],
    attrs: {
      "id": "on_ice_3",
      "name": "on_ice_3",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.goalData, "on_ice_3", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player 4")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goalData.on_ice_4),
      expression: "goalData.on_ice_4"
    }],
    attrs: {
      "id": "on_ice_4",
      "name": "on_ice_4",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.goalData, "on_ice_4", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player 5")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goalData.on_ice_5),
      expression: "goalData.on_ice_5"
    }],
    attrs: {
      "id": "on_ice_5",
      "name": "on_ice_5",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.goalData, "on_ice_5", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player 6")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goalData.on_ice_6),
      expression: "goalData.on_ice_6"
    }],
    attrs: {
      "id": "on_ice_6",
      "name": "on_ice_6",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.goalData, "on_ice_6", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.AllPlayerOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Game Time")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "text"
    }
  })])])
}]}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.heading) + " - " + _vm._s(_vm.total) + " Entries")]), _vm._v(" "), _c('button', {
    staticClass: "button is-success is-large",
    on: {
      "click": _vm.emitNew
    }
  }, [_vm._v("New Item")]), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('thead', [_vm._l((_vm.headers), function(heading) {
    return _c('th', {
      key: heading
    }, [_vm._v("\n          " + _vm._s(heading) + "\n        ")])
  }), _vm._v(" "), _c('th', [_vm._v("Validate")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])], 2), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row) {
    return _c('tr', {
      key: row.id
    }, [_vm._l((row), function(data) {
      return _c('td', {
        key: data.id,
        staticClass: "colourdtd",
        class: {
          'unverified': row.is_verified == 0,
          'verified': row.is_verified != 0
        }
      }, [_vm._v(_vm._s(data))])
    }), _vm._v(" "), _c('td', {
      class: {
        'unverified': row.is_verified == 0,
        'verified': row.is_verified != 0
      }
    }, [_c('button', {
      staticClass: "button is-success is-small",
      on: {
        "click": function($event) {
          return _vm.validate(row)
        }
      }
    }, [(row.is_verified == 0) ? _c('div', [_vm._v("Validate")]) : _c('div', {
      staticStyle: {
        "color": "white"
      }
    }, [_vm._v("Invalidate")])])]), _vm._v(" "), _c('td', {
      class: {
        'unverified': row.is_verified == 0,
        'verified': row.is_verified != 0
      }
    }, [_c('button', {
      staticClass: "button is-warning is-small",
      on: {
        "click": function($event) {
          return _vm.edit(row)
        }
      }
    }, [_vm._v("Edit")])]), _vm._v(" "), _c('td', {
      class: {
        'unverified': row.is_verified == 0,
        'verified': row.is_verified != 0
      }
    }, [_c('button', {
      staticClass: "button is-danger is-small",
      on: {
        "click": function($event) {
          return _vm.del(row)
        }
      }
    }, [_vm._v("Delete")])])], 2)
  }), 0)])])])])])
},staticRenderFns: []}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment-main"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Faceoffs PvP ")]), _vm._v(" "), _c('div', {
    staticClass: "segment"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Lane")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lane),
      expression: "lane"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lane = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Left"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Center"
    }
  }, [_vm._v("Center")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Right"
    }
  }, [_vm._v("Right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Zone")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zone),
      expression: "zone"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Offensive"
    }
  }, [_vm._v("Offensive")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Offensive"
    }
  }, [_vm._v("Neutral")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Offensive"
    }
  }, [_vm._v("Defensive")])])])])])])]), _vm._v(" "), (this.tableData.length <= 0) ? _c('span', [_c('h2', {
    staticClass: "segment title has-text-centered"
  }, [_vm._v("No data or Loading...")])]) : _vm._e(), _vm._v(" "), _vm._l((this.tableData), function(player) {
    return _c('div', {
      key: player.player,
      staticClass: "segment"
    }, [_c('h1', {
      staticClass: "subtitle has-text-centered"
    }, [_vm._v(_vm._s(player.player))]), _vm._v(" "), _c('table', {
      staticClass: "table main-table"
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((player.vs), function(opp) {
      return _c('tr', {
        key: opp.away_player
      }, [_c('td', [_vm._v(_vm._s(opp.away_player))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opp.fo_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opp.fo_win))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opp.fo_loss))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opp.fo_win_percentage))])])
    }), 0)])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("VS")]), _vm._v(" "), _c('th', [_vm._v("Taken")]), _vm._v(" "), _c('th', [_vm._v("Win")]), _vm._v(" "), _c('th', [_vm._v("Loss")]), _vm._v(" "), _c('th', [_vm._v("Win %")])])
}]}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.user().role) ? _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show,
      slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n    General Statistics\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', [(item.path) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem) {
      return (subItem.role == _vm.$auth.user().role) ? _c('li', [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem),
          "role": {
            item: item
          }
        }
      }, [_vm._v(" \n                " + _vm._s(subItem.meta && subItem.meta.label || subItem.name) + "\n                ")])], 1) : _vm._e()
    }), 0)]) : _vm._e()], 1)
  }), 0)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "hits"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Hits",
      "heading": "Hits",
      "headers": _vm.HitPlayerHeadings,
      "tableData": _vm.sortByHitData
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sort")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FilterSelected),
      expression: "FilterSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.FilterSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByHitData]
    }
  }, _vm._l((_vm.HitPlayerFilters), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.chartData,
      "options": _vm.bar_options
    }
  })], 1)], 2)], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "cumulative"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "Hits",
      "heading": "Cumulative Hit Data"
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Player(s)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.PlayerOptions,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "preserve-search": true,
      "placeholder": "Pick some",
      "label": "name",
      "track-by": "name",
      "preselect-first": true
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.PlayerSelected.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(_vm._s(_vm.PlayerSelected.length) + " options selected")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.PlayerSelected),
      callback: function($$v) {
        _vm.PlayerSelected = $$v
      },
      expression: "PlayerSelected"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Data Selection")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameDataSelected),
      expression: "GameByGameDataSelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.GameByGameDataSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.GameByGameDataOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('h1', {
    staticClass: "label"
  }, [_vm._v("Graph Options")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fill")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameFill),
      expression: "GameByGameFill"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.GameByGameFill) ? _vm._i(_vm.GameByGameFill, null) > -1 : (_vm.GameByGameFill)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.GameByGameFill,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.GameByGameFill = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.GameByGameFill = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.GameByGameFill = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Line Tension")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GameByGameTension),
      expression: "GameByGameTension"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "0.0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.GameByGameTension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.GameByGameTension = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'line',
      "data": _vm.buildCumulativeChartData,
      "options": _vm.line_options
    }
  })], 1)], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 22/10/2018 11:59AM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("Please beware, this is work in progress!")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
}]}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "penalty-minutes"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])]), _vm._v(" "), _c('data-table', {
    attrs: {
      "id": "Filtered Games",
      "heading": "Filtered Games",
      "headers": _vm.FilterHeadings,
      "tableData": _vm.GameFilter
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "players"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "PIM",
      "heading": "Penalty Minutes"
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Penalty Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PenaltyTypeSelected),
      expression: "PenaltyTypeSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.PenaltyTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Major & Minor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Minor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Major")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Misconduct")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("All")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Sort")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FilterSelected),
      expression: "FilterSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.FilterSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByPIMData]
    }
  }, _vm._l((_vm.PIMChartFilters), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.pim_chart_totals,
      "options": _vm.bar_options
    }
  }), _vm._v(" "), _c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.pim_chart_diff,
      "options": _vm.bar_options
    }
  })], 1)], 2), _vm._v(" "), _c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "PIM",
      "heading": "Penalty Minutes by Infraction",
      "headers": ['Infraction', 'Drawn', 'Taken', 'Diff'],
      "tableData": _vm.sortByPIMInfraction
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Penalty Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PenaltyTypeSelected),
      expression: "PenaltyTypeSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.PenaltyTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Major & Minor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Minor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Major")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Misconduct")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("All")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Sort")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FilterSelected),
      expression: "FilterSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.FilterSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByPIMInfraction]
    }
  }, _vm._l((_vm.PIMChartFilters), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.pim_by_infraction,
      "options": _vm.bar_options
    }
  })], 1)], 2), _vm._v(" "), _c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "PIM",
      "heading": "Penalty Minutes by Team",
      "headers": ['Team', 'Drawn', 'Taken', 'Diff', 'Most Common Taken', 'Most Common Drawn'],
      "tableData": _vm.sortByPIMTeam
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Penalty Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PenaltyTypeSelected),
      expression: "PenaltyTypeSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.PenaltyTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Major & Minor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Minor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Major")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Misconduct")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("All")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Sort")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FilterSelected),
      expression: "FilterSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.FilterSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByPIMTeam]
    }
  }, _vm._l((_vm.PIMChartFilters), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.pim_by_team,
      "options": _vm.bar_options
    }
  })], 1)], 2), _vm._v(" "), _c('data-table', {
    attrs: {
      "defaultShow": "true",
      "id": "PIM",
      "heading": "Penalty Minutes - All Data",
      "headers": _vm.PIMHeadings,
      "tableData": _vm.sortByPIMData
    }
  }, [_c('template', {
    slot: "filter"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Sort")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FilterSelected),
      expression: "FilterSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.FilterSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByPimData]
    }
  }, _vm._l((_vm.PIMPlayerFilters), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Penalty Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PenaltyTypeSelected),
      expression: "PenaltyTypeSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.PenaltyTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Major & Minor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Minor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Major")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Misconduct")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("All")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "graph"
    },
    slot: "graph"
  }, [_c('chart', {
    attrs: {
      "type": 'horizontalBar',
      "data": _vm.chartData,
      "options": _vm.bar_options
    }
  })], 1)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('apexchart', {
    ref: "lastFiveChart",
    attrs: {
      "type": "line",
      "height": "350",
      "options": _vm.lastFiveOptions,
      "series": _vm.pim_by_last_five
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 05/12/2019 09:36PM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("Removed penalties from penalty breakdown where there have been none taken / drawn.")]), _vm._v(" "), _c('li', [_vm._v("Added game by game taken / drawn graph.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
}]}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-parent is-vertical box"
  }, [_c('article', [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Shotmap")]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "player_shotmap"
    }
  }, [_c('section', {
    attrs: {
      "id": "global_filters"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Shot Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShotTypeSelected),
      expression: "ShotTypeSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ShotTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchShotmap]
    }
  }, _vm._l((_vm.ShotTypeOptions), function(option) {
    return _c('option', {
      key: option.text,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-small",
    on: {
      "click": function($event) {
        _vm.UseHeatmap = !_vm.UseHeatmap;
        _vm.renderHeatmap()
      }
    }
  }, [_vm._v("Heatmap")])])]), _vm._v(" "), (_vm.UseHeatmap) ? _c('div', {
    staticClass: "column is-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Blur")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BlurSelected),
      expression: "BlurSelected"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "0.5"
    },
    domProps: {
      "value": (_vm.BlurSelected)
    },
    on: {
      "change": _vm.renderHeatmap,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BlurSelected = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.UseHeatmap) ? _c('div', {
    staticClass: "column is-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Radius")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RadiusSelected),
      expression: "RadiusSelected"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "0.5"
    },
    domProps: {
      "value": (_vm.RadiusSelected)
    },
    on: {
      "change": _vm.renderHeatmap,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RadiusSelected = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-small",
    on: {
      "click": function($event) {
        _vm.UseShotZones = !_vm.UseShotZones;
        _vm.renderHeatmap()
      }
    }
  }, [_vm._v("Shot Zones")])])]), _vm._v(" "), (_vm.UseShotZones) ? _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-small",
    on: {
      "click": function($event) {
        _vm.UseShotZonesText = !_vm.UseShotZonesText;
        _vm.renderHeatmap()
      }
    }
  }, [_vm._v("Toggle Zone Count")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('canvas', {
    ref: "home_shot_canvas",
    staticClass: "is-canvas-responsive shotmap",
    attrs: {
      "id": "home_shotmap",
      "width": "412",
      "height": "520"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control has-addons flatpickr",
    class: ( _obj = {}, _obj[("has-addons-" + _vm.alignment)] = _vm.alignment, _obj ),
    attrs: {
      "data-wrap": "true",
      "data-clickOpens": "false"
    }
  }, [_c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "data-input": ""
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor is-centered"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Edit Player")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.updatePlayer
    }
  }, [_c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.forename),
      expression: "Player.forename"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.forename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "forename", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.surname),
      expression: "Player.surname"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "surname", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.number),
      expression: "Player.number"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('input', {
    ref: "file",
    staticClass: "input",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "--:--",
      "config": {
        enableTime: false,
        enableSeconds: true,
        noCalendar: false,
        time_24hr: true
      }
    },
    model: {
      value: (_vm.Player.dob),
      callback: function($$v) {
        _vm.$set(_vm.Player, "dob", $$v)
      },
      expression: "Player.dob"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.birth_place),
      expression: "Player.birth_place"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.birth_place)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "birth_place", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.nationality),
      expression: "Player.nationality"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.nationality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "nationality", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.position),
      expression: "Player.position"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Player, "position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.positionOptions), function(pos) {
    return _c('option', {
      domProps: {
        "value": pos.value
      }
    }, [_vm._v("\n                    " + _vm._s(pos.text) + "\n                  ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.height),
      expression: "Player.height"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.Player.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "height", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.weight),
      expression: "Player.weight"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.Player.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "weight", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.handedness),
      expression: "Player.handedness"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.Player.handedness)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "handedness", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.external_url),
      expression: "Player.external_url"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.Player.external_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Player, "external_url", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Player.status),
      expression: "Player.status"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Player, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.statusOptions), function(status) {
    return _c('option', {
      domProps: {
        "value": status.value
      }
    }, [_vm._v("\n                    " + _vm._s(status.text) + "\n                  ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "name": "submit"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-medium",
    attrs: {
      "to": '/editors/player-editor/' + this.$route.params.teamId
    }
  }, [_vm._v("Cancel")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Forename")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Surname")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Picture")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("DOB")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Birth Place")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nationality")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Position")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Height - Meters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Weight - lbs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Handedness - L/R")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("External URL - Elite Prospects etc.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Status")])])
}]}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: ['notification', 'animated', _vm.type ? ("is-" + _vm.type) : '']
  }, [_c('button', {
    staticClass: "delete touchable",
    on: {
      "click": function($event) {
        return _vm.closedByUser()
      }
    }
  }), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "is-parent box"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Season Totals")]), _vm._v(" "), _c('season-totals-menu', {
    attrs: {
      "name": "raw-data"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gameFilters"
    }
  }, [_c('div', {
    staticClass: "is-parent is-vertical"
  }, [_c('article', {
    staticClass: "is-child box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Season")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YearSelected),
      expression: "YearSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.YearSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, [_c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022-2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019-2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018-2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Competition")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompetitionSelected),
      expression: "CompetitionSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CompetitionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.CompetitionOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Opponent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OpponentSelected),
      expression: "OpponentSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.OpponentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.OpponentOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Venue")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VenueSelected),
      expression: "VenueSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.VenueSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.VenueOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Limit")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LimitSelected),
      expression: "LimitSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.LimitSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchSeasonStats]
    }
  }, _vm._l((_vm.LimitOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])])])])])])])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "rawdata"
    }
  }, [_c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("All Data")]), _vm._v(" "), _c('div', {
    staticClass: "rol-wrapper"
  }, [_c('div', {
    staticClass: "rol-scroller"
  }, [_c('table', {
    staticClass: "table rol-table"
  }, [_c('thead', [_c('th', {
    staticClass: "rol-sticky-col"
  }, [_vm._v("Player")]), _vm._v(" "), _c('th', {
    staticClass: "rol-sticky-col-gp"
  }, [_vm._v("GP")]), _vm._v(" "), _c('th', {
    staticClass: "shots-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('shots')
      }
    }
  }, [_c('a', {
    staticClass: "shots-col"
  }, [_vm._v("SHOTS")])]), _vm._v(" "), _c('th', {
    staticClass: "shots-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('shots_on_net')
      }
    }
  }, [_c('a', {
    staticClass: "shots-col"
  }, [_vm._v("SOT")])]), _vm._v(" "), _c('th', {
    staticClass: "shots-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('shots_missed_net')
      }
    }
  }, [_c('a', {
    staticClass: "shots-col"
  }, [_vm._v("MISSED")])]), _vm._v(" "), _c('th', {
    staticClass: "shots-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('shots_blocked')
      }
    }
  }, [_c('a', {
    staticClass: "shots-col"
  }, [_vm._v("BLOCKED")])]), _vm._v(" "), _c('th', {
    staticClass: "shots-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('shots_percentage')
      }
    }
  }, [_c('a', {
    staticClass: "shots-col"
  }, [_vm._v("SH%")])]), _vm._v(" "), _c('th', {
    staticClass: "shots-diff-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('shots_for')
      }
    }
  }, [_c('a', {
    staticClass: "shots-diff-col"
  }, [_vm._v("CF")])]), _vm._v(" "), _c('th', {
    staticClass: "shots-diff-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('shots_for')
      }
    }
  }, [_c('a', {
    staticClass: "shots-diff-col"
  }, [_vm._v("CA")])]), _vm._v(" "), _c('th', {
    staticClass: "shots-diff-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('shots_for')
      }
    }
  }, [_c('a', {
    staticClass: "shots-diff-col"
  }, [_vm._v("CDIFF")])]), _vm._v(" "), _c('th', {
    staticClass: "shots-diff-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('shots_for')
      }
    }
  }, [_c('a', {
    staticClass: "shots-diff-col"
  }, [_vm._v("CF%")])]), _vm._v(" "), _c('th', {
    staticClass: "shots-diff-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('shots_for')
      }
    }
  }, [_c('a', {
    staticClass: "shots-diff-col"
  }, [_vm._v("CREL")])]), _vm._v(" "), _c('th', {
    staticClass: "toi-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('toi_total')
      }
    }
  }, [_c('a', {
    staticClass: "toi-col"
  }, [_vm._v("TOI")])]), _vm._v(" "), _c('th', {
    staticClass: "toi-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('toi_game')
      }
    }
  }, [_c('a', {
    staticClass: "toi-col"
  }, [_vm._v("TOI/G")])]), _vm._v(" "), _c('th', {
    staticClass: "toi-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('toi_shifts')
      }
    }
  }, [_c('a', {
    staticClass: "toi-col"
  }, [_vm._v("SHIFTS")])]), _vm._v(" "), _c('th', {
    staticClass: "toi-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('toi_avg_shift')
      }
    }
  }, [_c('a', {
    staticClass: "toi-col"
  }, [_vm._v("SH/G")])]), _vm._v(" "), _c('th', {
    staticClass: "toi-col"
  }, [_vm._v("TOI/SHIFT")]), _vm._v(" "), _c('th', {
    staticClass: "faceoff-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('fo_taken')
      }
    }
  }, [_c('a', {
    staticClass: "faceoff-col"
  }, [_vm._v("FO")])]), _vm._v(" "), _c('th', {
    staticClass: "faceoff-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('fo_win')
      }
    }
  }, [_c('a', {
    staticClass: "faceoff-col"
  }, [_vm._v("FO WIN")])]), _vm._v(" "), _c('th', {
    staticClass: "faceoff-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('fo_loss')
      }
    }
  }, [_c('a', {
    staticClass: "faceoff-col"
  }, [_vm._v("FO LOSS")])]), _vm._v(" "), _c('th', {
    staticClass: "faceoff-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('')
      }
    }
  }, [_c('a', {
    staticClass: "faceoff-col"
  }, [_vm._v("FO +/-")])]), _vm._v(" "), _c('th', {
    staticClass: "faceoff-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('')
      }
    }
  }, [_c('a', {
    staticClass: "faceoff-col"
  }, [_vm._v("FOW/G")])]), _vm._v(" "), _c('th', {
    staticClass: "faceoff-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('fo_win_percentage')
      }
    }
  }, [_c('a', {
    staticClass: "faceoff-col"
  }, [_vm._v("FOW%")])]), _vm._v(" "), _c('th', {
    staticClass: "hits-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('hits')
      }
    }
  }, [_c('a', {
    staticClass: "hits-col"
  }, [_vm._v("HITS")])]), _vm._v(" "), _c('th', {
    staticClass: "hits-col"
  }, [_vm._v("HITS/G")]), _vm._v(" "), _c('th', {
    staticClass: "turnovers-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('turnovers')
      }
    }
  }, [_c('a', {
    staticClass: "turnovers-col"
  }, [_vm._v("TURNOVERS")])]), _vm._v(" "), _c('th', {
    staticClass: "turnovers-col"
  }, [_vm._v("TURNOVERS/G")]), _vm._v(" "), _c('th', {
    staticClass: "pim-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('pim_drawn')
      }
    }
  }, [_c('a', {
    staticClass: "pim-col"
  }, [_vm._v("PIM +")])]), _vm._v(" "), _c('th', {
    staticClass: "pim-col",
    on: {
      "click": function($event) {
        return _vm.sortDataBy('pim_taken')
      }
    }
  }, [_c('a', {
    staticClass: "pim-col"
  }, [_vm._v(" PIM -")])]), _vm._v(" "), _c('th', {
    staticClass: "pim-col"
  }, [_vm._v("PIM +/-")]), _vm._v(" "), _c('th', {
    staticClass: "pim-col"
  }, [_vm._v("PIM/G")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.PlayerTotals), function(player) {
    return _c('tr', {
      key: player.player
    }, [_c('th', {
      staticClass: "rol-sticky-col"
    }, [_vm._v(_vm._s(player.player))]), _vm._v(" "), _c('td', {
      staticClass: "rol-sticky-col-gp"
    }, [_vm._v(_vm._s(player.gp))]), _vm._v(" "), _c('td', {
      staticClass: "shots-col"
    }, [_vm._v(_vm._s(player.shots))]), _vm._v(" "), _c('td', {
      staticClass: "shots-col"
    }, [_vm._v(_vm._s(player.shots_on_net))]), _vm._v(" "), _c('td', {
      staticClass: "shots-col"
    }, [_vm._v(_vm._s(player.shots_missed_net))]), _vm._v(" "), _c('td', {
      staticClass: "shots-col"
    }, [_vm._v(_vm._s(player.shots_blocked))]), _vm._v(" "), _c('td', {
      staticClass: "shots-col"
    }, [_vm._v(_vm._s(player.shots_percentage))]), _vm._v(" "), _c('td', {
      staticClass: "shots-diff-col"
    }, [_vm._v(_vm._s(player.shots_for))]), _vm._v(" "), _c('td', {
      staticClass: "shots-diff-col"
    }, [_vm._v(_vm._s(player.shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "shots-diff-col"
    }, [_vm._v(_vm._s(player.shots_for - player.shots_against))]), _vm._v(" "), _c('td', {
      staticClass: "shots-diff-col"
    }, [_vm._v(_vm._s(player.shots_diff_percentage))]), _vm._v(" "), _c('td', {
      staticClass: "shots-diff-col"
    }, [_vm._v(_vm._s(player.shots_relative))]), _vm._v(" "), _c('td', {
      staticClass: "toi-col"
    }, [_vm._v(_vm._s(player.toi_total))]), _vm._v(" "), _c('td', {
      staticClass: "toi-col"
    }, [_vm._v(_vm._s(player.toi_game))]), _vm._v(" "), _c('td', {
      staticClass: "toi-col"
    }, [_vm._v(_vm._s(player.toi_shifts))]), _vm._v(" "), _c('td', {
      staticClass: "toi-col"
    }, [_vm._v(_vm._s(_vm._f("fixedDP")(player.toi_shifts / player.gp)))]), _vm._v(" "), _c('td', {
      staticClass: "toi-col"
    }, [_vm._v(_vm._s(player.toi_avg_shift))]), _vm._v(" "), _c('td', {
      staticClass: "faceoff-col"
    }, [_vm._v(_vm._s(player.fo_taken))]), _vm._v(" "), _c('td', {
      staticClass: "faceoff-col"
    }, [_vm._v(_vm._s(player.fo_win))]), _vm._v(" "), _c('td', {
      staticClass: "faceoff-col"
    }, [_vm._v(_vm._s(player.fo_loss))]), _vm._v(" "), _c('td', {
      staticClass: "faceoff-col"
    }, [_vm._v(_vm._s(player.fo_win - player.fo_loss))]), _vm._v(" "), _c('td', {
      staticClass: "faceoff-col"
    }, [_vm._v(_vm._s(_vm._f("fixedDP")(player.fo_win / player.gp)))]), _vm._v(" "), _c('td', {
      staticClass: "faceoff-col"
    }, [_vm._v(_vm._s(player.fo_win_percentage))]), _vm._v(" "), _c('td', {
      staticClass: "hits-col"
    }, [_vm._v(_vm._s(player.hits))]), _vm._v(" "), _c('td', {
      staticClass: "hits-col"
    }, [_vm._v(_vm._s(_vm._f("fixedDP")(player.hits / player.gp)))]), _vm._v(" "), _c('td', {
      staticClass: "turnovers-col"
    }, [_vm._v(_vm._s(player.turnovers))]), _vm._v(" "), _c('td', {
      staticClass: "turnovers-col"
    }, [_vm._v(_vm._s(_vm._f("fixedDP")(player.turnovers / player.gp)))]), _vm._v(" "), _c('td', {
      staticClass: "pim-col"
    }, [_vm._v(_vm._s(player.pim_drawn))]), _vm._v(" "), _c('td', {
      staticClass: "pim-col"
    }, [_vm._v(_vm._s(player.pim_taken))]), _vm._v(" "), _c('td', {
      staticClass: "pim-col"
    }, [_vm._v(_vm._s(player.pim_drawn - player.pim_taken))]), _vm._v(" "), _c('td', {
      staticClass: "pim-col"
    }, [_vm._v(_vm._s(_vm._f("fixedDP")(player.pim_taken / player.gp)))])])
  }), 0)])])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "name": "GoalsByGame"
    }
  }, [_c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Goals By Game")]), _vm._v(" "), _c('div', {
    staticClass: "rol-wrapper"
  }, [_c('div', {
    staticClass: "rol-scroller"
  }, [_c('table', {
    staticClass: "table rol-table-sub"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.GoalsByGame), function(game) {
    return _c('tr', {
      key: game.match_date
    }, [_c('th', {
      staticClass: "rol-sticky-col-game"
    }, [_vm._v(_vm._s(game.match_date))]), _vm._v(" "), _vm._l((game.goals), function(goal) {
      return _c('td', {
        key: goal.goal_id
      }, [_c('table', {
        class: [{
          'is-plus': goal.team_id == 1
        }, {
          'is-minus': goal.team_id != 1
        }]
      }, [_c('tr', [_c('td', [_c('b', [_vm._v("GS: " + _vm._s(goal.goal_scorer))]), _vm._v(" A1: " + _vm._s(goal.first_assist) + "  A2:" + _vm._s(goal.second_assist) + " "), _c('b', [_vm._v(_vm._s(goal.situation_id))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(goal.on_ice_1) + "\n                      " + _vm._s(goal.on_ice_2) + "\n                      " + _vm._s(goal.on_ice_3) + "\n                      " + _vm._s(goal.on_ice_4) + "\n                      " + _vm._s(goal.on_ice_5) + "\n                      " + _vm._s(goal.on_ice_6) + " \n                      ")]), _c('td', [_vm._v("P: " + _vm._s(goal.period))])])])])
    })], 2)
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header large"
  }, [_c('p', [_vm._v("Update 28/02/2019 11:59AM")])]), _vm._v(" "), _c('div', {
    staticClass: "message-body medium"
  }, [_c('ul', [_c('li', [_vm._v("Please beware, this is work in progress!")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v("Filters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "rol-sticky-col-game"
  }, [_vm._v("Game")]), _vm._v(" "), _c('th', [_vm._v("Goal Data")])])
}]}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor is-centered"
  }, [_c('div', {
    staticClass: "tile is-parent is-5"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Edit Turnover")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.updateTurnover
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Turnover.player.player_number),
      expression: "Turnover.player.player_number"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Who made the hit?"
    },
    domProps: {
      "value": (_vm.Turnover.player.player_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Turnover.player, "player_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Turnover.type),
      expression: "Turnover.type"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Zone/Location of TO"
    },
    domProps: {
      "value": (_vm.Turnover.type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Turnover, "type", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Turnover.period),
      expression: "Turnover.period"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Period"
    },
    domProps: {
      "value": (_vm.Turnover.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Turnover, "period", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Turnover.situation.secondary_situation),
      expression: "Turnover.situation.secondary_situation"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Situation of Play i.e. EH5v5"
    },
    domProps: {
      "value": (_vm.Turnover.situation.secondary_situation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Turnover.situation, "secondary_situation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Pick game time",
      "config": {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        time_24hr: true
      }
    },
    model: {
      value: (_vm.Turnover.game_time),
      callback: function($$v) {
        _vm.$set(_vm.Turnover, "game_time", $$v)
      },
      expression: "Turnover.game_time"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "name": "submit"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-small",
    attrs: {
      "to": '/editors/turnovers/:gameId'
    }
  }, [_vm._v("Cancel")])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Turnover By")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("On")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Period")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Situation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Game Time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  })])
}]}

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BackgroundSlider', [_c('p', [_c('img', {
    attrs: {
      "width": "200",
      "src": __webpack_require__(187),
      "alt": _vm.description
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "is-title is-bold",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.name.replace('-', ' ')))]), _vm._v(" "), _c('p', [_c('strong', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Stats Engine")])])])
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile box"
  }, [_c('form', {
    on: {
      "submit": _vm.updateTimeOnice
    }
  }, [_c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr'), _vm._l((_vm.TOI), function(toi) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(toi.player_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(toi.player_forename) + " " + _vm._s(toi.player_surname))]), _vm._v(" "), _c('td', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (toi.played_in_game),
        expression: "toi.played_in_game"
      }],
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox",
        "checked": "checked",
        "value": ""
      },
      domProps: {
        "checked": Array.isArray(toi.played_in_game) ? _vm._i(toi.played_in_game, "") > -1 : (toi.played_in_game)
      },
      on: {
        "change": function($event) {
          var $$a = toi.played_in_game,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(toi, "played_in_game", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(toi, "played_in_game", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(toi, "played_in_game", $$c)
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (toi.shots_for),
        expression: "toi.shots_for"
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "0"
      },
      domProps: {
        "value": (toi.shots_for)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(toi, "shots_for", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (toi.shots_against),
        expression: "toi.shots_against"
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "0"
      },
      domProps: {
        "value": (toi.shots_against)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(toi, "shots_against", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (toi.shifts),
        expression: "toi.shifts"
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "0"
      },
      domProps: {
        "value": (toi.shifts)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(toi, "shifts", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.avg_shift),
        callback: function($$v) {
          _vm.$set(toi, "avg_shift", $$v)
        },
        expression: "toi.avg_shift"
      }
    })], 1), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.total_time),
        callback: function($$v) {
          _vm.$set(toi, "total_time", $$v)
        },
        expression: "toi.total_time"
      }
    })], 1), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.time_5v5),
        callback: function($$v) {
          _vm.$set(toi, "time_5v5", $$v)
        },
        expression: "toi.time_5v5"
      }
    })], 1), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.time_4v4),
        callback: function($$v) {
          _vm.$set(toi, "time_4v4", $$v)
        },
        expression: "toi.time_4v4"
      }
    })], 1), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.time_PP),
        callback: function($$v) {
          _vm.$set(toi, "time_PP", $$v)
        },
        expression: "toi.time_PP"
      }
    })], 1), _vm._v(" "), _c('td', [_c('datepicker', {
      attrs: {
        "placeholder": "--:--",
        "config": {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },
        "value": "00:00:00"
      },
      model: {
        value: (toi.time_SH),
        callback: function($$v) {
          _vm.$set(toi, "time_SH", $$v)
        },
        expression: "toi.time_SH"
      }
    })], 1)])
  })], 2)]), _vm._v(" "), _c('p', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "name": "submit"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-small",
    attrs: {
      "to": '/editors/Player/'
    }
  }, [_vm._v("Cancel")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("GP")]), _vm._v(" "), _c('th', [_vm._v("+ Shots")]), _vm._v(" "), _c('th', [_vm._v("- Shots")]), _vm._v(" "), _c('th', [_vm._v("Shifts")]), _vm._v(" "), _c('th', [_vm._v("Time Avg Shift")]), _vm._v(" "), _c('th', [_vm._v("Time Total")]), _vm._v(" "), _c('th', [_vm._v("Time 5v5")]), _vm._v(" "), _c('th', [_vm._v("Time 4v4")]), _vm._v(" "), _c('th', [_vm._v("Time PP")]), _vm._v(" "), _c('th', [_vm._v("Time SH")])])])
}]}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */
/***/ (function(module, exports) {

module.exports = {"name":"devils-edge","version":"2.0.0","description":"Devils Edge Statistics Engine","repository":"roblutken.com/devils-admin","homepage":"https://cardiffdevils.com","license":"MIT","author":{"name":"Robert Lutken","email":"admin@roblutken.co.uk","url":"http://roblutken.com"},"keywords":["","","","","",""],"engines":{"node":">=4","npm":">=3"},"scripts":{"build":"cross-env NODE_ENV=production node build/build.js","clean":"rm -rf dist","dev":"cross-env NODE_ENV=development node build/dev-server.js","electron":"cross-env NODE_ELECTRON=true npm run build && electron electronIndex.js","gh":"npm run build && gh-pages -d dist","lint":"eslint --ext .js .vue client/*","lint:fix":"eslint --fix --ext .js .vue electron.js client/* build/* config/*","test":"echo lol"},"dependencies":{"@websanova/vue-auth":"^2.8.2-beta","animate.css":"3.5.2","animejs":"^2.0.1","apexcharts":"^3.34.0","axios":"^0.15.3","bulma":"^0.3.2","font-awesome":"4.7.0","lodash":"^4.17.21","mdi":"^1.8.36","plotly.js":"^1.24.2","regenerator-runtime":"^0.13.9","vue":"^2.2.2","vue-axios":"^2.0.1","vue-bulma-brace":"^0.1.0","vue-bulma-breadcrumb":"^1.0.1","vue-bulma-card":"^1.0.2","vue-bulma-chartist":"^1.1.0","vue-bulma-chartjs":"^1.0.4","vue-bulma-collapse":"1.0.3","vue-bulma-datepicker":"^1.3.6","vue-bulma-expanding":"^0.0.1","vue-bulma-jump":"^0.0.2","vue-bulma-message":"^1.1.1","vue-bulma-modal":"1.0.1","vue-bulma-notification":"^1.1.1","vue-bulma-progress-bar":"^1.0.2","vue-bulma-progress-tracker":"0.0.4","vue-bulma-quill":"0.0.1","vue-bulma-rating":"^1.0.1","vue-bulma-slider":"^1.0.2","vue-bulma-switch":"^1.0.4","vue-bulma-tabs":"^1.1.3","vue-bulma-tooltip":"^1.0.3","vue-cleave":"1.1.1","vue-lory":"0.0.4","vue-multiselect":"^2.1.6","vue-nprogress":"0.1.5","vue-peity":"0.5.0","vue-router":"^2.3.0","vue-scrollto":"^2.20.0","vuex":"^2.2.1","vuex-router-sync":"^4.1.2"},"devDependencies":{"autoprefixer":"^6.7.7","babel-core":"^6.21.0","babel-eslint":"^7.1.1","babel-loader":"^6.4.0","babel-plugin-transform-export-extensions":"^6.8.0","babel-plugin-transform-regenerator":"^6.26.0","babel-polyfill":"^6.26.0","babel-preset-es2015":"^6.14.0","babel-preset-stage-2":"^6.17.0","connect-history-api-fallback":"^1.3.0","cross-env":"^3.1.3","css-loader":"^0.27.1","electron-devtools-installer":"^2.0.1","eslint":"^3.17.1","eslint-config-standard":"^7.0.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.6.1","eslint-plugin-html":"^2.0.1","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^2.1.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^2.0.0-beta.4","file-loader":"^0.10.1","html-webpack-plugin":"^2.25.0","http-proxy-middleware":"^0.17.4","imports-loader":"^0.7.0","node-sass":"^4.1.1","opn":"^4.0.2","ora":"^1.1.0","postcss-loader":"^1.3.3","progress-bar-webpack-plugin":"^1.9.1","sass-loader":"^6.0.3","serve-favicon":"^2.4.1","style-loader":"^0.13.1","stylus":"^0.54.5","stylus-loader":"^3.0.1","url-loader":"^0.5.7","vue-apexcharts":"^1.6.2","vue-html-loader":"^1.2.3","vue-loader":"^11.1.4","vue-resource":"^1.3.5","vue-template-compiler":"^2.2.2","webpack":"^2.2.1","webpack-dev-middleware":"^1.9.0","webpack-hot-middleware":"^2.14.0","webpack-merge":"^4.0.0"}}

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(253);


/***/ })
],[677]);


// WEBPACK FOOTER //
// assets/js/app.88df132222c47f2fa79f.js